webpackJsonp([0],{

/***/ "+3jA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Ftn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_warrantForm_vue__ = __webpack_require__("cN80");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ed136a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_warrantForm_vue__ = __webpack_require__("yNX4");
function injectStyle (ssrContext) {
  __webpack_require__("Bip6")
  __webpack_require__("TUcQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02ed136a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_warrantForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ed136a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_warrantForm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+HUB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",attrs:{"disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+IYe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+XBq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var GET_WARRANTS_COUNT = 'get_warrants_count.php';
var REPORT_ID = 8;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'WarrantsCount',
	data: function data() {
		return {
			rows: []
		};
	},
	props: ['start', 'end'],
	methods: {
		fillTable: function fillTable(start, end) {
			var _this = this;

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + GET_WARRANTS_COUNT + '?start=' + start + '&end=' + end).then(function (res) {
				return res.json();
			}).then(function (res) {
				_this.rows = res;
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		this.rows = [];
		this.fillTable(this.start, this.end);

		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on('report-date', function (date) {
			// console.log('mon',date)
			_this2.fillTable(date.start, date.end);
		});
		/*
  const dispay_width = document.documentElement.clientWidth
  const dispay_height = document.documentElement.clientHeight
  let scroll_width = 17
  	const ua = navigator.userAgent
  	// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))
  	if (ua.search('OPR/') > 0) {
  	scroll_width = 15
  }
  	const table_width = dispay_width - 30 - scroll_width
  const col_width = Math.ceil(table_width / 13)
  
  	document.querySelectorAll('.m-td').forEach(td => {
  	td.width = col_width
  })
  document.querySelector('.m-header-wrapper').width = table_width
  document.querySelector('.m-body-wrapper').width = table_width
  document.querySelector('.m-body-wrapper').style.maxHeight = `${dispay_height - 340}px`
  	// console.log(dispay_width, col_width, table_width)
  	document.querySelector('.m-scroll').width = scroll_width*/
	},
	created: function created() {
		if (!this.$parent.$parent.reports.some(function (e) {
			return e.id == REPORT_ID;
		})) __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('/main');
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('report-date');
	}
});

/***/ }),

/***/ "+bB7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reg_vue__ = __webpack_require__("J5W9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30b93dd4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Reg_vue__ = __webpack_require__("bbli");
function injectStyle (ssrContext) {
  __webpack_require__("aycJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30b93dd4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30b93dd4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Reg_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+d+a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListDrafts_vue__ = __webpack_require__("f9q1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00c861c5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ListDrafts_vue__ = __webpack_require__("VGNK");
function injectStyle (ssrContext) {
  __webpack_require__("GYiq")
  __webpack_require__("0Jf0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00c861c5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListDrafts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00c861c5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ListDrafts_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/MHW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var DOCS = 'get_official_docs.php';
var WARRANT_INFO = 'get_warrant_info.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'official_docs',
	data: function data() {
		return {
			selected: '0',
			options: []
		};
	},
	props: {
		disabled: false
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('official_docs', this.selected);
		}
	},
	created: function created() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + WARRANT_INFO + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			return res[0].f_71;
		}).then(function (id) {
			fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + DOCS, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.options = data;
					if (id === null) _this.selected = data[0].id;else _this.selected = id;
				} else {
					_this.options = [];
				}
				_this.change();
			}).catch(function (err) {
				return console.log(err);
			});
		}).catch(function (err) {
			return console.log(err);
		});
	}
});

/***/ }),

/***/ "/Yg9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_strap__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var GET_SYS_REPORTS = 'get_sys_reports.php';
var UPDATE_JSON = 'update_json.php';

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            reports: [],
            showModal: false
        };
    },

    watch: {
        show: function show() {
            this.showModal = this.show;
            if (this.show) {
                this.getReports();
            }
        }
    },
    components: {
        modal: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["modal"]
    },
    props: {
        show: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        sortedReports: function sortedReports() {
            if (this.reports && this.reports.length) return this.reports.sort(function (a, b) {
                return a.priority - b.priority;
            });else return [];
        }
    },
    methods: {
        getReports: function getReports() {
            var _this = this;

            fetch(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DB */] + GET_SYS_REPORTS, {
                credentials: 'include'
            }).then(function (res) {
                return res.json();
            }).then(function (res) {
                _this.reports = res;
                if (_this.reports && _this.reports.length) _this.reports = _this.reports.map(function (e) {
                    var temp = e;
                    temp.is_actual = temp.is_actual == 't';
                    return temp;
                });
            }).catch(function (err) {
                return console.log(err);
            });
        },
        changeReport: function changeReport(id, actual, priority) {
            var clone = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.reports));
            for (var report in clone) {
                if (clone[report].id == id) {
                    clone[report].is_actual = actual;
                    var oldPriority = Number(clone[report].priority);
                    var newPriority = oldPriority + priority;
                    if (newPriority > 0 && newPriority < clone.length + 1) {
                        for (var report_2 in clone) {
                            if (clone[report_2].priority == newPriority) {
                                clone[report_2].priority = oldPriority;
                                clone[report].priority = newPriority;
                            }
                        }
                    }
                }
            }
            this.reports = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(clone));
        },
        saveReports: function saveReports() {
            //console.warn(JSON.stringify(this.reports))
            var res = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.reports), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var report = _step.value;

                    res.push({});
                    res[res.length - 1].tab_id = 5;
                    res[res.length - 1].f_v = {
                        'f_c': report.id,
                        'f_123': report.is_actual,
                        'f_124': Number(report.priority)
                    };
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(res);
            //console.warn(data)

            var form = new FormData();
            form.append('json', data);

            fetch(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DB */] + UPDATE_JSON, {
                credentials: 'include',
                method: 'post',
                body: form
            }).then(function (result) {
                return result.json();
            }).then(function (result) {
                if (result[0].code === '0') alert('Отчёты сохранены');
            });
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "/cCE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control",attrs:{"id":_vm.id,"data-num":"f_9","data-table":"1"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/tat":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addForm_vue__ = __webpack_require__("0mT4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d0e7e72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_addForm_vue__ = __webpack_require__("Kaa6");
function injectStyle (ssrContext) {
  __webpack_require__("h8Ot")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d0e7e72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_addForm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/uIn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control table-control my-control",attrs:{"id":_vm.id,"data-num":"f_27","data-table":"1"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/wky":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forestry_vue__ = __webpack_require__("yZxP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_561989d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_forestry_vue__ = __webpack_require__("wQSF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forestry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_561989d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_forestry_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0Jf0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0KnF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec4729ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CancelIcon_vue__ = __webpack_require__("EUcY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec4729ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CancelIcon_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0mT4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth__ = __webpack_require__("SQ6o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fetch_data_fo__ = __webpack_require__("zXUn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fetch_data_region__ = __webpack_require__("S1jb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fetch_data_forestry__ = __webpack_require__("Wf+r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fetch_data_localforestry__ = __webpack_require__("RBZK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fetch_data_subforestry__ = __webpack_require__("WFQ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fetch_data_species__ = __webpack_require__("2nlc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fetch_data_conclusionUser__ = __webpack_require__("l6fI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fetch_data_organization__ = __webpack_require__("6Zra");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__fetch_data_actionType__ = __webpack_require__("2Isl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__fetch_data_deletionReason__ = __webpack_require__("Lu+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__fetch_data_damages__ = __webpack_require__("zmlw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__fetch_data_lpoReason__ = __webpack_require__("kEvE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__fetch_data_lpoMethod__ = __webpack_require__("Dqt0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__fetch_data_lpoMode__ = __webpack_require__("DslM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__fetch_data_forestPurpose__ = __webpack_require__("pY7n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__fetch_data_protectiveCat__ = __webpack_require__("XMGQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__fetch_data_protectiveCatExt__ = __webpack_require__("V5LQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__fetch_data_tooltipWarn__ = __webpack_require__("MuUM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__fetch_data_locationTableField__ = __webpack_require__("TXeP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__lib_css_fontawesome_all_min_css__ = __webpack_require__("ThaU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__lib_css_fontawesome_all_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__lib_css_fontawesome_all_min_css__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






























//import datePick from './../datePicker'

// import jQuery from "jquery";  
// import datePicker from 'vue-bootstrap-datetimepicker';
// import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';


var INSERT_JSON = 'insert_json.php';
var ACTION_TYPE = 'get_action_type.php';
var CAN_EDIT = 'can_edit_unit.php';
var LPO_FILIALS = 'get_lpo_filials.php';
var ORGANIZATION_LPO = 'get_organization_lpo.php';
var FIND_ACT = 'find_act.php';
var UNIT_ID = 1;
var TIMEOUT = 10 * 60 * 1000; // 10 минут




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'addForm',
	data: function data() {
		return {
			line_count: 0,
			lines: [],
			mzl: [],
			mzlNoRAD: [],
			mzlRAD: [],
			f_1: '',
			f_2: '',
			f_3: '',
			f_4: '',
			f_5: '',
			f_6: __WEBPACK_IMPORTED_MODULE_6__auth__["a" /* default */].user.id,
			f_7: '',
			f_8: 0,
			f_9: 0,
			f_10: 1,
			f_11: 0,
			f_12: 0,
			f_13: '',
			f_14: '',
			f_15: __WEBPACK_IMPORTED_MODULE_6__auth__["a" /* default */].user.id,
			f_89: null,
			f_90: null,

			f_126: null,
			f_127: null,
			f_128: null,
			f_129: 2,
			f_130: null,

			f_115: '',
			/*	f_16: [],
   	f_17: [],
   	f_18: [],
   	f_19: [],
   	f_20: [],
   	f_21: [],
   	f_22: [],
   	f_23: [],
   	f_24: [],
   	f_25: [],
   	f_26: [],
   	f_27: [],*/

			controlTwenty: '',
			daysLeft: '',
			summ_s_lp: 0,
			summ_s_action_type: 0,
			value_summ: 0,

			fields_correct: {
				f_1: 'field-error',
				f_2: 'field-error',
				f_3: 'field-error',
				f_5: 'field-error',
				f_9: 'field-error',
				f_11: 'field-error',
				f_12: 'field-error',
				f_13: 'field-error',
				f_126: 'field-error',
				f_127: 'field-error',
				f_128: 'field-error',
				f_130: 'field-error'
			},

			organization_types: [],
			lpo_filials: [],

			lines_correct: 'field-error',
			submit_disabled: false
		};
	},
	components: {
		region: __WEBPACK_IMPORTED_MODULE_9__fetch_data_region__["a" /* default */],
		forestry: __WEBPACK_IMPORTED_MODULE_10__fetch_data_forestry__["a" /* default */],
		localforestry: __WEBPACK_IMPORTED_MODULE_11__fetch_data_localforestry__["a" /* default */],
		subforestry: __WEBPACK_IMPORTED_MODULE_12__fetch_data_subforestry__["a" /* default */],
		fo: __WEBPACK_IMPORTED_MODULE_8__fetch_data_fo__["a" /* default */],
		species: __WEBPACK_IMPORTED_MODULE_13__fetch_data_species__["a" /* default */],
		conclusionUser: __WEBPACK_IMPORTED_MODULE_14__fetch_data_conclusionUser__["a" /* default */],
		organization: __WEBPACK_IMPORTED_MODULE_15__fetch_data_organization__["a" /* default */],
		actionType: __WEBPACK_IMPORTED_MODULE_16__fetch_data_actionType__["a" /* default */],
		deletionReason: __WEBPACK_IMPORTED_MODULE_17__fetch_data_deletionReason__["a" /* default */],
		damageReason: __WEBPACK_IMPORTED_MODULE_18__fetch_data_damages__["a" /* default */],
		datepicker: __WEBPACK_IMPORTED_MODULE_27_vue_strap__["datepicker"],
		lpoReason: __WEBPACK_IMPORTED_MODULE_19__fetch_data_lpoReason__["a" /* default */],
		lpoMethod: __WEBPACK_IMPORTED_MODULE_20__fetch_data_lpoMethod__["a" /* default */],
		lpoMode: __WEBPACK_IMPORTED_MODULE_21__fetch_data_lpoMode__["a" /* default */],
		forestPurpose: __WEBPACK_IMPORTED_MODULE_22__fetch_data_forestPurpose__["a" /* default */],
		protectiveCat: __WEBPACK_IMPORTED_MODULE_23__fetch_data_protectiveCat__["a" /* default */],
		protectiveCatExt: __WEBPACK_IMPORTED_MODULE_24__fetch_data_protectiveCatExt__["a" /* default */],
		tooltipWarn: __WEBPACK_IMPORTED_MODULE_25__fetch_data_tooltipWarn__["a" /* default */],
		locationTableField: __WEBPACK_IMPORTED_MODULE_26__fetch_data_locationTableField__["a" /* default */]
	},
	methods: {
		tryBlurMzl: function tryBlurMzl(e, val, type) {
			//if(type && !Number.isInteger(Number(val)))
			//	setTimeout(() => e.target.focus(), 10)
		},
		floatConvert: function floatConvert(number) {
			return +parseFloat(number).toPrecision(12);
		},
		filterInput: function filterInput(e) {
			e.target.value = e.target.value.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "");
		},
		addSLP: function addSLP(e) {
			if (e) {
				e.target.value = e.target.value.replace(/[,-]/g, ".");
				var f = e.target.getAttribute('data-field');
				var l = e.target.getAttribute('data-line');

				this.lines[l][f] = e.target.value;
			}

			var s = 0;
			for (var i = 0; i < this.lines.length; i++) {
				s += +this.lines[i].f_23;
			}

			this.summ_s_lp = this.floatConvert(s);
		},
		addSAT: function addSAT(e) {
			if (e) {
				e.target.value = e.target.value.replace(/[,-]/g, ".");
				var f = e.target.getAttribute('data-field');
				var l = e.target.getAttribute('data-line');

				this.lines[l][f] = e.target.value;
			}

			var s = 0;

			for (var i = 0; i < this.mzl.length; i++) {
				this.mzl[i].value = 0;
			}

			for (var j = 0; j < this.lines.length; j++) {
				for (var _i = 0; _i < this.mzl.length; _i++) {
					if (this.mzl[_i].id === this.lines[j].f_16) {
						this.mzl[_i].value += +this.lines[j].f_22;
					}
				}
			}

			for (var _i2 = 0; _i2 < this.mzl.length; _i2++) {
				this.mzl[_i2].value = this.floatConvert(this.mzl[_i2].value);
			}

			for (var _i3 = 0; _i3 < this.lines.length; _i3++) {
				s += +this.lines[_i3].f_22;
			}

			this.summ_s_action_type = this.floatConvert(s);
		},
		addLine: function addLine() {
			var obj = {};
			for (var i = 16; i <= 27; i++) {
				obj['f_' + i] = '';
			}
			obj.correct_f_17 = 'field-error';
			obj.correct_f_20 = 'field-error';
			obj.correct_f_21 = 'field-error';
			obj.correct_f_22 = 'field-error';
			obj.correct_f_24 = 'field-error';

			this.lines.push(obj);
			this.lines_correct = '';
		},
		copyLine: function copyLine() {
			var _this = this;

			//console.warn(this.lines)
			document.querySelectorAll('tbody .checkbox').forEach(function (checkbox) {
				if (checkbox.checked) {
					checkbox.checked = false;
					var index = checkbox.getAttribute('data-index');
					var line_to_copy = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, _this.lines[index]);
					line_to_copy.f_c = null;

					for (var l in line_to_copy) {
						if (line_to_copy[l] == null) delete line_to_copy[l];
					}_this.lines.push(line_to_copy);
				}
			});
			document.getElementById('chkBoxSelAll').checked = false;
		},
		deleteLine: function deleteLine() {
			var _this2 = this;

			document.querySelectorAll('tbody .checkbox').forEach(function (checkbox) {
				if (checkbox.checked) {
					var index = checkbox.getAttribute('data-index');

					checkbox.parentNode.parentNode.remove();

					for (var i = 16; i <= 27; i++) {
						_this2.lines[index]['f_' + i] = null;
					}

					if (_this2.lines[index].f_c) {
						_this2.prepareToDelete.push(_this2.lines[index].f_c);
					}

					_this2.lines[index].f_d = true;
				}
			});
			document.getElementById('chkBoxSelAll').checked = false;

			var c = true;
			for (var i = 0; i < this.lines.length; i++) {
				if (typeof this.lines[i].f_d === 'undefined') {
					c = false;
					break;
				}
			}

			this.lines_correct = c ? 'field-error' : '';
		},
		selectAll: function selectAll() {
			document.querySelectorAll('tbody .checkbox').forEach(function (checkbox) {
				checkbox.checked = document.getElementById('chkBoxSelAll').checked;
			});
		},
		clear: function clear() {
			this.lines.forEach(function (line) {
				line.f_d = true;
			});

			document.querySelectorAll('tbody .checkbox').forEach(function (checkbox) {
				checkbox.parentNode.parentNode.remove();
			});
		},
		checkFields: function checkFields() {
			var main_fields = [1, 2, 3, 5, 9, 11, 12, 13];
			var location_fields = [17, 20, 21, 24];
			var result = true;

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(main_fields), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var i = _step.value;

					result = result && !!this['f_' + i]; //one false = result false, all true = result true
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			result = result && !!this.lines.length; //lines.length == 0 => result false

			var deleted_lines_count = 0;
			for (var j = 0; j < this.lines.length; j++) {
				if (this.lines[j].f_d) deleted_lines_count++;
			}

			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(location_fields), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var _i4 = _step2.value;

					for (var _j = 0; _j < this.lines.length; _j++) {
						if (!this.lines[_j].f_d) result = result && !!this.lines[_j]['f_' + _i4];
					}
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			if (deleted_lines_count === this.lines.length) //all lines is deleted => result false
				result = false;

			return result;
		},
		submit: function submit() {
			var _this3 = this;

			this.submit_disabled = true;

			for (var i = 0; i < this.lines.length; i++) {
				if (this.lines[i].f_16 == this.mzlRAD.id && !__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default()(Number(this.lines[i].f_22))) {
					__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$emit('show_tooltip_mzl_add', { id: i });
					this.submit_disabled = false;
					return false;
				}
			}

			var obj = {};
			obj.tab = [{}];
			obj.tab[0].tab_id = 1;
			obj.tab[0].f_v = {};

			for (var _i5 = 1; _i5 <= 15; _i5++) {
				if ((_i5 === 1 || _i5 === 3 || _i5 === 5 || _i5 === 7) && this['f_' + _i5] !== '') {
					obj.tab[0].f_v['f_' + _i5] = this['f_' + _i5];
				} else if ((_i5 === 6 || _i5 === 9 || _i5 === 11 || _i5 === 12) && this['f_' + _i5] != 0) {
					obj.tab[0].f_v['f_' + _i5] = this['f_' + _i5];
				}

				if (_i5 !== 1 && _i5 !== 3 && _i5 !== 5 && _i5 !== 7 && _i5 !== 6 && _i5 !== 9 && _i5 !== 11 && _i5 !== 12 && this['f_' + _i5] !== '') {
					if (_i5 === 13 || _i5 === 14) {
						obj.tab[0].f_v['f_' + _i5] = commaToPeriod(this['f_' + _i5]);
					} else {
						obj.tab[0].f_v['f_' + _i5] = this['f_' + _i5];
					}
				}
			}

			obj.tab[0].f_v.f_88 = this.f_88;
			obj.tab[0].f_v.f_89 = this.f_89;
			obj.tab[0].f_v.f_90 = this.f_90;

			obj.tab[0].f_v.f_126 = this.f_126;
			obj.tab[0].f_v.f_127 = this.f_127 || "";
			obj.tab[0].f_v.f_128 = this.f_128 || "";
			obj.tab[0].f_v.f_129 = this.f_129;
			obj.tab[0].f_v.f_130 = this.f_130;

			if (this.f_115) obj.tab[0].f_v.f_115 = commaToPeriod(this.f_115);

			obj.tab[0].tab = [];

			for (var _i6 = 0; _i6 < this.lines.length; _i6++) {
				if (!this.lines[_i6].f_d) {
					obj.tab[0].tab.push({});

					obj.tab[0].tab[obj.tab[0].tab.length - 1].tab_id = 2;
					obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v = {};

					for (var j = 16; j <= 26; j++) {
						if (this.lines[_i6]['f_' + j]) if (j === 21 || j === 22 || j === 23) {
							obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_' + j] = commaToPeriod(this.lines[_i6]['f_' + j]);
						} else {
							obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_' + j] = this.lines[_i6]['f_' + j];
						}
					}
					if (Number(this.lines[_i6]['f_27'])) obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_27'] = this.lines[_i6]['f_27'];

					obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_104'] = this.lines[_i6]['f_104'];
					obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_105'] = this.lines[_i6]['f_105'];
					if (this.lines[_i6]['f_106']) obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_106'] = this.lines[_i6]['f_106'];

					if (this.lines[_i6]['f_111']) obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_111'] = this.lines[_i6]['f_111'];
					if (this.lines[_i6]['f_112']) obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_112'] = this.lines[_i6]['f_112'];
					if (this.lines[_i6]['f_113']) obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_113'] = this.lines[_i6]['f_113'];
					if (this.lines[_i6]['f_114']) obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_114'] = this.lines[_i6]['f_114'];
					if (this.lines[_i6]['f_116']) obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_116'] = this.lines[_i6]['f_116'];
					if (this.lines[_i6]['f_131']) obj.tab[0].tab[obj.tab[0].tab.length - 1].f_v['f_131'] = this.lines[_i6]['f_131'];
				}
			}

			//console.log(obj)

			// console.log(JSON.stringify(obj))
			var submit_act_info = function submit_act_info() {
				var form = new FormData();
				form.append('json', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(obj));

				var zero_check_result = null;
				var zero_check = setTimeout(function () {
					if (zero_check_result === null) {
						zero_check_result = false;
						var save = confirm('Во время сохранения акта произошла ошибка. Сохранить файл с отладочной информацией для отправки разработчикам?');

						if (save) _this3.download(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(obj) + '_timeout', 'edit_' + Date() + '.json', 'text/json');

						_this3.submit_disabled = false;
					}
				}, TIMEOUT);

				fetch(__WEBPACK_IMPORTED_MODULE_29__constants__["a" /* DB */] + FIND_ACT + ('?create_date=' + _this3.f_1 + '&adoption_date=' + _this3.f_5 + '&placement_date=' + _this3.f_3 + '&act_num=' + _this3.f_2 + '&forestry_id=' + _this3.f_9)).then(function (res) {
					return res.json();
				}).then(function (res) {
					if (zero_check_result === null) {
						clearTimeout(zero_check);
						zero_check_result = true;
						if (res.czl_get_act_id > -1) {
							_this3.submit_disabled = false;
							alert('Данный акт уже присутствует в системе. Обратитесь к администратору');
						} else {
							var first_check_result = null;
							var second_check_result = null;

							var first_check = setTimeout(function () {
								if (first_check_result === null) {
									first_check_result = false;
									var second_check = setTimeout(function () {
										if (second_check_result === null) {
											second_check_result = false;
											alert('Во время сохранения акта произошла ошибка. Повторите попытку позже.');
											_this3.submit_disabled = false;
										}
									}, TIMEOUT);

									fetch(__WEBPACK_IMPORTED_MODULE_29__constants__["a" /* DB */] + FIND_ACT + ('?create_date=' + _this3.f_1 + '&adoption_date=' + _this3.f_5 + '&placement_date=' + _this3.f_3 + '&act_num=' + _this3.f_2 + '&forestry_id=' + _this3.f_9)).then(function (res) {
										return res.json();
									}).then(function (res) {
										if (second_check_result === null) {
											second_check_result = true;
											clearTimeout(second_check);
											if (res.czl_get_act_id && res.czl_get_act_id > -1) {
												alert('Акт сохранен');
												_this3.submit_disabled = false;
												if (_this3.$parent.lastJournalURL) __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].replace(_this3.$parent.lastJournalURL);else __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].replace('/main');
											} else {
												alert('Во время сохранения акта произошла ошибка. Повторите попытку позже.');
												_this3.submit_disabled = false;
											}
										}
									}).catch(function (e) {
										alert('Во время сохранения акта произошла ошибка. Повторите попытку позже.');
										_this3.submit_disabled = false;
									});
								}
							}, TIMEOUT);

							//console.warn(this.f_1, this.f_2, this.f_9)

							fetch(__WEBPACK_IMPORTED_MODULE_29__constants__["a" /* DB */] + INSERT_JSON, {
								method: 'post',
								body: form
							}).then(function (result) {
								return result.json();
							}).then(function (result) {
								if (first_check_result === null) {
									first_check_result = true;
									clearTimeout(first_check);
									if (result[0].code === '0') {
										alert('Акт сохранен');
										__WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].replace('/main');
										_this3.submit_disabled = false;
									} else {
										alert('Во время сохранения акта произошла ошибка. На Ваш компьютер будет сохранён файл с отладочной информацией. Перешлите данный файл вместе со скриншотом экрана разработчикам для выявления и устранения ошибки.');
										_this3.download(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(obj) + '_' + result[0].name, 'edit_' + Date() + '.json', 'text/json');
										_this3.submit_disabled = false;
									}
								}
							}).catch(function (err) {
								alert('Во время сохранения акта произошла ошибка. Повторите попытку позже.');
								_this3.submit_disabled = false;
								console.log(err);
							});
						}
					}
				});
			};
			if (this.checkFields()) {
				if (document.querySelector('.field-error') !== null) {
					var b = confirm('Часть полей может содержать некорректные данные. Вы уверены, что хотите продолжить?');
					if (b) {
						submit_act_info();
					} else {
						this.submit_disabled = false;
					}
				} else {
					submit_act_info();
				}
			} else {
				alert('Поля, отмеченные звёздочкой, обязательны к заполнению.');
				this.submit_disabled = false;
			}
		},
		close: function close() {
			if (this.$parent.lastJournalURL) __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].replace(this.$parent.lastJournalURL);else __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].replace('/main');
		},
		download: function download(content, fileName, contentType) {
			var a = document.createElement("a");
			var file = new Blob([content], { type: contentType });
			a.href = URL.createObjectURL(file);
			a.download = fileName;
			var event = document.createEvent("MouseEvents");
			event.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
			a.dispatchEvent(event);
		},
		tdChange: function tdChange(e) {
			var f = e.target.getAttribute('data-field');
			var l = e.target.getAttribute('line_count');
			if (f === 'f_21') {
				e.target.value = e.target.value.replace(/[,-]/g, ".");
			}

			this.lines[l]['correct_' + f] = e.target.value === '' ? 'field-error' : 'place-success';
		},
		adoptionChange: function adoptionChange(e) {
			if (e) {
				if (this.f_3) {
					var adoption = __WEBPACK_IMPORTED_MODULE_28_moment___default()(e, 'DD.MM.YYYY');
					var place = __WEBPACK_IMPORTED_MODULE_28_moment___default()(this.f_3, 'DD.MM.YYYY');
					var diff = place.diff(adoption, 'days');

					var dp_adoption = document.getElementById('datepicker_f_5').firstChild;
					var dp_placement = document.getElementById('datepicker_f_3').firstChild;

					if (diff < 0 || diff > 3) {
						if (!dp_adoption.classList.contains('error')) {
							dp_adoption.classList.add('error');
							dp_placement.classList.add('error');
							this.fields_correct.f_3 = 'error';
							this.fields_correct.f_5 = 'error';
						}
					} else {
						dp_adoption.classList.remove('error');
						dp_placement.classList.remove('error');
						this.fields_correct.f_3 = '';
						this.fields_correct.f_5 = '';
					}
				} else {
					this.fields_correct.f_5 = 'field-success';
				}
			} else {
				document.getElementById('datepicker_f_3').firstChild.classList.remove('error');
				document.getElementById('datepicker_f_5').firstChild.classList.remove('error');
				this.fields_correct.f_5 = 'field-error';
				this.fields_correct.f_3 = this.fields_correct.f_3 !== 'field-error' ? 'field-success' : 'field-error';
			}
		},
		placeChange: function placeChange(e) {
			if (e) {
				var d = __WEBPACK_IMPORTED_MODULE_28_moment___default()(e, 'DD.MM.YYYY');
				d.add(20, 'd');
				var now = __WEBPACK_IMPORTED_MODULE_28_moment___default()();

				this.controlTwenty = d.format('DD.MM.YYYY');
				this.daysLeft = d.diff(now, 'days');

				if (this.f_5) {
					var adoption = __WEBPACK_IMPORTED_MODULE_28_moment___default()(this.f_5, 'DD.MM.YYYY');
					var place = __WEBPACK_IMPORTED_MODULE_28_moment___default()(e, 'DD.MM.YYYY');
					var diff = place.diff(adoption, 'days');

					var dp_adoption = document.getElementById('datepicker_f_5').firstChild;
					var dp_placement = document.getElementById('datepicker_f_3').firstChild;

					if (diff < 0 || diff > 3) {
						if (!dp_adoption.classList.contains('error')) {
							dp_adoption.classList.add('error');
							dp_placement.classList.add('error');
							this.fields_correct.f_3 = 'error';
							this.fields_correct.f_5 = 'error';
						}
					} else {
						dp_adoption.classList.remove('error');
						dp_placement.classList.remove('error');
						this.fields_correct.f_3 = '';
						this.fields_correct.f_5 = '';
					}
				} else {
					this.fields_correct.f_3 = '';
				}
			} else {
				this.controlTwenty = '';
				this.daysLeft = '';

				document.getElementById('datepicker_f_3').firstChild.classList.remove('error');
				document.getElementById('datepicker_f_5').firstChild.classList.remove('error');
				this.fields_correct.f_3 = 'field-error';
				this.fields_correct.f_5 = this.fields_correct.f_5 !== 'field-error' ? 'field-success' : 'field-error';
			}
		},
		checkS_LPO: function checkS_LPO() {
			var locations_S_sum = this.lines.length ? this.lines.reduce(function (a, cur) {
				return a + Number(cur.f_21);
			}, 0) : 0;
			var locations_S_MZL_sum = this.lines.length ? this.lines.reduce(function (a, cur) {
				//console.warn(cur)
				return a + (cur.f_16 == 563 ? 0 : Number(cur.f_22)); //Для всех, кроме РАД
			}, 0) : 0;
			//console.warn(Number(this.f_13), locations_S_sum, locations_S_MZL_sum)
			this.fields_correct.f_13 = this.f_13 === '' || this.f_13 === null || Number(this.f_13) > locations_S_sum || Number(this.f_13) < locations_S_MZL_sum ? 'field-error' : '';
		},
		change_f_129: function change_f_129() {
			this.f_130 = null;
			this.f_128 = "";
		},
		setSKSAllLocations: function setSKSAllLocations(val) {
			var newLines = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.lines));
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(newLines), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var line = _step3.value;

					line[val.field] = val.value;
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			this.lines = newLines;
		}
	},
	created: function created() {
		var _this4 = this;

		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$on('add_region', function (id) {
			_this4.f_12 = id;
			_this4.f_9 = 0;
			_this4.clear();
			_this4.fields_correct.f_12 = id === '0' ? 'field-error' : '';
			_this4.fields_correct.f_9 = 'field-error';
		});
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$on('add_forestry', function (id) {
			var add_line = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

			_this4.f_9 = id;
			_this4.clear();
			_this4.fields_correct.f_9 = id === '0' ? 'field-error' : '';

			if (add_line) {
				_this4.addLine();
			}
		});
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$on('add_localforestry', function (data) {
			_this4.lines[data.index].f_20 = +data.value;

			_this4.lines[data.index].correct_f_20 = +data.value === 0 ? 'field-error' : 'place-success';
		});
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$on('add_subforestry', function (data) {
			_this4.lines[data.index].f_27 = data.value;
		});
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$on('conclusion_user', function (id) {
			_this4.f_6 = id;
		});
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$on('species', function (data) {
			_this4.lines[data.index].f_26 = data.value;
		});
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$on('organization', function (id) {
			_this4.f_11 = id;
			_this4.fields_correct.f_11 = id === '0' ? 'field-error' : '';
		});
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$on('action_type', function (data) {
			_this4.lines[data.index].f_16 = +data.value;

			for (var i = 0; i < _this4.mzl.length; i++) {
				_this4.mzl[i].value = 0;
			}

			for (var j = 0; j < _this4.lines.length; j++) {
				for (var _i7 = 0; _i7 < _this4.mzl.length; _i7++) {
					if (_this4.mzl[_i7].id === _this4.lines[j].f_16) {
						_this4.mzl[_i7].value += +_this4.lines[j].f_22;
					}
				}
			}

			for (var _i8 = 0; _i8 < _this4.mzl.length; _i8++) {
				_this4.mzl[_i8].value = _this4.floatConvert(_this4.mzl[_i8].value);
			}
		});
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$on('deletion_reason', function (id) {
			_this4.f_8 = id;
		});
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$on('damages', function (data) {
			_this4.lines[data.index].f_19 = data.value;
		});

		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$on('lpo_reason', function (id) {
			_this4.f_88 = id;
		});
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$on('lpo_method', function (id) {
			_this4.f_89 = id;
		});
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$on('lpo_mode', function (id) {
			_this4.f_90 = id;
		});
		//---------------------
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$on('add_forest_purpose', function (data) {
			if (_this4.lines[data.index]) {
				_this4.lines[data.index].f_104 = data.value;
			} else {
				_this4.lines[data.index] = {};
			}
		});
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$on('add_protective_cat', function (data) {
			if (_this4.lines[data.index]) {
				_this4.lines[data.index].f_105 = data.value;
			} else {
				_this4.lines[data.index] = {};
			}
		});
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$on('add_protective_cat_ext', function (data) {
			_this4.lines[data.index].f_106 = data.value;
		});

		fetch(__WEBPACK_IMPORTED_MODULE_29__constants__["a" /* DB */] + CAN_EDIT + '?act_id=0&unit_id=1', { //Can create act?
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			if (res[0].czl_check_can_edit_unit == null) __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].replace('/main');
		}).catch(function (err) {
			return console.log(err);
		});
	},
	mounted: function mounted() {
		var _this5 = this;

		fetch(__WEBPACK_IMPORTED_MODULE_29__constants__["a" /* DB */] + ACTION_TYPE, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			if (res) {
				var tmp = [];
				for (var i = 1; i < res.length; i++) {
					tmp.push({ id: +res[i].id, name: res[i].name, value: 0 });
				}
				_this5.mzl = tmp;
			} else _this5.mzl = [];
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_29__constants__["a" /* DB */] + LPO_FILIALS, {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (data) {
			if (data) {
				_this5.lpo_filials = data;
			}
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_29__constants__["a" /* DB */] + ORGANIZATION_LPO, {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (data) {
			if (data) {
				_this5.organization_types = data;
			}
		}).catch(function (err) {
			return console.log(err);
		});

		//console.warn('params', this.$route.params)

		if (this.$route.params && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$route.params) && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$route.params).length) {
			var p = this.$route.params;
			this.f_2 = p.act_num;

			this.f_1 = p.date_of_realization;
			this.f_5 = p.date_of_approval;
			this.f_3 = p.date_of_publication;

			this.f_13 = p.s_lpo.replace('.', ',');

			this.f_89 = +p.lpo_method_id;
			//this.f_90 = +p.lpo_mode_id

			if (p.lines && p.lines.length) {
				var _iteratorNormalCompletion4 = true;
				var _didIteratorError4 = false;
				var _iteratorError4 = undefined;

				try {
					for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(p.lines), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
						var line = _step4.value;

						var obj = {};
						for (var i = 16; i <= 27; i++) {
							obj['f_' + i] = '';
						}
						obj.correct_f_17 = line.area ? '' : 'field-error';
						obj.correct_f_20 = line.localforestry_id ? '' : 'field-error';
						obj.correct_f_21 = line.section_s ? '' : 'field-error';
						obj.correct_f_22 = line.action_s ? '' : 'field-error';
						obj.correct_f_24 = line.section ? '' : 'field-error';

						obj.f_20 = line.localforestry_id;
						obj.f_17 = line.area;
						obj.f_24 = line.section;
						obj.f_21 = line.section_s;
						obj.f_25 = line.lp_section;
						obj.f_23 = line.lp_section_s;

						obj.f_111 = line.composition;
						obj.f_112 = line.age;
						obj.f_113 = line.сompleteness;
						obj.f_114 = line.reserve;

						obj.f_131 = line.sks;

						obj.f_22 = line.action_s;
						obj.f_116 = line.volume;
						obj.f_18 = line.comment;

						if (line.protection_cat_ext_id) {
							obj.f_105 = +line.protection_cat_ext_id;
						}
						if (line.species_id) {
							obj.f_26 = +line.species_id;
						}
						if (line.damages_id) {
							obj.f_19 = +line.damages_id;
						}
						if (line.action_id) {
							obj.f_16 = +line.action_id;
						}
						if (line.purpose_id) {
							obj.f_104 = +line.purpose_id;
						}

						this.lines.push(obj);
					}
				} catch (err) {
					_didIteratorError4 = true;
					_iteratorError4 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion4 && _iterator4.return) {
							_iterator4.return();
						}
					} finally {
						if (_didIteratorError4) {
							throw _iteratorError4;
						}
					}
				}

				this.lines_correct = '';

				this.addSLP(false);
				this.addSAT(false);
			}

			__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$emit('add_region', +p.region_id);
			__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$emit('add_forestry', +p.forestry_id, false);
		}
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$off('add_region');
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$off('add_forestry');
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$off('add_localforestry');
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$off('add_subforestry');
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$off('conclusion_user');
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$off('species');
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$off('organization');
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$off('action_type');
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$off('deletion_reason');
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$off('damages');
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$off('lpo_reason');
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$off('lpo_method');
		__WEBPACK_IMPORTED_MODULE_30__lib_EventBus__["a" /* EventBus */].$off('lpo_mode');
	},

	watch: {
		lines: {
			handler: function handler(val, oldVal) {
				this.checkS_LPO();
				this.value_summ = 0;
				for (var line in this.lines) {
					if (this.lines[line].f_21 != undefined) this.lines[line].f_21 = this.lines[line].f_21.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "");

					if (this.lines[line].f_112 != undefined) this.lines[line].f_112 = this.lines[line].f_112.replace(/[^\d]/g, "");

					if (this.lines[line].f_113 != undefined) this.lines[line].f_113 = this.lines[line].f_113.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "");

					if (this.lines[line].f_114 != undefined) this.lines[line].f_114 = this.lines[line].f_114.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "");

					if (this.lines[line].f_131 != undefined) this.lines[line].f_131 = this.lines[line].f_131.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "");

					if (this.lines[line].f_116 != undefined) {
						this.lines[line].f_116 = this.lines[line].f_116.replace(/[,]/g, ".").replace(/[.]{2,}/g, ".").replace(/[^\.\d]/g, "");
						this.value_summ += Number(this.lines[line].f_116);
					}

					this.lines[line].correct_f_22 = !this.lines[line].f_22 || !this.lines[line].f_22.length ? 'field-error' : 'place-success';
					this.lines[line].correct_f_23 = Number(this.lines[line].f_23) > Number(this.lines[line].f_21) ? 'field-error' : 'place-success';
				}

				this.value_summ = this.floatConvert(this.value_summ);
			},
			deep: true
		},
		f_2: function f_2(e) {
			this.fields_correct.f_2 = e === '' ? 'field-error' : '';
		},
		f_13: function f_13(e) {
			this.fields_correct.f_13 = e === '' ? 'field-error' : '';
			this.checkS_LPO();
		},
		f_115: function f_115(e) {
			if (!e) {
				this.fields_correct.f_115 = '';
				return;
			}

			var r = new RegExp("^-?\\d*(\\.\\d+)?$", "g"); //numeric
			this.fields_correct.f_115 = r.test(e) ? '' : 'field-error';
		},
		f_1: function f_1(e) {
			var arr_f_5 = this.f_5.split('.');
			var date_f_5 = new Date(+arr_f_5[2], +arr_f_5[1] - 1, +arr_f_5[0]);
			var arr_f_1 = this.f_1.split('.');
			var date_f_1 = new Date(+arr_f_1[2], +arr_f_1[1] - 1, +arr_f_1[0]);
			if (date_f_5 < date_f_1) {
				this.fields_correct.f_1 = 'field-error';
				this.fields_correct.f_5 = 'field-error';
			} else {
				this.fields_correct.f_1 = e === '' || e === null ? 'field-error' : 'field-success';
				this.fields_correct.f_5 = this.f_5 === '' || this.f_5 === null ? 'field-error' : 'field-success';
			}
		},
		f_5: function f_5(e) {
			var arr_f_5 = this.f_5.split('.');
			var date_f_5 = new Date(+arr_f_5[2], +arr_f_5[1] - 1, +arr_f_5[0]);
			var arr_f_1 = this.f_1.split('.');
			var date_f_1 = new Date(+arr_f_1[2], +arr_f_1[1] - 1, +arr_f_1[0]);
			if (date_f_5 < date_f_1) {
				this.fields_correct.f_1 = 'field-error';
				this.fields_correct.f_5 = 'field-error';
			} else {
				this.fields_correct.f_1 = this.f_5 === '' || this.f_5 === null ? 'field-error' : 'field-success';
				this.fields_correct.f_5 = e === '' || e === null ? 'field-error' : 'field-success';
			}
		},
		mzl: function mzl(e) {
			var result = this.mzl.slice(0);
			for (var _e in result) {
				if (result[_e].name == 'РАД') {
					this.mzlRAD = result[_e];
					result.splice(_e, 1);
				}
			}
			this.mzlNoRAD = result;
			this.mzlRAD = this.mzlRAD ? this.mzlRAD : { name: 'РАД', value: '0' };
		},
		f_126: function f_126(e) {
			this.fields_correct.f_126 = e === null ? 'field-error' : 'field-success';
		},
		f_127: function f_127(e) {
			this.fields_correct.f_127 = !e ? 'field-error' : 'field-success';
		},
		f_128: function f_128(e) {
			this.fields_correct.f_128 = !e ? 'field-error' : 'field-success';
		},
		f_130: function f_130(e) {
			this.fields_correct.f_130 = !e ? 'field-error' : 'field-success';
		}
	}
});

function commaToPeriod(str) {
	return str.replace(/,/g, ".");
}

/***/ }),

/***/ "0pd7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Filter__ = __webpack_require__("XKhj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FilterDateRange__ = __webpack_require__("aXt2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_css_fontawesome_all_min_css__ = __webpack_require__("ThaU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_css_fontawesome_all_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__lib_css_fontawesome_all_min_css__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// const TABLE = 'get_journal.php'
var TABLE = 'get_journal.php';
// const TABLE = 'get_journal_new.php'
var FILTER_TABLE = 'get_journal_filter.php';
var GET_JOURNAL_YEARS = "get_journal_years.php";
var COUNT_OF_FILTERS = 13;
var PADDING = 3;









/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'list',
	data: function data() {
		return {
			lines: [],
			selected: 0,
			pages: [],
			active: 1,
			pages_count: 1,
			cf_count: 0,
			loading: false,
			years: [],
			selected_year: null,

			filter: {
				num: [],
				act_placement_date: [],
				url: [],
				fo: [],
				region: [],
				forestry: [],
				localforestry: [],
				subforestry: [],
				area: [],
				section: [],
				section_lp: [],
				conclusion_date: [],
				conclusion_num: [],
				page_num: null
			}
		};
	},

	components: {
		filterTable: __WEBPACK_IMPORTED_MODULE_5__Filter__["a" /* default */], filterTableDateRange: __WEBPACK_IMPORTED_MODULE_6__FilterDateRange__["a" /* default */]
	},
	watch: {
		selected_year: function selected_year(newVal, oldVal) {
			if (oldVal === null) {
				return;
			}
			this.filter_lines();
		}
	},
	methods: {
		isNumeric: function isNumeric(x) {
			return !__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(+x);
		},
		select_line: function select_line(i) {
			if (!this.lines[i].flag) {
				var k = i;
				while (!this.lines[k].flag) {
					k--;
				}

				i = k;
			}

			this.selected = i;

			for (var j = 0; j < this.lines.length; j++) {
				if (this.lines[j].flag) {
					this.lines[j].selected = i === j;
				} else {
					var _k = j;
					while (!this.lines[_k].flag) {
						_k--;
					}
					for (var l = 0; l < this.lines[_k].count; l++) {
						this.lines[j].selected = i === _k;
					}
				}
			}

			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('act_id', this.lines[i].id);

			// document.getElementById(i).checked = true
			//EventBus.$emit('can_edit', {act: this.lines[i].can_edit_act, conclusion: this.lines[i].can_edit_conclusion, warrant: this.lines[i].can_edit_warrant})
		},
		fetch_lines: function fetch_lines(start) {
			var _this = this;

			document.querySelector('.l-body-wrapper').scrollTop = 0;
			this.loading = true;
			var temp_lines = [];
			var temp_pages = [];

			var where = '(';
			for (var f in this.filter) {
				if (f == 'conclusion_date' || f == 'act_placement_date') {
					if (this.filter[f].length == 2) {
						var from = this.filter[f][0];
						var to = this.filter[f][1];
						where += f + ' BETWEEN \'' + from + '\' AND \'' + to + '\'  or ';
					}
				} else {
					for (var i = 0; i < this.filter[f].length; i++) {
						if (f !== this.field) where += this.filter[f][i] !== '' ? f + '=\'' + this.filter[f][i] + '\' or ' : f + ' is null or ';
					}
				}

				if (f !== this.field) {
					where = this.filter[f].length !== 0 ? where.slice(0, -4) : where;
					where += this.filter[f].length !== 0 ? ') and (' : '';
				}
			}
			where = where.slice(0, -6);
			if (where) where = '&filter=' + where;

			fetch(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + FILTER_TABLE + ('?start=' + start + '&rows=' + __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ROWS_ON_PAGE */] + where), {
				// fetch(DB + TABLE, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				var prev_id = -1;
				var prev_localforestry_id = -1;
				var prev_subforestry_id = -1;
				for (var _i = 0; _i < res.length - 1; _i++) {
					var act = {};

					var start_fo = _i;
					while (_i > 0 && res[start_fo - 1].act_id === res[_i].act_id && start_fo > 1) {
						start_fo--;
					}

					var curr = start_fo;
					while (curr < res.length && res[curr].act_id === res[start_fo].act_id) {
						curr++;
					}
					act.count = curr - start_fo;

					if (res[_i].act_id === prev_id) {
						act.flag = false;
					} else {
						act.flag = true;
					}
					//////////////////

					var start_lf = _i;
					while (_i > 0 && res[start_lf - 1].localforestry_id === res[_i].localforestry_id && start_lf > 1 && res[start_lf - 1].act_id === res[_i].act_id) {
						start_lf--;
					}

					var curr_lf = start_lf;
					while (curr_lf < res.length && res[curr_lf].act_id === res[start_lf].act_id && res[curr_lf].localforestry_id === res[_i].localforestry_id) {
						curr_lf++;
					}
					act.count_lf = curr_lf - start_lf;

					if (res[_i].act_id === prev_id && prev_localforestry_id === res[_i].localforestry_id) {
						act.flag_lf = false;
					} else {
						act.flag_lf = true;
					}

					////////////////////////
					var start_sf = _i;
					while (_i > 0 && res[start_sf - 1].localforestry_id === res[_i].localforestry_id && start_sf > 1 && res[start_sf - 1].act_id === res[_i].act_id) {
						start_sf--;
					}

					var curr_sf = start_sf;
					while (curr_sf < res.length && res[curr_sf].act_id === res[start_sf].act_id && res[curr_sf].localforestry_id === res[_i].localforestry_id) {
						curr_sf++;
					}
					act.count_sf = curr_sf - start_sf;

					if (res[_i].act_id === prev_id && prev_localforestry_id === res[_i].localforestry_id) {
						act.flag_sf = false;
					} else {
						act.flag_sf = true;
					}
					////////////////////////


					prev_id = res[_i].act_id;
					prev_localforestry_id = res[_i].localforestry_id;
					prev_subforestry_id = res[_i].subforestry_id;

					act.id = res[_i].act_id;
					act.act_placement_date = res[_i].act_placement_date;
					act.num = res[_i].num;
					act.url = res[_i].url;
					act.fo = res[_i].fo;
					act.region = res[_i].region;
					act.forestry = res[_i].forestry;
					act.localforestry = res[_i].localforestry;
					act.subforestry = res[_i].subforestry;
					act.area = res[_i].area;
					act.section = res[_i].section;
					act.section_lp = res[_i].section_lp;
					act.conclusion_date = res[_i].conclusion_date ? __WEBPACK_IMPORTED_MODULE_7_moment___default()(res[_i].conclusion_date, 'YYYY-MM-DD').format('DD.MM.YYYY') : '';
					act.conclusion_num = res[_i].conclusion_num;
					act.selected = false;

					temp_lines.push(act);
				}

				_this.lines = temp_lines;

				temp_lines = [];

				// this.pages = temp_pages

				_this.lines[0].selected = true;

				if (!_this.lines[1].flag) {
					var k = 1;
					while (!_this.lines[k].flag) {
						_this.lines[k].selected = true;
						k++;
					}
				}

				__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('act_id', _this.lines[0].id);
				_this.loading = false;
			}).catch(function (err) {
				return console.log(err);
			});
		},
		select_page: function select_page(e) {
			var _this2 = this;

			var value = e;
			if (!this.isNumeric(value)) value = +e.target.getAttribute('data-value');

			this.fetch_lines((value - 1) * __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ROWS_ON_PAGE */] + 1);
			this.active = value;
			this.page_num = value;
			var temp_pages = [];

			if (this.active - 1 > PADDING) {
				temp_pages.push({ active: false, num: 1 });

				if (this.active - 2 > PADDING) temp_pages.push({ active: false, num: '...' });
			}

			for (var i = this.active - PADDING - 1; i < this.active + PADDING; i++) {
				if (i >= 0 && i < this.pages_count) temp_pages.push({ active: false, num: i + 1 });
			}if (this.active < this.pages_count - PADDING) {
				if (this.active + 1 < this.pages_count - PADDING) temp_pages.push({ active: false, num: '...' });

				temp_pages.push({ active: false, num: this.pages_count });
			}

			this.pages = temp_pages;

			this.pages.forEach(function (p) {
				p.active = p.num == _this2.active;
			});

			//this.pages[value - 1].active = true
		},
		clearFilters: function clearFilters() {
			this.cf_count = 0;
			this.$parent.selected_filters = {};
			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('clearFilters');
		},
		filter_lines: function filter_lines() {
			var _this3 = this;

			var save_page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var temp_lines, temp_pages, where, f, from, to, i, start, t;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (!(!_this3.years || !_this3.years.length || !_this3.selected_year)) {
									_context.next = 3;
									break;
								}

								_context.next = 3;
								return _this3.getJournalYears();

							case 3:
								document.querySelector('.l-body-wrapper').scrollTop = 0;
								_this3.loading = true;
								temp_lines = [];
								temp_pages = [];
								where = '(';

								for (f in _this3.filter) {
									if (f == 'conclusion_date' || f == 'act_placement_date') {
										if (_this3.filter[f].length == 2) {
											from = _this3.filter[f][0];
											to = _this3.filter[f][1];

											where += f + ' BETWEEN \'' + from + '\' AND \'' + to + '\'  or ';
										}
									} else {
										for (i = 0; i < _this3.filter[f].length; i++) {
											if (f !== _this3.field) where += _this3.filter[f][i] !== '' ? f + '=\'' + _this3.filter[f][i] + '\' or ' : f + ' is null or ';
										}
									}

									if (f !== _this3.field) {
										where = _this3.filter[f].length !== 0 ? where.slice(0, -4) : where;
										where += _this3.filter[f].length !== 0 ? ') and (' : '';
									}
								}
								where = where.slice(0, -6);
								if (where && where.length) {
									where += ' and ';
								}
								where += '(act_placement_date BETWEEN \'' + _this3.selected_year + '-01-01\' AND \'' + _this3.selected_year + '-12-31\')';

								start = 1;

								//console.warn('save_page 1', save_page, this.active, this.page_num)

								if (save_page) {
									start = (_this3.page_num - 1) * __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ROWS_ON_PAGE */] + 1;
									//this.active = this.page_num
								} else if (_this3.$route.params.id || _this3.$parent.act_id) {
									start = (_this3.page_num - 1) * __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ROWS_ON_PAGE */] + 1;
									_this3.active = _this3.page_num;
								}

								//console.warn('save_page 2', save_page, this.active, this.page_num)

								t = TABLE + ('?start=' + start + '&rows=' + __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ROWS_ON_PAGE */]);

								if (where) {
									t = FILTER_TABLE + ('?start=' + start + '&rows=' + __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ROWS_ON_PAGE */] + '&filter=' + where);
								}

								fetch(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + t, {
									credentials: 'include'
								}).then(function (res) {
									return res.json();
								}).then(function (res) {
									var prev_id = -1;
									var prev_localforestry_id = -1;
									var prev_subforestry_id = -1;

									var length = !!where ? res.length : res.length - 1;

									for (var _i2 = 0; _i2 < length; _i2++) {
										var act = {};

										var start_fo = _i2;
										while (_i2 > 0 && res[start_fo - 1].act_id === res[_i2].act_id && start_fo > 1) {
											start_fo--;
										}

										var curr = start_fo;
										while (curr < res.length && res[curr].act_id === res[start_fo].act_id) {
											curr++;
										}
										act.count = curr - start_fo;

										if (res[_i2].act_id === prev_id) {
											act.flag = false;
										} else {
											act.flag = true;
										}
										//////////////////

										var start_lf = _i2;
										while (_i2 > 0 && res[start_lf - 1].localforestry_id === res[_i2].localforestry_id && start_lf > 1 && res[start_lf - 1].act_id === res[_i2].act_id) {
											start_lf--;
										}

										var curr_lf = start_lf;
										while (curr_lf < res.length && res[curr_lf].act_id === res[start_lf].act_id && res[curr_lf].localforestry_id === res[_i2].localforestry_id) {
											curr_lf++;
										}
										act.count_lf = curr_lf - start_lf;

										if (res[_i2].act_id === prev_id && prev_localforestry_id === res[_i2].localforestry_id) {
											act.flag_lf = false;
										} else {
											act.flag_lf = true;
										}

										////////////////////////
										var start_sf = _i2;
										while (_i2 > 0 && res[start_sf - 1].localforestry_id === res[_i2].localforestry_id && start_sf > 1 && res[start_sf - 1].act_id === res[_i2].act_id) {
											start_sf--;
										}

										var curr_sf = start_sf;
										while (curr_sf < res.length && res[curr_sf].act_id === res[start_sf].act_id && res[curr_sf].localforestry_id === res[_i2].localforestry_id) {
											curr_sf++;
										}
										act.count_sf = curr_sf - start_sf;

										if (res[_i2].act_id === prev_id && prev_localforestry_id === res[_i2].localforestry_id) {
											act.flag_sf = false;
										} else {
											act.flag_sf = true;
										}
										////////////////////////


										prev_id = res[_i2].act_id;
										prev_localforestry_id = res[_i2].localforestry_id;
										prev_subforestry_id = res[_i2].subforestry_id;

										act.id = res[_i2].act_id;
										act.num = res[_i2].num;
										act.act_placement_date = res[_i2].act_placement_date ? __WEBPACK_IMPORTED_MODULE_7_moment___default()(res[_i2].act_placement_date, 'YYYY-MM-DD').format('DD.MM.YYYY') : '';
										act.url = res[_i2].url;
										act.fo = res[_i2].fo;
										act.region = res[_i2].region;
										act.forestry = res[_i2].forestry;
										act.localforestry = res[_i2].localforestry;
										act.subforestry = res[_i2].subforestry;
										act.area = res[_i2].area;
										act.section = res[_i2].section;
										act.section_lp = res[_i2].section_lp;
										act.conclusion_date = res[_i2].conclusion_date ? __WEBPACK_IMPORTED_MODULE_7_moment___default()(res[_i2].conclusion_date, 'YYYY-MM-DD').format('DD.MM.YYYY') : '';
										act.conclusion_num = res[_i2].conclusion_num;
										act.selected = false;

										temp_lines.push(act);
									}

									//if (!where) {
									//let count = Math.round(res[res.length - 1].count / ROWS_ON_PAGE)
									_this3.pages_count = Math.round(res[res.length - 1].count / __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ROWS_ON_PAGE */]);
									temp_pages = [];

									if (_this3.active > PADDING) {
										temp_pages.push({ active: false, num: 1 });
										temp_pages.push({ active: false, num: '...' });
									}

									for (var _i3 = _this3.active - PADDING; _i3 < _this3.active + PADDING; _i3++) {
										if (_i3 >= 0 && _i3 < _this3.pages_count) temp_pages.push({ active: false, num: _i3 + 1 });
									}

									if (_this3.active < _this3.pages_count - PADDING) {
										temp_pages.push({ active: false, num: '...' });
										temp_pages.push({ active: false, num: _this3.pages_count });
									}

									_this3.pages = temp_pages;
									_this3.pages.forEach(function (p) {
										p.active = p.num == _this3.active;
									});
									//}

									_this3.lines = temp_lines;

									if (_this3.$route.params.id || _this3.$parent.act_id) {
										var act_id = _this3.$route.params.id || _this3.$parent.act_id;
										var found = false;
										for (var _i4 = 0; _i4 < _this3.lines.length; _i4++) {
											if (_this3.lines[_i4].id == act_id) {
												_this3.select_line(_i4);

												_this3.$nextTick(function () {
													var selected_row = document.querySelector("tr.selected");
													if (selected_row) selected_row.scrollIntoView(true);
												});

												found = true;
												break;
											}
										}
										if (!found) _this3.select_line(0);
									} else {
										_this3.select_line(0);
									}

									_this3.loading = false;
								}).catch(function (err) {
									return console.log(err);
								});

							case 17:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this3);
			}))();
		},
		resizeList: function resizeList() {
			var dispay_height = document.documentElement.clientHeight - 234;
			document.querySelector('.l-body-wrapper').style.maxHeight = dispay_height + 'px';
		},
		getJournalYears: function getJournalYears() {
			var _this4 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return fetch(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + GET_JOURNAL_YEARS, {
									credentials: 'include'
								}).then(function (res) {
									return res.json();
								}).then(function (json) {
									if (json && json.length) {
										_this4.years = json.map(function (e) {
											return e.years;
										});
										_this4.selected_year = _this4.years[0];
									}
								});

							case 2:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this4);
			}))();
		}
	},
	created: function created() {},
	mounted: function mounted() {
		var _this5 = this;

		this.$parent.lastJournalURL = '/main';

		this.getJournalYears();

		__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$on('filter_list', function (f) {
			console.warn('filter_list');
			_this5.filter[f.field] = f.value !== '' ? f.value : null;

			_this5.active = 1;
			if (f.cf) //clearFilters
				{
					_this5.cf_count++;
					if (_this5.cf_count == COUNT_OF_FILTERS) _this5.filter_lines();
				} else _this5.filter_lines();
		});

		this.page_num = this.$parent.page_num ? this.$parent.page_num : 1;
		this.active = this.page_num;

		this.filter = this.$parent.filter;
		this.filter_lines();

		// const w = document.documentElement.clientWidth - 50
		// document.querySelector('.main_table_wrapper').style.width = `${w}px`

		////////////////////////////////////////////

		var dispay_width = document.documentElement.clientWidth;
		// const dispay_height = document.documentElement.clientHeight - 146
		var dispay_height = document.documentElement.clientHeight - 234;
		var scroll_width = 17;

		var ua = navigator.userAgent;

		if (ua.search('OPR/') > 0) {
			scroll_width = 15;
		}

		var table_width = dispay_width - scroll_width;
		var col_width = Math.floor(table_width / 11);
		// 
		var large_width = table_width - col_width * 9;

		// console.log(col_width, large_width, table_width, col_width * 9 + large_width)


		document.querySelectorAll('.l-td').forEach(function (td) {
			td.width = col_width;
		});
		document.querySelectorAll('.large-td').forEach(function (td) {
			td.width = large_width;
		});
		document.querySelector('.l-header-wrapper').width = dispay_width;
		document.querySelector('.l-body-wrapper').width = dispay_width;
		document.querySelector('.l-body-wrapper').style.maxHeight = dispay_height + 'px';

		// console.log(dispay_height, dispay_width, col_width, table_width)
		// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))

		document.querySelector('.l-scroll').width = scroll_width;

		window.addEventListener('resize', this.resizeList, true);

		__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$on('delete_act', function () {
			_this5.filter_lines(true);
		});
	},
	beforeDestroy: function beforeDestroy() {
		//this.lines = []
		__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$off('filter_list');
		__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$off('delete_act');
		//EventBus.$emit('save-filter', {f: this.filter})
		__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('save-page', this.active);
		window.removeEventListener('resize', this.resizeList, true);
	}
});

/***/ }),

/***/ "19Ik":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subforestry_vue__ = __webpack_require__("JlOi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83bba638_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_subforestry_vue__ = __webpack_require__("/uIn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subforestry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83bba638_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_subforestry_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1AyV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Fbt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var REASON = 'get_deletion_reason.php';
var ACT_INFO = 'get_act_info.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'reason',
	data: function data() {
		return {
			selected: '0',
			options: []
		};
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('edit_deletion_reason', this.selected);
		}
	},
	created: function created() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + ACT_INFO + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			return res[0].f_8;
		}).then(function (id) {
			fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + REASON, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.options = data;
					_this.selected = id;
				} else {
					_this.options = [];
					_this.selected = '0';
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}).catch(function (err) {
			return console.log(err);
		});
	}
});

/***/ }),

/***/ "1elM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{key:option.id,domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1lZM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control table-control my-control",attrs:{"id":'subforestry_id_' + this.id,"data-num":"f_27","data-table":"1"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "20Kl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_warrantTableField_vue__ = __webpack_require__("Pf7y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3897e1a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_warrantTableField_vue__ = __webpack_require__("fraP");
function injectStyle (ssrContext) {
  __webpack_require__("gDJV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3897e1a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_warrantTableField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3897e1a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_warrantTableField_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2HvF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_actionType_vue__ = __webpack_require__("T8Q6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28af0755_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_actionType_vue__ = __webpack_require__("IhVI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_actionType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28af0755_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_actionType_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2Isl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_actionType_vue__ = __webpack_require__("tDd1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67480c86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_actionType_vue__ = __webpack_require__("z/Fz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_actionType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67480c86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_actionType_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2MEK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_actsNumsSelector_vue__ = __webpack_require__("IhTn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55af7e54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_actsNumsSelector_vue__ = __webpack_require__("cpQa");
function injectStyle (ssrContext) {
  __webpack_require__("4ONa")
  __webpack_require__("ePV6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55af7e54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_actsNumsSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55af7e54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_actsNumsSelector_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2nlc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_species_vue__ = __webpack_require__("t9MA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68032d5f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_species_vue__ = __webpack_require__("h+JD");
function injectStyle (ssrContext) {
  __webpack_require__("mXRx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_species_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68032d5f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_species_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2wgW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var ORGANIZATION_PROPERTY = 'get_organization_property.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'regOrganizationProperty',
	data: function data() {
		return {
			selected: '0',
			options: []
		};
	},
	props: {
		set_id: '',
		field_class: '',
		org_id: '',
		id: null
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('reg-organization-property', this.selected);
		}
	},
	mounted: function mounted() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + ORGANIZATION_PROPERTY + '?org_id=' + this.$props.org_id, {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (data) {
			if (data) {
				_this.options = data;
				_this.selected = _this.$props.id ? _this.$props.id : data[0].id;
				_this.change();
			} else {
				_this.options = [];
			}
		}).catch(function (err) {
			return console.log(err);
		});
	}
});

/***/ }),

/***/ "3VDO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Y0u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr'),_vm._v(" "),_c('div',{staticClass:"m-header-wrapper"},[_c('table',{staticClass:"m-header"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.rows),function(row,i){return _c('tr',[_c('td',[_vm._v(_vm._s(row.fo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.count))])])}))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bold"},[_c('tr',[_c('td',{staticClass:"m-td"},[_vm._v("Федеральный округ")]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("Количество")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3uqE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4+An":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4+jQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TerritoryFilter_vue__ = __webpack_require__("gPHc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb59f012_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TerritoryFilter_vue__ = __webpack_require__("JmJV");
function injectStyle (ssrContext) {
  __webpack_require__("QMgY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TerritoryFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb59f012_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TerritoryFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4/07":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NpaMzl_vue__ = __webpack_require__("CSBt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3e25d36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NpaMzl_vue__ = __webpack_require__("AGzF");
function injectStyle (ssrContext) {
  __webpack_require__("1AyV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f3e25d36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NpaMzl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3e25d36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NpaMzl_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "41F9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr'),_vm._v(" "),_c('div',{staticClass:"m-header-wrapper"},[_c('table',{staticClass:"m-header"},[_c('thead',{staticClass:"bold"},[_c('tr',[_c('th',{attrs:{"rowspan":"4"}},[_vm._v("Федеральные округа, субъекты РФ")]),_vm._v(" "),_c('th',{attrs:{"rowspan":"4"}},[_vm._v("Количество актов ЛПО размещённых на сайтах с "+_vm._s(_vm.start)+" по "+_vm._s(_vm.end))]),_vm._v(" "),_c('th',{attrs:{"colspan":"4"}},[_vm._v("Блок ФБУ «Рослесозащита»")]),_vm._v(" "),_c('th',{attrs:{"colspan":"10"}},[_vm._v("Блок Департаментов")]),_vm._v(" "),_c('td',{staticClass:"m-scroll",attrs:{"rowspan":"5"}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)])])]),_vm._v(" "),_c('div',{staticClass:"m-body-wrapper"},[_c('table',{staticClass:"m-body"},[_c('tbody',_vm._l((_vm.rows),function(row,i){return _c('tr',{key:row.region + i,class:(row.bold ? "bold" :"")},[(row.new_fo)?_c('td',{attrs:{"colspan":"16"}},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(row.fo))])]):_vm._e(),_vm._v(" "),(!row.new_fo)?_c('td',{staticClass:"left m-td"},[_vm._v(_vm._s(row.region))]):_vm._e(),_vm._v(" "),(!row.new_fo)?_c('td',{staticClass:"right m-td"},[_vm._v(_vm._s(row.whole))]):_vm._e(),_vm._v(" "),(!row.new_fo)?_c('td',{staticClass:"right m-td"},[_vm._v(_vm._s(row.from_dept))]):_vm._e(),_vm._v(" "),(!row.new_fo)?_c('td',{staticClass:"right m-td"},[_vm._v(_vm._s(row.conclusion_complete))]):_vm._e(),_vm._v(" "),(!row.new_fo)?_c('td',{staticClass:"right m-td"},[_vm._v(_vm._s(row.pct_concl_whole))]):_vm._e(),_vm._v(" "),(!row.new_fo)?_c('td',{staticClass:"right m-td"},[_vm._v(_vm._s(row.pct_concl_dept))]):_vm._e(),_vm._v(" "),(!row.new_fo)?_c('td',{staticClass:"right m-td"},[_vm._v(_vm._s(row.from_fo))]):_vm._e(),_vm._v(" "),(!row.new_fo)?_c('td',{staticClass:"right m-td"},[_vm._v(_vm._s(row.warrant_complete))]):_vm._e(),_vm._v(" "),(!row.new_fo)?_c('td',{staticClass:"right m-td"},[_vm._v(_vm._s(row.pct_warr_whole))]):_vm._e(),_vm._v(" "),(!row.new_fo)?_c('td',{staticClass:"right m-td"},[_vm._v(_vm._s(row.pct_warr_fo))]):_vm._e(),_vm._v(" "),(!row.new_fo)?_c('td',{staticClass:"right m-td"},[_vm._v(_vm._s(row.warrant_draft))]):_vm._e(),_vm._v(" "),(!row.new_fo)?_c('td',{staticClass:"right m-td"},[_vm._v(_vm._s(row.pct_warr_draft_whole))]):_vm._e(),_vm._v(" "),(!row.new_fo)?_c('td',{staticClass:"right m-td"},[_vm._v(_vm._s(row.pct_warr_draft_fo))]):_vm._e(),_vm._v(" "),(!row.new_fo)?_c('td',{staticClass:"right m-td"},[_vm._v(_vm._s(row.warrant_empty))]):_vm._e(),_vm._v(" "),(!row.new_fo)?_c('td',{staticClass:"right m-td"},[_vm._v(_vm._s(row.pct_warr_empty_whole))]):_vm._e(),_vm._v(" "),(!row.new_fo)?_c('td',{staticClass:"right m-td"},[_vm._v(_vm._s(row.pct_warr_empty_fo))]):_vm._e()])}))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Количество актов ЛПО, поступивших от Департаметов")]),_vm._v(" "),_c('td',{attrs:{"colspan":"3","rowspan":"2"}},[_vm._v("по которым данные заполнены")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Количество актов ЛПО, поступивших от субъектов")]),_vm._v(" "),_c('td',{attrs:{"colspan":"9"}},[_vm._v("по которым данные")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"3"}},[_vm._v("заполнены")]),_vm._v(" "),_c('td',{attrs:{"colspan":"3"}},[_vm._v("заполнены в статусе «Черновик»")]),_vm._v(" "),_c('td',{attrs:{"colspan":"3"}},[_vm._v("не заполнены")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("шт.")]),_vm._v(" "),_c('td',[_vm._v("шт.")]),_vm._v(" "),_c('td',[_vm._v("% от количества размещённых актов ЛПО")]),_vm._v(" "),_c('td',[_vm._v("% от количества поступивших актов ЛПО")]),_vm._v(" "),_c('td',[_vm._v("шт.")]),_vm._v(" "),_c('td',[_vm._v("шт.")]),_vm._v(" "),_c('td',[_vm._v("% от количества размещённых актов ЛПО")]),_vm._v(" "),_c('td',[_vm._v("% от количества поступивших актов ЛПО")]),_vm._v(" "),_c('td',[_vm._v("шт.")]),_vm._v(" "),_c('td',[_vm._v("% от количества размещённых актов ЛПО")]),_vm._v(" "),_c('td',[_vm._v("% от количества поступивших актов ЛПО")]),_vm._v(" "),_c('td',[_vm._v("шт.")]),_vm._v(" "),_c('td',[_vm._v("% от количества размещённых актов ЛПО")]),_vm._v(" "),_c('td',[_vm._v("% от количества поступивших актов ЛПО")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("2")]),_vm._v(" "),_c('td',[_vm._v("3")]),_vm._v(" "),_c('td',[_vm._v("4")]),_vm._v(" "),_c('td',[_vm._v("5")]),_vm._v(" "),_c('td',[_vm._v("6")]),_vm._v(" "),_c('td',[_vm._v("7")]),_vm._v(" "),_c('td',[_vm._v("8")]),_vm._v(" "),_c('td',[_vm._v("9")]),_vm._v(" "),_c('td',[_vm._v("10")]),_vm._v(" "),_c('td',[_vm._v("11")]),_vm._v(" "),_c('td',[_vm._v("12")]),_vm._v(" "),_c('td',[_vm._v("13")]),_vm._v(" "),_c('td',[_vm._v("14")]),_vm._v(" "),_c('td',[_vm._v("15")]),_vm._v(" "),_c('td',[_vm._v("16")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "45dX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var ACT_INFO = 'get_act_info.php';
var LPO_REASON = 'get_lpo_reason.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'lpoReason',
	data: function data() {
		return {
			selected: '2',
			options: []
		};
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('edit_lpo_reason', this.selected);
		}
	},
	created: function created() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + ACT_INFO + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			return res[0].f_88;
		}).then(function (id) {
			fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + LPO_REASON, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.options = data;
					_this.selected = id ? id : data[0].id;
				} else {
					_this.options = [];
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}).catch(function (err) {
			return console.log(err);
		});
	}
});

/***/ }),

/***/ "4ONa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4ga3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-md-1"},[_vm._v("\n\t\tФедеральный округ\n\t")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_fo),expression:"selected_fo"}],staticClass:"form-control my-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected_fo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.options_fo),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t\t\t"+_vm._s(option.name)+"\n\t\t\t")])}))]),_vm._v(" "),_c('div',{staticClass:"col-md-1 text-center"},[_vm._v("\n\t\tСубъект РФ\n\t")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_region),expression:"selected_region"}],staticClass:"form-control my-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected_region=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.options_region),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t\t\t"+_vm._s(option.name)+"\n\t\t\t")])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4h8u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_css_fontawesome_all_min_css__ = __webpack_require__("ThaU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_css_fontawesome_all_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lib_css_fontawesome_all_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Filter__ = __webpack_require__("XKhj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FilterDateRange__ = __webpack_require__("aXt2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_strap__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var TABLE = 'get_journal_decisions.php';
var FILTER_TABLE = 'get_journal_decisions.php';
var COUNT_OF_FILTERS = 9;
var PADDING = 3;








/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'ListDecisions',
	data: function data() {
		return {
			lines: [],
			selected: 0,
			pages: [],
			active: 1,
			pages_count: 1,
			cf_count: 0,
			displayAlert: false,
			alwaysFalse: false,

			filter: {
				act_num: [],
				act_placement_date: [],
				conclusion_decision: [],
				fo: [],
				region: [],
				forestry: [],
				conclusion_decision_reason: [],
				warrant_decision: [],
				violation: []
			},

			DBlink: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */],
			journalSuffix: '-decisions'
		};
	},

	components: {
		filterTable: __WEBPACK_IMPORTED_MODULE_4__Filter__["a" /* default */], alert: __WEBPACK_IMPORTED_MODULE_7_vue_strap__["alert"], filterTableDateRange: __WEBPACK_IMPORTED_MODULE_5__FilterDateRange__["a" /* default */]
	},
	methods: {
		isNumeric: function isNumeric(x) {
			return !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(+x);
		},
		select_line: function select_line(i) {
			if (!this.lines[i].flag) {
				var k = i;
				while (!this.lines[k].flag) {
					k--;
				}

				i = k;
			}

			this.selected = i;

			for (var j = 0; j < this.lines.length; j++) {
				if (this.lines[j].flag) {
					this.lines[j].selected = i === j;
				} else {
					var _k = j;
					while (!this.lines[_k].flag) {
						_k--;
					}
					for (var l = 0; l < this.lines[_k].count; l++) {
						this.lines[j].selected = i === _k;
					}
				}
			}

			__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$emit('act_id', this.lines[i].id);

			// document.getElementById(i).checked = true
			//EventBus.$emit('can_edit', {act: this.lines[i].can_edit_act, conclusion: this.lines[i].can_edit_conclusion, warrant: this.lines[i].can_edit_warrant})
		},
		fetch_lines: function fetch_lines(start) {
			var _this = this;

			var temp_lines = [];
			var temp_pages = [];

			var where = '(';
			for (var f in this.filter) {
				var field_name = f;
				field_name = field_name.replace(this.journalSuffix, '');

				if (field_name == 'act_placement_date') {
					if (this.filter[f].length == 2) {
						var from = this.filter[f][0];
						var to = this.filter[f][1];
						where += field_name + ' BETWEEN \'' + from + '\' AND \'' + to + '\'  or ';
					}
				} else {
					for (var i = 0; i < this.filter[f].length; i++) {
						where += this.filter[f][i] !== '' ? field_name + '=\'' + this.filter[f][i] + '\' or ' : field_name + ' is null or ';
					}
				}

				where = this.filter[f].length !== 0 ? where.slice(0, -4) : where;
				where += this.filter[f].length !== 0 ? ') and (' : '';
			}

			where = where.slice(0, -6);
			if (where) where = '&filter=' + where;

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + FILTER_TABLE + ('?start=' + start + '&rows=' + __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */] + where), {
				// fetch(DB + TABLE, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				var prev_id = -1;
				var prev_localforestry_id = -1;
				var prev_subforestry_id = -1;
				for (var _i = 0; _i < res.length - 1; _i++) {
					var act = {};

					var start_fo = _i;
					while (_i > 0 && res[start_fo - 1].act_id === res[_i].act_id && start_fo > 1) {
						start_fo--;
					}

					var curr = start_fo;
					while (curr < res.length && res[curr].act_id === res[start_fo].act_id) {
						curr++;
					}
					act.count = curr - start_fo;

					if (res[_i].act_id === prev_id) {
						act.flag = false;
					} else {
						act.flag = true;
					}
					//////////////////

					var start_lf = _i;
					while (_i > 0 && res[start_lf - 1].localforestry_id === res[_i].localforestry_id && start_lf > 1 && res[start_lf - 1].act_id === res[_i].act_id) {
						start_lf--;
					}

					var curr_lf = start_lf;
					while (curr_lf < res.length && res[curr_lf].act_id === res[start_lf].act_id && res[curr_lf].localforestry_id === res[_i].localforestry_id) {
						curr_lf++;
					}
					act.count_lf = curr_lf - start_lf;

					if (res[_i].act_id === prev_id && prev_localforestry_id === res[_i].localforestry_id) {
						act.flag_lf = false;
					} else {
						act.flag_lf = true;
					}

					////////////////////////
					var start_sf = _i;
					while (_i > 0 && res[start_sf - 1].localforestry_id === res[_i].localforestry_id && start_sf > 1 && res[start_sf - 1].act_id === res[_i].act_id) {
						start_sf--;
					}

					var curr_sf = start_sf;
					while (curr_sf < res.length && res[curr_sf].act_id === res[start_sf].act_id && res[curr_sf].localforestry_id === res[_i].localforestry_id) {
						curr_sf++;
					}
					act.count_sf = curr_sf - start_sf;

					if (res[_i].act_id === prev_id && prev_localforestry_id === res[_i].localforestry_id) {
						act.flag_sf = false;
					} else {
						act.flag_sf = true;
					}
					////////////////////////


					prev_id = res[_i].act_id;
					prev_localforestry_id = res[_i].localforestry_id;
					prev_subforestry_id = res[_i].subforestry_id;

					act.id = res[_i].act_id;
					act.act_num = res[_i].act_num;
					act.act_placement_date = res[_i].act_placement_date;
					act.conclusion_decision = res[_i].conclusion_decision;
					act.conclusion_decision_reason = res[_i].conclusion_decision_reason;
					act.warrant_decision = res[_i].warrant_decision;
					act.violation = res[_i].violation;
					act.fo = res[_i].fo;
					act.region = res[_i].region;
					act.forestry = res[_i].forestry;
					act.selected = false;

					temp_lines.push(act);
				}

				_this.lines = temp_lines;

				temp_lines = [];

				// this.pages = temp_pages

				_this.lines[0].selected = true;

				if (!_this.lines[1].flag) {
					var k = 1;
					while (!_this.lines[k].flag) {
						_this.lines[k].selected = true;
						k++;
					}
				}

				__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$emit('act_id', _this.lines[0].id);
			}).catch(function (err) {
				return console.log(err);
			});
		},
		select_page: function select_page(e) {
			var _this2 = this;

			var value = +e.target.getAttribute('data-value');
			this.fetch_lines((value - 1) * __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */] + 1);
			this.active = value;
			var temp_pages = [];

			if (this.active - 1 > PADDING) {
				temp_pages.push({ active: false, num: 1 });
				temp_pages.push({ active: false, num: '...' });
			}

			for (var i = this.active - PADDING - 1; i < this.active + PADDING; i++) {
				if (i >= 0 && i < this.pages_count) temp_pages.push({ active: false, num: i + 1 });
			}if (this.active < this.pages_count - PADDING) {
				temp_pages.push({ active: false, num: '...' });
				temp_pages.push({ active: false, num: this.pages_count });
			}

			this.pages = temp_pages;

			this.pages.forEach(function (p) {
				p.active = p.num == _this2.active;
			});

			//this.pages[value - 1].active = true
		},
		clearFilters: function clearFilters() {
			this.cf_count = 0;
			__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$emit('clearFilters' + this.journalSuffix);
		},
		filter_lines: function filter_lines() {
			var _this3 = this;

			var temp_lines = [];
			var temp_pages = [];

			var where = '(';
			for (var f in this.filter) {
				var field_name = f;
				field_name = field_name.replace(this.journalSuffix, '');
				if (field_name == 'act_placement_date') {
					if (this.filter[f].length == 2) {
						var from = this.filter[f][0];
						var to = this.filter[f][1];
						where += field_name + ' BETWEEN \'' + from + '\' AND \'' + to + '\'  or ';
					}
				} else {
					for (var i = 0; i < this.filter[f].length; i++) {
						where += this.filter[f][i] !== '' ? field_name + '=\'' + this.filter[f][i] + '\' or ' : field_name + ' is null or ';
					}
				}

				where = this.filter[f].length !== 0 ? where.slice(0, -4) : where;
				where += this.filter[f].length !== 0 ? ') and (' : '';
			}
			where = where.slice(0, -6);

			var start = 1;

			if (this.$route.params.id || this.$parent.act_id) {
				start = (this.page_num - 1) * __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */] + 1;
				this.active = this.page_num;
			}

			var t = TABLE + ('?start=' + start + '&rows=' + __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */]);
			if (where) {
				t = FILTER_TABLE + ('?start=' + start + '&rows=' + __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */] + '&filter=' + where);
			}

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + t, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				var prev_id = -1;
				var prev_localforestry_id = -1;
				var prev_subforestry_id = -1;

				var length = !!where ? res.length : res.length - 1;

				for (var _i2 = 0; _i2 < length; _i2++) {
					var act = {};

					var start_fo = _i2;
					while (_i2 > 0 && res[start_fo - 1].act_id === res[_i2].act_id && start_fo > 1) {
						start_fo--;
					}

					var curr = start_fo;
					while (curr < res.length && res[curr].act_id === res[start_fo].act_id) {
						curr++;
					}
					act.count = curr - start_fo;

					if (res[_i2].act_id === prev_id) {
						act.flag = false;
					} else {
						act.flag = true;
					}
					//////////////////

					var start_lf = _i2;
					while (_i2 > 0 && res[start_lf - 1].localforestry_id === res[_i2].localforestry_id && start_lf > 1 && res[start_lf - 1].act_id === res[_i2].act_id) {
						start_lf--;
					}

					var curr_lf = start_lf;
					while (curr_lf < res.length && res[curr_lf].act_id === res[start_lf].act_id && res[curr_lf].localforestry_id === res[_i2].localforestry_id) {
						curr_lf++;
					}
					act.count_lf = curr_lf - start_lf;

					if (res[_i2].act_id === prev_id && prev_localforestry_id === res[_i2].localforestry_id) {
						act.flag_lf = false;
					} else {
						act.flag_lf = true;
					}

					////////////////////////
					var start_sf = _i2;
					while (_i2 > 0 && res[start_sf - 1].localforestry_id === res[_i2].localforestry_id && start_sf > 1 && res[start_sf - 1].act_id === res[_i2].act_id) {
						start_sf--;
					}

					var curr_sf = start_sf;
					while (curr_sf < res.length && res[curr_sf].act_id === res[start_sf].act_id && res[curr_sf].localforestry_id === res[_i2].localforestry_id) {
						curr_sf++;
					}
					act.count_sf = curr_sf - start_sf;

					if (res[_i2].act_id === prev_id && prev_localforestry_id === res[_i2].localforestry_id) {
						act.flag_sf = false;
					} else {
						act.flag_sf = true;
					}
					////////////////////////


					prev_id = res[_i2].act_id;
					prev_localforestry_id = res[_i2].localforestry_id;
					prev_subforestry_id = res[_i2].subforestry_id;

					act.id = res[_i2].act_id;
					act.act_num = res[_i2].act_num;
					act.act_placement_date = res[_i2].act_placement_date;
					act.conclusion_decision = res[_i2].conclusion_decision;
					act.conclusion_decision_reason = res[_i2].conclusion_decision_reason;
					act.warrant_decision = res[_i2].warrant_decision;
					act.violation = res[_i2].violation;
					act.fo = res[_i2].fo;
					act.region = res[_i2].region;
					act.forestry = res[_i2].forestry;
					act.selected = false;

					temp_lines.push(act);
				}

				//if (!where) {
				//let count = Math.round(res[res.length - 1].count / ROWS_ON_PAGE)
				_this3.pages_count = Math.round(res[res.length - 1].count / __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */]);
				temp_pages = [];

				if (_this3.active > PADDING) {
					temp_pages.push({ active: false, num: 1 });
					temp_pages.push({ active: false, num: '...' });
				}

				for (var _i3 = _this3.active - PADDING; _i3 < _this3.active + PADDING; _i3++) {
					if (_i3 >= 0 && _i3 < _this3.pages_count) temp_pages.push({ active: false, num: _i3 + 1 });
				}

				if (_this3.active < _this3.pages_count - PADDING) {
					temp_pages.push({ active: false, num: '...' });
					temp_pages.push({ active: false, num: _this3.pages_count });
				}

				_this3.pages = temp_pages;
				_this3.pages.forEach(function (p) {
					p.active = p.num == _this3.active;
				});
				//}

				_this3.lines = temp_lines;

				if (_this3.$route.params.id || _this3.$parent.act_id) {
					var act_id = _this3.$route.params.id || _this3.$parent.act_id;
					var found = false;
					for (var _i4 = 0; _i4 < _this3.lines.length; _i4++) {
						if (_this3.lines[_i4].id == act_id) {
							_this3.select_line(_i4);

							_this3.$nextTick(function () {
								var selected_row = document.querySelector("tr.selected");
								if (selected_row) selected_row.scrollIntoView(true);
							});

							found = true;
							break;
						}
					}
					if (!found) _this3.select_line(0);
				} else {
					_this3.select_line(0);
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	created: function created() {},
	mounted: function mounted() {
		var _this4 = this;

		this.$parent.lastJournalURL = '/main/decisions';

		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$on('filter' + this.journalSuffix + '_list', function (f) {
			_this4.filter[f.field + _this4.journalSuffix] = f.value !== '' ? f.value : null;
			_this4.active = 1;
			if (f.cf) //clearFilters
				{
					_this4.cf_count++;
					if (_this4.cf_count == COUNT_OF_FILTERS) _this4.filter_lines();
				} else _this4.filter_lines();
		});

		this.page_num = this.$parent.page_num_decisions ? this.$parent.page_num_decisions : 1;

		//console.warn(this.$parent.selected_filters, this.$parent.selected_filters.length)

		if (this.$parent.selected_filters) {
			for (var field in this.$parent.selected_filters) {
				if (field.includes(this.journalSuffix)) this.filter[field] = this.$parent.selected_filters[field].value;
			}
		}

		this.filter_lines();

		// const w = document.documentElement.clientWidth - 50
		// document.querySelector('.main_table_wrapper').style.width = `${w}px`

		////////////////////////////////////////////

		var dispay_width = document.documentElement.clientWidth;
		// const dispay_height = document.documentElement.clientHeight - 146
		var dispay_height = document.documentElement.clientHeight - 225;
		var scroll_width = 17;

		var ua = navigator.userAgent;

		if (ua.search('OPR/') > 0) {
			scroll_width = 15;
		}

		var table_width = dispay_width - scroll_width;
		var col_width = Math.floor(table_width / COUNT_OF_FILTERS);
		// 
		var large_width = table_width - col_width * 9;

		// console.log(col_width, large_width, table_width, col_width * 9 + large_width)


		document.querySelectorAll('.l-td').forEach(function (td) {
			td.width = col_width;
		});
		document.querySelectorAll('.large-td').forEach(function (td) {
			td.width = large_width;
		});
		document.querySelector('.l-header-wrapper').width = dispay_width;
		document.querySelector('.l-body-wrapper').width = dispay_width;
		document.querySelector('.l-body-wrapper').style.maxHeight = dispay_height + 'px';

		// console.log(dispay_height, dispay_width, col_width, table_width)
		// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))

		document.querySelector('.l-scroll').width = scroll_width;
	},
	beforeDestroy: function beforeDestroy() {
		//this.lines = []
		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$off('filter' + this.journalSuffix + '_list');
		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$emit('save-page' + this.journalSuffix, this.active);
	}
});

/***/ }),

/***/ "4jb0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var USERS = 'get_users.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'conclusionUsers',
	data: function data() {
		return {
			selected: '0',
			options: []
		};
	},
	props: {
		conc_id: false
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('conclusion_user', this.selected);
		}
	},
	created: function created() {
		var _this = this;

		if (typeof this.conc_id !== 'undefined' && this.conc_id !== null && this.conc_id) {
			fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + USERS, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.options = data;
					_this.selected = _this.conc_id;
				} else {
					_this.options = [];
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}
	}
});

/***/ }),

/***/ "4v1F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dropdown',{staticClass:"npa-violation-dropdown form-control height-control",attrs:{"disabled":_vm.npa_disabled,"text":_vm.names},on:{"input":_vm.open},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},[_c('li',[_c('checkbox',{attrs:{"type":"info"},model:{value:(_vm.sel),callback:function ($$v) {_vm.sel=$$v},expression:"sel"}},[_vm._v("Выбрать всё")])],1),_vm._v(" "),_c('li',{staticClass:"divider",attrs:{"role":"separator"}}),_vm._v(" "),_c('table',{staticClass:"npa-violation-table"},[_c('thead',[_c('th'),_vm._v(" "),_c('th',[_vm._v("НПА")]),_vm._v(" "),_c('th',[_vm._v("Нарушение")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(i){return _c('tr',[_c('td',{staticClass:"npa-violation-td-checkbox"},[_c('checkbox',{staticClass:"npa-violation-checkbox",attrs:{"type":"info"},on:{"input":function($event){_vm.check(i.id, i.name, i.checked)}},model:{value:(i.checked),callback:function ($$v) {_vm.$set(i, "checked", $$v)},expression:"i.checked"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(i.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(i.violation))])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4y5K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5+Uu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.disabled},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5XhY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_actionType_vue__ = __webpack_require__("UkrR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c702580_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_actionType_vue__ = __webpack_require__("7VrL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_actionType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c702580_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_actionType_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5o/A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_damageReason_vue__ = __webpack_require__("vQlM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c9491c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_damageReason_vue__ = __webpack_require__("8x8z");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_damageReason_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c9491c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_damageReason_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5yz/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__edit_fetch_data_region__ = __webpack_require__("hLYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__edit_fetch_data_organization__ = __webpack_require__("Ha1D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__edit_fetch_data_fo__ = __webpack_require__("60jp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fetch_data_forestry__ = __webpack_require__("D/lR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fetch_data_localforestry__ = __webpack_require__("y1d8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fetch_data_subforestry__ = __webpack_require__("pEw+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fetch_data_decisionReason__ = __webpack_require__("vq+Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fetch_data_actionType__ = __webpack_require__("raIG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fetch_data_npaViolation__ = __webpack_require__("VtK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_EventBus__ = __webpack_require__("O67w");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var HEADER = 'get_header.php';
var ACT_INFO = 'get_act_info.php';
var LOCATION = 'get_conclusion_location.php';
var CONCLUSION_INFO = 'get_conclusion_info.php';
var UPDATE_JSON = 'update_json.php';
var CAN_EDIT = 'can_edit_unit.php';
var NPA_VIOLATION_NEW = 'get_npa_violation_new.php';
var UNIT_ID = 2;
/*	const INSERT_JSON = 'insert_json.php'
	const UPDATE_JSON = 'update_json.php'
	const DELETE_JSON = 'delete_json.php'
	const JSON_U2 = 'get_json_u2.php'*/
//	const GET_PARENT = 'get_parent.php'















// import jQuery from "jquery"; 
// import datePicker from 'vue-bootstrap-datetimepicker';
//import datePicker from './../datePicker'



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'conclusionModal',
	data: function data() {
		return {
			scroll_width: 17,
			readonly: true,
			line_count: 0,
			lines: [],
			//action: '',
			//old_obj: '',

			f_2: '',
			f_4: '',
			f_11: '',
			f_9: '',
			f_12: '',

			f_35: '',
			f_36: '',
			f_37: '',
			f_38: '',
			f_39: '',
			f_40: '',
			f_41: 2,
			f_42: 2,
			f_43: '',
			f_44: '',
			f_45: '',
			f_46: '',
			f_47: 1,
			f_48: '',
			f_49: '',
			f_50: '',

			upp_count: 0,
			mzl_count: 0,
			upp_lastdate: '',
			mzl_lastdate: '',

			f_28: [],
			f_29: [],
			f_30: [],
			f_31: [],
			f_32: [],
			f_33: [],
			f_34: [],

			f_17: [],
			f_24: [],
			f_25: [],

			f_0: [],
			location_id: [],

			fields_correct: {
				f_35: 'field-error',
				f_36: 'field-error',
				// f_38: 'field-error',
				// f_39: 'field-error',
				f_41: 'field-error',
				// f_44: 'field-error',
				// f_45: 'field-error',
				f_48: 'field-error',
				f_49: 'field-error'
			},

			submit_disabled: false,
			npa_violations: [],
			errorDecisionReason: false

		};
	},
	components: {
		region: __WEBPACK_IMPORTED_MODULE_5__edit_fetch_data_region__["a" /* default */],
		forestry: __WEBPACK_IMPORTED_MODULE_8__fetch_data_forestry__["a" /* default */],
		localforestry: __WEBPACK_IMPORTED_MODULE_9__fetch_data_localforestry__["a" /* default */],
		subforestry: __WEBPACK_IMPORTED_MODULE_10__fetch_data_subforestry__["a" /* default */],
		organization: __WEBPACK_IMPORTED_MODULE_6__edit_fetch_data_organization__["a" /* default */],
		fo: __WEBPACK_IMPORTED_MODULE_7__edit_fetch_data_fo__["a" /* default */],
		decisionReason: __WEBPACK_IMPORTED_MODULE_11__fetch_data_decisionReason__["a" /* default */],
		actionType: __WEBPACK_IMPORTED_MODULE_12__fetch_data_actionType__["a" /* default */],
		datepicker: __WEBPACK_IMPORTED_MODULE_14_vue_strap__["datepicker"],
		npaViolation: __WEBPACK_IMPORTED_MODULE_13__fetch_data_npaViolation__["a" /* default */]
	},
	methods: {
		setRegistryAccordance: function setRegistryAccordance() {
			for (var i in this.lines) {
				if (this.lines[i].upp == 't') {
					if (this.lines[i].accordance_upp == 't') this.lines[i].f_28 = 1;
					if (this.lines[i].accordance_upp == 'f') this.lines[i].f_28 = 0;
				} else this.lines[i].f_28 = 2;

				if (this.lines[i].accordance_mzl == 't') this.lines[i].f_30 = 1;else if (this.lines[i].accordance_mzl == 'f') this.lines[i].f_30 = 0;else this.lines[i].f_30 = 2;
			}
		},
		decisionChange: function decisionChange(old, e) {
			var l = e.target.getAttribute('data-line');
			this.lines[l].f_33 = e.target.value;
			this.lines[l]['correct_f_33'] = e.target.value == '2' ? 'field-error' : 'place-success';
			if (this.f_41 == '1' && e.target.value == '0') this.f_41 = '0';

			if (old == '2' && e.target.value == '1') {
				this.lines[l].f_28 = '1';
				this.lines[l].f_29 = '1';
				this.lines[l].f_30 = '1';
				this.lines[l].f_31 = '1';
			}
		},
		mainDecisionChange: function mainDecisionChange(old, e) {
			this.f_41 = e.target.value;
			if (e.target.value == '1') for (var line in this.lines) {
				this.lines[line].f_28 = '1';
				this.lines[line].f_29 = '1';
				this.lines[line].f_30 = '1';
				this.lines[line].f_31 = '1';
				this.lines[line].f_33 = '1';
				this.lines[line]['correct_f_33'] = 'place-success';
			}
		},
		checkFields: function checkFields() {
			var main_fields = [35, 36, 48, 49];
			// const location_fields = [33]

			var result = true;

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(main_fields), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var i = _step.value;

					result = result && !!this['f_' + i]; //one false = result false, all true = result true
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			result = result && this.f_41 != '2';

			result = result && !!this.lines.length; //lines.length == 0 => result false

			for (var j = 0; j < this.lines.length; j++) {
				result = result && this.lines[j].f_33 != '2';
			}

			return result;
		},
		submit: function submit() {
			var _this = this;

			this.submit_disabled = true;
			var obj = [{}];
			obj[0].tab_id = 1;
			obj[0].f_v = {};
			obj[0].f_v.f_c = this.$route.params.id;

			for (var i = 35; i <= 50; i++) {
				if (this['f_' + i] !== '') {
					if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this['f_' + i]) !== 'object') {
						if (i === 41) obj[0].f_v['f_' + i] = this['f_' + i] != '2' ? this['f_' + i] == '1' ? true : false : null;else if (i === 36 || i === 39 || i === 45 || i === 49) obj[0].f_v['f_' + i] = commaToPeriod(this['f_' + i]);else obj[0].f_v['f_' + i] = this['f_' + i];
					} else {
						obj[0].f_v['f_' + i] = this['f_' + i].format('DD.MM.YYYY');
					}
				} else {
					obj[0].f_v['f_' + i] = null;
				}
			}

			if (obj[0].f_v.f_41 != false) obj[0].f_v.f_42 = null;

			for (var _i = 0; _i < this.lines.length; _i++) {
				obj.push({});

				obj[_i + 1].tab_id = 2;
				obj[_i + 1].f_v = {};
				obj[_i + 1].f_v.f_c = this.lines[_i].f_c;

				for (var j = 28; j <= 33; j++) {
					obj[_i + 1].f_v['f_' + j] = this.lines[_i]['f_' + j] != '2' ? this.lines[_i]['f_' + j] == '1' ? true : false : null;
				}

				obj[_i + 1].f_v.f_34 = this.lines[_i].f_34 ? this.lines[_i].f_34 : null;
				obj[_i + 1].f_v.f_91 = this.lines[_i].f_91;
				obj[_i + 1].f_v.f_107 = this.lines[_i].f_107;
			}
			// console.log(JSON.stringify(obj)) 

			var submit_conclusion_info = function submit_conclusion_info() {
				var form = new FormData();
				form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));

				fetch(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + UPDATE_JSON, {
					credentials: 'include',
					method: 'post',
					body: form
				}).then(function (result) {
					return result.json();
				}).then(function (result) {
					if (result[0].code === '0') {
						alert('Заключение сохранено');

						if (_this.$parent.lastJournalURL) __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace(_this.$parent.lastJournalURL);else __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace('/main');
					} else {
						alert(result[0].name);
					}
					_this.submit_disabled = false;
				}).catch(function (err) {
					return console.log(err);
				});
			};

			if (this.checkFields()) {
				if (this.errorDecisionReason) {
					alert("Выбранная главная причина отрицательного заключения отсутствует среди соответствий");
				}
				if (document.querySelector('.field-error') !== null) {
					alert('Часть полей содержит некорректные данные. Сохранение невозможно');
					this.submit_disabled = false;
				} else {
					submit_conclusion_info();
				}
			} else {
				alert('Поля, отмеченные звёздочкой, обязательны к заполнению.');
				this.submit_disabled = false;
			}
		},
		close: function close() {
			if (this.$parent.lastJournalURL) __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace(this.$parent.lastJournalURL);else __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace('/main');
		},
		errorDecisionReasonHandler: function errorDecisionReasonHandler() {
			this.errorDecisionReason = false;
			if (Number(this.f_41) == 0) {
				var array = [];

				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;

				try {
					for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.lines), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var line = _step2.value;

						for (var i = 28; i <= 31; i++) {
							array[i] = array[i] || line['f_' + i] == 0;
						}
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}

				if (this.f_42 == 1) this.errorDecisionReason = !array[31];
				if (this.f_42 == 2) this.errorDecisionReason = !array[30];
				if (this.f_42 == 3) this.errorDecisionReason = !array[28];
				if (this.f_42 == 4) this.errorDecisionReason = !array[29];
			}
		}
	},
	created: function created() {
		var _this2 = this;

		__WEBPACK_IMPORTED_MODULE_16__lib_EventBus__["a" /* EventBus */].$on('decision_reason', function (id) {
			_this2.f_42 = id;
		});

		__WEBPACK_IMPORTED_MODULE_16__lib_EventBus__["a" /* EventBus */].$on('npa_violation', function (data) {
			_this2.lines[data.index].f_107 = data.value;
		});

		fetch(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + CAN_EDIT + '?act_id=' + this.$route.params.id + '&unit_id=' + UNIT_ID, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			_this2.readonly = res[0].czl_check_can_edit_unit == 't' ? false : true;
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + HEADER + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			for (var i in res[0]) {
				_this2[i] = res[0][i];
			}
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + LOCATION + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			// console.log(res)
			if (res) {
				_this2.lines = res;
			}

			for (var i = 0; i < res.length; i++) {
				for (var j = 28; j <= 33; j++) {
					_this2.lines[i]['f_' + j] = res[i]['f_' + j] ? res[i]['f_' + j] === 't' ? 1 : 0 : 2;
				}
				_this2.lines[i].correct_f_33 = res[i].f_33 === 2 ? 'field-error' : '';

				_this2.lines[i].f_91 = res[i].f_91 ? res[i].f_91 === 't' ? true : false : false;
			}
		}).catch(function (err) {
			return console.log('9', err);
		});

		var ua = navigator.userAgent;

		if (ua.search('OPR/') > 0) {
			this.scroll_width = 15;
		}
	},
	mounted: function mounted() {
		var _this3 = this;

		fetch(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + CONCLUSION_INFO + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			if (res) {
				for (var i in res[0]) {
					if (res[0][i]) {
						if (i === 'f_35' || i === 'f_38' || i === 'f_44' || i === 'f_48') {
							var d = __WEBPACK_IMPORTED_MODULE_15_moment___default()(res[0][i], 'YYYY-MM-DD');
							// console.log(res[0][i], d.format('DD.MM.YYYY'))
							_this3[i] = res[0][i] ? d.format('DD.MM.YYYY') : '';
						} else if (i === 'f_47' || i === 'f_41') {
							_this3[i] = res[0][i] === 't' ? 1 : 0;
						} else {
							_this3[i] = res[0][i];
						}
					}
				}

				_this3.fields_correct.f_41 = res[0].f_41 == 2 || res[0].f_41 === null ? 'field-error' : '';
			}
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + ACT_INFO + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (res) {
			var act_date = __WEBPACK_IMPORTED_MODULE_15_moment___default()(res[0].f_3, "YYYY-MM-DD");
			var formattedDate = void 0;
			if (act_date.isValid()) {
				formattedDate = act_date.format("DD.MM.YYYY");
			} else {
				formattedDate = __WEBPACK_IMPORTED_MODULE_15_moment___default()().format("DD.MM.YYYY");
			}

			fetch(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + NPA_VIOLATION_NEW + "?date=" + formattedDate, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this3.npa_violations = data;
					__WEBPACK_IMPORTED_MODULE_16__lib_EventBus__["a" /* EventBus */].$emit('fetch_npa_violations_complete');
				}
			}).catch(function (err) {
				return console.log(err);
			});
		});
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_16__lib_EventBus__["a" /* EventBus */].$off('decision_reason');
	},

	watch: {
		//[35,36,38,39,44,45,48,49]
		lines: {
			handler: function handler() {
				this.errorDecisionReasonHandler();
			},
			deep: true
		},
		f_41: function f_41(e) {
			this.fields_correct.f_41 = e === '2' || e === null ? 'field-error' : '';
			this.errorDecisionReasonHandler();
		},
		f_42: function f_42() {
			this.errorDecisionReasonHandler();
		},
		f_35: function f_35(e) {
			var arr_f_35 = this.f_35.split('.');
			var date_f_35 = new Date(+arr_f_35[2], +arr_f_35[1] - 1, +arr_f_35[0]);
			var arr_f_48 = this.f_48.split('.');
			var date_f_48 = new Date(+arr_f_48[2], +arr_f_48[1] - 1, +arr_f_48[0]);
			if (date_f_35 > date_f_48) {
				this.fields_correct.f_35 = 'field-error';
				this.fields_correct.f_48 = 'field-error';
			} else {
				this.fields_correct.f_35 = e === '' || e === null ? 'field-error' : 'field-success';
				//this.fields_correct.f_48 = 'field-success'
			}
		},
		f_36: function f_36(e) {
			this.fields_correct.f_36 = e === '' || e === null ? 'field-error' : 'place-success';
		},
		f_38: function f_38(e) {
			this.fields_correct.f_38 = e === '' || e === null ? 'field-error' : 'field-success';
		},
		f_39: function f_39(e) {
			this.fields_correct.f_39 = e === '' || e === null ? 'field-error' : '';
		},
		f_44: function f_44(e) {
			this.fields_correct.f_44 = e === '' || e === null ? 'field-error' : 'field-success';
		},
		f_45: function f_45(e) {
			this.fields_correct.f_45 = e === '' || e === null ? 'field-error' : '';
		},
		f_48: function f_48(e) {
			var arr_f_35 = this.f_35.split('.');
			var date_f_35 = new Date(+arr_f_35[2], +arr_f_35[1] - 1, +arr_f_35[0]);
			var arr_f_48 = this.f_48.split('.');
			var date_f_48 = new Date(+arr_f_48[2], +arr_f_48[1] - 1, +arr_f_48[0]);
			if (date_f_35 > date_f_48) {
				this.fields_correct.f_35 = 'field-error';
				this.fields_correct.f_48 = 'field-error';
			} else {
				this.fields_correct.f_35 = 'field-success';
				this.fields_correct.f_48 = e === '' || e === null ? 'field-error' : 'field-success';
			}
		},
		f_49: function f_49(e) {
			this.fields_correct.f_49 = e === '' || e === null ? 'field-error' : '';
		}
	}
});

function commaToPeriod(str) {
	return str.replace(/,/g, ".");
}

/***/ }),

/***/ "60jp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fo_vue__ = __webpack_require__("L4e2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_424856f9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_fo_vue__ = __webpack_require__("sJgg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_424856f9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_fo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "66jr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "69oF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_vm._v("\n\tСтраница не найдена.\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6OcU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_conclusionUser_vue__ = __webpack_require__("V98W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2f12f8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_conclusionUser_vue__ = __webpack_require__("HezV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_conclusionUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2f12f8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_conclusionUser_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6VXu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6Zra":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_organization_vue__ = __webpack_require__("DF1r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_208995a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_organization_vue__ = __webpack_require__("YmFx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_organization_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_208995a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_organization_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "71UR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"text-center"},[_vm._v("\n\t\tТерриториальный справочник\n\t")]),_vm._v(" "),_c('table',{staticClass:"top-table"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"20%"}},[_vm._v("\n\t\t\t\t\tСубъект РФ\n\t\t\t\t")]),_vm._v(" "),_c('th',{staticStyle:{"width":"20%"}},[_vm._v("\n\t\t\t\t\tЛесничество\n\t\t\t\t")]),_vm._v(" "),_c('th',{staticStyle:{"width":"20%"}},[_vm._v("\n\t\t\t\t\tУчастковое лесничество\n\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v("\n\t\t\t\t\tУрочище (дача)\n\t\t\t\t")]),_vm._v(" "),(_vm.showScrollWrap)?_c('th',{staticStyle:{"width":"18px","padding":"0"},attrs:{"rowspan":"2"}}):_vm._e()]),_vm._v(" "),_c('tr',[_c('th',[_c('TerritoryFilter',{attrs:{"field":"region_name","filter":_vm.filter}})],1),_vm._v(" "),_c('th',[_c('TerritoryFilter',{attrs:{"field":"forestry_name","filter":_vm.filter}})],1),_vm._v(" "),_c('th',[_c('TerritoryFilter',{attrs:{"field":"localforestry_name","filter":_vm.filter}})],1),_vm._v(" "),_c('th',[_c('TerritoryFilter',{attrs:{"field":"subforestry_name","filter":_vm.filter}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"scroller-bottom"},[_c('table',{staticClass:"main-table"},[_c('tbody',_vm._l((_vm.territory_journal),function(line){return _c('tr',[_c('td',[_vm._v("\n\t\t\t\t\t\t"+_vm._s(line.region_name)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('td',[_vm._v("\n\t\t\t\t\t\t"+_vm._s(line.forestry_name)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('td',[_vm._v("\n\t\t\t\t\t\t"+_vm._s(line.localforestry_name)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('td',[_vm._v("\n\t\t\t\t\t\t"+_vm._s(line.subforestry_name)+"\n\t\t\t\t\t")])])}))])]),_vm._v(" "),_c('div',{staticClass:"table_footer"},[_c('div',{staticClass:"pull-left",staticStyle:{"position":"absolute","margin":"20px 0 20px 0"}},[_c('a',{staticClass:"btn btn-primary",attrs:{"href":_vm.DBlink + "get_territory_journal_csv.php?where=" + _vm.compose_filter()}},[_vm._v("Выгрузить")]),_vm._v(" "),(_vm.$parent.canEditAddress)?_c('button',{staticClass:"btn btn-info",on:{"click":_vm.showEditTerritoryModal}},[_vm._v("Редактирование")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"text-center"},[(_vm.pages)?_c('ul',{staticClass:"pagination"},_vm._l((_vm.pages),function(page){return _c('li',{class:{ active: page.active }},[(_vm.isNumeric(page.num))?_c('a',{attrs:{"href":"#","data-value":page.num},on:{"click":_vm.select_page}},[_vm._v(_vm._s(page.num))]):_c('span',{staticClass:"disabled_page",attrs:{"href":"#"}},[_vm._v(_vm._s(page.num))])])})):_vm._e()])]),_vm._v(" "),_c('modal',{staticClass:"modal-catalog",attrs:{"backdrop":false,"effect":"fade","medium":""},model:{value:(_vm.displayEditTerritory),callback:function ($$v) {_vm.displayEditTerritory=$$v},expression:"displayEditTerritory"}},[_c('div',{staticClass:"modal-header",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('h3',{staticClass:"modal-title"},[_vm._v("\n\t\t    \tРедактирование справочника\n\t\t    ")])]),_vm._v(" "),_c('div',[_c('edit-territory-catalog')],1),_vm._v(" "),_c('div',{staticClass:"modal-footer",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":_vm.hideEditTerritoryModal}},[_vm._v("Закрыть")])])]),_vm._v(" "),(_vm.load_journal_status)?_c('div',{staticClass:"loading-wrap"},[_c('i',{staticClass:"fa fa-spinner fa-spin",staticStyle:{"font-size":"48px"}})]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7LcB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"s-body-wrapper"},[_c('table',{staticClass:"s-body"},[_c('tbody',_vm._l((_vm.rows),function(row,i){return _c('tr',[(row.flag)?_c('td',{attrs:{"colspan":"17"}},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(row.fo))])]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"left s-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.region))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.lpo_volume))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_published))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_som))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_prof))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_agit))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_ssr))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_vsr))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_und))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_rad))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_others))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_negative_ssr))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_negative_vsr))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_negative_und))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_negative_rad))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_negative_others))]):_vm._e()])}))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-header-wrapper"},[_c('table',{staticClass:"s-header"},[_c('thead',{staticClass:"bold"},[_c('tr',[_c('td',{staticClass:"s-td",attrs:{"rowspan":"2"}},[_vm._v("Субъекты, федеральные округа")]),_vm._v(" "),_c('td',{staticClass:"s-td",attrs:{"rowspan":"2"}},[_vm._v("Объёмы выполненных л.п. обследований (в соответствии с опубликованными на сайтах Актах ЛПО), га")]),_vm._v(" "),_c('td',{staticClass:"s-td",attrs:{"rowspan":"2"}},[_vm._v("Назначено мероприятий (в соответствии с опубликованными Актами ЛПО), га")]),_vm._v(" "),_c('td',{staticClass:"s-td",attrs:{"rowspan":"2"}},[_vm._v("Назначено мероприятий (в соответствии с поступившими Актами ЛПО), га")]),_vm._v(" "),_c('td',{attrs:{"colspan":"3"}},[_vm._v("из них")]),_vm._v(" "),_c('td',{attrs:{"colspan":"5"}},[_vm._v("в т.ч. по видам мероприятий")]),_vm._v(" "),_c('td',{attrs:{"colspan":"5"}},[_vm._v("в т.ч. по актам с отрицательными заключениями, га")]),_vm._v(" "),_c('td',{staticClass:"s-scroll",attrs:{"rowspan":"2"}})]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"s-td-small"},[_vm._v("СОМ, га")]),_vm._v(" "),_c('td',{staticClass:"s-td"},[_vm._v("профилактические мероприятия")]),_vm._v(" "),_c('td',{staticClass:"s-td"},[_vm._v("Агитационные мероприятия")]),_vm._v(" "),_c('td',{staticClass:"s-td-small"},[_vm._v("ССР, га")]),_vm._v(" "),_c('td',{staticClass:"s-td-small"},[_vm._v("ВСР, га")]),_vm._v(" "),_c('td',{staticClass:"s-td-small"},[_vm._v("УНД, га")]),_vm._v(" "),_c('td',{staticClass:"s-td-small"},[_vm._v("РАД, га")]),_vm._v(" "),_c('td',{staticClass:"s-td-small"},[_vm._v("Иные, га")]),_vm._v(" "),_c('td',{staticClass:"s-td-small"},[_vm._v("ССР, га")]),_vm._v(" "),_c('td',{staticClass:"s-td-small"},[_vm._v("ВСР, га")]),_vm._v(" "),_c('td',{staticClass:"s-td-small"},[_vm._v("УНД, га")]),_vm._v(" "),_c('td',{staticClass:"s-td-small"},[_vm._v("РАД, га")]),_vm._v(" "),_c('td',{staticClass:"s-td-small"},[_vm._v("Иные, га")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("2")]),_vm._v(" "),_c('td',[_vm._v("3")]),_vm._v(" "),_c('td',[_vm._v("4")]),_vm._v(" "),_c('td',[_vm._v("5")]),_vm._v(" "),_c('td',[_vm._v("6")]),_vm._v(" "),_c('td',[_vm._v("7")]),_vm._v(" "),_c('td',[_vm._v("8")]),_vm._v(" "),_c('td',[_vm._v("9")]),_vm._v(" "),_c('td',[_vm._v("10")]),_vm._v(" "),_c('td',[_vm._v("11")]),_vm._v(" "),_c('td',[_vm._v("12")]),_vm._v(" "),_c('td',[_vm._v("13")]),_vm._v(" "),_c('td',[_vm._v("14")]),_vm._v(" "),_c('td',[_vm._v("15")]),_vm._v(" "),_c('td',[_vm._v("16")]),_vm._v(" "),_c('td',[_vm._v("17")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Von":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var OZU = 'get_ozu.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'protectiveCatExt',
	data: function data() {
		return {
			selected: '',
			options: [],
			internal_id: null
		};
	},
	props: {
		line_count: 0,
		type: '',
		id: null,
		disabled: false
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit(this.type + '_protective_cat_ext', { index: this.line_count, value: this.selected });
		},
		fill: function fill(id) {
			var _this = this;

			if (this.$parent.data_location.ozu.length) {

				this.options = this.$parent.data_location.ozu;
				this.selected = this.internal_id ? this.internal_id : this.$parent.data_location.ozu[0].id;
				this.internal_id = null;
			} else {
				__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$on('fetch_ozu_complete', function () {
					_this.options = _this.$parent.data_location.ozu;
					_this.selected = _this.internal_id ? _this.internal_id : _this.$parent.data_location.ozu[0].id;
					_this.internal_id = null;

					__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$off('fetch_ozu_complete');
				});
			}
		}
	},
	created: function created() {
		this.internal_id = this.$props.id;
		this.fill();
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$off('fetch_ozu_complete');
		//EventBus.$off(`${this.type}_protective_cat_${this.line_count}`)
	}
});

/***/ }),

/***/ "7VrL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7jbk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var GET_MONITORING_REPORT = 'get_monitoring_report_v2.php';
var REPORT_ID = 1;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Monitoring',
	data: function data() {
		return {
			rows: []
		};
	},
	props: ['start', 'end'],
	computed: {
		endYear: function endYear() {
			return this.$props.end.split('.')[2];
		}
	},
	methods: {
		fillTable: function fillTable(start, end) {
			var _this = this;

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + GET_MONITORING_REPORT + '?start=' + start + '&end=' + end).then(function (res) {
				return res.json();
			}).then(function (res) {
				var temp_rows = [{}];
				var flag = true;
				var total_summ = {};
				total_summ.region = 'Итого по РФ';
				total_summ.placement_all = 0;
				total_summ.placement_week = 0;
				total_summ.entrance_all = 0;
				total_summ.entrance_week = 0;
				total_summ.sending_conclusion_all = 0;
				total_summ.sending_conclusion_week = 0;
				total_summ.decision_false_all = 0;
				total_summ.decision_false_week = 0;
				total_summ.deletion_all = 0;
				total_summ.deletion_week = 0;
				total_summ.online_acts_all = 0;
				total_summ.online_acts_week = 0;

				var fo_summ = {};
				fo_summ.region = 'Итого по округу';
				fo_summ.placement_all = 0;
				fo_summ.placement_week = 0;
				fo_summ.entrance_all = 0;
				fo_summ.entrance_week = 0;
				fo_summ.sending_conclusion_all = 0;
				fo_summ.sending_conclusion_week = 0;
				fo_summ.decision_false_all = 0;
				fo_summ.decision_false_week = 0;
				fo_summ.deletion_all = 0;
				fo_summ.deletion_week = 0;
				fo_summ.online_acts_all = 0;
				fo_summ.online_acts_week = 0;

				var i = 0;

				while (i < res.length - 1) {

					if (res[i].fo === res[i + 1].fo && flag) {
						var obj = {};
						obj.fo = res[i].fo;
						obj.flag = true;
						flag = false;

						if (i !== 0) {
							var _clone_fo = {}; //клонируем объект для передачи по значению
							for (var key in fo_summ) {
								_clone_fo[key] = fo_summ[key];
							}

							temp_rows.push(_clone_fo);

							fo_summ.placement_all = 0;
							fo_summ.placement_week = 0;
							fo_summ.entrance_all = 0;
							fo_summ.entrance_week = 0;
							fo_summ.sending_conclusion_all = 0;
							fo_summ.sending_conclusion_week = 0;
							fo_summ.decision_false_all = 0;
							fo_summ.decision_false_week = 0;
							fo_summ.deletion_all = 0;
							fo_summ.deletion_week = 0;
							fo_summ.online_acts_all = 0;
							fo_summ.online_acts_week = 0;
						}

						temp_rows.push(obj);
					} else {
						total_summ.placement_all += +res[i].placement_all;
						total_summ.placement_week += +res[i].placement_week;
						total_summ.entrance_all += +res[i].entrance_all;
						total_summ.entrance_week += +res[i].entrance_week;
						total_summ.sending_conclusion_all += +res[i].sending_conclusion_all;
						total_summ.sending_conclusion_week += +res[i].sending_conclusion_week;
						total_summ.decision_false_all += +res[i].decision_false_all;
						total_summ.decision_false_week += +res[i].decision_false_week;
						total_summ.deletion_all += +res[i].deletion_all;
						total_summ.deletion_week += +res[i].deletion_week;
						total_summ.online_acts_all += +res[i].online_acts_all;
						total_summ.online_acts_week += +res[i].online_acts_week;

						fo_summ.placement_all += +res[i].placement_all;
						fo_summ.placement_week += +res[i].placement_week;
						fo_summ.entrance_all += +res[i].entrance_all;
						fo_summ.entrance_week += +res[i].entrance_week;
						fo_summ.sending_conclusion_all += +res[i].sending_conclusion_all;
						fo_summ.sending_conclusion_week += +res[i].sending_conclusion_week;
						fo_summ.decision_false_all += +res[i].decision_false_all;
						fo_summ.decision_false_week += +res[i].decision_false_week;
						fo_summ.deletion_all += +res[i].deletion_all;
						fo_summ.deletion_week += +res[i].deletion_week;
						fo_summ.online_acts_all += +res[i].online_acts_all;
						fo_summ.online_acts_week += +res[i].online_acts_week;

						temp_rows.push(res[i]);
						if (res[i].fo !== res[i + 1].fo) {
							flag = true;
						}
						i++;
					}
				}

				var last = res.length - 1;

				temp_rows.push(res[last]);

				fo_summ.placement_all += +res[last].placement_all;
				fo_summ.placement_week += +res[last].placement_week;
				fo_summ.entrance_all += +res[last].entrance_all;
				fo_summ.entrance_week += +res[last].entrance_week;
				fo_summ.sending_conclusion_all += +res[last].sending_conclusion_all;
				fo_summ.sending_conclusion_week += +res[last].sending_conclusion_week;
				fo_summ.decision_false_all += +res[last].decision_false_all;
				fo_summ.decision_false_week += +res[last].decision_false_week;
				fo_summ.deletion_all += +res[last].deletion_all;
				fo_summ.deletion_week += +res[last].deletion_week;
				fo_summ.online_acts_all += +res[last].online_acts_all;
				fo_summ.online_acts_week += +res[last].online_acts_week;

				total_summ.placement_all += +res[last].placement_all;
				total_summ.placement_week += +res[last].placement_week;
				total_summ.entrance_all += +res[last].entrance_all;
				total_summ.entrance_week += +res[last].entrance_week;
				total_summ.sending_conclusion_all += +res[last].sending_conclusion_all;
				total_summ.sending_conclusion_week += +res[last].sending_conclusion_week;
				total_summ.decision_false_all += +res[last].decision_false_all;
				total_summ.decision_false_week += +res[last].decision_false_week;
				total_summ.deletion_all += +res[last].deletion_all;
				total_summ.deletion_week += +res[last].deletion_week;
				total_summ.online_acts_all += +res[last].online_acts_all;
				total_summ.online_acts_week += +res[last].online_acts_week;

				var clone_fo = {}; //клонируем объект для передачи по значению
				for (var _key in fo_summ) {
					clone_fo[_key] = fo_summ[_key];
				}

				temp_rows.push(clone_fo);

				temp_rows[0] = total_summ;

				_this.rows = temp_rows;
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		this.rows = [];
		this.fillTable(this.start, this.end);

		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on('monitoring-date', function (date) {
			// console.log('mon',date)
			_this2.fillTable(date.start, date.end);
		});

		var dispay_width = document.documentElement.clientWidth;
		var dispay_height = document.documentElement.clientHeight;
		var scroll_width = 17;

		var ua = navigator.userAgent;

		// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))

		if (ua.search('OPR/') > 0) {
			scroll_width = 15;
		}

		var table_width = dispay_width - 30 - scroll_width;
		var col_width = Math.ceil(table_width / 13);

		document.querySelectorAll('.m-td').forEach(function (td) {
			td.width = col_width;
		});
		document.querySelector('.m-header-wrapper').width = table_width;
		document.querySelector('.m-body-wrapper').width = table_width;
		document.querySelector('.m-body-wrapper').style.maxHeight = dispay_height - 340 + 'px';

		// console.log(dispay_width, col_width, table_width)

		document.querySelector('.m-scroll').width = scroll_width;
	},
	created: function created() {
		/*if(!this.$parent.$parent.reports.some((e) => {
  	return e.id == REPORT_ID
  }))
  	router.replace('/main')*/
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('monitoring-date');
	}
});

/***/ }),

/***/ "7lnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var REASON = 'get_deletion_reason.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'reason',
	data: function data() {
		return {
			selected: '0',
			id: '0',
			options: []
		};
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('deletion_reason', this.selected);
		}
	},
	mounted: function mounted() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + REASON, {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (data) {
			if (data) {
				_this.options = data;
				_this.selected = _this.id;
			} else {
				_this.options = [];
				_this.selected = '0';
			}
		}).catch(function (err) {
			return console.log('6', err);
		});
	}
});

/***/ }),

/***/ "8IsD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8XMK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_npaViolation_vue__ = __webpack_require__("ZNIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1daa0ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_npaViolation_vue__ = __webpack_require__("WA+y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_npaViolation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1daa0ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_npaViolation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8bM+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr'),_vm._v(" "),_c('div',{staticClass:"m-header-wrapper"},[_c('table',{staticClass:"m-header"},[_c('thead',{staticClass:"bold"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('tr',[_c('td',{staticClass:"m-td"},[_vm._v("c 01.01."+_vm._s(_vm.endYear)+" по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("отчётный период (c "+_vm._s(_vm.start)+" по "+_vm._s(_vm.end)+")")]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("c 01.01."+_vm._s(_vm.endYear)+" по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("отчётный период (c "+_vm._s(_vm.start)+" по "+_vm._s(_vm.end)+")")]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("c 01.01."+_vm._s(_vm.endYear)+" по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("отчётный период (c "+_vm._s(_vm.start)+" по "+_vm._s(_vm.end)+")")]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("c 01.01."+_vm._s(_vm.endYear)+" по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("отчётный период (c "+_vm._s(_vm.start)+" по "+_vm._s(_vm.end)+")")]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("c 01.01."+_vm._s(_vm.endYear)+" по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("отчётный период (c "+_vm._s(_vm.start)+" по "+_vm._s(_vm.end)+")")]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("c 01.01."+_vm._s(_vm.endYear)+" по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("отчётный период (c "+_vm._s(_vm.start)+" по "+_vm._s(_vm.end)+")")])]),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"m-body-wrapper"},[_c('table',{staticClass:"m-body"},[_c('tbody',_vm._l((_vm.rows),function(row,i){return _c('tr',[(row.flag)?_c('td',{attrs:{"colspan":"13"}},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(row.fo))])]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"left m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.region))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.placement_all))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.placement_week))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.entrance_all))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.entrance_week))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.sending_conclusion_all))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.sending_conclusion_week))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_false_all))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_false_week))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.deletion_all))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.deletion_week))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.online_acts_all))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.online_acts_week))]):_vm._e()])}))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"m-td",attrs:{"rowspan":"3"}},[_vm._v("Субъекты, федеральные округа")]),_vm._v(" "),_c('td',{attrs:{"colspan":"12"}},[_vm._v("Количество актов ЛПО")]),_vm._v(" "),_c('td',{staticClass:"m-scroll",attrs:{"rowspan":"4"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"2"}},[_vm._v("Размещённых на сайтах")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("Поступивших на заключение")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("По которым были направлены заключения")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("в т.ч. отрицательных заключений")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("Снятых с сайта")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("Находящихся на сайте на конец периода мониторинга размещённых")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("2")]),_vm._v(" "),_c('td',[_vm._v("3")]),_vm._v(" "),_c('td',[_vm._v("4")]),_vm._v(" "),_c('td',[_vm._v("5")]),_vm._v(" "),_c('td',[_vm._v("6")]),_vm._v(" "),_c('td',[_vm._v("7")]),_vm._v(" "),_c('td',[_vm._v("8")]),_vm._v(" "),_c('td',[_vm._v("9")]),_vm._v(" "),_c('td',[_vm._v("10")]),_vm._v(" "),_c('td',[_vm._v("11")]),_vm._v(" "),_c('td',[_vm._v("12")]),_vm._v(" "),_c('td',[_vm._v("13")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8x0Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HELP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ROWS_ON_PAGE; });
var DB = './php/'; //for production web server
//export const DB = '../455_vs/'                //for local web server
//export const DB = 'http://127.0.0.1/455_vs/src/php/' //for local dev

// export const HELP = "./../../static/Руководство пользователя.pdf"
var HELP = "./static/Руководство пользователя - v5.pdf";

var ROWS_ON_PAGE = 100;

/***/ }),

/***/ "8x8z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.id)+" — "+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Vd5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Zs4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__edit_fetch_data_region__ = __webpack_require__("hLYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fetch_data_organization__ = __webpack_require__("ixZc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__edit_fetch_data_fo__ = __webpack_require__("60jp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fetch_data_forestry__ = __webpack_require__("MtIP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fetch_data_localforestry__ = __webpack_require__("Da4G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fetch_data_subforestry__ = __webpack_require__("vDdQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fetch_data_decisionReason__ = __webpack_require__("W34n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fetch_data_actionType__ = __webpack_require__("2HvF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fetch_data_npaViolation__ = __webpack_require__("8XMK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib_EventBus__ = __webpack_require__("O67w");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var HEADER = 'get_header.php';
var LOCATION_GROUP = 'get_conclusion_location_group.php';
var CONCLUSION_INFO = 'get_conclusion_info.php';
var UPDATE_JSON = 'update_json.php';
var SAVE_GROUP = 'save_group.php';
var CAN_EDIT = 'can_edit_unit.php';
var NPA_VIOLATION_NEW = 'get_npa_violation_new.php';
var GET_GROUP = 'get_group.php';
var EDIT_GROUP = 'edit_group.php';
var FIND_GROUP = 'find_for_group.php';
var UNIT_ID = 2;
/*	const INSERT_JSON = 'insert_json.php'
	const UPDATE_JSON = 'update_json.php'
	const DELETE_JSON = 'delete_json.php'
	const JSON_U2 = 'get_json_u2.php'*/
//	const GET_PARENT = 'get_parent.php'















// import jQuery from "jquery"; 
// import datePicker from 'vue-bootstrap-datetimepicker';
//import datePicker from './../datePicker'



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'groupConclusion',
	data: function data() {
		return {
			scroll_width: 17,
			readonly: true,
			line_count: 0,
			selected_act: 0,
			similar_acts: [],
			saved_act: [],
			display_similar_acts: false,
			lines: [],
			group_acts: [],
			group_id: this.$route.params.id,
			//action: '',
			//old_obj: '',

			f_2: '',
			f_4: '',
			f_11: '',
			f_9: '',
			f_12: '',

			f_35: '',
			f_36: '',
			f_37: '',
			f_38: '',
			f_39: '',
			f_40: '',
			f_41: 2,
			f_42: 2,
			f_43: '',
			f_44: '',
			f_45: '',
			f_46: '',
			f_47: 1,
			f_48: '',
			f_49: '',
			f_50: '',

			upp_count: 0,
			mzl_count: 0,
			upp_lastdate: '',
			mzl_lastdate: '',

			f_28: [],
			f_29: [],
			f_30: [],
			f_31: [],
			f_32: [],
			f_33: [],
			f_34: [],

			f_17: [],
			f_24: [],
			f_25: [],

			f_0: [],
			location_id: [],

			fields_correct: {
				f_35: 'field-error',
				f_36: 'field-error',
				// f_38: 'field-error',
				// f_39: 'field-error',
				f_41: 'field-error',
				// f_44: 'field-error',
				// f_45: 'field-error',
				f_48: 'field-error',
				f_49: 'field-error'
			},

			submit_disabled: false,
			npa_violations: [],
			errorDecisionReason: false,
			data_is_loaded: false

		};
	},
	components: {
		region: __WEBPACK_IMPORTED_MODULE_7__edit_fetch_data_region__["a" /* default */],
		forestry: __WEBPACK_IMPORTED_MODULE_10__fetch_data_forestry__["a" /* default */],
		localforestry: __WEBPACK_IMPORTED_MODULE_11__fetch_data_localforestry__["a" /* default */],
		subforestry: __WEBPACK_IMPORTED_MODULE_12__fetch_data_subforestry__["a" /* default */],
		organization: __WEBPACK_IMPORTED_MODULE_8__fetch_data_organization__["a" /* default */],
		fo: __WEBPACK_IMPORTED_MODULE_9__edit_fetch_data_fo__["a" /* default */],
		decisionReason: __WEBPACK_IMPORTED_MODULE_13__fetch_data_decisionReason__["a" /* default */],
		actionType: __WEBPACK_IMPORTED_MODULE_14__fetch_data_actionType__["a" /* default */],
		datepicker: __WEBPACK_IMPORTED_MODULE_16_vue_strap__["datepicker"],
		modal: __WEBPACK_IMPORTED_MODULE_16_vue_strap__["modal"],
		npaViolation: __WEBPACK_IMPORTED_MODULE_15__fetch_data_npaViolation__["a" /* default */],
		checkbox: __WEBPACK_IMPORTED_MODULE_16_vue_strap__["checkbox"]
	},
	methods: {
		spreadActs: function spreadActs() {
			var firstLine = this.lines[this.getSelectedActIndex()][0];
			for (var act_index in this.lines) {
				for (var line in this.lines[act_index]) {
					if (line == 'act_id') continue;

					this.lines[act_index][line].f_28 = firstLine.f_28;
					this.lines[act_index][line].f_29 = firstLine.f_29;
					this.lines[act_index][line].f_30 = firstLine.f_30;
					this.lines[act_index][line].f_31 = firstLine.f_31;
					this.lines[act_index][line].f_33 = firstLine.f_33;
					this.lines[act_index][line].f_107 = firstLine.f_107;
				}
			}
		},
		getActLocations: function getActLocations(id) {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.lines), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var line = _step.value;

					if (line.act_id == id) {
						return line;
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return false;
		},
		checkActInGroup: function checkActInGroup(act_id) {
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.group_acts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var act = _step2.value;

					if (act.act_id == act_id) return true;
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			return false;
		},
		getSelectedActIndex: function getSelectedActIndex() {
			var selected_act_index = null;
			for (var i in this.lines) {
				if (this.lines[i].act_id == this.selected_act) {
					selected_act_index = i;
					break;
				}
			}
			return selected_act_index;
		},
		setRegistryAccordance: function setRegistryAccordance() {
			var selected_act_index = this.getSelectedActIndex();

			for (var i in this.lines[selected_act_index]) {
				if (i == 'act_id') continue;

				if (this.lines[selected_act_index][i].upp == 't') {
					if (this.lines[selected_act_index][i].accordance_upp == 't') this.lines[selected_act_index][i].f_28 = 1;
					if (this.lines[selected_act_index][i].accordance_upp == 'f') this.lines[selected_act_index][i].f_28 = 0;
				} else this.lines[selected_act_index][i].f_28 = 2;

				if (this.lines[selected_act_index][i].accordance_mzl == 't') this.lines[selected_act_index][i].f_30 = 1;else if (this.lines[selected_act_index][i].accordance_mzl == 'f') this.lines[selected_act_index][i].f_30 = 0;else this.lines[selected_act_index][i].f_30 = 2;
			}
		},
		decisionChange: function decisionChange(old, e) {
			var selected_act_index = this.getSelectedActIndex();
			var l = e.target.getAttribute('data-line');

			this.lines[selected_act_index][l].f_33 = e.target.value;
			this.lines[selected_act_index][l]['correct_f_33'] = e.target.value == '2' ? 'field-error' : 'place-success';
			if (this.f_41 == '1' && e.target.value == '0') this.f_41 = '0';

			if (old == '2' && e.target.value == '1') {
				this.lines[selected_act_index][l].f_28 = '1';
				this.lines[selected_act_index][l].f_29 = '1';
				this.lines[selected_act_index][l].f_30 = '1';
				this.lines[selected_act_index][l].f_31 = '1';
			}
		},
		mainDecisionChange: function mainDecisionChange(old, e) {
			var selected_act_index = this.getSelectedActIndex();

			this.f_41 = e.target.value;
			if (e.target.value == '0' || e.target.value == '1') {
				for (var act_index in this.lines) {
					for (var line in this.lines[act_index]) {
						if (line == 'act_id') continue;

						this.lines[act_index][line].f_28 = e.target.value;
						this.lines[act_index][line].f_29 = e.target.value;
						this.lines[act_index][line].f_30 = e.target.value;
						this.lines[act_index][line].f_31 = e.target.value;
						this.lines[act_index][line].f_33 = e.target.value;
						this.lines[act_index][line]['correct_f_33'] = 'place-success';
					}
				}
			}
		},
		checkFields: function checkFields() {
			return true;
			var main_fields = [35, 36, 48, 49];
			// const location_fields = [33]

			var result = true;

			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(main_fields), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var i = _step3.value;

					result = result && !!this['f_' + i]; //one false = result false, all true = result true
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			result = result && this.f_41 != '2';

			result = result && !!this.lines.length; //lines.length == 0 => result false

			for (var j = 0; j < this.lines.length; j++) {
				result = result && this.lines[j].f_33 != '2';
			}

			return result;
		},
		submit: function submit() {
			var _this = this;

			//console.warn(this.lines)

			this.submit_disabled = true;
			var obj = [];

			var counter = 0;
			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;

			try {
				for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.group_acts), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var act = _step4.value;

					obj.push({});
					obj[counter].tab_id = 1;
					obj[counter].f_v = {};
					obj[counter].f_v.f_c = act.act_id;

					for (var i = 35; i <= 50; i++) {
						if (this['f_' + i] !== '') {
							if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this['f_' + i]) !== 'object') {
								if (i === 41) obj[counter].f_v['f_' + i] = this['f_' + i] != '2' ? this['f_' + i] == '1' ? true : false : null;else if (i === 36 || i === 39 || i === 45 || i === 49) obj[counter].f_v['f_' + i] = commaToPeriod(this['f_' + i]);else obj[counter].f_v['f_' + i] = this['f_' + i];
							} else {
								obj[counter].f_v['f_' + i] = this['f_' + i].format('DD.MM.YYYY');
							}
						} else {
							obj[counter].f_v['f_' + i] = null;
						}
					}

					if (obj[counter].f_v.f_41 != false) obj[counter].f_v.f_42 = null;

					counter++;
				}

				//let counter = 0
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}

			var _iteratorNormalCompletion5 = true;
			var _didIteratorError5 = false;
			var _iteratorError5 = undefined;

			try {
				for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.lines), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
					var line = _step5.value;


					//console.warn(line)

					for (var _i in line) {
						if (_i == 'act_id') continue;

						obj.push({});

						obj[counter].tab_id = 2;
						obj[counter].f_v = {};
						obj[counter].f_v.f_c = line[_i].f_c;

						for (var j = 28; j <= 33; j++) {
							obj[counter].f_v['f_' + j] = line[_i]['f_' + j] != '2' ? line[_i]['f_' + j] == '1' ? true : false : null;
						}

						obj[counter].f_v.f_34 = line[_i].f_34 ? line[_i].f_34 : null;
						obj[counter].f_v.f_91 = line[_i].f_91;
						obj[counter].f_v.f_107 = line[_i].f_107;
						counter++;
					}
				}

				//console.log(JSON.stringify(obj)) 
			} catch (err) {
				_didIteratorError5 = true;
				_iteratorError5 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion5 && _iterator5.return) {
						_iterator5.return();
					}
				} finally {
					if (_didIteratorError5) {
						throw _iteratorError5;
					}
				}
			}

			var submit_conclusion_info = function submit_conclusion_info() {
				var form = new FormData();
				form.append('json', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(obj));

				fetch(__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DB */] + UPDATE_JSON, {
					credentials: 'include',
					method: 'post',
					body: form
				}).then(function (result) {
					return result.json();
				}).then(function (result) {
					if (result[0].code === '0') {
						alert('Заключение на группу актов сохранено');

						if (_this.$parent.lastJournalURL) __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].replace(_this.$parent.lastJournalURL);else __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].replace('/main');
					} else {
						alert(result[0].name);
					}
					_this.submit_disabled = false;
				}).catch(function (err) {
					return console.log(err);
				});
			};

			if (this.checkFields()) {
				if (this.errorDecisionReason) {
					alert("Выбранная главная причина отрицательного заключения отсутствует среди соответствий");
				}
				if (document.querySelector('.field-error') !== null) {
					alert('Часть полей содержит некорректные данные. Сохранение невозможно');
					this.submit_disabled = false;
				} else {
					//console.warn(JSON.stringify(obj))
					submit_conclusion_info();
				}
			} else {
				alert('Поля, отмеченные звёздочкой, обязательны к заполнению.');
				this.submit_disabled = false;
			}
		},
		close: function close() {
			if (this.$parent.lastJournalURL) __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].replace(this.$parent.lastJournalURL);else __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].replace('/main');
		},
		errorDecisionReasonHandler: function errorDecisionReasonHandler() {
			this.errorDecisionReason = false;
			if (Number(this.f_41) == 0) {
				var array = [];

				var selected_act_index = this.getSelectedActIndex();
				var error = false;
				var _iteratorNormalCompletion6 = true;
				var _didIteratorError6 = false;
				var _iteratorError6 = undefined;

				try {
					for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.lines), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
						var act = _step6.value;
						var _iteratorNormalCompletion7 = true;
						var _didIteratorError7 = false;
						var _iteratorError7 = undefined;

						try {
							for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(act), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
								var line = _step7.value;

								for (var i = 28; i <= 31; i++) {
									array[i] = array[i] || line['f_' + i] == 0;
								}
							}
						} catch (err) {
							_didIteratorError7 = true;
							_iteratorError7 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion7 && _iterator7.return) {
									_iterator7.return();
								}
							} finally {
								if (_didIteratorError7) {
									throw _iteratorError7;
								}
							}
						}

						if (this.f_42 == 1) error = !array[31];
						if (this.f_42 == 2) error = !array[30];
						if (this.f_42 == 3) error = !array[28];
						if (this.f_42 == 4) error = !array[29];

						if (error) {
							this.errorDecisionReason = true;
							break;
						}
					}
				} catch (err) {
					_didIteratorError6 = true;
					_iteratorError6 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion6 && _iterator6.return) {
							_iterator6.return();
						}
					} finally {
						if (_didIteratorError6) {
							throw _iteratorError6;
						}
					}
				}
			}
		},
		loadConclusionData: function loadConclusionData() {
			var _this2 = this;

			if (this.data_is_loaded) return;

			this.data_is_loaded = true;

			__WEBPACK_IMPORTED_MODULE_18__lib_EventBus__["a" /* EventBus */].$off('decision_reason');
			__WEBPACK_IMPORTED_MODULE_18__lib_EventBus__["a" /* EventBus */].$on('decision_reason', function (id) {
				_this2.f_42 = id;
			});

			__WEBPACK_IMPORTED_MODULE_18__lib_EventBus__["a" /* EventBus */].$off('npa_violation');
			__WEBPACK_IMPORTED_MODULE_18__lib_EventBus__["a" /* EventBus */].$on('npa_violation', function (data) {
				//console.warn(this.getActLocations(this.selected_act)[data.index].f_107)
				_this2.getActLocations(_this2.selected_act)[data.index].f_107 = data.value;
				//console.warn(this.getActLocations(this.selected_act)[data.index].f_107)
			});

			__WEBPACK_IMPORTED_MODULE_18__lib_EventBus__["a" /* EventBus */].$off('showSimilarActs');
			__WEBPACK_IMPORTED_MODULE_18__lib_EventBus__["a" /* EventBus */].$on('showSimilarActs', this.showSimilarActs);

			fetch(__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DB */] + CAN_EDIT + '?act_id=' + this.selected_act + '&unit_id=' + UNIT_ID, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				_this2.readonly = res[0].czl_check_can_edit_unit == 't' ? false : true;
			}).catch(function (err) {
				return console.log(err);
			});

			fetch(__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DB */] + HEADER + '?id=' + this.selected_act, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				//console.log('header:');
				//console.log(res);
				for (var i in res[0]) {
					//if(!this[i])
					_this2[i] = res[0][i];
				}

				_this2.loadConclusionData2();
			}).catch(function (err) {
				return console.log(err);
			});

			fetch(__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DB */] + LOCATION_GROUP + '?id=' + this.group_id, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				//console.log('location group:');
				//console.log(res);
				var _iteratorNormalCompletion8 = true;
				var _didIteratorError8 = false;
				var _iteratorError8 = undefined;

				try {
					for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(res), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
						var location = _step8.value;

						var found_id = false;
						for (var _i2 in _this2.lines) {
							if (_this2.lines[_i2].act_id == location.f_p) {
								_this2.lines[_i2].push(location);
								found_id = _i2;
							}
						}
						if (found_id === false) {
							var obj = [];
							obj['act_id'] = location.f_p;
							obj.push(location);
							_this2.lines.push(obj);
						}
					}
				} catch (err) {
					_didIteratorError8 = true;
					_iteratorError8 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion8 && _iterator8.return) {
							_iterator8.return();
						}
					} finally {
						if (_didIteratorError8) {
							throw _iteratorError8;
						}
					}
				}

				for (var i = 0; i < _this2.lines.length; i++) {
					for (var ii in _this2.lines[i]) {
						if (ii == 'act_id') continue;

						for (var j = 28; j <= 33; j++) {
							_this2.lines[i][ii]['f_' + j] = _this2.lines[i][ii]['f_' + j] ? _this2.lines[i][ii]['f_' + j] === 't' ? 1 : 0 : 2;
						}
						_this2.lines[i][ii].correct_f_33 = _this2.lines[i][ii].f_33 === 2 ? 'field-error' : '';
						_this2.lines[i][ii].f_91 = _this2.lines[i][ii].f_91 ? _this2.lines[i][ii].f_91 === 't' ? true : false : false;
					}
				}

				//console.warn(this.lines)

				/*if (res && !this.getActLocations(this.selected_act)) {
    	let locations = res
    	locations.act_id = this.selected_act
    	this.lines.push(locations)
    	console.warn(this.lines)
    }
    	for (let i = 0; i < res.length; i++) {
    	for (let j = 28; j <= 33; j++) {
    		this.getActLocations(this.selected_act)[i][`f_${j}`] = res[i][`f_${j}`] ? ((res[i][`f_${j}`] === 't') ? 1 : 0) : 2
    	}
    	this.getActLocations(this.selected_act)[i].correct_f_33 = res[i].f_33 === 2 ? 'field-error' : ''
    		this.getActLocations(this.selected_act)[i].f_91 = res[i].f_91 ? ((res[i].f_91 === 't') ? true : false) : false
    }*/
			}).catch(function (err) {
				return console.log('9', err);
			});
		},
		loadConclusionData2: function loadConclusionData2() {
			var _this3 = this;

			if (this.selected_act) {
				fetch(__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DB */] + CONCLUSION_INFO + '?id=' + this.selected_act, {
					credentials: 'include'
				}).then(function (res) {
					return res.json();
				}).then(function (res) {
					//console.log('conclusion info:');
					//console.log(res);
					if (res) {
						for (var i in res[0]) {
							if (res[0][i]) {
								if (!_this3[i]) {
									if (i === 'f_35' || i === 'f_38' || i === 'f_44' || i === 'f_48') {
										var d = __WEBPACK_IMPORTED_MODULE_17_moment___default()(res[0][i], 'YYYY-MM-DD');
										// console.log(res[0][i], d.format('DD.MM.YYYY'))
										_this3[i] = res[0][i] ? d.format('DD.MM.YYYY') : '';
									} else if (i === 'f_47' || i === 'f_41') {
										_this3[i] = res[0][i] === 't' ? 1 : 0;
									} else {
										_this3[i] = res[0][i];
									}
								}
							}
						}

						_this3.fields_correct.f_41 = res[0].f_41 == 2 || res[0].f_41 === null ? 'field-error' : '';
					}
				}).catch(function (err) {
					return console.log(err);
				});

				var act_date = __WEBPACK_IMPORTED_MODULE_17_moment___default()(this.f_48, "YYYY-MM-DD");
				var formattedDate = void 0;
				if (act_date.isValid()) {
					formattedDate = act_date.format("DD.MM.YYYY");
				} else {
					formattedDate = __WEBPACK_IMPORTED_MODULE_17_moment___default()().format("DD.MM.YYYY");
				}

				fetch(__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DB */] + NPA_VIOLATION_NEW + '?date=' + formattedDate, {
					credentials: 'include'
				}).then(function (data) {
					return data.json();
				}).then(function (data) {
					//console.log('npm violation');
					//console.log(data);
					if (data) {
						_this3.npa_violations = data;
						__WEBPACK_IMPORTED_MODULE_18__lib_EventBus__["a" /* EventBus */].$emit('fetch_npa_violations_complete');
					}
				}).catch(function (err) {
					return console.log(err);
				});
			}
		},
		showSimilarActs: function showSimilarActs() {
			var _this4 = this;

			fetch(__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DB */] + FIND_GROUP + '?act_id=' + this.selected_act, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				//console.warn(res)
				_this4.similar_acts = res;
				for (var act in _this4.similar_acts) {
					_this4.similar_acts[act].checked = _this4.checkActInGroup(_this4.similar_acts[act].act_id);
				}
				_this4.display_similar_acts = true;
			}).catch(function (err) {
				return console.log(err);
			});
		},
		editGroup: function editGroup() {
			var ids = [];
			var _iteratorNormalCompletion9 = true;
			var _didIteratorError9 = false;
			var _iteratorError9 = undefined;

			try {
				for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.similar_acts), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
					var act = _step9.value;

					if (act.checked) ids.push(act.act_id);
				}
			} catch (err) {
				_didIteratorError9 = true;
				_iteratorError9 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion9 && _iterator9.return) {
						_iterator9.return();
					}
				} finally {
					if (_didIteratorError9) {
						throw _iteratorError9;
					}
				}
			}

			fetch(__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DB */] + EDIT_GROUP + '?group_id=' + this.group_id + '&ids=' + ids.join(','), {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				window.location.reload();
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	created: function created() {
		var _this5 = this;

		fetch(__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DB */] + GET_GROUP + '?group_id=' + this.group_id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			//console.log('group');
			//console.log(res);
			_this5.group_acts = res;
			_this5.selected_act = _this5.group_acts[0].act_id;

			_this5.loadConclusionData();
		}).catch(function (err) {
			return console.log(err);
		});

		var ua = navigator.userAgent;

		if (ua.search('OPR/') > 0) {
			this.scroll_width = 15;
		}
	},
	mounted: function mounted() {
		this.loadConclusionData2();
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_18__lib_EventBus__["a" /* EventBus */].$off('decision_reason');
	},

	watch: {
		//[35,36,38,39,44,45,48,49]
		selected_act: function selected_act(id) {
			var _this6 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_this6.loadConclusionData();
								_this6.loadConclusionData2();
								_this6.$forceUpdate();

							case 3:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this6);
			}))();
		},

		lines: {
			handler: function handler() {
				this.errorDecisionReasonHandler();
			},
			deep: true
		},
		f_41: function f_41(e) {
			this.fields_correct.f_41 = e === '2' || e === null ? 'field-error' : '';
			this.errorDecisionReasonHandler();
		},
		f_42: function f_42() {
			this.errorDecisionReasonHandler();
		},
		f_35: function f_35(e) {
			var arr_f_35 = this.f_35.split('.');
			var date_f_35 = new Date(+arr_f_35[2], +arr_f_35[1] - 1, +arr_f_35[0]);
			var arr_f_48 = this.f_48.split('.');
			var date_f_48 = new Date(+arr_f_48[2], +arr_f_48[1] - 1, +arr_f_48[0]);
			if (date_f_35 > date_f_48) {
				this.fields_correct.f_35 = 'field-error';
				this.fields_correct.f_48 = 'field-error';
			} else {
				this.fields_correct.f_35 = e === '' || e === null ? 'field-error' : 'field-success';
				//this.fields_correct.f_48 = 'field-success'
			}
		},
		f_36: function f_36(e) {
			this.fields_correct.f_36 = e === '' || e === null ? 'field-error' : 'place-success';
		},
		f_38: function f_38(e) {
			this.fields_correct.f_38 = e === '' || e === null ? 'field-error' : 'field-success';
		},
		f_39: function f_39(e) {
			this.fields_correct.f_39 = e === '' || e === null ? 'field-error' : '';
		},
		f_44: function f_44(e) {
			this.fields_correct.f_44 = e === '' || e === null ? 'field-error' : 'field-success';
		},
		f_45: function f_45(e) {
			this.fields_correct.f_45 = e === '' || e === null ? 'field-error' : '';
		},
		f_48: function f_48(e) {
			var arr_f_35 = this.f_35.split('.');
			var date_f_35 = new Date(+arr_f_35[2], +arr_f_35[1] - 1, +arr_f_35[0]);
			var arr_f_48 = this.f_48.split('.');
			var date_f_48 = new Date(+arr_f_48[2], +arr_f_48[1] - 1, +arr_f_48[0]);
			if (date_f_35 > date_f_48) {
				this.fields_correct.f_35 = 'field-error';
				this.fields_correct.f_48 = 'field-error';
			} else {
				this.fields_correct.f_35 = 'field-success';
				this.fields_correct.f_48 = e === '' || e === null ? 'field-error' : 'field-success';
			}
		},
		f_49: function f_49(e) {
			this.fields_correct.f_49 = e === '' || e === null ? 'field-error' : '';
		}
	}
});

function commaToPeriod(str) {
	return str.replace(/,/g, ".");
}

/***/ }),

/***/ "9b0B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var FORESTRY = 'forestrie_list.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'forestry',
	data: function data() {
		return {
			selected: '0',
			options: [],
			id: this.type + '_forestry'
		};
	},
	props: {
		type: '',
		reg_id: '',
		f_id: ''
	},
	methods: {
		fill: function fill(id) {
			var _this = this;

			//console.log(id)
			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + FORESTRY + '?id=' + id).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					// this.selected = select ? select : '0'
					_this.options = [{ id: '0', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
					_this.selected = _this.f_id ? _this.f_id : '0';
				} else {
					_this.selected = '0';
					_this.options = [];
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	watch: {
		reg_id: function reg_id(id) {
			if (id) {
				this.fill(id);
			}
		}
	}
});

/***/ }),

/***/ "A+Qq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_locationTableField_vue__ = __webpack_require__("CFN4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ff05cde_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_locationTableField_vue__ = __webpack_require__("hY8M");
function injectStyle (ssrContext) {
  __webpack_require__("VfPe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ff05cde"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_locationTableField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ff05cde_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_locationTableField_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AGzF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"s-body-wrapper"},[_c('table',{staticClass:"s-body"},[_c('tbody',_vm._l((_vm.rows),function(row,i){return _c('tr',[_c('td',{staticClass:"medium_td"},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(row.npa))])]),_vm._v(" "),_c('td',{staticClass:"right s-td"},[_vm._v(_vm._s(row.som_count))]),_vm._v(" "),_c('td',{staticClass:"right s-td"},[_vm._v(_vm._s(row.som_s_mzl))]),_vm._v(" "),_c('td',{staticClass:"right s-td"},[_vm._v(_vm._s(row.ssr_count))]),_vm._v(" "),_c('td',{staticClass:"right s-td"},[_vm._v(_vm._s(row.ssr_s_mzl))]),_vm._v(" "),_c('td',{staticClass:"right s-td"},[_vm._v(_vm._s(row.vsr_count))]),_vm._v(" "),_c('td',{staticClass:"right s-td"},[_vm._v(_vm._s(row.vsr_s_mzl))]),_vm._v(" "),_c('td',{staticClass:"right s-td"},[_vm._v(_vm._s(row.und_count))]),_vm._v(" "),_c('td',{staticClass:"right s-td"},[_vm._v(_vm._s(row.und_s_mzl))]),_vm._v(" "),_c('td',{staticClass:"right s-td"},[_vm._v(_vm._s(row.rad_count))]),_vm._v(" "),_c('td',{staticClass:"right s-td"},[_vm._v(_vm._s(row.rad_s_mzl))])])}))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-header-wrapper"},[_c('table',{staticClass:"s-header"},[_c('thead',{staticClass:"bold"},[_c('tr',[_c('td',{staticClass:"medium_td",attrs:{"rowspan":"3"}},[_vm._v("Запрещение или ограничение законодательством")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2","colspan":"2"}},[_vm._v("СОМ")]),_vm._v(" "),_c('td',{attrs:{"colspan":"8"}},[_vm._v("В том числе:")]),_vm._v(" "),_c('td',{staticClass:"s-scroll",attrs:{"rowspan":"3"}})]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_vm._v("Сплошная санитарная рубка")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("Выборочная санитарная рубка")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("Уборка неликвидной древесины")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("Рубка аварийных деревьев")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"s-td small_td"},[_vm._v("кол-во участков")]),_vm._v(" "),_c('td',{staticClass:"s-td small_td"},[_vm._v("Площадь, га")]),_vm._v(" "),_c('td',{staticClass:"s-td small_td"},[_vm._v("кол-во участков")]),_vm._v(" "),_c('td',{staticClass:"s-td small_td"},[_vm._v("Площадь, га")]),_vm._v(" "),_c('td',{staticClass:"s-td small_td"},[_vm._v("кол-во участков")]),_vm._v(" "),_c('td',{staticClass:"s-td small_td"},[_vm._v("Площадь, га")]),_vm._v(" "),_c('td',{staticClass:"s-td small_td"},[_vm._v("кол-во участков")]),_vm._v(" "),_c('td',{staticClass:"s-td small_td"},[_vm._v("Площадь, га")]),_vm._v(" "),_c('td',{staticClass:"s-td small_td"},[_vm._v("кол-во участков")]),_vm._v(" "),_c('td',{staticClass:"s-td small_td"},[_vm._v("шт")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AVBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var GET_CONCLUSION_REPORT = 'get_conclusion_report.php';
var REPORT_ID = 2;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Conclusion',
	data: function data() {
		return {
			rows: []
		};
	},

	props: ['start', 'end'],
	methods: {
		fillTable: function fillTable(start, end) {
			var _this = this;

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + GET_CONCLUSION_REPORT + '?start=' + start + '&end=' + end).then(function (res) {
				return res.json();
			}).then(function (res) {
				var temp_rows = [{}];
				var flag = true;
				var total_summ = {};
				total_summ.region = 'Итого по РФ';
				total_summ.sending_conclusion = 0;
				total_summ.decision_true = 0;
				total_summ.decision_false = 0;
				total_summ.decision_false_glpm = 0;
				total_summ.decision_false_tax = 0;
				total_summ.decision_false_som = 0;
				total_summ.decision_false_law = 0;

				var fo_summ = {};
				fo_summ.region = 'Итого по округу';
				fo_summ.sending_conclusion = 0;
				fo_summ.decision_true = 0;
				fo_summ.decision_false = 0;
				fo_summ.decision_false_glpm = 0;
				fo_summ.decision_false_tax = 0;
				fo_summ.decision_false_som = 0;
				fo_summ.decision_false_law = 0;

				var i = 0;

				while (i < res.length - 1) {

					if (res[i].fo === res[i + 1].fo && flag) {
						var obj = {};
						obj.fo = res[i].fo;
						obj.flag = true;
						flag = false;

						if (i !== 0) {
							var _clone_fo = {}; //клонируем объект для передачи по значению
							for (var key in fo_summ) {
								_clone_fo[key] = fo_summ[key];
							}

							temp_rows.push(_clone_fo);

							fo_summ.sending_conclusion = 0;
							fo_summ.decision_true = 0;
							fo_summ.decision_false = 0;
							fo_summ.decision_false_glpm = 0;
							fo_summ.decision_false_tax = 0;
							fo_summ.decision_false_som = 0;
							fo_summ.decision_false_law = 0;
						}

						temp_rows.push(obj);
					} else {
						total_summ.sending_conclusion += +res[i].sending_conclusion;
						total_summ.decision_true += +res[i].decision_true;
						total_summ.decision_false += +res[i].decision_false;
						total_summ.decision_false_glpm += +res[i].decision_false_glpm;
						total_summ.decision_false_tax += +res[i].decision_false_tax;
						total_summ.decision_false_som += +res[i].decision_false_som;
						total_summ.decision_false_law += +res[i].decision_false_law;

						fo_summ.sending_conclusion += +res[i].sending_conclusion;
						fo_summ.decision_true += +res[i].decision_true;
						fo_summ.decision_false += +res[i].decision_false;
						fo_summ.decision_false_glpm += +res[i].decision_false_glpm;
						fo_summ.decision_false_tax += +res[i].decision_false_tax;
						fo_summ.decision_false_som += +res[i].decision_false_som;
						fo_summ.decision_false_law += +res[i].decision_false_law;

						temp_rows.push(res[i]);
						if (res[i].fo !== res[i + 1].fo) {
							flag = true;
						}
						i++;
					}
				}

				var last = res.length - 1;
				temp_rows.push(res[last]);

				total_summ.sending_conclusion += +res[last].sending_conclusion;
				total_summ.decision_true += +res[last].decision_true;
				total_summ.decision_false += +res[last].decision_false;
				total_summ.decision_false_glpm += +res[last].decision_false_glpm;
				total_summ.decision_false_tax += +res[last].decision_false_tax;
				total_summ.decision_false_som += +res[last].decision_false_som;
				total_summ.decision_false_law += +res[last].decision_false_law;

				fo_summ.sending_conclusion += +res[last].sending_conclusion;
				fo_summ.decision_true += +res[last].decision_true;
				fo_summ.decision_false += +res[last].decision_false;
				fo_summ.decision_false_glpm += +res[last].decision_false_glpm;
				fo_summ.decision_false_tax += +res[last].decision_false_tax;
				fo_summ.decision_false_som += +res[last].decision_false_som;
				fo_summ.decision_false_law += +res[last].decision_false_law;

				var clone_fo = {}; //клонируем объект для передачи по значению
				for (var _key in fo_summ) {
					clone_fo[_key] = fo_summ[_key];
				}

				temp_rows.push(clone_fo);

				temp_rows[0] = total_summ;

				_this.rows = temp_rows;
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		this.fillTable(this.start, this.end);

		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on('conclusion-date', function (date) {
			// console.log('con',date)
			_this2.fillTable(date.start, date.end);
		});

		var dispay_width = document.documentElement.clientWidth;
		var dispay_height = document.documentElement.clientHeight;
		var scroll_width = 17;

		var ua = navigator.userAgent;

		if (ua.search('OPR/') > 0) {
			scroll_width = 15;
		}

		var table_width = dispay_width - 30 - scroll_width;
		var col_width = Math.round(table_width / 8);

		document.querySelectorAll('.c-td').forEach(function (td) {
			td.width = col_width;
		});
		document.querySelector('.c-header-wrapper').width = table_width;
		document.querySelector('.c-body-wrapper').width = table_width;
		document.querySelector('.c-body-wrapper').style.maxHeight = dispay_height - 370 + 'px';

		// console.log(dispay_height, dispay_width, col_width, table_width)
		// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))

		document.querySelector('.c-scroll').width = scroll_width;
	},
	created: function created() {
		/*if(!this.$parent.$parent.reports.some((e) => {
  	return e.id == REPORT_ID
  }))
  	router.replace('/main')*/
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('conclusion-date');
	}
});

/***/ }),

/***/ "Ahfj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var ORGANIZATION = 'get_organization.php';
var HEADER = 'get_header.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'organization',
	data: function data() {
		return {
			selected: '0',
			options: []
		};
	},
	props: {
		set_id: ''
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('organization', this.selected);
		}
	},
	created: function created() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + HEADER + '?id=' + this.$parent.selected_act, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			return res[0].f_11;
		}).then(function (id) {
			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + ORGANIZATION, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.options = [{ id: '0', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
					_this.selected = id;
				} else {
					_this.options = [];
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}).catch(function (err) {
			return console.log(err);
		});
	}
});

/***/ }),

/***/ "Au1H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B4IV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_conclusionForm_vue__ = __webpack_require__("5yz/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f98ad9e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_conclusionForm_vue__ = __webpack_require__("vYQi");
function injectStyle (ssrContext) {
  __webpack_require__("G+eT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_conclusionForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f98ad9e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_conclusionForm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BI/C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_discoveredViolations_vue__ = __webpack_require__("h6Wo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4355913f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_discoveredViolations_vue__ = __webpack_require__("Ivw8");
function injectStyle (ssrContext) {
  __webpack_require__("Zshe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_discoveredViolations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4355913f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_discoveredViolations_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BLNQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListStates_vue__ = __webpack_require__("Rp2u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_449d6cd5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ListStates_vue__ = __webpack_require__("KSaI");
function injectStyle (ssrContext) {
  __webpack_require__("MxWA")
  __webpack_require__("3VDO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-449d6cd5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListStates_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_449d6cd5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ListStates_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Bip6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BqrJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'tooltipWarn',
	data: function data() {
		return {
			show_force: false,
			closed: false
		};
	},
	methods: {
		close: function close() {
			this.closed = true;
			this.show_force = false;
		}
	},
	props: ['value', 'typeIsRad', 'id'],
	computed: {
		display: function display() {
			//console.warn(this.$props, this.show_force, this.closed, this.typeIsRad && !Number.isInteger(Number(this.value)))
			if (this.show_force) return true;

			if (this.closed) return false;

			if (this.typeIsRad && !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(Number(this.value))) return true;

			return false;
		}
	},
	watch: {
		typeIsRad: function typeIsRad() {
			this.closed = false;
			this.show_force = false;
		},
		value: function value(e) {
			if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(Number(e))) this.closed = false;
		}
	},
	created: function created() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$on('show_tooltip_mzl_add', function (data) {
			if (data.id == _this.$props.id) _this.show_force = true;
		});
	}
});

/***/ }),

/***/ "C752":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CBfh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var GET_STAT_LPO_REPORT = 'get_stat_lpo_report.php';
var REPORT_ID = 12;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'StatLpo',
	data: function data() {
		return {
			rows: [],
			total_row: {}
		};
	},
	props: ['year'],
	computed: {
		endYear: function endYear() {
			return this.$props.end.split('.')[2];
		}
	},
	methods: {
		fillTable: function fillTable(year) {
			var _this = this;

			fetch(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DB */] + GET_STAT_LPO_REPORT + '?year=' + year).then(function (res) {
				return res.json();
			}).then(function (res) {
				//let temp_rows = [{}]
				//let flag = true
				//let total_summ = {}
				/*
        total_summ.region = 'Итого по РФ'
        total_summ.placement_all = 0
        total_summ.placement_week = 0
        total_summ.entrance_all = 0
        total_summ.entrance_week = 0
        total_summ.sending_conclusion_all = 0
        total_summ.sending_conclusion_week = 0
        total_summ.decision_false_all = 0
        total_summ.decision_false_week = 0
        total_summ.deletion_all = 0
        total_summ.deletion_week = 0
        total_summ.online_acts_all = 0
        total_summ.online_acts_week = 0
         let fo_summ = {}
        fo_summ.region = 'Итого по округу'
        fo_summ.placement_all = 0
        fo_summ.placement_week = 0
        fo_summ.entrance_all = 0
        fo_summ.entrance_week = 0
        fo_summ.sending_conclusion_all = 0
        fo_summ.sending_conclusion_week = 0
        fo_summ.decision_false_all = 0
        fo_summ.decision_false_week = 0
        fo_summ.deletion_all = 0
        fo_summ.deletion_week = 0
        fo_summ.online_acts_all = 0
        fo_summ.online_acts_week = 0
    */

				_this.total_row = {};
				_this.rows = [];
				var i = 0;
				var last_fo = null;

				var current_lpo_volume_plan = 0;
				var current_lpo_volume = 0;
				var russia_lpo_volume_plan = 0;
				var russia_lpo_volume = 0;

				for (var row_index in res) {
					if (res[row_index].fo_id == null) {
						_this.total_row = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res[row_index]));
						continue;
					}

					if (row_index == 0) _this.rows.push({
						new_fo: true,
						region: res[row_index].fo,
						fo: res[row_index].fo
					});

					if (res[row_index].fo != last_fo && row_index > 0) {
						_this.rows.push({
							bold: true,
							region: 'Итого по округу',
							lpo_volume_plan: +current_lpo_volume_plan.toFixed(2),
							lpo_volume: +current_lpo_volume.toFixed(2),
							proc: +Number(100 * current_lpo_volume / current_lpo_volume_plan).toFixed(2)
						});
						_this.rows.push({
							new_fo: true,
							region: res[row_index].fo,
							fo: res[row_index].fo
						});
						current_lpo_volume_plan = 0;
						current_lpo_volume = 0;
					}
					current_lpo_volume_plan += +res[row_index].lpo_volume_plan;
					current_lpo_volume += +res[row_index].lpo_volume;
					russia_lpo_volume_plan += +res[row_index].lpo_volume_plan;
					russia_lpo_volume += +res[row_index].lpo_volume;

					_this.rows.push(res[row_index]);
					last_fo = res[row_index].fo;
				}
				_this.rows.push({
					bold: true,
					region: 'Итого по округу',
					lpo_volume_plan: +current_lpo_volume_plan.toFixed(2),
					lpo_volume: +current_lpo_volume.toFixed(2),
					proc: +Number(100 * current_lpo_volume / current_lpo_volume_plan).toFixed(2)
				});

				_this.total_row = {
					lpo_volume_plan: +russia_lpo_volume_plan.toFixed(2),
					lpo_volume: +russia_lpo_volume.toFixed(2),
					proc: +Number(100 * russia_lpo_volume / russia_lpo_volume_plan).toFixed(2)
				};
				if (_this.total_row) {
					_this.total_row.bold = true;
					_this.rows.unshift(_this.total_row);

					_this.rows.unshift({
						new_fo: true,
						bold: true,
						region: 'Итого по РФ',
						fo: 'Итого по РФ'
					});
				}

				/*while (i < res.length - 1) {
    		if ((res[i].fo === res[i+1].fo) && flag) {
    		let obj = {}
    		obj.fo = res[i].fo
    		obj.flag = true
    		flag = false
    			if (i !== 0) {
    			let clone_fo = {} //клонируем объект для передачи по значению
    			for (let key in fo_summ) {
    				clone_fo[key] = fo_summ[key]
    			}
    				temp_rows.push(clone_fo)
    				/*fo_summ.placement_all = 0
    			fo_summ.placement_week = 0
    			fo_summ.entrance_all = 0
    			fo_summ.entrance_week = 0
    			fo_summ.sending_conclusion_all = 0
    			fo_summ.sending_conclusion_week = 0
    			fo_summ.decision_false_all = 0
    			fo_summ.decision_false_week = 0
    			fo_summ.deletion_all = 0
    			fo_summ.deletion_week = 0
    			fo_summ.online_acts_all = 0
    			fo_summ.online_acts_week = 0
    	}
    		temp_rows.push(obj)						
    }
    else {
    	/*total_summ.placement_all += +res[i].placement_all
    	total_summ.placement_week += +res[i].placement_week
    	total_summ.entrance_all += +res[i].entrance_all
    	total_summ.entrance_week += +res[i].entrance_week
    	total_summ.sending_conclusion_all += +res[i].sending_conclusion_all
    	total_summ.sending_conclusion_week += +res[i].sending_conclusion_week
    	total_summ.decision_false_all += +res[i].decision_false_all
    	total_summ.decision_false_week += +res[i].decision_false_week
    	total_summ.deletion_all += +res[i].deletion_all
    	total_summ.deletion_week += +res[i].deletion_week
    	total_summ.online_acts_all += +res[i].online_acts_all
    	total_summ.online_acts_week += +res[i].online_acts_week
    		fo_summ.placement_all += +res[i].placement_all
    	fo_summ.placement_week += +res[i].placement_week
    	fo_summ.entrance_all += +res[i].entrance_all
    	fo_summ.entrance_week += +res[i].entrance_week
    	fo_summ.sending_conclusion_all += +res[i].sending_conclusion_all
    	fo_summ.sending_conclusion_week += +res[i].sending_conclusion_week
    	fo_summ.decision_false_all += +res[i].decision_false_all
    	fo_summ.decision_false_week += +res[i].decision_false_week
    	fo_summ.deletion_all += +res[i].deletion_all
    	fo_summ.deletion_week += +res[i].deletion_week
    	fo_summ.online_acts_all += +res[i].online_acts_all
    	fo_summ.online_acts_week += +res[i].online_acts_week
    		temp_rows.push(res[i])
    	if (res[i].fo !== res[i+1].fo) {
    		flag = true
    	}
    	i++
    }*/

				/*
        let last = res.length - 1
         temp_rows.push(res[last])
         fo_summ.placement_all += +res[last].placement_all
        fo_summ.placement_week += +res[last].placement_week
        fo_summ.entrance_all += +res[last].entrance_all
        fo_summ.entrance_week += +res[last].entrance_week
        fo_summ.sending_conclusion_all += +res[last].sending_conclusion_all
        fo_summ.sending_conclusion_week += +res[last].sending_conclusion_week
        fo_summ.decision_false_all += +res[last].decision_false_all
        fo_summ.decision_false_week += +res[last].decision_false_week
        fo_summ.deletion_all += +res[last].deletion_all
        fo_summ.deletion_week += +res[last].deletion_week
        fo_summ.online_acts_all += +res[last].online_acts_all
        fo_summ.online_acts_week += +res[last].online_acts_week
         total_summ.placement_all += +res[last].placement_all
        total_summ.placement_week += +res[last].placement_week
        total_summ.entrance_all += +res[last].entrance_all
        total_summ.entrance_week += +res[last].entrance_week
        total_summ.sending_conclusion_all += +res[last].sending_conclusion_all
        total_summ.sending_conclusion_week += +res[last].sending_conclusion_week
        total_summ.decision_false_all += +res[last].decision_false_all
        total_summ.decision_false_week += +res[last].decision_false_week
        total_summ.deletion_all += +res[last].deletion_all
        total_summ.deletion_week += +res[last].deletion_week
        total_summ.online_acts_all += +res[last].online_acts_all
        total_summ.online_acts_week += +res[last].online_acts_week
         let clone_fo = {} //клонируем объект для передачи по значению
        for (let key in fo_summ) {
            clone_fo[key] = fo_summ[key]
        }
         temp_rows.push(clone_fo)
         temp_rows[0] = total_summ
         this.rows = temp_rows
    */
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		this.rows = [];
		this.fillTable(this.year);

		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$on('stat-lpo-date', function (date) {
			// console.log('mon',date)
			_this2.fillTable(date.year);
		});

		var dispay_width = document.documentElement.clientWidth;
		var dispay_height = document.documentElement.clientHeight;
		var scroll_width = 17;

		var ua = navigator.userAgent;

		// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))

		if (ua.search('OPR/') > 0) {
			scroll_width = 15;
		}

		var table_width = dispay_width - 30 - scroll_width;
		var col_width = Math.ceil(table_width / 13);

		document.querySelectorAll('.m-td').forEach(function (td) {
			td.width = col_width;
		});
		document.querySelector('.m-header-wrapper').width = table_width;
		document.querySelector('.m-body-wrapper').width = table_width;
		document.querySelector('.m-body-wrapper').style.maxHeight = dispay_height - 280 + 'px';

		// console.log(dispay_width, col_width, table_width)

		document.querySelector('.m-scroll').width = scroll_width;
	},
	created: function created() {
		if (!this.$parent.$parent.reports.some(function (e) {
			return e.id == REPORT_ID;
		})) __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].replace('/main');
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$off('stat-lpo-date');
	}
});

/***/ }),

/***/ "CDOg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var SUBFORESTRY = 'subforestrie_list.php';
//const HEADER = 'get_header.php'
var LOCATION = 'get_warrant_location.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'subforestry',
	data: function data() {
		return {
			id: this.type + '_localforestry_' + this.line_count,
			selected: '0',
			options: []
		};
	},
	props: {
		line_count: 0,
		type: ''
	},
	created: function created() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + LOCATION + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			var lf = res.filter(function (item) {
				return item.field == 'f_20';
			});
			var sf = res.filter(function (item) {
				return item.field == 'f_27';
			});
			if (lf[_this.line_count]) {
				if (sf[_this.line_count]) return { localforestry_id: lf[_this.line_count].val, subforestry_id: sf[_this.line_count].val };else return { localforestry_id: lf[_this.line_count].val, subforestry_id: '0' };
			} else return { localforestry_id: '0', subforestry_id: '0' };
		}).then(function (location) {
			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + SUBFORESTRY + '?id=' + location.localforestry_id).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.options = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
					//this.options.forEach(a => console.log(a.name))
					_this.selected = !location.subforestry_id ? '0' : location.subforestry_id;

					var sf = _this.options.filter(function (item) {
						return item.id == location.subforestry_id;
					});

					if (sf.length > 0) {
						__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('warrant_subforestry', { index: _this.line_count, value: _this.selected, text: sf[0].name });
					} else {
						__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('warrant_subforestry', { index: _this.line_count, value: _this.selected, text: '-' });
					}
					//console.log(data[this.line_count+1].name, this.line_count, location.localforestry_id, location.subforestry_id)
				} else {
					_this.selected = '0';
					_this.options = [];
				}
			}).catch(function (err) {
				return console.log('4', err);
			});
		}).catch(function (err) {
			return console.log('5', err);
		});
	}
});

/***/ }),

/***/ "CFN4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_CancelIcon__ = __webpack_require__("0KnF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_CheckIcon__ = __webpack_require__("xhmk");
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'locationTableField',
	data: function data() {
		return {
			tooltipIsVisible: false
		};
	},
	components: {
		CheckIcon: __WEBPACK_IMPORTED_MODULE_3__assets_CheckIcon__["a" /* default */], CancelIcon: __WEBPACK_IMPORTED_MODULE_2__assets_CancelIcon__["a" /* default */]
	},
	computed: {
		slotText: function slotText() {
			return this.$slots.default[0].text;
		}
	},
	props: {
		field_name: ''
	},
	methods: {
		showTooltip: function showTooltip() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('closeOtherTooltip');
			this.tooltipIsVisible = true;
		},
		hideTooltip: function hideTooltip(e) {
			if (e && (e.target.classList.contains('field_tooltip_parent') || e.target.classList.contains('field_tooltip'))) return 0;

			this.tooltipIsVisible = false;
		},
		sendZero: function sendZero() {
			this.$emit('set', { field: this.field_name, value: '0' });
		}
	},
	created: function created() {
		window.addEventListener('click', this.hideTooltip);
		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$on('closeOtherTooltip', this.hideTooltip);
	},
	beforeDestroy: function beforeDestroy() {
		window.removeEventListener('click', this.hideTooltip);
		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$off('closeOtherTooltip');
	}
});

/***/ }),

/***/ "CHse":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var FOREST_PURPOSE = 'get_forest_purpose.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'forestPurpose',
	data: function data() {
		return {
			selected: '',
			options: []
		};
	},
	props: {
		line_count: 0,
		type: '',
		id: null,
		disabled: false
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit(this.type + '_forest_purpose', { index: this.line_count, value: this.selected });
		}
	},
	created: function created() {
		var _this = this;

		if (this.$parent.data_location.forest_purpose.length) {
			this.options = this.$parent.data_location.forest_purpose;
			this.selected = this.$props.id ? this.$props.id : this.$parent.data_location.forest_purpose[0].id;

			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit(this.type + '_protective_cat_' + this.line_count, this.selected);
		} else {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$on('fetch_protective_cat_complete', function () {
				_this.options = _this.$parent.data_location.forest_purpose;
				_this.selected = _this.$props.id ? _this.$props.id : _this.$parent.data_location.forest_purpose[0].id;

				__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$off('fetch_protective_cat_complete');
			});
		}

		/*
  fetch(DB + FOREST_PURPOSE, {
  	credentials: 'include'
  })
  .then(data => data.json())
  .then(data => {
  	if (data) {
  		this.options = data
  		this.selected = this.$props.id ? this.$props.id : data[0].id
  	}
  	else {
  		this.options = []
  	}
  })
  .catch(err => console.log(err)) */
	}
});

/***/ }),

/***/ "CKjs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TerritoryCatalog_vue__ = __webpack_require__("z4V9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a89dd5ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TerritoryCatalog_vue__ = __webpack_require__("71UR");
function injectStyle (ssrContext) {
  __webpack_require__("4+An")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a89dd5ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TerritoryCatalog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a89dd5ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TerritoryCatalog_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CSBt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var GET_NPA_MZL_REPORT = 'get_npa_mzl_report.php';
var REPORT_ID = 3;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'NpaMzl',
	data: function data() {
		return {
			rows: []
		};
	},
	props: ['start', 'end', 'regions'],
	methods: {
		floatConvert: function floatConvert(number) {
			return +parseFloat(number).toPrecision(12);
		},
		fillTable: function fillTable(start, end, regions) {
			var _this = this;

			var joined = 'null';
			if (regions.length) joined = '{' + regions.map(function (e) {
				return e.id;
			}).join(',') + '}';

			fetch(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DB */] + GET_NPA_MZL_REPORT + '?start=' + start + '&end=' + end + '&regions=' + joined).then(function (res) {
				return res.json();
			}).then(function (res) {
				var sum_som_count = 0;
				var sum_som_s_mzl = 0;
				var sum_ssr_count = 0;
				var sum_ssr_s_mzl = 0;
				var sum_vsr_count = 0;
				var sum_vsr_s_mzl = 0;
				var sum_und_count = 0;
				var sum_und_s_mzl = 0;
				var sum_rad_count = 0;
				var sum_rad_s_mzl = 0;

				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var row = _step.value;

						sum_som_count += +row.som_count;
						sum_som_s_mzl += +row.som_s_mzl;
						sum_ssr_count += +row.ssr_count;
						sum_ssr_s_mzl += +row.ssr_s_mzl;
						sum_vsr_count += +row.vsr_count;
						sum_vsr_s_mzl += +row.vsr_s_mzl;
						sum_und_count += +row.und_count;
						sum_und_s_mzl += +row.und_s_mzl;
						sum_rad_count += +row.rad_count;
						sum_rad_s_mzl += +row.rad_s_mzl;
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				_this.rows = res;
				_this.rows.push({
					npa: 'Итого',
					som_count: _this.floatConvert(sum_som_count),
					som_s_mzl: _this.floatConvert(sum_som_s_mzl),
					ssr_count: _this.floatConvert(sum_ssr_count),
					ssr_s_mzl: _this.floatConvert(sum_ssr_s_mzl),
					vsr_count: _this.floatConvert(sum_vsr_count),
					vsr_s_mzl: _this.floatConvert(sum_vsr_s_mzl),
					und_count: _this.floatConvert(sum_und_count),
					und_s_mzl: _this.floatConvert(sum_und_s_mzl),
					rad_count: _this.floatConvert(sum_rad_count),
					rad_s_mzl: _this.floatConvert(sum_rad_s_mzl)
				});
			}).then(function () {
				_this.resizeTable();
			}).catch(function (err) {
				return console.log(err);
			});
		},
		resizeTable: function resizeTable() {
			var dispay_width = document.documentElement.clientWidth;
			var dispay_height = document.documentElement.clientHeight;
			var scroll_width = 17;

			var ua = navigator.userAgent;
			if (ua.search('OPR/') > 0) {
				scroll_width = 15;
			}

			var table_width = document.querySelector('.s-header').clientWidth - scroll_width + 2;
			var col_width = Math.floor(table_width / 12);

			document.querySelectorAll('.s-td').forEach(function (td) {
				td.width = col_width;
			});

			document.querySelectorAll('.medium_td').forEach(function (td) {
				td.width = 2 * col_width;
			});
			document.querySelector('.s-scroll').width = scroll_width;
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		this.fillTable(this.start, this.end, this.regions);

		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$on('npa-mzl-data', function (data) {
			_this2.fillTable(data.start, data.end, data.regions);
		});

		this.resizeTable();

		//document.querySelector('.s-header-wrapper').width = table_width
		//document.querySelector('.s-body-wrapper').width = table_width
		//document.querySelector('.s-body-wrapper').style.maxHeight = `${dispay_height - 340}px`

		// console.log(dispay_width, col_width, table_width)


		// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))
	},
	created: function created() {
		/*if(!this.$parent.$parent.reports.some((e) => {
  	return e.id == REPORT_ID
  }))
  	router.replace('/main')*/
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$off('npa-mzl-data');
	}
});

/***/ }),

/***/ "CTFA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D/lR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forestry_vue__ = __webpack_require__("P0g7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df3815ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_forestry_vue__ = __webpack_require__("uMkM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forestry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df3815ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_forestry_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DF1r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var ORGANIZATION = 'get_organization.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'organization',
	data: function data() {
		return {
			selected: '0',
			options: []
		};
	},
	props: {
		set_id: '',
		field_class: ''
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('organization', this.selected);
		}
	},
	mounted: function mounted() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + ORGANIZATION, {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (data) {
			if (data) {
				_this.options = data;
			} else {
				_this.options = [];
			}
		}).catch(function (err) {
			return console.log(err);
		});
	}
});

/***/ }),

/***/ "DNPs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1 col"},[_vm._v("Вид отчёта")]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.type),expression:"type"}],staticClass:"form-control my-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.reportsList),function(report){return _c('option',{key:report.id,domProps:{"value":report.id}},[_vm._v(_vm._s(report.name))])}))]),_vm._v(" "),(_vm.type == 12)?[_c('div',{staticClass:"col-md-1 col"},[_vm._v("Период")]),_vm._v(" "),_c('span',{staticClass:"col-md-1"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.year),expression:"year"}],staticClass:"form-control my-control",on:{"input":_vm.yearChange,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"2018"}},[_vm._v("2018")]),_vm._v(" "),_c('option',{attrs:{"value":"2019"}},[_vm._v("2019")]),_vm._v(" "),_c('option',{attrs:{"value":"2020"}},[_vm._v("2020")]),_vm._v(" "),_c('option',{attrs:{"value":"2021"}},[_vm._v("2021")]),_vm._v(" "),_c('option',{attrs:{"value":"2022"}},[_vm._v("2022")]),_vm._v(" "),_c('option',{attrs:{"value":"2023"}},[_vm._v("2023")]),_vm._v(" "),_c('option',{attrs:{"value":"2024"}},[_vm._v("2024")]),_vm._v(" "),_c('option',{attrs:{"value":"2025"}},[_vm._v("2025")]),_vm._v(" "),_c('option',{attrs:{"value":"2026"}},[_vm._v("2026")])])])]:[_c('div',{staticClass:"col-md-1 col"},[_vm._v("Период")]),_vm._v(" "),_c('span',{staticClass:"col-md-1",staticStyle:{"width":"30px"}},[_vm._v("\n\t\t\t\tс\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col"},[_c('datepicker',{staticClass:"dp-control",attrs:{"format":"dd.MM.yyyy","disabled":_vm.disableDate},on:{"input":_vm.startChange},model:{value:(_vm.start),callback:function ($$v) {_vm.start=$$v},expression:"start"}})],1),_vm._v(" "),_c('span',{staticClass:"col-md-1",staticStyle:{"width":"30px"}},[_vm._v("\n\t\t\t\tдо\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col"},[_c('datepicker',{staticClass:"dp-control",attrs:{"format":"dd.MM.yyyy","disabled":_vm.disableDate},on:{"input":_vm.endChange},model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}})],1)],_vm._v(" "),_c('div',{staticClass:"col-md-3 pull-right"},[_c('input',{staticClass:"btn btn-secondary",attrs:{"type":"button","value":"Отмена"},on:{"click":function($event){$event.preventDefault();_vm.close($event)}}}),_vm._v(" "),_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Сохранить"},on:{"click":function($event){$event.preventDefault();_vm.save($event)}}}),_vm._v(" "),_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Сформировать","disabled":_vm.disableView},on:{"click":function($event){$event.preventDefault();_vm.view($event)}}})])],2),_vm._v(" "),(_vm.displayRegionsList)?_c('regions-list'):_vm._e(),_vm._v(" "),(_vm.displayFoList)?_c('fo-list',{attrs:{"all":_vm.displaySelectAllFOs}}):_vm._e(),_vm._v(" "),(!_vm.disableView)?_c('router-view',{attrs:{"start":_vm.start,"end":_vm.end,"regions":_vm.regions,"year":_vm.year}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Da4G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_localforestry_vue__ = __webpack_require__("WGk3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2890fd5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_localforestry_vue__ = __webpack_require__("pt6s");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_localforestry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2890fd5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_localforestry_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dqt0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lpoMethod_vue__ = __webpack_require__("KeBO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3ffbce2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_lpoMethod_vue__ = __webpack_require__("a1nV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lpoMethod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3ffbce2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_lpoMethod_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DslM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lpoMode_vue__ = __webpack_require__("TiF/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e0006d1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_lpoMode_vue__ = __webpack_require__("1elM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lpoMode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e0006d1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_lpoMode_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dyyd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E+9r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E+Qb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center list-title"},[_vm._v("\n\t\t\tРеестр взаимодействия\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"l-header-wrapper"},[_c('table',{staticClass:"header"},[_c('thead',[_vm._m(0),_vm._v(" "),_c('tr',[_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"fo","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"region","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"forestry","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"act_nums","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"supervisory","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"letter_date_txt","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"letter_num","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-scroll",on:{"click":_vm.clearFilters}},[_c('span',{staticClass:"glyphicon glyphicon-remove pointer",attrs:{"title":"Сбросить фильтры"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"l-body-wrapper"},[_c('table',{staticClass:"body"},[_c('tbody',_vm._l((_vm.lines),function(line,i){return _c('tr',{class:{ selected: line.selected },on:{"click":function($event){_vm.select_line(i)}}},[_c('td',{staticClass:"td-num l-td"},[_vm._v(_vm._s(line.fo))]),_vm._v(" "),_c('td',{staticClass:"td-num l-td"},[_vm._v(_vm._s(line.region))]),_vm._v(" "),_c('td',{staticClass:"td-num l-td"},[_vm._v(_vm._s(line.forestry))]),_vm._v(" "),_c('td',{staticClass:"td-num l-td"},[_vm._v(_vm._s(line.act_nums))]),_vm._v(" "),_c('td',{staticClass:"td-num l-td"},[_vm._v(_vm._s(line.supervisory))]),_vm._v(" "),_c('td',{staticClass:"td-num l-td"},[_vm._v(_vm._s(line.letter_date_txt))]),_vm._v(" "),_c('td',{staticClass:"td-num l-td"},[_vm._v(_vm._s(line.letter_num))])])}))])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"text-center"},[(_vm.pages)?_c('ul',{staticClass:"pagination"},_vm._l((_vm.pages),function(page){return _c('li',{class:{ active: page.active }},[(_vm.isNumeric(page.num))?_c('a',{attrs:{"href":"#","data-value":page.num},on:{"click":_vm.select_page}},[_vm._v(_vm._s(page.num))]):_c('span',{staticClass:"disabled_page",attrs:{"href":"#"}},[_vm._v(_vm._s(page.num))])])})):_vm._e()])]),_vm._v(" "),_c('modal',{attrs:{"backdrop":false,"medium":""},model:{value:(_vm.showChangeConclusionUserValue),callback:function ($$v) {_vm.showChangeConclusionUserValue=$$v},expression:"showChangeConclusionUserValue"}},[_c('div',{staticClass:"modal-header",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_c('b',[_vm._v("Назначить ответственного за заключения")])])]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"15px"}},[_c('ul',{staticClass:"user-list"},_vm._l((_vm.users),function(user){return _c('li',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.conclusion_user),expression:"conclusion_user"}],attrs:{"type":"radio","id":user.id},domProps:{"value":user.id,"checked":_vm._q(_vm.conclusion_user,user.id)},on:{"change":function($event){_vm.conclusion_user=user.id}}}),_vm._v(" "),_c('label',{attrs:{"for":user.id}},[_vm._v(_vm._s(user.name))])])}))]),_vm._v(" "),_c('div',{staticClass:"modal-footer",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":_vm.closeChangeConclusionUser}},[_vm._v("Отмена")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.conclusion_user},on:{"click":_vm.changeConclusionUser}},[_vm._v("Ок")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"center l-td"},[_vm._v("ФО")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Субъект РФ")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Лесничество")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Номера актов")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Надзорный орган")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Дата")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Номер")]),_vm._v(" "),_c('th',{staticClass:"l-scroll"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E4hU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lpoReason_vue__ = __webpack_require__("45dX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcfeece2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_lpoReason_vue__ = __webpack_require__("EZGs");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lpoReason_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcfeece2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_lpoReason_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EUcY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 426.667 426.667"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 426.667 426.667","xml:space":"preserve"}},[_c('path',{staticStyle:{"fill":"#F05228"},attrs:{"d":"M213.333,0C95.514,0,0,95.514,0,213.333s95.514,213.333,213.333,213.333\r\n\ts213.333-95.514,213.333-213.333S331.153,0,213.333,0z M330.995,276.689l-54.302,54.306l-63.36-63.356l-63.36,63.36l-54.302-54.31\r\n\tl63.356-63.356l-63.356-63.36l54.302-54.302l63.36,63.356l63.36-63.356l54.302,54.302l-63.356,63.36L330.995,276.689z"}}),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EZGs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F9gM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var REASON = 'get_decision_reason.php';
var CONCLUSION_INFO = 'get_conclusion_info.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'decisionReason',
	data: function data() {
		return {
			selected: '',
			options: [],
			savedOptions: [],
			savedId: ''
		};
	},
	props: {
		disabled: false,
		error: false
	},
	watch: {
		disabled: function disabled(newVal, oldVal) {
			if (newVal) {
				this.savedOptions = this.options;
				this.savedId = this.selected;
				this.options = [{ id: '', name: '' }];
				this.selected = '';
			} else {
				this.options = this.savedOptions;
				this.selected = this.savedId ? this.savedId : this.options[0] ? this.options[0].id : '';
			}
			this.change();
		}
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('decision_reason', this.selected);
		}
	},
	mounted: function mounted() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + CONCLUSION_INFO + '?id=' + this.$parent.selected_act, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			return res[0].f_42;
		}).then(function (set_id) {
			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + REASON, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.savedOptions = data;
					_this.options = set_id ? data : [{ id: '', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
					_this.selected = set_id ? set_id : '';
					_this.savedId = _this.selected;
				} else {
					_this.options = [];
					_this.selected = '';
				}
				_this.change();
			}).catch(function (err) {
				return console.log(err);
			});
		}).catch(function (err) {
			return console.log(err);
		});
	},
	created: function created() {
		var _this2 = this;

		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on('set_decision_reason', function (id) {
			_this2.selected = id;
		});
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('set_decision_reason');
	}
});

/***/ }),

/***/ "FCR+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FPpz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//


// const LOCALFORESTRY = 'localforestrie_list.php'
var LOCALFORESTRY = 'get_localforestry_by_id.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'localforestry',
	data: function data() {
		return {
			value: '',
			id: this.type + '_localforestry_' + this.line_count,
			l: this.lf_id
		};
	},
	props: {
		line_count: 0,
		type: '',
		lf_id: ''
	},
	watch: {
		created: function created() {
			var _this = this;

			//console.log(`set_localforestry_${this.line_count}`)
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$on('set_localforestry_' + this.line_count, function (id) {
				//console.log(id)
				fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + LOCALFORESTRY + '?id=' + id).then(function (data) {
					return data.json();
				}).then(function (data) {
					//console.log(d, data)
					if (data) {
						_this.value = data[0].name;
					} else {
						_this.value = '';
					}
				}).catch(function (err) {
					return console.log(err);
				});
			});
		},
		beforeDestroy: function beforeDestroy() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$off('set_localforestry_' + this.line_count);
		}
	}
});

/***/ }),

/***/ "FmPq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G+eT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G4I8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",class:!_vm.selected ? "field-error-warrant" : "",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GFu2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__ = __webpack_require__("Mbf/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_137d66ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__ = __webpack_require__("DNPs");
function injectStyle (ssrContext) {
  __webpack_require__("yc1Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_137d66ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GPnH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control table-control my-control",attrs:{"id":_vm.id,"data-num":"f_20","data-table":"1"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GX2f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GYiq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GkOP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gp+w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H724":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HEn/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var GET_FO = 'get_fo.php';
var GET_REGIONS = 'region_list.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'RegionsList',
	data: function data() {
		return {
			selected_fo: '',
			options_fo: [],
			selected_region: '',
			options_region: [],
			skip_emit: false
		};
	},
	watch: {
		selected_fo: function selected_fo(val) {
			if (this.selected_region) this.skip_emit = true;
			this.fill_region(val);
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('change_fo', this.options_fo.find(function (e) {
				return e.id == val;
			}));
		},
		selected_region: function selected_region(val) {
			var _this = this;

			if (val) {
				__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('change_regions', [this.options_region.find(function (e) {
					return e.id == _this.selected_region;
				})]);
				this.select_fo(val);
			} else __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('change_regions', this.options_region);
		},
		options_region: function options_region(val) {
			if (!this.selected_region) {
				if (this.skip_emit) this.skip_emit = false;else __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('change_regions', this.options_region);
			}
		}
	},
	methods: {
		select_fo: function select_fo(region_id) {
			var _this2 = this;

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + GET_FO + '?id=' + region_id, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this2.selected_fo = data[0].id;
				} else {
					_this2.selected_fo = null;
				}
			}).catch(function (err) {
				return console.log(err);
			});
		},
		fill_fo: function fill_fo() {
			var _this3 = this;

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + GET_FO, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this3.options_fo = [{ id: 0, name: 'Все федеральные округа' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
					_this3.selected_fo = _this3.options_fo[0].id;
				} else {
					_this3.options_fo = [];
					_this3.selected_fo = null;
				}
			}).catch(function (err) {
				return console.log(err);
			});
		},
		fill_region: function fill_region(id) {
			var _this4 = this;

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + GET_REGIONS + ('?id=' + id), {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					if (id == 0) _this4.options_region = [{ id: 0, name: 'Все субъекты РФ' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));else _this4.options_region = [{ id: 0, name: 'Все субъекты федерального округа' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));

					if (!_this4.options_region.find(function (e) {
						return e.id === _this4.selected_region;
					})) _this4.selected_region = _this4.options_region[0].id;
				} else {
					_this4.options_region = [];
					_this4.selected_region = null;
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	created: function created() {
		this.fill_fo();
	},
	beforeDestroy: function beforeDestroy() {}
});

/***/ }),

/***/ "Ha1D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_organization_vue__ = __webpack_require__("QAHX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba72973a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_organization_vue__ = __webpack_require__("Sdi2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_organization_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba72973a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_organization_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HccC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var FORESTRY = 'forestrie_list.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'forestry',
	data: function data() {
		return {
			selected: '0',
			options: [],
			id: this.type + '_forestry'
		};
	},
	props: {
		type: '',
		field_class: '',
		forestry_id: null
	},
	watch: {
		forestry_id: function forestry_id(val) {
			this.selected = val;
		}
	},
	methods: {
		checkDisableOnButtons: function checkDisableOnButtons() {
			var btnAddLine = document.getElementById('btnAddLine');
			var btnCopyLine = document.getElementById('btnCopyLine');
			var btnDeleteLine = document.getElementById('btnDeleteLine');

			if (this.selected === '0') {
				btnAddLine.disabled = true;
				btnCopyLine.disabled = true;
				btnDeleteLine.disabled = true;
			} else {
				btnAddLine.disabled = false;
				btnCopyLine.disabled = false;
				btnDeleteLine.disabled = false;
			}
		},

		fill: function fill(id) {
			var _this = this;

			//console.log(id)
			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + FORESTRY + '?id=' + id).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.options = [{ id: '0', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
					if (_this.forestry_id) {
						_this.selected = _this.forestry_id;
					}
				} else {
					_this.selected = '0';
					//console.log(this.selected)
					_this.options = [];
				}
			}).then(function () {
				_this.checkDisableOnButtons();
			}).catch(function (err) {
				return console.log(err);
			});
		},
		change: function change() {
			this.checkDisableOnButtons();
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit(this.type + '_forestry', this.selected);
		}
	},
	created: function created() {
		var _this2 = this;

		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on(this.type + '_region', function (id) {
			_this2.fill(id);
		});
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off(this.type + '_region');
	}
});

/***/ }),

/***/ "HezV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hyik":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control",class:{"field-error": _vm.error},attrs:{"disabled":_vm.disabled},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IFg0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control",attrs:{"disabled":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IhTn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "actsNumsSelector",
    data: function data() {
        return {
            display_nums_hint: false,
            act_num: '',
            acts_nums_to_search: [],
            date: '',
            similar_nums: [],
            no_lose_focus: false,
            year: null
        };
    },
    props: {
        acts_is_loading: {
            type: Boolean,
            default: false
        },
        acts_nums: {
            type: Array,
            required: true
        }
    },
    components: {
        datepicker: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["datepicker"]
    },
    computed: {
        searchButtonDisabled: function searchButtonDisabled() {
            if (this.acts_is_loading) return true;
            if (this.date.length == 0) {
                return this.acts_nums_to_search.length == 0;
            } else {
                return false;
            }
        }
    },
    methods: {
        isNumIsSelected: function isNumIsSelected(num) {
            return this.acts_nums_to_search.includes(num);
        },
        search: function search() {
            this.$emit('change', { nums: this.acts_nums_to_search, date: this.date });
            this.$emit('search');
        },
        searchInputFocus: function searchInputFocus() {
            this.inputActNum();

            if (this.similar_nums.length) this.display_nums_hint = true;
        },
        inputActNum: function inputActNum(e) {
            if (!this.act_num) return false;

            this.similar_nums = [];
            this.display_nums_hint = false;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.acts_nums), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var num = _step.value;

                    if (this.similar_nums.length > 20) break;

                    if (num.num.includes(this.act_num)) this.similar_nums.push(num);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (this.similar_nums.length) this.display_nums_hint = true;
        },
        selectActNum: function selectActNum(num) {
            if (this.isNumIsSelected(num)) {
                this.deleteNum(num);
            } else {
                this.acts_nums_to_search.push(num);
            }
            /*
            this.act_num_to_search = num
            this.$emit('change', this.acts_nums_to_search)
            this.display_nums_hint = false*/
        },
        closeNumsHint: function closeNumsHint() {
            this.display_nums_hint = false;
        },
        deleteNum: function deleteNum(num) {
            this.acts_nums_to_search = this.acts_nums_to_search.filter(function (e) {
                return e != num;
            });
        }
    }
});

/***/ }),

/***/ "IhVI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",attrs:{"disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Iu82":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ivw8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dropdown',{staticClass:"npa-discovered-violations-dropdown form-control height-control",class:_vm.names == "н/д" ? "warrant-field-error" : "",attrs:{"disabled":_vm.disabled,"text":_vm.names},on:{"input":_vm.open},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},[_c('li',{staticClass:"divider",attrs:{"role":"separator"}}),_vm._v(" "),_c('table',{staticClass:"npa-violation-table"},[_c('thead',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Нарушение пунктов пост. Пра-ва 1158")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(i){return _c('tr',[_c('td',{staticClass:"npa-violation-td-checkbox"},[_c('checkbox',{staticClass:"npa-violation-checkbox",attrs:{"type":"info"},on:{"input":function($event){_vm.check(i.id, i.name_short, i.checked)}},model:{value:(i.checked),callback:function ($$v) {_vm.$set(i, "checked", $$v)},expression:"i.checked"}})],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left !important","padding-left":"5px"}},[_vm._v(_vm._s(i.name))])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J5W9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__("SQ6o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__organization__ = __webpack_require__("uJ1M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__organizationProperty__ = __webpack_require__("bnjB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__("qI5z");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var REG = 'reg_new_user.php';
var USER_ID = 'get_user_id.php';
var UNITS = 'get_units.php';
var REPORTS = 'get_reports.php';

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      user: {
        f_93: '', //f
        f_94: '', //i
        f_95: '', //o
        f_96: '', //org_id
        f_97: '', //org_loc_id
        f_98: '', //post
        f_99: '', //contacts
        f_100: '', //email
        f_108: '',
        f_109: ''
      },
      stage: 1,
      showRegModal: false,
      showErrorModal: false,
      new_login: null,
      new_pass: null,
      double_login: null,
      double_user: null,
      units: [],
      reports: [],
      rights: []
    };
  },

  computed: {
    header: function header() {
      if (this.stage == 1) return 'Регистрация нового пользователя';else return 'Укажите права пользователя';
    },
    button_label: function button_label() {
      if (this.stage == 3) return 'Регистрация';else return 'Продолжить';
    },
    disableButton: function disableButton() {
      if (this.stage == 1) if (this.user.f_93.length && this.user.f_94.length && this.user.f_95.length && this.user.f_96 != '0' && this.user.f_97 != '0' && this.user.f_98.length && this.user.f_100.length && /\S+@\S+\.\S+/.test(this.user.f_100)) return false;

      if (this.stage == 2 || this.stage == 3) return false;

      return true;
    }
  },
  methods: {
    cancel: function cancel() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace('/main');
    },
    disabledBox: function disabledBox(id) {
      if (this.units[id].state === null) return true;else return false;
    },
    canUpdateUnitChange: function canUpdateUnitChange(id, value) {
      if (value) this.units[id].state = false;else this.units[id].state = null;
      this.$forceUpdate();
    },
    canAdministrateUnitChange: function canAdministrateUnitChange(id, value) {
      this.units[id].state = value;
      this.$forceUpdate();
    },
    canVievReportChange: function canVievReportChange(id, value) {
      this.reports[id].state = value;
    },
    nextStage: function nextStage() {
      var _this = this;

      if (this.stage == 1) {
        var data = new FormData();

        data.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.user));

        fetch(__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* DB */] + USER_ID, {
          method: 'POST',
          body: data,
          credentials: 'include'
        }).then(function (result) {
          return result.json();
        }).then(function (result) {
          if (result.id != -1) {
            _this.showErrorModal = true;
            _this.double_user = result.name;
            _this.double_login = result.login;
          } else {
            _this.stage++;
            return;
          }
        }).catch(function (e) {
          console.log(e);
        });
      }
      if (this.stage == 2) {
        this.stage++;
        return;
      }
      if (this.stage == 3) {
        var units_obj = '';
        for (var i in this.units) {
          if (this.units[i].state == true || this.units[i].state == false) units_obj += '{' + this.units[i].id + ',' + this.units[i].state + '},';
        }units_obj = '{' + units_obj.substring(0, units_obj.length - 1) + '}';
        this.user.f_109 = units_obj;

        var reports_obj = '';
        for (var _i in this.reports) {
          if (this.reports[_i].state) reports_obj += this.reports[_i].id + ',';
        }reports_obj = '{' + reports_obj.substring(0, reports_obj.length - 1) + '}';
        this.user.f_108 = reports_obj;

        this.submit();
        //console.warn(reports_obj)
      }
    },
    submit: function submit() {
      var _this2 = this;

      var data = new FormData();

      data.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.user));

      fetch(__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* DB */] + REG, {
        method: 'POST',
        body: data,
        credentials: 'include'
      }).then(function (result) {
        return result.json();
      }).then(function (result) {
        if (result.error_code) {
          window.alert('Ошибка во время регистрации пользователя');
          console.warn(result.error_code);
        } else {
          _this2.new_login = result.login;
          _this2.new_pass = result.password;
          _this2.showRegModal = true;
        }
      }).catch(function (e) {
        console.log(e);
      });
    }
  },
  created: function created() {
    var _this3 = this;

    if (!this.$parent.can_reg_user) __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace('/main');

    __WEBPACK_IMPORTED_MODULE_6__lib_EventBus__["a" /* EventBus */].$on('reg-organization', function (id) {
      _this3.user.f_96 = id;
      _this3.user.f_99 = '';
    });
    __WEBPACK_IMPORTED_MODULE_6__lib_EventBus__["a" /* EventBus */].$on('reg-organization-property', function (id) {
      _this3.user.f_97 = id;
    });

    fetch(__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* DB */] + UNITS, {
      credentials: 'include'
    }).then(function (result) {
      return result.json();
    }).then(function (result) {
      if (result) {
        _this3.units = result;
        for (var i in _this3.units) {
          _this3.units[i].state = null;
        }
      }
    }).catch(function (e) {
      console.log(e);
    });

    fetch(__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* DB */] + REPORTS, {
      credentials: 'include'
    }).then(function (result) {
      return result.json();
    }).then(function (result) {
      if (result) {
        _this3.reports = result;
        for (var i in _this3.reports) {
          _this3.reports[i].state = true;
        }
      }
    }).catch(function (e) {
      console.log(e);
    });
  },

  components: {
    alert: alert,
    regOrganization: __WEBPACK_IMPORTED_MODULE_3__organization__["a" /* default */],
    regOrganizationProperty: __WEBPACK_IMPORTED_MODULE_4__organizationProperty__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_5_vue_strap__["modal"]
  }
});

/***/ }),

/***/ "JANY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConclusionV2_vue__ = __webpack_require__("c8CE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28377a20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ConclusionV2_vue__ = __webpack_require__("j3u3");
function injectStyle (ssrContext) {
  __webpack_require__("FmPq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28377a20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConclusionV2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28377a20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ConclusionV2_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JLVG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"c-body-wrapper"},[_c('table',{staticClass:"body"},[_c('tbody',_vm._l((_vm.rows),function(row,i){return _c('tr',[(row.flag)?_c('td',{attrs:{"colspan":"8"}},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(row.fo))])]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"left c-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.region))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right c-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.sending_conclusion))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right c-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_true))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right c-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_false))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right c-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_false_glpm))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right c-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_false_tax))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right c-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_false_som))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right c-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_false_law))]):_vm._e()])}))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-header-wrapper"},[_c('table',{staticClass:"header"},[_c('thead',{staticClass:"bold"},[_c('tr',[_c('td',{staticClass:"c-td",attrs:{"rowspan":"4"}},[_vm._v("Субъекты, федеральные округа")]),_vm._v(" "),_c('td',{attrs:{"colspan":"7"}},[_vm._v("Количество Актов ЛПО, на которые были направлены заключения")]),_vm._v(" "),_c('td',{staticClass:"c-scroll",attrs:{"rowspan":"4"}})]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"c-td",attrs:{"rowspan":"3"}},[_vm._v("Всего")]),_vm._v(" "),_c('td',{staticClass:"c-td",attrs:{"rowspan":"3"}},[_vm._v("положительных "),_c('br'),_vm._v(" (наличие в реестре "),_c('br'),_vm._v(" ГЛПМ)")]),_vm._v(" "),_c('td',{attrs:{"colspan":"5"}},[_vm._v("отрицательных")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"c-td",attrs:{"rowspan":"2"}},[_vm._v("Всего")]),_vm._v(" "),_c('td',{attrs:{"colspan":"4"}},[_vm._v("в том числе по главным причинам")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"c-td"},[_vm._v("несоответствия сведений данным государственного лесопатологического мониторинга (1)")]),_vm._v(" "),_c('td',{staticClass:"c-td"},[_vm._v("несоответствия сведений таксационным характеристикам лесного участка (2)")]),_vm._v(" "),_c('td',{staticClass:"c-td"},[_vm._v("несоответствия запланированных мероприятий санитарному и лесопатологическому состоянию лесов(3)")]),_vm._v(" "),_c('td',{staticClass:"c-td"},[_vm._v("запрещения или ограничения законодательством Российской Федерации запланированных мероприятий (4)")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("2")]),_vm._v(" "),_c('td',[_vm._v("3")]),_vm._v(" "),_c('td',[_vm._v("4")]),_vm._v(" "),_c('td',[_vm._v("5")]),_vm._v(" "),_c('td',[_vm._v("6")]),_vm._v(" "),_c('td',[_vm._v("7")]),_vm._v(" "),_c('td',[_vm._v("8")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JXV7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var SUBFORESTRY = 'subforestrie_list.php';
//const HEADER = 'get_header.php'
var LOCATION = 'get_act_location.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'subforestry',
	data: function data() {
		return {
			id: this.type + '_localforestry_' + this.line_count,
			selected: '0',
			options: []
		};
	},
	props: {
		line_count: 0,
		type: ''
	},
	created: function created() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + LOCATION + '?id=' + this.$parent.selected_act, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			var lf = res.filter(function (item) {
				return item.field == 'f_20';
			});
			var sf = res.filter(function (item) {
				return item.field == 'f_27';
			});
			if (lf[_this.line_count]) {
				if (sf[_this.line_count]) return { localforestry_id: lf[_this.line_count].val, subforestry_id: sf[_this.line_count].val };else return { localforestry_id: lf[_this.line_count].val, subforestry_id: '0' };
			} else return { localforestry_id: '0', subforestry_id: '0' };
		}).then(function (location) {
			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + SUBFORESTRY + '?id=' + location.localforestry_id).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.options = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
					_this.selected = !location.subforestry_id ? '0' : location.subforestry_id;
				} else {
					_this.selected = '0';
					_this.options = [];
				}
			}).catch(function (err) {
				return console.log('4', err);
			});
		}).catch(function (err) {
			return console.log('5', err);
		});
	}
});

/***/ }),

/***/ "JlOi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var SUBFORESTRY = 'subforestrie_list.php';
//const HEADER = 'get_header.php'
var ACT_LOCATION = 'get_act_location.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'subforestry',
	data: function data() {
		return {
			id: this.type + '_subforestry_' + this.line_count,
			selected: '0',
			options: []
		};
	},
	props: {
		line_count: 0,
		type: '',
		lf_id: false,
		sf_id: false
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit(this.type + '_subforestry', { index: this.line_count, value: this.selected });
		},
		fill: function fill(lf, sf) {
			var _this = this;

			if (this.$parent.data_location.subforestrie_list[lf]) {
				this.options = this.$parent.data_location.subforestrie_list[lf];
				this.selected = sf ? sf : '0';
			} else {
				if (!this.$parent.data_location.subforestrie_list_queue[lf]) {
					this.$parent.data_location.subforestrie_list_queue[lf] = true;
					fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + SUBFORESTRY + '?id=' + lf).then(function (data) {
						return data.json();
					}).then(function (data) {
						_this.$parent.data_location.subforestrie_list[lf] = data;
						_this.$parent.data_location.subforestrie_list_queue[lf] = false;
						__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('subforestries_fetch_complete');

						if (data) {
							_this.options = data;
							_this.selected = sf ? sf : '0';
						} else {
							_this.options = [];
							_this.selected = '0';
						}
					}).catch(function (err) {
						return console.log(err);
					});
				} else {
					__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$on('subforestries_fetch_complete', function () {
						_this.options = _this.$parent.data_location.subforestrie_list[lf];
						_this.selected = sf ? sf : '0';
					});
				}
			}
		}
	},
	created: function created() {
		var _this2 = this;

		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$on(this.type + '_localforestry_' + this.line_count, function (id) {
			_this2.fill(id);
		});

		var lf_id = this.$options.propsData.lf_id;
		var sf_id = this.$options.propsData.sf_id;
		if (lf_id) this.fill(lf_id, sf_id);else this.fill('0');
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$off('subforestries_fetch_complete');
		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$off(this.type + '_localforestry_' + this.line_count);
	}
});

/***/ }),

/***/ "JmJV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dropdown',{class:{activeFilter: _vm.filtered, rightAlign: _vm.right_align, filter: _vm.filter},attrs:{"text":_vm.name},on:{"input":_vm.open},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},[_c('li',[_c('checkbox',{attrs:{"type":"info"},model:{value:(_vm.sel),callback:function ($$v) {_vm.sel=$$v},expression:"sel"}},[_vm._v("Выбрать всё")])],1),_vm._v(" "),_c('li',{staticClass:"divider",attrs:{"role":"separator"}}),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"auto","max-height":"300px"}},_vm._l((_vm.items),function(i){return _c('li',[_c('checkbox',{attrs:{"type":"info"},model:{value:(i.checked),callback:function ($$v) {_vm.$set(i, "checked", $$v)},expression:"i.checked"}},[_vm._v(_vm._s(i.value))])],1)})),_vm._v(" "),_c('li',{staticClass:"divider",attrs:{"role":"separator"}}),_vm._v(" "),_c('li',{staticClass:"pull-right"},[_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Ок"},on:{"click":_vm.ok}}),_vm._v(" "),_c('input',{staticClass:"btn btn-default",attrs:{"type":"button","value":"Отмена"},on:{"click":_vm.cancel}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K/Ax":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_protectiveCat_vue__ = __webpack_require__("Kpat");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e79c1f26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_protectiveCat_vue__ = __webpack_require__("riCz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_protectiveCat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e79c1f26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_protectiveCat_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K3yO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//


var FO = 'get_fo.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'fo',
	data: function data() {
		return {
			value: ''
		};
	},
	methods: {
		fill: function fill(id) {
			var _this = this;

			fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + FO + '?id=' + id, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.value = data[0].name;
				} else {
					_this.value = '';
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	props: {
		type: ''
	},
	created: function created() {
		var _this2 = this;

		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$on(this.type + '_region', function (id) {
			_this2.fill(id);
		});
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$off(this.type + '_region');
	}
});

/***/ }),

/***/ "KLW5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control table-control my-control",attrs:{"id":'subforestry_id_' + this.id,"data-num":"f_27","data-table":"1","disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KNgc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KSaI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center list-title"},[_vm._v("\n\t\t\tРеестр состояний\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"l-header-wrapper"},[_c('table',{staticClass:"header"},[_c('thead',[_vm._m(0),_vm._v(" "),_c('tr',[_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"num","filter":_vm.filter,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table-date-range',{attrs:{"field":"act_placement_date","filter":_vm.filter,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"fo","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"region","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"forestry","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"act_user_name","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"act_state","filter":_vm.filter,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"conclusion_user_name","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"conclusion_state","filter":_vm.filter,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"warrant_user_name","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"warrant_state","filter":_vm.filter,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-scroll",on:{"click":_vm.clearFilters}},[_c('span',{staticClass:"glyphicon glyphicon-remove pointer",attrs:{"title":"Сбросить фильтры"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"l-body-wrapper"},[_c('table',{staticClass:"body"},[_c('tbody',_vm._l((_vm.lines),function(line,i){return _c('tr',{class:{ selected: line.selected },on:{"click":function($event){_vm.select_line(i)}}},[(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.num))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.act_placement_date))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.fo))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.region))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.forestry))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.act_user_name))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.act_state))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.conclusion_user_name))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.conclusion_state))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.warrant_user_name))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.warrant_state))]):_vm._e()])}))])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[(_vm.pages)?_c('ul',{staticClass:"pagination"},_vm._l((_vm.pages),function(page){return _c('li',{class:{ active: page.active }},[(_vm.isNumeric(page.num))?_c('a',{attrs:{"href":"#","data-value":page.num},on:{"click":_vm.select_page}},[_vm._v(_vm._s(page.num))]):_c('span',{staticClass:"disabled_page",attrs:{"href":"#"}},[_vm._v(_vm._s(page.num))])])})):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"center l-td"},[_vm._v("№ акта")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Дата размещения")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("ФО")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Субъект РФ")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Лесничество")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Ответственный за акт")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Состояние акта")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Ответственный за заключение")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Состояние заключения")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Ответственный за предписание")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Состояние предписания")]),_vm._v(" "),_c('th',{staticClass:"l-scroll"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kaa6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();_vm.submit($event)}}},[_c('h4',[_vm._v("Мониторинг актов ЛПО")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1 col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_2),expression:"f_2"}],staticClass:"form-control my-control",class:_vm.fields_correct.f_2,attrs:{"type":"text"},domProps:{"value":(_vm.f_2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_2=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col"},[_c('organization',{attrs:{"field_class":_vm.fields_correct.f_11}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_4),expression:"f_4"}],staticClass:"form-control my-control",attrs:{"type":"text"},domProps:{"value":(_vm.f_4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_4=$event.target.value}}})])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col"},[_c('fo',{attrs:{"type":"add"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_c('region',{attrs:{"type":"add","field_class":_vm.fields_correct.f_12,"region_id":_vm.f_12}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_c('forestry',{attrs:{"type":"add","field_class":_vm.fields_correct.f_9,"forestry_id":_vm.f_9}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-7",staticStyle:{"margin-bottom":"5px"}},[_c('input',{class:_vm.lines_correct,attrs:{"id":"btnAddLine","value":"Добавить","type":"button","disabled":"true"},on:{"click":_vm.addLine}}),_vm._v(" "),_c('input',{attrs:{"id":"btnCopyLine","value":"Дублировать отмеченное","type":"button","disabled":"true"},on:{"click":_vm.copyLine}}),_vm._v(" "),_c('input',{attrs:{"id":"btnDeleteLine","value":"Удалить отмеченное","type":"button","disabled":"true"},on:{"click":_vm.deleteLine}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('table',{staticClass:"place_table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"form_td_chkbox"},[_c('input',{staticStyle:{"margin":"5px"},attrs:{"id":"chkBoxSelAll","type":"checkbox"},on:{"click":_vm.selectAll}})]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Участковое лесничество *")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Подлес-во")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Квартал *")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Выдел *")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("S выдела *")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Лп. выдел")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("S лп. выдела")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Состав")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Возраст")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Полнота")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Запас")]),_vm._v(" "),_c('location-table-field',{attrs:{"field_name":"f_131","title":"СКС насаждения"},on:{"set":_vm.setSKSAllLocations}},[_vm._v("\n\t\t\t\t\t\t\tСКС насаждения\n\t\t\t\t\t\t")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("МЗЛ *")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("S МЗЛ (для РАД шт.)")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Целевое назначение лесов")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Категория защитных лесов")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("ОЗУ")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Порода")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Причина ослабления")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Комментарии")])],1)]),_vm._v(" "),_c('tbody',_vm._l((_vm.lines),function(line,index){return _c('tr',[_c('td',{staticClass:"form_td_chkbox"},[_c('input',{staticClass:"checkbox control-access-first",attrs:{"type":"checkbox","data-index":index}})]),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_20},[_c('localforestry',{attrs:{"line_count":index,"type":"add","forestry_id":_vm.f_9,"lf_id":line.f_20}})],1),_vm._v(" "),_c('td',{staticClass:"form_td",staticStyle:{"border-right":"none"}},[_c('subforestry',{attrs:{"line_count":index,"type":"add","lf_id":line.f_20,"sf_id":line.f_27}})],1),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_17},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_17),expression:"line.f_17"}],staticClass:"form-control table-control my-control",attrs:{"type":"text","data-field":"f_17","line_count":index},domProps:{"value":(line.f_17)},on:{"keyup":_vm.tdChange,"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_17", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_24},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_24),expression:"line.f_24"}],staticClass:"form-control table-control my-control",attrs:{"type":"text","data-field":"f_24","line_count":index},domProps:{"value":(line.f_24)},on:{"keyup":_vm.tdChange,"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_24", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_21},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_21),expression:"line.f_21"}],staticClass:"form-control table-control my-control",attrs:{"type":"text","data-field":"f_21","line_count":index},domProps:{"value":(line.f_21)},on:{"keyup":_vm.tdChange,"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_21", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_25),expression:"line.f_25"}],staticClass:"form-control table-control my-control",attrs:{"type":"text"},domProps:{"value":(line.f_25)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_25", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_23,staticStyle:{"border-right":"none"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_23),expression:"line.f_23"}],staticClass:"form-control table-control my-control",attrs:{"type":"text","data-field":"f_23","data-line":index},domProps:{"value":(line.f_23)},on:{"keyup":_vm.addSLP,"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_23", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_111,staticStyle:{"border-right":"none"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_111),expression:"line.f_111"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","data-field":"f_111","data-line":index},domProps:{"value":(line.f_111)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_111", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_112,staticStyle:{"border-right":"none"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_112),expression:"line.f_112"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","data-field":"f_112","data-line":index},domProps:{"value":(line.f_112)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_112", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_113,staticStyle:{"border-right":"none"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_113),expression:"line.f_113"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","data-field":"f_113","data-line":index},domProps:{"value":(line.f_113)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_113", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_114,staticStyle:{"border-right":"none"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_114),expression:"line.f_114"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","data-field":"f_114","data-line":index},domProps:{"value":(line.f_114)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_114", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.f_131 ? "" : "field-error",staticStyle:{"border-right":"none"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_131),expression:"line.f_131"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","data-field":"f_131","data-line":index},domProps:{"value":(line.f_131)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_131", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('action-type',{attrs:{"line_count":index,"id":line.f_16}})],1),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_22,staticStyle:{"position":"relative"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_22),expression:"line.f_22"}],staticClass:"form-control table-control my-control",attrs:{"type":"text","data-field":"f_22","data-line":index},domProps:{"value":(line.f_22)},on:{"keyup":_vm.addSAT,"blur":function (e) {_vm.tryBlurMzl(e, line.f_22, line.f_16 == _vm.mzlRAD.id)},"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_22", $event.target.value)}}}),_vm._v(" "),_c('tooltip-warn',{key:index,attrs:{"value":line.f_22,"type-is-rad":line.f_16 == _vm.mzlRAD.id,"id":index}})],1),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_116),expression:"line.f_116"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","data-field":"f_116","data-line":index},domProps:{"value":(line.f_116)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_116", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('forest-purpose',{attrs:{"line_count":index,"type":"add","id":line.f_104}})],1),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('protective-cat',{attrs:{"line_count":index,"id":line.f_105,"type":"add"}})],1),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('protective-cat-ext',{attrs:{"line_count":index,"type":"add"}})],1),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('species',{attrs:{"line_count":index,"sp_id":line.f_26}})],1),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('damage-reason',{attrs:{"line_count":index,"id":line.f_19}})],1),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_18),expression:"line.f_18"}],staticClass:"form-control table-control my-control",attrs:{"type":"text"},domProps:{"value":(line.f_18)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_18", $event.target.value)}}})])])}))])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"20px","margin-bottom":"10px"}},[_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"left_input_wrapper"},[_c('span',{staticClass:"bold"},[_vm._v("S ЛПО *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_13),expression:"f_13"}],staticClass:"short my-control form-control",class:_vm.fields_correct.f_13,staticStyle:{"float":"right"},attrs:{"type":"text"},domProps:{"value":(_vm.f_13)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_13=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-11"},[_c('table',{staticClass:"table-mzl"},[_c('thead',[_c('tr',[_c('th',[_vm._v("\n\t\t\t\t\t\t\tS лп. выдела\n\t\t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.mzlRAD.name)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._l((_vm.mzlNoRAD),function(item){return _c('th',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t\t\t\t")])})],2)]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{attrs:{"rowspan":"2"}},[_vm._v(_vm._s(_vm.summ_s_lp))]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v(_vm._s(_vm.mzlRAD.value))]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v(_vm._s(_vm.value_summ))]),_vm._v(" "),_vm._l((_vm.mzlNoRAD),function(item){return _c('td',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(item.value)+"\n\t\t\t\t\t\t")])})],2),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":_vm.mzl.length}},[_vm._v(_vm._s(_vm.floatConvert(_vm.summ_s_action_type - _vm.mzlRAD.value)))])])])])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('table',{staticClass:"dateTable"},[_vm._m(5),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{class:_vm.fields_correct.f_1},[_c('datepicker',{staticClass:"table-control",attrs:{"format":"dd.MM.yyyy"},model:{value:(_vm.f_1),callback:function ($$v) {_vm.f_1=$$v},expression:"f_1"}})],1),_vm._v(" "),_c('td',{class:_vm.fields_correct.f_5},[_c('datepicker',{staticClass:"table-control",attrs:{"id":"datepicker_f_5","format":"dd.MM.yyyy"},on:{"input":_vm.adoptionChange},model:{value:(_vm.f_5),callback:function ($$v) {_vm.f_5=$$v},expression:"f_5"}})],1),_vm._v(" "),_c('td',{class:_vm.fields_correct.f_3},[_c('datepicker',{staticClass:"table-control",attrs:{"id":"datepicker_f_3","format":"dd.MM.yyyy"},on:{"input":_vm.placeChange},model:{value:(_vm.f_3),callback:function ($$v) {_vm.f_3=$$v},expression:"f_3"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.controlTwenty),expression:"controlTwenty"}],staticClass:"table-control my-control form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.controlTwenty)},on:{"input":function($event){if($event.target.composing){ return; }_vm.controlTwenty=$event.target.value}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.daysLeft),expression:"daysLeft"}],staticClass:"table-control my-control form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.daysLeft)},on:{"input":function($event){if($event.target.composing){ return; }_vm.daysLeft=$event.target.value}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"rent-title"},[_vm._v("Аренда")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_126),expression:"f_126"}],staticClass:"form-control my-control medium",class:_vm.fields_correct.f_126,on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.f_126=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}}),_vm._v(" "),_c('option',{domProps:{"value":true}},[_vm._v("Да")]),_vm._v(" "),_c('option',{domProps:{"value":false}},[_vm._v("Нет")])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin":"5px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('table',{staticClass:"dateTable"},[_vm._m(6),_vm._v(" "),_c('tbody',[_c('td',[_c('lpo-reason')],1),_vm._v(" "),_c('td',[_c('lpo-method',{attrs:{"id":_vm.f_89}})],1),_vm._v(" "),_c('td',[_c('lpo-mode',{attrs:{"method":_vm.f_89,"id":_vm.f_90}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin":"5px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('table',{staticClass:"dateTable"},[_vm._m(7),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('datepicker',{staticClass:"table-control",attrs:{"format":"dd.MM.yyyy"},model:{value:(_vm.f_7),callback:function ($$v) {_vm.f_7=$$v},expression:"f_7"}})],1),_vm._v(" "),_c('td',[_c('deletion-reason')],1),_vm._v(" "),_c('td',[_c('conclusion-user',{attrs:{"conc_id":_vm.f_6}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_10),expression:"f_10"}],staticClass:"form-control my-control medium",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.f_10=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Черновик")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Чистовик")])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin":"5px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_vm._m(8),_vm._v(" "),_c('table',{staticClass:"dateTable"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"no-right-border",staticStyle:{"width":"15%"}},[_vm._v("ФИО")]),_vm._v(" "),_c('td',{class:_vm.fields_correct.f_127},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_127),expression:"f_127"}],staticClass:"table-control my-control form-control",attrs:{"type":"text"},domProps:{"value":(_vm.f_127)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_127=$event.target.value}}})]),_vm._v(" "),_c('td',{staticClass:"no-right-border",staticStyle:{"width":"20%"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_129),expression:"f_129"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.f_129=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change_f_129]}},_vm._l((_vm.organization_types),function(type){return _c('option',{key:type.id,domProps:{"value":type.id}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(type.name)+"\n\t\t\t\t\t\t\t\t")])}))]),_vm._v(" "),_c('td',{class:_vm.f_129 == 2 ? _vm.fields_correct.f_128 : _vm.fields_correct.f_130},[(_vm.f_129 == 1)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_130),expression:"f_130"}],staticClass:"form-control my-control table-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.f_130=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.lpo_filials),function(item){return _c('option',{key:item.id,domProps:{"value":item.id}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t\t\t\t\t\t")])})):_vm._e(),_vm._v(" "),(_vm.f_129 == 2)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_128),expression:"f_128"}],staticClass:"table-control my-control form-control",attrs:{"type":"text"},domProps:{"value":(_vm.f_128)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_128=$event.target.value}}}):_vm._e()])])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"btnPanel"},[_c('input',{staticClass:"btn btn-secondary",attrs:{"type":"button","value":"Отмена"},on:{"click":function($event){$event.preventDefault();_vm.close($event)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.submit_disabled},on:{"click":function($event){$event.preventDefault();_vm.submit($event)}}},[(_vm.submit_disabled)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v("\n\t\t\t"+_vm._s(_vm.submit_disabled ? 'Сохранение' : 'Сохранить')+"\n\t\t")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1 col"},[_c('span',{staticClass:"bold"},[_vm._v("№ акта ЛПО *")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col"},[_c('span',{staticClass:"bold"},[_vm._v("Организация *")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col"},[_vm._v("Ссылка на акт")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col"},[_vm._v("Федеральный округ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_c('span',{staticClass:"bold"},[_vm._v("Субъект РФ *")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_c('span',{staticClass:"bold"},[_vm._v("Лесничество *")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"form_td"},[_vm._v("V(м"),_c('sup',[_vm._v("3")]),_vm._v(")")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_vm._v("\n\t\t\t\t\t\t\tV(м"),_c('sup',[_vm._v("3")]),_vm._v(")\n\t\t\t\t\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1 col-md-offset-2"},[_c('label',[_vm._v("Контроль 3 дня")])]),_vm._v(" "),_c('div',{staticClass:"col-md-1",staticStyle:{"margin-left":"6.33%"}},[_c('label',[_vm._v("Даты")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("проведения ЛПО *")]),_vm._v(" "),_c('th',[_vm._v("утверждения *")]),_vm._v(" "),_c('th',[_vm._v("размещения на сайте *")]),_vm._v(" "),_c('th',[_vm._v("контроль 20 дней")]),_vm._v(" "),_c('th',[_vm._v("осталось дней")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Основание проведения ЛПО")]),_vm._v(" "),_c('th',[_vm._v("Метод проведения ЛПО")]),_vm._v(" "),_c('th',[_vm._v("Способ проведения ЛПО")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Дата снятия с сайта")]),_vm._v(" "),_c('th',[_vm._v("Причина снятия с сайта Акта ЛПО")]),_vm._v(" "),_c('th',[_vm._v("Ответственный за заключение на акты ЛПО")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"dateTable no-bottom-border"},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"4"}},[_vm._v("Исполнитель работ по ЛПО")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KeBO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var LPO_METHOD = 'get_lpo_method.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'lpoMethod',
	data: function data() {
		return {
			selected: '',
			options: []
		};
	},
	props: {
		id: null
	},
	watch: {
		id: function id(val) {
			this.selected = val;
			this.change();
		}
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('lpo_method', this.selected);
		}
	},
	created: function created() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + LPO_METHOD, {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (data) {
			if (data) {
				_this.options = data;
				_this.selected = _this.id ? _this.id : data[0].id;
				_this.change();
			} else {
				_this.options = [];
			}
		}).catch(function (err) {
			return console.log(err);
		});
	}
});

/***/ }),

/***/ "Kj4/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lpoMode_vue__ = __webpack_require__("zHFB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2350ba4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_lpoMode_vue__ = __webpack_require__("T/XK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lpoMode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2350ba4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_lpoMode_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kpat":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var PROTECTIVE_CAT = 'get_protective_cat.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'protectiveCat',
	data: function data() {
		return {
			selected: '',
			options: []
		};
	},
	props: {
		line_count: 0,
		type: '',
		id: null,
		disabled: false
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit(this.type + '_protective_cat', { index: this.line_count, value: this.selected });
			//EventBus.$emit(`${this.type}_protective_cat_${this.line_count}`, this.selected)
		}
	},
	created: function created() {
		var _this = this;

		if (this.$parent.data_location.protective_cat.length) {
			this.options = this.$parent.data_location.protective_cat;
			this.selected = this.$props.id ? this.$props.id : this.$parent.data_location.protective_cat[0].id;

			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit(this.type + '_protective_cat_' + this.line_count, this.selected);
		} else {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$on('fetch_protective_cat_complete', function () {
				_this.options = _this.$parent.data_location.protective_cat;
				_this.selected = _this.$props.id ? _this.$props.id : protective_cat[0].id;

				__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit(_this.type + '_protective_cat_' + _this.line_count, _this.selected);

				__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$off('fetch_protective_cat_complete');
			});
		}
		/*
  fetch(DB + PROTECTIVE_CAT, {
  	credentials: 'include'
  })
  .then(data => data.json())
  .then(data => {
  	if (data) {
  		this.options = data
  		this.selected = this.$props.id ? this.$props.id : data[0].id
  	}
  	else {
  		this.options = []
  	}
  	EventBus.$emit(`${this.type}_protective_cat_${this.line_count}`, this.selected)
  })
  .catch(err => console.log(err))*/
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$off('fetch_protective_cat_complete');
	}
});

/***/ }),

/***/ "L4e2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//


var FO = 'get_fo.php';
var HEADER = 'get_header.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'fo',
	data: function data() {
		return {
			value: ''
		};
	},
	props: {
		type: '',
		reg_id: false
	},
	watch: {
		reg_id: function reg_id(id) {
			var _this = this;

			//console.warn('id = ', id)
			if (typeof id !== 'undefined' && id !== null) {
				fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + FO + '?id=' + id, {
					credentials: 'include'
				}).then(function (data) {
					return data.json();
				}).then(function (data) {
					if (data) {
						_this.value = data[0].name;
					} else {
						_this.value = '';
					}
				}).catch(function (err) {
					return console.log(err);
				});
			}
		}
	}
});

/***/ }),

/***/ "LCLF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-md-1"},[_vm._v("\n\t\tФедеральный округ\n\t")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_fo),expression:"selected_fo"}],staticClass:"form-control my-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected_fo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[(_vm.all)?_c('option',{domProps:{"value":-1}},[_vm._v("\n\t\t\t\tВсе федеральные округа\n\t\t\t")]):_vm._e(),_vm._v(" "),_vm._l((_vm.options_fo),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t\t\t"+_vm._s(option.name)+"\n\t\t\t")])})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LDEc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login-header"},[_vm._v("\n    ФБУ \"Рослесозащита\"\n  ")]),_vm._v(" "),_c('div',{staticClass:"login-title"},[_vm._v("\n    Автоматизированная аналитическая система \"ГЛПМ - контроль\"\n  ")]),_vm._v(" "),_c('div',{staticClass:"login-wrapper"},[_c('form',{staticClass:"form-signin",attrs:{"id":"login-form","role":"form"},on:{"submit":function($event){$event.preventDefault();_vm.submit($event)}}},[_c('h2',{staticClass:"form-signin-heading"},[_vm._v("Авторизация")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.login),expression:"user.login"}],staticClass:"form-control",attrs:{"id":"input-login","type":"text","placeholder":"Логин"},domProps:{"value":(_vm.user.login)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "login", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password),expression:"user.password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Пароль","enterSubmit":""},domProps:{"value":(_vm.user.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "password", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"checkbox text-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.remember),expression:"user.remember"}],attrs:{"id":"remember","type":"checkbox","value":"remember-me"},domProps:{"checked":Array.isArray(_vm.user.remember)?_vm._i(_vm.user.remember,"remember-me")>-1:(_vm.user.remember)},on:{"change":function($event){var $$a=_vm.user.remember,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="remember-me",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.user.remember=$$a.concat([$$v]))}else{$$i>-1&&(_vm.user.remember=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.user, "remember", $$c)}}}}),_vm._v(" "),_c('span',{staticStyle:{"font-color":"white"}},[_vm._v("Запомнить меня")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-color",attrs:{"type":"submit"}},[_vm._v("Войти")]),_vm._v(" "),(_vm.error)?_c('alert',{attrs:{"type":"danger"}},[_vm._v("Логин или пароль введены неверно")]):_vm._e(),_vm._v(" "),(_vm.error_db)?_c('alert',{attrs:{"type":"danger"}},[_vm._v("Отсутствует подключение к БД")]):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LEMR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var ORGANIZATION = 'get_organization.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'regOrganization',
	data: function data() {
		return {
			selected: '0',
			options: []
		};
	},
	props: {
		set_id: '',
		field_class: '',
		id: null
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('reg-organization', this.selected);
		}
	},
	mounted: function mounted() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + ORGANIZATION, {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (data) {
			if (data) {
				_this.options = data;
				_this.selected = _this.$props.id ? _this.$props.id : data[0].id;
				_this.change();
			} else {
				_this.options = [];
			}
		}).catch(function (err) {
			return console.log(err);
		});
	}
});

/***/ }),

/***/ "LJ/H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stat_vue__ = __webpack_require__("oYeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87c5100e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Stat_vue__ = __webpack_require__("41F9");
function injectStyle (ssrContext) {
  __webpack_require__("MVop")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-87c5100e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87c5100e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Stat_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Le89":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var GET_MONITORING_RLH_REPORT = 'get_monitoring_rlh_report.php';
var REPORT_ID = 1;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'MonitoringRlh',
	data: function data() {
		return {
			rows: []
		};
	},
	props: ['start', 'end'],
	computed: {
		endYear: function endYear() {
			return this.$props.end.split('.')[2];
		}
	},
	methods: {
		floatConvert: function floatConvert(number) {
			return +parseFloat(number).toPrecision(12);
		},
		fillTable: function fillTable(start, end) {
			var _this = this;

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + GET_MONITORING_RLH_REPORT + '?start=' + start + '&end=' + end).then(function (res) {
				return res.json();
			}).then(function (res) {
				var temp_rows = [{}];
				var flag = true;
				var total_summ = {};
				total_summ.region = 'Итого по РФ';
				total_summ.placement_all_count = 0;
				total_summ.placement_all_ga = 0;
				total_summ.placement_week_count = 0;
				total_summ.placement_week_ga = 0;
				total_summ.entrance_all_count = 0;
				total_summ.entrance_all_ga = 0;
				total_summ.entrance_week_count = 0;
				total_summ.entrance_week_ga = 0;
				total_summ.consideration_all_count = 0;
				total_summ.consideration_all_ga = 0;
				total_summ.consideration_week_count = 0;
				total_summ.consideration_week_ga = 0;
				total_summ.conclusion_consideration_all_count = 0;
				total_summ.conclusion_consideration_all_s_mzl = 0;
				total_summ.decision_good_count = 0;
				total_summ.decision_good_s_mzl = 0;
				total_summ.decision_bad_count = 0;
				total_summ.decision_bad_s_mzl = 0;
				total_summ.decision_bad_count_sved_glpm = 0;
				total_summ.decision_bad_s_mzl_sved_glpm = 0;
				total_summ.decision_bad_count_mer_glpm = 0;
				total_summ.decision_bad_s_mzl_mer_glpm = 0;
				total_summ.decision_bad_count_sved_to = 0;
				total_summ.decision_bad_s_mzl_sved_to = 0;
				total_summ.decision_bad_count_sved_sansost = 0;
				total_summ.decision_bad_s_mzl_sved_sansost = 0;
				total_summ.decision_bad_count_zak_rf = 0;
				total_summ.decision_bad_s_mzl_zak_rf = 0;
				total_summ.needs_verification_all_count = 0;
				total_summ.needs_verification_week_count = 0;

				var fo_summ = {};
				fo_summ.region = 'Итого по округу';
				fo_summ.placement_all_count = 0;
				fo_summ.placement_all_ga = 0;
				fo_summ.placement_week_count = 0;
				fo_summ.placement_week_ga = 0;
				fo_summ.entrance_all_count = 0;
				fo_summ.entrance_all_ga = 0;
				fo_summ.entrance_week_count = 0;
				fo_summ.entrance_week_ga = 0;
				fo_summ.consideration_all_count = 0;
				fo_summ.consideration_all_ga = 0;
				fo_summ.consideration_week_count = 0;
				fo_summ.consideration_week_ga = 0;
				fo_summ.conclusion_consideration_all_count = 0;
				fo_summ.conclusion_consideration_all_s_mzl = 0;
				fo_summ.decision_good_count = 0;
				fo_summ.decision_good_s_mzl = 0;
				fo_summ.decision_bad_count = 0;
				fo_summ.decision_bad_s_mzl = 0;
				fo_summ.decision_bad_count_sved_glpm = 0;
				fo_summ.decision_bad_s_mzl_sved_glpm = 0;
				fo_summ.decision_bad_count_mer_glpm = 0;
				fo_summ.decision_bad_s_mzl_mer_glpm = 0;
				fo_summ.decision_bad_count_sved_to = 0;
				fo_summ.decision_bad_s_mzl_sved_to = 0;
				fo_summ.decision_bad_count_sved_sansost = 0;
				fo_summ.decision_bad_s_mzl_sved_sansost = 0;
				fo_summ.decision_bad_count_zak_rf = 0;
				fo_summ.decision_bad_s_mzl_zak_rf = 0;
				fo_summ.needs_verification_all_count = 0;
				fo_summ.needs_verification_week_count = 0;

				var i = 0;

				while (i < res.length - 1) {

					if (res[i].fo === res[i + 1].fo && flag) {
						var obj = {};
						obj.fo = res[i].fo;
						obj.flag = true;
						flag = false;

						if (i !== 0) {
							var _clone_fo = {}; //клонируем объект для передачи по значению
							for (var key in fo_summ) {
								_clone_fo[key] = fo_summ[key];
							}

							temp_rows.push(_clone_fo);

							fo_summ.placement_all_count = 0;
							fo_summ.placement_all_ga = 0;
							fo_summ.placement_week_count = 0;
							fo_summ.placement_week_ga = 0;
							fo_summ.entrance_all_count = 0;
							fo_summ.entrance_all_ga = 0;
							fo_summ.entrance_week_count = 0;
							fo_summ.entrance_week_ga = 0;
							fo_summ.consideration_all_count = 0;
							fo_summ.consideration_all_ga = 0;
							fo_summ.consideration_week_count = 0;
							fo_summ.consideration_week_ga = 0;
							fo_summ.conclusion_consideration_all_count = 0;
							fo_summ.conclusion_consideration_all_s_mzl = 0;
							fo_summ.decision_good_count = 0;
							fo_summ.decision_good_s_mzl = 0;
							fo_summ.decision_bad_count = 0;
							fo_summ.decision_bad_s_mzl = 0;
							fo_summ.decision_bad_count_sved_glpm = 0;
							fo_summ.decision_bad_s_mzl_sved_glpm = 0;
							fo_summ.decision_bad_count_mer_glpm = 0;
							fo_summ.decision_bad_s_mzl_mer_glpm = 0;
							fo_summ.decision_bad_count_sved_to = 0;
							fo_summ.decision_bad_s_mzl_sved_to = 0;
							fo_summ.decision_bad_count_sved_sansost = 0;
							fo_summ.decision_bad_s_mzl_sved_sansost = 0;
							fo_summ.decision_bad_count_zak_rf = 0;
							fo_summ.decision_bad_s_mzl_zak_rf = 0;
							fo_summ.needs_verification_all_count = 0;
							fo_summ.needs_verification_week_count = 0;
						}

						temp_rows.push(obj);
					} else {
						fo_summ.placement_all_count += +res[i].placement_all_count;
						fo_summ.placement_all_ga += +res[i].placement_all_ga;
						fo_summ.placement_week_count += +res[i].placement_week_count;
						fo_summ.placement_week_ga += +res[i].placement_week_ga;
						fo_summ.entrance_all_count += +res[i].entrance_all_count;
						fo_summ.entrance_all_ga += +res[i].entrance_all_ga;
						fo_summ.entrance_week_count += +res[i].entrance_week_count;
						fo_summ.entrance_week_ga += +res[i].entrance_week_ga;
						fo_summ.consideration_all_count += +res[i].consideration_all_count;
						fo_summ.consideration_all_ga += +res[i].consideration_all_ga;
						fo_summ.consideration_week_count += +res[i].consideration_week_count;
						fo_summ.consideration_week_ga += +res[i].consideration_week_ga;
						fo_summ.conclusion_consideration_all_count += +res[i].conclusion_consideration_all_count;
						fo_summ.conclusion_consideration_all_s_mzl += +res[i].conclusion_consideration_all_s_mzl;
						fo_summ.decision_good_count += +res[i].decision_good_count;
						fo_summ.decision_good_s_mzl += +res[i].decision_good_s_mzl;
						fo_summ.decision_bad_count += +res[i].decision_bad_count;
						fo_summ.decision_bad_s_mzl += +res[i].decision_bad_s_mzl;
						fo_summ.decision_bad_count_sved_glpm += +res[i].decision_bad_count_sved_glpm;
						fo_summ.decision_bad_s_mzl_sved_glpm += +res[i].decision_bad_s_mzl_sved_glpm;
						fo_summ.decision_bad_count_mer_glpm += +res[i].decision_bad_count_mer_glpm;
						fo_summ.decision_bad_s_mzl_mer_glpm += +res[i].decision_bad_s_mzl_mer_glpm;
						fo_summ.decision_bad_count_sved_to += +res[i].decision_bad_count_sved_to;
						fo_summ.decision_bad_s_mzl_sved_to += +res[i].decision_bad_s_mzl_sved_to;
						fo_summ.decision_bad_count_sved_sansost += +res[i].decision_bad_count_sved_sansost;
						fo_summ.decision_bad_s_mzl_sved_sansost += +res[i].decision_bad_s_mzl_sved_sansost;
						fo_summ.decision_bad_count_zak_rf += +res[i].decision_bad_count_zak_rf;
						fo_summ.decision_bad_s_mzl_zak_rf += +res[i].decision_bad_s_mzl_zak_rf;
						fo_summ.needs_verification_all_count += +res[i].needs_verification_all_count;
						fo_summ.needs_verification_week_count += +res[i].needs_verification_week_count;

						total_summ.placement_all_count += +res[i].placement_all_count;
						total_summ.placement_all_ga += +res[i].placement_all_ga;
						total_summ.placement_week_count += +res[i].placement_week_count;
						total_summ.placement_week_ga += +res[i].placement_week_ga;
						total_summ.entrance_all_count += +res[i].entrance_all_count;
						total_summ.entrance_all_ga += +res[i].entrance_all_ga;
						total_summ.entrance_week_count += +res[i].entrance_week_count;
						total_summ.entrance_week_ga += +res[i].entrance_week_ga;
						total_summ.consideration_all_count += +res[i].consideration_all_count;
						total_summ.consideration_all_ga += +res[i].consideration_all_ga;
						total_summ.consideration_week_count += +res[i].consideration_week_count;
						total_summ.consideration_week_ga += +res[i].consideration_week_ga;
						total_summ.conclusion_consideration_all_count += +res[i].conclusion_consideration_all_count;
						total_summ.conclusion_consideration_all_s_mzl += +res[i].conclusion_consideration_all_s_mzl;
						total_summ.decision_good_count += +res[i].decision_good_count;
						total_summ.decision_good_s_mzl += +res[i].decision_good_s_mzl;
						total_summ.decision_bad_count += +res[i].decision_bad_count;
						total_summ.decision_bad_s_mzl += +res[i].decision_bad_s_mzl;
						total_summ.decision_bad_count_sved_glpm += +res[i].decision_bad_count_sved_glpm;
						total_summ.decision_bad_s_mzl_sved_glpm += +res[i].decision_bad_s_mzl_sved_glpm;
						total_summ.decision_bad_count_mer_glpm += +res[i].decision_bad_count_mer_glpm;
						total_summ.decision_bad_s_mzl_mer_glpm += +res[i].decision_bad_s_mzl_mer_glpm;
						total_summ.decision_bad_count_sved_to += +res[i].decision_bad_count_sved_to;
						total_summ.decision_bad_s_mzl_sved_to += +res[i].decision_bad_s_mzl_sved_to;
						total_summ.decision_bad_count_sved_sansost += +res[i].decision_bad_count_sved_sansost;
						total_summ.decision_bad_s_mzl_sved_sansost += +res[i].decision_bad_s_mzl_sved_sansost;
						total_summ.decision_bad_count_zak_rf += +res[i].decision_bad_count_zak_rf;
						total_summ.decision_bad_s_mzl_zak_rf += +res[i].decision_bad_s_mzl_zak_rf;
						total_summ.needs_verification_all_count += +res[i].needs_verification_all_count;
						total_summ.needs_verification_week_count += +res[i].needs_verification_week_count;

						for (var _key in fo_summ) {
							if (_key !== 'region') fo_summ[_key] = +_this.floatConvert(fo_summ[_key]);
						}

						for (var _key2 in total_summ) {
							if (_key2 !== 'region') total_summ[_key2] = +_this.floatConvert(total_summ[_key2]);
						}

						temp_rows.push(res[i]);
						if (res[i].fo !== res[i + 1].fo) {
							flag = true;
						}
						i++;
					}
				}

				var last = res.length - 1;

				temp_rows.push(res[last]);

				fo_summ.placement_all_count += +res[last].placement_all_count;
				fo_summ.placement_all_ga += +res[last].placement_all_ga;
				fo_summ.placement_week_count += +res[last].placement_week_count;
				fo_summ.placement_week_ga += +res[last].placement_week_ga;
				fo_summ.entrance_all_count += +res[last].entrance_all_count;
				fo_summ.entrance_all_ga += +res[last].entrance_all_ga;
				fo_summ.entrance_week_count += +res[last].entrance_week_count;
				fo_summ.entrance_week_ga += +res[last].entrance_week_ga;
				fo_summ.consideration_all_count += +res[last].consideration_all_count;
				fo_summ.consideration_all_ga += +res[last].consideration_all_ga;
				fo_summ.consideration_week_count += +res[last].consideration_week_count;
				fo_summ.consideration_week_ga += +res[last].consideration_week_ga;
				fo_summ.conclusion_consideration_all_count += +res[last].conclusion_consideration_all_count;
				fo_summ.conclusion_consideration_all_s_mzl += +res[last].conclusion_consideration_all_s_mzl;
				fo_summ.decision_good_count += +res[last].decision_good_count;
				fo_summ.decision_good_s_mzl += +res[last].decision_good_s_mzl;
				fo_summ.decision_bad_count += +res[last].decision_bad_count;
				fo_summ.decision_bad_s_mzl += +res[last].decision_bad_s_mzl;
				fo_summ.decision_bad_count_sved_glpm += +res[last].decision_bad_count_sved_glpm;
				fo_summ.decision_bad_s_mzl_sved_glpm += +res[last].decision_bad_s_mzl_sved_glpm;
				fo_summ.decision_bad_count_mer_glpm += +res[last].decision_bad_count_mer_glpm;
				fo_summ.decision_bad_s_mzl_mer_glpm += +res[last].decision_bad_s_mzl_mer_glpm;
				fo_summ.decision_bad_count_sved_to += +res[last].decision_bad_count_sved_to;
				fo_summ.decision_bad_s_mzl_sved_to += +res[last].decision_bad_s_mzl_sved_to;
				fo_summ.decision_bad_count_sved_sansost += +res[last].decision_bad_count_sved_sansost;
				fo_summ.decision_bad_s_mzl_sved_sansost += +res[last].decision_bad_s_mzl_sved_sansost;
				fo_summ.decision_bad_count_zak_rf += +res[last].decision_bad_count_zak_rf;
				fo_summ.decision_bad_s_mzl_zak_rf += +res[last].decision_bad_s_mzl_zak_rf;
				fo_summ.needs_verification_all_count += +res[last].needs_verification_all_count;
				fo_summ.needs_verification_week_count += +res[last].needs_verification_week_count;

				total_summ.placement_all_count += +res[last].placement_all_count;
				total_summ.placement_all_ga += +res[last].placement_all_ga;
				total_summ.placement_week_count += +res[last].placement_week_count;
				total_summ.placement_week_ga += +res[last].placement_week_ga;
				total_summ.entrance_all_count += +res[last].entrance_all_count;
				total_summ.entrance_all_ga += +res[last].entrance_all_ga;
				total_summ.entrance_week_count += +res[last].entrance_week_count;
				total_summ.entrance_week_ga += +res[last].entrance_week_ga;
				total_summ.consideration_all_count += +res[last].consideration_all_count;
				total_summ.consideration_all_ga += +res[last].consideration_all_ga;
				total_summ.consideration_week_count += +res[last].consideration_week_count;
				total_summ.consideration_week_ga += +res[last].consideration_week_ga;
				total_summ.conclusion_consideration_all_count += +res[last].conclusion_consideration_all_count;
				total_summ.conclusion_consideration_all_s_mzl += +res[last].conclusion_consideration_all_s_mzl;
				total_summ.decision_good_count += +res[last].decision_good_count;
				total_summ.decision_good_s_mzl += +res[last].decision_good_s_mzl;
				total_summ.decision_bad_count += +res[last].decision_bad_count;
				total_summ.decision_bad_s_mzl += +res[last].decision_bad_s_mzl;
				total_summ.decision_bad_count_sved_glpm += +res[last].decision_bad_count_sved_glpm;
				total_summ.decision_bad_s_mzl_sved_glpm += +res[last].decision_bad_s_mzl_sved_glpm;
				total_summ.decision_bad_count_mer_glpm += +res[last].decision_bad_count_mer_glpm;
				total_summ.decision_bad_s_mzl_mer_glpm += +res[last].decision_bad_s_mzl_mer_glpm;
				total_summ.decision_bad_count_sved_to += +res[last].decision_bad_count_sved_to;
				total_summ.decision_bad_s_mzl_sved_to += +res[last].decision_bad_s_mzl_sved_to;
				total_summ.decision_bad_count_sved_sansost += +res[last].decision_bad_count_sved_sansost;
				total_summ.decision_bad_s_mzl_sved_sansost += +res[last].decision_bad_s_mzl_sved_sansost;
				total_summ.decision_bad_count_zak_rf += +res[last].decision_bad_count_zak_rf;
				total_summ.decision_bad_s_mzl_zak_rf += +res[last].decision_bad_s_mzl_zak_rf;
				total_summ.needs_verification_all_count += +res[last].needs_verification_all_count;
				total_summ.needs_verification_week_count += +res[last].needs_verification_week_count;

				for (var _key3 in fo_summ) {
					if (_key3 !== 'region') fo_summ[_key3] = +_this.floatConvert(fo_summ[_key3]);
				}

				for (var _key4 in total_summ) {
					if (_key4 !== 'region') total_summ[_key4] = +_this.floatConvert(total_summ[_key4]);
				}

				var clone_fo = {}; //клонируем объект для передачи по значению
				for (var _key5 in fo_summ) {
					clone_fo[_key5] = fo_summ[_key5];
				}

				temp_rows.push(clone_fo);

				temp_rows[0] = total_summ;

				_this.rows = temp_rows;
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		this.rows = [];
		this.fillTable(this.start, this.end);

		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on('monitoring-rlh-date', function (date) {
			// console.log('mon',date)
			_this2.fillTable(date.start, date.end);
		});

		var dispay_width = document.documentElement.clientWidth;
		var dispay_height = document.documentElement.clientHeight;
		var scroll_width = 17;

		var ua = navigator.userAgent;
		if (ua.search('OPR/') > 0) {
			scroll_width = 15;
		}

		//const table_width = dispay_width - 30 - scroll_width
		//const col_width = Math.ceil((table_width) / 23)

		document.querySelectorAll('.wide_col').forEach(function (td) {
			td.width = 215;
		});

		document.querySelectorAll('.medium_col').forEach(function (td) {
			td.width = 95;
		});

		//document.querySelector('.m-header-wrapper').width = table_width
		//document.querySelector('.m-body-wrapper').width = table_width
		document.querySelector('.m-body-wrapper').style.maxHeight = dispay_height - 440 + 'px';

		// console.log(dispay_width, col_width, table_width)

		document.querySelector('.m-scroll').width = scroll_width;
		//document.querySelector('.m-body-wrapper').style.paddingRight = `${scroll_width}px`

		var f = false;
		document.querySelector('.m-header-wrapper').addEventListener('scroll', function (e) {
			if (f) {
				f = false;
				return;
			}
			f = true;
			document.querySelector('.m-body-wrapper').scrollLeft = e.target.scrollLeft;
		});
		document.querySelector('.m-body-wrapper').addEventListener('scroll', function (e) {
			if (f) {
				f = false;
				return;
			}
			f = true;
			document.querySelector('.m-header-wrapper').scrollLeft = e.target.scrollLeft;
		});
	},
	updated: function updated() {
		document.querySelectorAll('.wide_col').forEach(function (td) {
			td.width = 215;
		});

		document.querySelectorAll('.medium_col').forEach(function (td) {
			td.width = 95;
		});
	},
	created: function created() {
		/*if(!this.$parent.$parent.reports.some((e) => {
  	return e.id == REPORT_ID
  }))
  	router.replace('/main')*/
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('monitoring-rlh-date');
	}
});

/***/ }),

/***/ "Lu+N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_deletionReason_vue__ = __webpack_require__("7lnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_167ec142_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_deletionReason_vue__ = __webpack_require__("9Vd5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_deletionReason_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_167ec142_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_deletionReason_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M+g5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2227d6dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("+IYe");
function injectStyle (ssrContext) {
  __webpack_require__("CTFA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2227d6dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MUnB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Conclusion_vue__ = __webpack_require__("AVBi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_032be884_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Conclusion_vue__ = __webpack_require__("JLVG");
function injectStyle (ssrContext) {
  __webpack_require__("66jr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-032be884"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Conclusion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_032be884_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Conclusion_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MVop":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MXRL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forestPurpose_vue__ = __webpack_require__("CHse");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0286557e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_forestPurpose_vue__ = __webpack_require__("NXDo");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forestPurpose_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0286557e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_forestPurpose_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MY6s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"select2-enable",attrs:{"id":("species_" + _vm.line_count)},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.options),function(group){return _c('optgroup',{key:group.text,attrs:{"label":group.text}},_vm._l((group.children),function(option){return _c('option',{key:option.id,domProps:{"value":option.id}},[_vm._v("\n        "+_vm._s(option.name)+"\n      ")])}))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MZAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var LPO_REASON = 'get_lpo_reason.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'lpoReason',
	data: function data() {
		return {
			selected: '',
			options: []
		};
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('lpo_reason', this.selected);
		}
	},
	created: function created() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + LPO_REASON, {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (data) {
			if (data) {
				_this.options = data;
				_this.selected = data[0].id;
			} else {
				_this.options = [];
			}
		}).catch(function (err) {
			return console.log(err);
		});
	}
});

/***/ }),

/***/ "Mbf/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RegionsList__ = __webpack_require__("afdD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FoList__ = __webpack_require__("e8if");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var REPORT_WEEK = 'report_week.php';
var REPORT_CONCLUSION = 'report_conclusion.php';
var REPORT_SOM = 'report_som.php';
var REPORT_MONITORING_RLH = 'report_monitoring_rlh.php';
var REPORT_NPA_MZL = 'report_npa_mzl.php';
var REPORT_DLH_FO = 'report_dlh.php';
var REPORT_WARRANTS_COUNT = 'report_warrants_count.php';
var REPORT_ACTS_AND_CONCLUSIONS_COUNT = 'report_acts_and_conclusions_count.php';
var REPORT_ACTS_LPO = 'report_acts_lpo.php';
var REPORT_STAT = 'report_stat.php';
var REPORT_STAT_LPO = 'report_stat_lpo.php';

var REPORT_WEEK_V2 = 'report_week_v2.php';
var REPORT_CONCLUSION_V2 = 'report_conclusion_v2.php';
var REPORT_SOM_V2 = 'report_som_v2.php';
var REPORT_MONITORING_RLH_V2 = 'report_monitoring_rlh_v2.php';
var REPORT_DLH_FO_V2 = 'report_dlh_v2.php';
var REPORT_DLH_FO_V3 = 'report_dlh_v3.php';
var REPORT_MOVING = 'report_moving.php';
var REPORT_ACTS_COUNT = 'report_acts_count.php';
var REPORT_DLH_7 = 'report_dlh_7.php';

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'reports',
	data: function data() {
		return {
			start: __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(7, 'days').format('DD.MM.YYYY'),
			end: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('DD.MM.YYYY'),
			type: '0',
			regions: [],
			fo: null,
			year: 2026
		};
	},
	components: {
		datepicker: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["datepicker"],
		RegionsList: __WEBPACK_IMPORTED_MODULE_5__RegionsList__["a" /* default */],
		FoList: __WEBPACK_IMPORTED_MODULE_6__FoList__["a" /* default */]
	},
	computed: {
		displayRegionsList: function displayRegionsList() {
			return this.type == 5 || this.type == 10;
		},
		displayFoList: function displayFoList() {
			return this.type == 7 || this.type == 17 || this.type == 18 || this.type == 22;
		},
		displaySelectAllFOs: function displaySelectAllFOs() {
			return this.type == 22;
		},
		reportsList: function reportsList() {
			return this.$parent.reports.filter(function (e) {
				return e.id != 6;
			});
		},
		disableView: function disableView() {
			var _this = this;

			var found = this.$parent.reports.find(function (e) {
				return e.id == _this.type;
			});
			return found ? found.print_only == 't' : false;
		},
		disableDate: function disableDate() {
			return this.type == 9;
		}
	},
	methods: {
		close: function close() {
			__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('/main');
		},
		save: function save() {
			var joined = 'null';
			var report_name = 'Российская Федерация';

			switch (this.type) {
				case '1':
					window.location.href = '' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + REPORT_WEEK + '?start_date=' + this.start + '&end_date=' + this.end;
					break;
				case '2':
					window.location.href = '' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + REPORT_CONCLUSION + '?start_date=' + this.start + '&end_date=' + this.end;
					break;
				case '3':
					window.location.href = '' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + REPORT_SOM + '?start_date=' + this.start + '&end_date=' + this.end;
					break;
				case '4':
					window.location.href = '' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + REPORT_MONITORING_RLH + '?start_date=' + this.start + '&end_date=' + this.end;
					break;
				case '5':
					if (this.regions.length) joined = '{' + this.regions.map(function (e) {
						return e.id;
					}).join(',') + '}';

					if (this.fo && this.fo.id != 0) if (this.regions.length > 1) report_name = this.fo.name;

					if (this.regions.length == 1) report_name = this.regions[0].name;

					window.location.href = '' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + REPORT_NPA_MZL + '?start_date=' + this.start + '&end_date=' + this.end + '&name=' + report_name + '&regions=' + joined;
					break;
				case '7':
					window.location.href = '' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + REPORT_DLH_FO + '?start_date=' + this.start + '&end_date=' + this.end + '&fo_id=' + this.fo.id;
					break;
				case '8':
					window.location.href = '' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + REPORT_WARRANTS_COUNT + '?start_date=' + this.start + '&end_date=' + this.end;
					break;
				case '9':
					window.location.href = '' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + REPORT_ACTS_AND_CONCLUSIONS_COUNT;
					break;
				case '10':
					if (this.regions.length) joined = this.regions.map(function (e) {
						return e.id;
					}).join(',');

					if (this.fo && this.fo.id != 0) if (this.regions.length > 1) report_name = this.fo.name;

					if (this.regions.length == 1) report_name = this.regions[0].name;

					window.location.href = '' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + REPORT_ACTS_LPO + '?start_date=' + this.start + '&end_date=' + this.end + '&name=' + report_name + '&regions=' + joined;
					break;
				case '11':
					window.location.href = '' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + REPORT_STAT + '?start_date=' + this.start + '&end_date=' + this.end;
					break;
				case '12':
					window.location.href = '' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + REPORT_STAT_LPO + '?year=' + this.year;
					break;
				//v2
				case '13':
					window.location.href = '' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + REPORT_WEEK_V2 + '?start_date=' + this.start + '&end_date=' + this.end;
					break;
				case '14':
					window.location.href = '' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + REPORT_CONCLUSION_V2 + '?start_date=' + this.start + '&end_date=' + this.end;
					break;
				case '15':
					window.location.href = '' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + REPORT_SOM_V2 + '?start_date=' + this.start + '&end_date=' + this.end;
					break;
				case '16':
					window.location.href = '' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + REPORT_MONITORING_RLH_V2 + '?start_date=' + this.start + '&end_date=' + this.end;
					break;
				case '17':
					window.location.href = '' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + REPORT_DLH_FO_V2 + '?start_date=' + this.start + '&end_date=' + this.end + '&fo_id=' + this.fo.id;
					break;
				case '18':
					window.location.href = '' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + REPORT_DLH_FO_V3 + '?start_date=' + this.start + '&end_date=' + this.end + '&fo_id=' + this.fo.id;
					break;
				case '19':
					window.location.href = '' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + REPORT_MOVING + '?start_date=' + this.start + '&end_date=' + this.end;
					break;
				case '21':
					window.location.href = '' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + REPORT_ACTS_COUNT + '?start_date=' + this.start + '&end_date=' + this.end;
					break;
				case '22':
					window.location.href = '' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + REPORT_DLH_7 + '?start_date=' + this.start + '&end_date=' + this.end + '&fo_id=' + this.fo.id;
					break;
				default:
					break;
			}
		},
		view: function view() {
			switch (this.type) {
				case '1':
					__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('/main/reports/monitoring');
					break;
				case '2':
					__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('/main/reports/conclusion');
					break;
				case '3':
					__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('/main/reports/mzl');
					break;
				case '4':
					__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('/main/reports/monitoring-rlh');
					break;
				case '5':
					__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('/main/reports/npa-mzl');
					break;
				case '8':
					__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('/main/reports/warrants-count');
					break;
				case '11':
					__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('/main/reports/stat');
					break;
				case '12':
					__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('/main/reports/stat_lpo');
					break;
				//v2
				case '13':
					__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('/main/reports/monitoring-v2');
					break;
				case '14':
					__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('/main/reports/conclusion-v2');
					break;
				case '15':
					__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('/main/reports/mzl-v2');
					break;
				case '16':
					__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('/main/reports/monitoring-rlh-v2');
					break;
				default:
					break;
			}
		},
		startChange: function startChange(e) {
			var date = {};
			date.start = e;
			date.end = this.end;
			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('monitoring-date', date);
			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('monitoring-rlh-date', date);
			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('conclusion-date', date);
			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('mzl-date', date);
			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('report-date', date);
			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('npa-mzl-data', { start: e, end: this.end, regions: this.regions });
			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('stat-date', date);
		},
		endChange: function endChange(e) {
			var date = {};
			date.start = this.start;
			date.end = e;
			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('monitoring-date', date);
			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('monitoring-rlh-date', date);
			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('conclusion-date', date);
			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('mzl-date', date);
			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('report-date', date);
			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('npa-mzl-data', { start: this.start, end: e, regions: this.regions });
			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('stat-date', date);
		},
		yearChange: function yearChange(e) {
			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('stat-lpo-date', { year: e.target.value });
		}
	},
	created: function created() {
		var _this2 = this;

		if (this.$parent.reports.length) this.type = this.$parent.reports[0].id;else __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('/main');

		__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$on('change_regions', function (data) {
			_this2.regions = data;
			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('npa-mzl-data', { start: _this2.start, end: _this2.end, regions: _this2.regions });
		});

		__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$on('change_fo', function (data) {
			_this2.fo = data;
		});
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$off('change_regions');
		__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$off('change_fo');
	}
});

/***/ }),

/***/ "MtIP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forestry_vue__ = __webpack_require__("9b0B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2aba2529_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_forestry_vue__ = __webpack_require__("ZAGF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forestry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2aba2529_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_forestry_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MuUM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tooltipWarn_vue__ = __webpack_require__("BqrJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03eae568_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_tooltipWarn_vue__ = __webpack_require__("tpcH");
function injectStyle (ssrContext) {
  __webpack_require__("E+9r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03eae568"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tooltipWarn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03eae568_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_tooltipWarn_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MxWA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth__ = __webpack_require__("SQ6o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bootstrap_dist_css_bootstrap_css__);



var _this = this;

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





//import browser from 'browser-detect';
// import Bootstrap from 'vue-strap'



// auth.checkAuth()

//const result = browser();
//console.log(result);

__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].beforeEach(function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!to.matched.some(function (record) {
              return record.meta.requiresAuth;
            })) {
              _context.next = 10;
              break;
            }

            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_6__auth__["a" /* default */].checkAuth();

          case 3:
            if (!_context.sent) {
              _context.next = 7;
              break;
            }

            next();
            _context.next = 8;
            break;

          case 7:
            next({
              path: '/login'
            });

          case 8:
            _context.next = 11;
            break;

          case 10:
            next();

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);
// Vue.use(Bootstrap)

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('click-outside', {
  bind: function bind(el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: function unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

/***/ }),

/***/ "NL6A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control",class:_vm.field_class,attrs:{"id":_vm.id,"data-num":"f_9","data-table":"1"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NOV8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editForm_vue__ = __webpack_require__("iQxQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fc1e324_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_editForm_vue__ = __webpack_require__("v0ZA");
function injectStyle (ssrContext) {
  __webpack_require__("H724")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fc1e324_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_editForm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NXDo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.disabled},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ne53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forestry_vue__ = __webpack_require__("p6OC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_139122e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_forestry_vue__ = __webpack_require__("/cCE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forestry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_139122e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_forestry_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NgKa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O/fP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonitoringRlhV2_vue__ = __webpack_require__("jKLE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a40ff0e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringRlhV2_vue__ = __webpack_require__("atfw");
function injectStyle (ssrContext) {
  __webpack_require__("bPM2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a40ff0e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonitoringRlhV2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a40ff0e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringRlhV2_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O67w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),

/***/ "OLPc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'tooltipWarn',
	data: function data() {
		return {
			show_force: false,
			closed: false
		};
	},
	methods: {
		close: function close() {
			this.closed = true;
			this.show_force = false;
		}
	},
	props: ['value', 'typeIsRad', 'id'],
	computed: {
		display: function display() {
			if (this.show_force) return true;

			if (this.closed) return false;

			if (this.typeIsRad && !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(Number(this.value))) return true;

			return false;
		}
	},
	watch: {
		typeIsRad: function typeIsRad() {
			this.closed = false;
			this.show_force = false;
		},
		value: function value(e) {
			if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(Number(e))) this.closed = false;
		}
	},
	created: function created() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$on('show_tooltip_mzl_edit', function (data) {
			if (data.id == _this.$props.id) _this.show_force = true;
		});
	}
});

/***/ }),

/***/ "OsXf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OxvV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center list-title"},[_vm._v("\n\t\t\tРеестр результатов оценки актов ЛПО\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"l-header-wrapper"},[_c('table',{staticClass:"header"},[_c('thead',[_vm._m(0),_vm._v(" "),_c('tr',[_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"act_num","filter":_vm.filter,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table-date-range',{attrs:{"field":"act_placement_date","filter":_vm.filter,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"fo","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"region","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"forestry","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"conclusion_decision","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"conclusion_decision_reason","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"warrant_decision","filter":_vm.filter,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"violation","filter":_vm.filter,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-scroll",on:{"click":_vm.clearFilters}},[_c('span',{staticClass:"glyphicon glyphicon-remove pointer",attrs:{"title":"Сбросить фильтры"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"l-body-wrapper"},[_c('table',{staticClass:"body"},[_c('tbody',_vm._l((_vm.lines),function(line,i){return _c('tr',{key:line.act_id,class:{ selected: line.selected },on:{"click":function($event){_vm.select_line(i)}}},[(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.act_num))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.act_placement_date))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.fo))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.region))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.forestry))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.conclusion_decision))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.conclusion_decision_reason))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.warrant_decision))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.violation))]):_vm._e()])}))])]),_vm._v(" "),_c('div',[(_vm.lines.length)?_c('div',{staticClass:"pull-left",staticStyle:{"position":"absolute","margin":"20px"}},[_c('a',{staticClass:"btn btn-primary",attrs:{"href":_vm.DBlink + "get_journal_decisions_csv.php"}},[_vm._v("Выгрузить")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center"},[(_vm.pages)?_c('ul',{staticClass:"pagination"},_vm._l((_vm.pages),function(page){return _c('li',{key:page.num,class:{ active: page.active }},[(_vm.isNumeric(page.num))?_c('a',{attrs:{"href":"#","data-value":page.num},on:{"click":_vm.select_page}},[_vm._v(_vm._s(page.num))]):_c('span',{staticClass:"disabled_page",attrs:{"href":"#"}},[_vm._v(_vm._s(page.num))])])})):_vm._e()])]),_vm._v(" "),_c('alert',{attrs:{"value":_vm.displayAlert,"placement":"top","type":"warning","width":"400px","duration":"0","dismissable":""},on:{"update:value":function($event){_vm.displayAlert=$event}}},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('strong',[_vm._v("Внимание!")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px"}},[_vm._v("Началось формирование документа. Пожалуйста, не закрывайте страницу.")])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"center l-td"},[_vm._v("№ акта ЛПО")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Дата размещения")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("ФО")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Субъект РФ")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Лесничество")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Итоговое решение ФБУ \"Рослесозащита\"")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Главная причина отрицательного заключения")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Итоговое решение \"Документарная проверка\"")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Нарушение пунктов Постановления прав-ва 1158")]),_vm._v(" "),_c('th',{staticClass:"l-scroll"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P0g7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var FORESTRY = 'forestrie_list.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'forestry',
	data: function data() {
		return {
			selected: '0',
			options: [],
			id: this.type + '_forestry'
		};
	},
	props: {
		type: '',
		reg_id: '',
		f_id: ''
	},
	methods: {
		fill: function fill(id) {
			var _this = this;

			//console.log(id)
			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + FORESTRY + '?id=' + id).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					// this.selected = select ? select : '0'
					_this.options = [{ id: '0', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
					_this.selected = _this.f_id ? _this.f_id : '0';
				} else {
					_this.selected = '0';
					_this.options = [];
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	watch: {
		reg_id: function reg_id(id) {
			if (id) {
				this.fill(id);
			}
		}
	}
});

/***/ }),

/***/ "PV4o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lpoMethod_vue__ = __webpack_require__("SCZq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b5631ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_lpoMethod_vue__ = __webpack_require__("wHl5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lpoMethod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b5631ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_lpoMethod_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PbVx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dropdown',{class:{wide: _vm.wideWindow, activeFilter: _vm.filtered, right_align: _vm.rightAlign, filter: _vm.filter},attrs:{"text":_vm.name},on:{"input":_vm.open},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},[(_vm.loading)?_c('div',{staticClass:"loading-wrap"},[_c('i',{staticClass:"fa fa-spinner fa-spin",staticStyle:{"font-size":"26px"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"heading"},[_vm._v("\n\t\tПериод\n\t")]),_vm._v(" "),_c('div',{staticClass:"inputs_wrap"},[_c('div',{staticClass:"column"},[_vm._v("\n\t\t\tОт "),_c('datepicker',{staticClass:"table-control",attrs:{"format":"dd.MM.yyyy"},model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1),_vm._v(" "),_c('div',{staticClass:"column"},[_vm._v("\n\t\t\tДо "),_c('datepicker',{staticClass:"table-control",attrs:{"format":"dd.MM.yyyy"},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})],1)]),_vm._v(" "),_c('li',{staticClass:"divider",attrs:{"role":"separator"}}),_vm._v(" "),_c('li',{staticClass:"pull-right"},[_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Ок"},on:{"click":_vm.ok}}),_vm._v(" "),_c('input',{staticClass:"btn btn-default",attrs:{"type":"button","value":"Отмена"},on:{"click":_vm.cancel}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pf7y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_CancelIcon__ = __webpack_require__("0KnF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_CheckIcon__ = __webpack_require__("xhmk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'warrantTableField',
	data: function data() {
		return {
			tooltipIsVisible: false
		};
	},
	components: {
		CheckIcon: __WEBPACK_IMPORTED_MODULE_3__assets_CheckIcon__["a" /* default */], CancelIcon: __WEBPACK_IMPORTED_MODULE_2__assets_CancelIcon__["a" /* default */]
	},
	computed: {
		slotText: function slotText() {
			return this.$slots.default[0].text;
		}
	},
	props: {
		field_name: ''
	},
	methods: {
		showTooltip: function showTooltip() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('closeOtherTooltip');
			this.tooltipIsVisible = true;
		},
		hideTooltip: function hideTooltip(e) {
			if (e && (e.target.classList.contains('field_tooltip_parent') || e.target.classList.contains('field_tooltip'))) return 0;

			this.tooltipIsVisible = false;
		},
		sendAccordance: function sendAccordance() {
			this.$emit('set', { field: this.field_name, value: 1 });
		},
		sendNotAccordance: function sendNotAccordance() {
			this.$emit('set', { field: this.field_name, value: 0 });
		}
	},
	created: function created() {
		window.addEventListener('click', this.hideTooltip);
		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$on('closeOtherTooltip', this.hideTooltip);
	},
	beforeDestroy: function beforeDestroy() {
		window.removeEventListener('click', this.hideTooltip);
		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$off('closeOtherTooltip');
	}
});

/***/ }),

/***/ "Pi43":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var REGION = 'region_list.php';
var FORESTRIES = 'forestries_list.php';
var LOCALFORESTRIES = 'localforestries_list.php';
var SUBFORESTRIES = 'subforestries_list.php';

var EDIT_FORESTRY = 'edit_forestry.php';
var ADD_FORESTRY = 'add_forestry.php';
var EDIT_LOCALFORESTRY = 'edit_localforestry.php';
var ADD_LOCALFORESTRY = 'add_localforestry.php';
var EDIT_SUBFORESTRY = 'edit_subforestry.php';
var ADD_SUBFORESTRY = 'add_subforestry.php';

//import {EventBus} from '../../lib/EventBus'

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'editTerritoryCatalog',
	data: function data() {
		return {
			selectedRegion: '0',
			regions_list: [],

			selectedForestrie: '0',
			forestries_list: [],

			selectedLocalforestrie: '0',
			localforestries_list: [],

			selectedSubForestrie: '0',
			subforestries_list: [],

			blockRegionSelect: false,
			blockForestrieSelect: false,
			blockLocalforestrieSelect: false,
			blockSubforestrieSelect: false,

			popup_select: null,

			displayModal: false,
			modalTitle: '',
			newName: '',
			modalCallback: false
		};
	},
	components: {
		modal: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["modal"]
	},
	computed: {
		disabledRegion: function disabledRegion() {
			return this.regions_list.length == 0 || this.blockRegionSelect;
		},
		disabledForestrie: function disabledForestrie() {
			return this.forestries_list.length == 0 || this.blockRegionSelect || this.blockForestrieSelect;
		},
		disabledLocalforestrie: function disabledLocalforestrie() {
			return this.localforestries_list.length == 0 || this.blockRegionSelect || this.blockForestrieSelect || this.blockLocalforestrieSelect;
		},
		disabledSubforestrie: function disabledSubforestrie() {
			return this.subforestries_list.length == 0 || this.blockRegionSelect || this.blockForestrieSelect || this.blockLocalforestrieSelect || this.blockSubforestrieSelect;
		}
	},
	methods: {
		editForestrie: function editForestrie() {
			var _this = this;

			this.modalTitle = 'Редактирование лесничества';
			this.newName = this.forestries_list.find(function (e) {
				return e.id == _this.selectedForestrie;
			}).name;
			this.displayModal = true;
			this.modalCallback = function () {
				fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + EDIT_FORESTRY + '?id=' + _this.selectedForestrie + '&name=' + _this.newName, { credentials: 'include' }).then(function (res) {
					return res.json();
				}).then(function (json) {
					if (json.error == null) {
						_this.fillForestriesList(_this.selectedForestrie);
						_this.displayModal = false;
					} else {
						console.warn(json.error);
					}
				}).catch(function (e) {
					return console.log(e);
				});
			};
			//console.warn(this.modalCallback)
		},
		addForestrie: function addForestrie() {
			var _this2 = this;

			this.modalTitle = 'Создание лесничества';
			this.newName = '';
			this.displayModal = true;
			this.modalCallback = function () {
				fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + ADD_FORESTRY + '?id=' + _this2.selectedRegion + '&name=' + _this2.newName, { credentials: 'include' }).then(function (res) {
					return res.json();
				}).then(function (json) {
					if (json.error == null) {
						_this2.fillForestriesList(json.id);
						_this2.displayModal = false;
					} else {
						console.warn(json.error);
					}
				}).catch(function (e) {
					return console.log(e);
				});
			};
		},
		editLocalForestrie: function editLocalForestrie() {
			var _this3 = this;

			this.modalTitle = 'Редактирование участкового лесничества';
			this.newName = this.localforestries_list.find(function (e) {
				return e.id == _this3.selectedLocalforestrie;
			}).name;
			this.displayModal = true;
			this.modalCallback = function () {
				fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + EDIT_LOCALFORESTRY + '?id=' + _this3.selectedLocalforestrie + '&name=' + _this3.newName, { credentials: 'include' }).then(function (res) {
					return res.json();
				}).then(function (json) {
					if (json.error == null) {
						_this3.fillLocalForestriesList(_this3.selectedLocalForestrie);
						_this3.displayModal = false;
					} else {
						console.warn(json.error);
					}
				}).catch(function (e) {
					return console.log(e);
				});
			};
			//console.warn(this.modalCallback)
		},
		addLocalForestrie: function addLocalForestrie() {
			var _this4 = this;

			this.modalTitle = 'Создание участкового лесничества';
			this.newName = '';
			this.displayModal = true;
			this.modalCallback = function () {
				fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + ADD_LOCALFORESTRY + '?id=' + _this4.selectedForestrie + '&name=' + _this4.newName, { credentials: 'include' }).then(function (res) {
					return res.json();
				}).then(function (json) {
					if (json.error == null) {
						_this4.fillLocalForestriesList(json.id);
						_this4.displayModal = false;
					} else {
						console.warn(json.error);
					}
				}).catch(function (e) {
					return console.log(e);
				});
			};
		},
		editSubForestrie: function editSubForestrie() {
			var _this5 = this;

			this.modalTitle = 'Редактирование подлесничества';
			this.newName = this.subforestries_list.find(function (e) {
				return e.id == _this5.selectedSubForestrie;
			}).name;
			this.displayModal = true;
			this.modalCallback = function () {
				fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + EDIT_SUBFORESTRY + '?id=' + _this5.selectedSubForestrie + '&name=' + _this5.newName, { credentials: 'include' }).then(function (res) {
					return res.json();
				}).then(function (json) {
					if (json.error == null) {
						_this5.fillSubForestriesList(_this5.selectedSubForestrie);
						_this5.displayModal = false;
					} else {
						console.warn(json.error);
					}
				}).catch(function (e) {
					return console.log(e);
				});
			};
		},
		addSubForestrie: function addSubForestrie() {
			var _this6 = this;

			this.modalTitle = 'Создание подлесничества';
			this.newName = '';
			this.displayModal = true;
			this.modalCallback = function () {
				fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + ADD_SUBFORESTRY + '?id=' + _this6.selectedLocalforestrie + '&name=' + _this6.newName, { credentials: 'include' }).then(function (res) {
					return res.json();
				}).then(function (json) {
					if (json.error == null) {
						_this6.fillSubForestriesList(json.id);
						_this6.displayModal = false;
					} else {
						console.warn(json.error);
					}
				}).catch(function (e) {
					return console.log(e);
				});
			};
		},


		/*removePopup () {
  	const old_element = document.querySelector('.context_popup')
  	if(old_element)
  		old_element.parentNode.removeChild(old_element)
  },
  bodyClick (evt) {
  	this.removePopup()
  },
  buttonClick (evt) {
  	let search_id, search_array
  	switch (this.popup_select)
  	{
  		case 'region':
  			search_id = this.selectedRegion
  			search_array = this.regions_list
  			break
  		case 'forestry':
  			search_id = this.selectedForestrie
  			search_array = this.forestries_list
  			break
  		case 'localforestry':
  			search_id = this.selectedLocalforestrie
  			search_array = this.localforestries_list
  			break
  		case 'subforestry':
  			search_id = this.selectedSubForestrie
  			search_array = this.subforestries_list
  			break
  	}
  	const found = search_array.find(e => {return e.id == search_id})
  	if(!navigator.clipboard)
  		fallbackCopyTextToClipboard(found.name)
  	else
  		navigator.clipboard.writeText(found.name)
  	this.removePopup()
  },
  createPopup (evt) {
  	this.removePopup()
  	let popup = document.createElement('div')
  	let button = document.createElement('button')
  	button.innerHTML = 'Копировать значение'
  	button.onclick = this.buttonClick
  		popup.classList.add('context_popup')
  	popup.appendChild(button)
  	popup.style.display = 'block';
  	popup.style.left = evt.clientX + 'px'
  	popup.style.top = evt.clientY + 'px'
  		document.querySelector('body').appendChild(popup)
  },
  contextMenu (evt, select) {
  	//this.popup_select = select
  	//this.createPopup(evt)
  },
  drop () {
  	this.selectedRegion = this.regions_list[0].id
  	this.changeRegion()
  },*/
		fillRegionsList: function fillRegionsList() {
			var _this7 = this;

			this.blockRegionSelect = true;
			fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + REGION, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this7.regions_list = data;
					_this7.selectedRegion = _this7.regions_list[0].id;
					if (_this7.selectedRegion) _this7.changeRegion();
					_this7.blockRegionSelect = false;
				} else {
					_this7.regions_list = [];
				}
			}).catch(function (err) {
				return console.log(err);
			});
		},
		fillForestriesList: function fillForestriesList(select) {
			var _this8 = this;

			this.blockForestrieSelect = true;
			fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + FORESTRIES + '?id=' + this.selectedRegion, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this8.forestries_list = data;
					_this8.selectedForestrie = select ? select : _this8.forestries_list[0].id;
					if (_this8.selectedForestrie) _this8.changeForestrie();
					_this8.blockForestrieSelect = false;
				} else {
					_this8.forestries_list = [];
					_this8.localforestries_list = [];
					_this8.subforestries_list = [];
				}
			}).catch(function (err) {
				return console.log(err);
			});
		},
		fillLocalForestriesList: function fillLocalForestriesList(select) {
			var _this9 = this;

			this.blockLocalforestrieSelect = true;
			fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + LOCALFORESTRIES + '?id=' + this.selectedForestrie, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this9.localforestries_list = data;
					_this9.selectedLocalforestrie = select ? select : _this9.localforestries_list[0].id;
					if (_this9.selectedLocalforestrie) _this9.changeLocalforestrie();
					_this9.blockLocalforestrieSelect = false;
				} else {
					_this9.localforestries_list = [];
					_this9.subforestries_list = [];
				}
			}).catch(function (err) {
				return console.log(err);
			});
		},
		fillSubForestriesList: function fillSubForestriesList(select) {
			var _this10 = this;

			this.blockSubforestrieSelect = true;
			fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + SUBFORESTRIES + '?id=' + this.selectedLocalforestrie, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this10.subforestries_list = data;
					_this10.selectedSubForestrie = select ? select : _this10.subforestries_list[0].id;
					_this10.blockSubforestrieSelect = false;
				} else {
					_this10.subforestries_list = [];
				}
			}).catch(function (err) {
				return console.log(err);
			});
		},
		changeRegion: function changeRegion() {
			this.fillForestriesList();
			//EventBus.$emit(`change_region${this.$props.event_suffix}`, this.selected)
		},
		changeForestrie: function changeForestrie() {
			this.fillLocalForestriesList();
		},
		changeLocalforestrie: function changeLocalforestrie() {
			this.fillSubForestriesList();
		},
		changeSubforestrie: function changeSubforestrie() {}
	},
	mounted: function mounted() {
		/*
  EventBus.$on(`change_region_from_parent${this.$props.event_suffix}`, id => {
  	this.selected = id
  })*/
		this.fillRegionsList();
		//document.querySelector('.modal-catalog').addEventListener('click', this.bodyClick, {capture: true})
	},
	beforeDestroy: function beforeDestroy() {
		//if(document.querySelector('.modal-catalog'))
		//	document.querySelector('.modal-catalog').removeEventListener('click', this.bodyClick)
		//EventBus.$off(`change_region_from_parent${this.$props.event_suffix}`)
	}
});

/***/ }),

/***/ "QAHX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var ORGANIZATION = 'get_organization.php';
var HEADER = 'get_header.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'organization',
	data: function data() {
		return {
			selected: '0',
			options: []
		};
	},
	props: {
		field_class: '',
		id: null
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('edit_organization', this.selected);
		}
	},
	created: function created() {
		var _this = this;

		var id = this.$route.params.id || this.$props.id;
		fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + HEADER + ('?id=' + id), {
			credentials: 'include'
		}).then(function (h) {
			return h.json();
		}).then(function (h) {
			if (h) {
				// console.log(h)
				fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + ORGANIZATION, {
					credentials: 'include'
				}).then(function (data) {
					return data.json();
				}).then(function (data) {
					if (data) {
						_this.options = data;
						_this.selected = h[0].f_11;
						__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('edit_organization', _this.selected);
					} else {
						_this.options = [];
					}
				}).catch(function (err) {
					return console.log(err);
				});
			}
		}).catch(function (err) {
			return console.log(err);
		});
	}
	/*watch: {
 	org_id(id) {
 		if (typeof id !== 'undefined') {
 			fetch(DB + ORGANIZATION, {
 				credentials: 'include'
 			})
 			.then(data => data.json())
 			.then(data => {
 				if (data) {
 					this.options = [{id: '0', name: ''}, ...data]; 
 					this.selected = id
 				}
 				else {
 					this.options = []
 				}
 			})
 			.catch(err => console.log(err))
 		}
 	}
 }*/

});

/***/ }),

/***/ "QMgY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RBZK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_localforestry_vue__ = __webpack_require__("Yblq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_439611f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_localforestry_vue__ = __webpack_require__("gOFJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_localforestry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_439611f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_localforestry_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RFht":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Raak":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.disabled},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rhmw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rp/j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_species_vue__ = __webpack_require__("WGXW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee2ebe88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_species_vue__ = __webpack_require__("MY6s");
function injectStyle (ssrContext) {
  __webpack_require__("OsXf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_species_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee2ebe88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_species_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rp2u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Filter__ = __webpack_require__("XKhj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FilterDateRange__ = __webpack_require__("aXt2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var TABLE = 'get_journal_states.php';
var FILTER_TABLE = 'get_journal_states.php';
var COUNT_OF_FILTERS = 11;
var PADDING = 3;







/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'ListStates',
	data: function data() {
		return {
			lines: [],
			selected: 0,
			pages: [],
			active: 1,
			pages_count: 1,
			cf_count: 0,

			filter: {
				num: [],
				act_placement_date: [],
				url: [],
				fo: [],
				region: [],
				forestry: [],
				act_user_name: [],
				act_state: [],
				conclusion_user_name: [],
				conclusion_state: [],
				warrant_user_name: [],
				warrant_state: []
			},

			journalSuffix: '-states'
		};
	},

	components: {
		filterTable: __WEBPACK_IMPORTED_MODULE_3__Filter__["a" /* default */], filterTableDateRange: __WEBPACK_IMPORTED_MODULE_4__FilterDateRange__["a" /* default */]
	},
	methods: {
		isNumeric: function isNumeric(x) {
			return !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(+x);
		},
		select_line: function select_line(i) {
			if (!this.lines[i].flag) {
				var k = i;
				while (!this.lines[k].flag) {
					k--;
				}

				i = k;
			}

			this.selected = i;

			for (var j = 0; j < this.lines.length; j++) {
				if (this.lines[j].flag) {
					this.lines[j].selected = i === j;
				} else {
					var _k = j;
					while (!this.lines[_k].flag) {
						_k--;
					}
					for (var l = 0; l < this.lines[_k].count; l++) {
						this.lines[j].selected = i === _k;
					}
				}
			}

			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('act_id', this.lines[i].id);

			// document.getElementById(i).checked = true
			//EventBus.$emit('can_edit', {act: this.lines[i].can_edit_act, conclusion: this.lines[i].can_edit_conclusion, warrant: this.lines[i].can_edit_warrant})
		},
		fetch_lines: function fetch_lines(start) {
			var _this = this;

			var temp_lines = [];
			var temp_pages = [];

			var where = '(';
			for (var f in this.filter) {
				var field_name = f;
				field_name = field_name.replace(this.journalSuffix, '');

				if (field_name == 'act_placement_date') {
					if (this.filter[f].length == 2) {
						var from = this.filter[f][0];
						var to = this.filter[f][1];
						where += field_name + ' BETWEEN \'' + from + '\' AND \'' + to + '\'  or ';
					}
				} else {
					for (var i = 0; i < this.filter[f].length; i++) {
						where += this.filter[f][i] !== '' ? field_name + '=\'' + this.filter[f][i] + '\' or ' : field_name + ' is null or ';
					}
				}

				where = this.filter[f].length !== 0 ? where.slice(0, -4) : where;
				where += this.filter[f].length !== 0 ? ') and (' : '';
			}
			where = where.slice(0, -6);
			if (where) where = '&filter=' + where;

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + FILTER_TABLE + ('?start=' + start + '&rows=' + __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */] + where), {
				// fetch(DB + TABLE, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				var prev_id = -1;
				var prev_localforestry_id = -1;
				var prev_subforestry_id = -1;
				for (var _i = 0; _i < res.length - 1; _i++) {
					var act = {};

					var start_fo = _i;
					while (_i > 0 && res[start_fo - 1].act_id === res[_i].act_id && start_fo > 1) {
						start_fo--;
					}

					var curr = start_fo;
					while (curr < res.length && res[curr].act_id === res[start_fo].act_id) {
						curr++;
					}
					act.count = curr - start_fo;

					if (res[_i].act_id === prev_id) {
						act.flag = false;
					} else {
						act.flag = true;
					}
					//////////////////

					var start_lf = _i;
					while (_i > 0 && res[start_lf - 1].localforestry_id === res[_i].localforestry_id && start_lf > 1 && res[start_lf - 1].act_id === res[_i].act_id) {
						start_lf--;
					}

					var curr_lf = start_lf;
					while (curr_lf < res.length && res[curr_lf].act_id === res[start_lf].act_id && res[curr_lf].localforestry_id === res[_i].localforestry_id) {
						curr_lf++;
					}
					act.count_lf = curr_lf - start_lf;

					if (res[_i].act_id === prev_id && prev_localforestry_id === res[_i].localforestry_id) {
						act.flag_lf = false;
					} else {
						act.flag_lf = true;
					}

					////////////////////////
					var start_sf = _i;
					while (_i > 0 && res[start_sf - 1].localforestry_id === res[_i].localforestry_id && start_sf > 1 && res[start_sf - 1].act_id === res[_i].act_id) {
						start_sf--;
					}

					var curr_sf = start_sf;
					while (curr_sf < res.length && res[curr_sf].act_id === res[start_sf].act_id && res[curr_sf].localforestry_id === res[_i].localforestry_id) {
						curr_sf++;
					}
					act.count_sf = curr_sf - start_sf;

					if (res[_i].act_id === prev_id && prev_localforestry_id === res[_i].localforestry_id) {
						act.flag_sf = false;
					} else {
						act.flag_sf = true;
					}
					////////////////////////


					prev_id = res[_i].act_id;
					prev_localforestry_id = res[_i].localforestry_id;
					prev_subforestry_id = res[_i].subforestry_id;

					act.id = res[_i].act_id;
					act.act_placement_date = res[_i].act_placement_date;
					act.num = res[_i].num;
					act.fo = res[_i].fo;
					act.region = res[_i].region;
					act.forestry = res[_i].forestry;
					act.act_user_name = res[_i].act_user_name;
					act.act_state = res[_i].act_state;
					act.conclusion_user_name = res[_i].conclusion_user_name;
					act.conclusion_state = res[_i].conclusion_state;
					act.warrant_user_name = res[_i].warrant_user_name;
					act.warrant_state = res[_i].warrant_state;
					act.selected = false;

					temp_lines.push(act);
				}

				_this.lines = temp_lines;

				temp_lines = [];

				// this.pages = temp_pages

				_this.lines[0].selected = true;

				if (!_this.lines[1].flag) {
					var k = 1;
					while (!_this.lines[k].flag) {
						_this.lines[k].selected = true;
						k++;
					}
				}

				__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('act_id', _this.lines[0].id);
			}).catch(function (err) {
				return console.log(err);
			});
		},
		select_page: function select_page(e) {
			var _this2 = this;

			var value = +e.target.getAttribute('data-value');
			this.fetch_lines((value - 1) * __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */] + 1);
			this.active = value;
			var temp_pages = [];

			if (this.active - 1 > PADDING) {
				temp_pages.push({ active: false, num: 1 });
				temp_pages.push({ active: false, num: '...' });
			}

			for (var i = this.active - PADDING - 1; i < this.active + PADDING; i++) {
				if (i >= 0 && i < this.pages_count) temp_pages.push({ active: false, num: i + 1 });
			}if (this.active < this.pages_count - PADDING) {
				temp_pages.push({ active: false, num: '...' });
				temp_pages.push({ active: false, num: this.pages_count });
			}

			this.pages = temp_pages;

			this.pages.forEach(function (p) {
				p.active = p.num == _this2.active;
			});

			//this.pages[value - 1].active = true
		},
		clearFilters: function clearFilters() {
			this.cf_count = 0;
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('clearFilters' + this.journalSuffix);
		},
		filter_lines: function filter_lines() {
			var _this3 = this;

			var temp_lines = [];
			var temp_pages = [];

			var where = '(';
			for (var f in this.filter) {
				var field_name = f;
				field_name = field_name.replace(this.journalSuffix, '');

				if (field_name == 'act_placement_date') {
					if (this.filter[f].length == 2) {
						var from = this.filter[f][0];
						var to = this.filter[f][1];
						where += field_name + ' BETWEEN \'' + from + '\' AND \'' + to + '\'  or ';
					}
				} else {
					for (var i = 0; i < this.filter[f].length; i++) {
						where += this.filter[f][i] !== '' ? field_name + '=\'' + this.filter[f][i] + '\' or ' : field_name + ' is null or ';
					}
				}

				where = this.filter[f].length !== 0 ? where.slice(0, -4) : where;
				where += this.filter[f].length !== 0 ? ') and (' : '';
			}
			where = where.slice(0, -6);

			var start = 1;

			if (this.$route.params.id || this.$parent.act_id) {
				start = (this.page_num - 1) * __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */] + 1;
				this.active = this.page_num;
			}

			var t = TABLE + ('?start=' + start + '&rows=' + __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */]);
			if (where) {
				t = FILTER_TABLE + ('?start=' + start + '&rows=' + __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */] + '&filter=' + where);
			}

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + t, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				var prev_id = -1;
				var prev_localforestry_id = -1;
				var prev_subforestry_id = -1;

				var length = !!where ? res.length : res.length - 1;

				for (var _i2 = 0; _i2 < length; _i2++) {
					var act = {};

					var start_fo = _i2;
					while (_i2 > 0 && res[start_fo - 1].act_id === res[_i2].act_id && start_fo > 1) {
						start_fo--;
					}

					var curr = start_fo;
					while (curr < res.length && res[curr].act_id === res[start_fo].act_id) {
						curr++;
					}
					act.count = curr - start_fo;

					if (res[_i2].act_id === prev_id) {
						act.flag = false;
					} else {
						act.flag = true;
					}
					//////////////////

					var start_lf = _i2;
					while (_i2 > 0 && res[start_lf - 1].localforestry_id === res[_i2].localforestry_id && start_lf > 1 && res[start_lf - 1].act_id === res[_i2].act_id) {
						start_lf--;
					}

					var curr_lf = start_lf;
					while (curr_lf < res.length && res[curr_lf].act_id === res[start_lf].act_id && res[curr_lf].localforestry_id === res[_i2].localforestry_id) {
						curr_lf++;
					}
					act.count_lf = curr_lf - start_lf;

					if (res[_i2].act_id === prev_id && prev_localforestry_id === res[_i2].localforestry_id) {
						act.flag_lf = false;
					} else {
						act.flag_lf = true;
					}

					////////////////////////
					var start_sf = _i2;
					while (_i2 > 0 && res[start_sf - 1].localforestry_id === res[_i2].localforestry_id && start_sf > 1 && res[start_sf - 1].act_id === res[_i2].act_id) {
						start_sf--;
					}

					var curr_sf = start_sf;
					while (curr_sf < res.length && res[curr_sf].act_id === res[start_sf].act_id && res[curr_sf].localforestry_id === res[_i2].localforestry_id) {
						curr_sf++;
					}
					act.count_sf = curr_sf - start_sf;

					if (res[_i2].act_id === prev_id && prev_localforestry_id === res[_i2].localforestry_id) {
						act.flag_sf = false;
					} else {
						act.flag_sf = true;
					}
					////////////////////////


					prev_id = res[_i2].act_id;
					prev_localforestry_id = res[_i2].localforestry_id;
					prev_subforestry_id = res[_i2].subforestry_id;

					act.id = res[_i2].act_id;
					act.num = res[_i2].num;
					act.act_placement_date = res[_i2].act_placement_date ? __WEBPACK_IMPORTED_MODULE_5_moment___default()(res[_i2].act_placement_date, 'YYYY-MM-DD').format('DD.MM.YYYY') : '';
					act.fo = res[_i2].fo;
					act.region = res[_i2].region;
					act.forestry = res[_i2].forestry;
					act.act_user_name = res[_i2].act_user_name;
					act.act_state = res[_i2].act_state;
					act.conclusion_user_name = res[_i2].conclusion_user_name;
					act.conclusion_state = res[_i2].conclusion_state;
					act.warrant_user_name = res[_i2].warrant_user_name;
					act.warrant_state = res[_i2].warrant_state;
					act.selected = false;

					temp_lines.push(act);
				}

				//if (!where) {
				//let count = Math.round(res[res.length - 1].count / ROWS_ON_PAGE)
				_this3.pages_count = Math.round(res[res.length - 1].count / __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */]);
				temp_pages = [];

				if (_this3.active > PADDING) {
					temp_pages.push({ active: false, num: 1 });
					temp_pages.push({ active: false, num: '...' });
				}

				for (var _i3 = _this3.active - PADDING; _i3 < _this3.active + PADDING; _i3++) {
					if (_i3 >= 0 && _i3 < _this3.pages_count) temp_pages.push({ active: false, num: _i3 + 1 });
				}

				if (_this3.active < _this3.pages_count - PADDING) {
					temp_pages.push({ active: false, num: '...' });
					temp_pages.push({ active: false, num: _this3.pages_count });
				}

				_this3.pages = temp_pages;
				_this3.pages.forEach(function (p) {
					p.active = p.num == _this3.active;
				});
				//}

				_this3.lines = temp_lines;

				if (_this3.$route.params.id || _this3.$parent.act_id) {
					var act_id = _this3.$route.params.id || _this3.$parent.act_id;
					var found = false;
					for (var _i4 = 0; _i4 < _this3.lines.length; _i4++) {
						if (_this3.lines[_i4].id == act_id) {
							_this3.select_line(_i4);

							_this3.$nextTick(function () {
								var selected_row = document.querySelector("tr.selected");
								if (selected_row) selected_row.scrollIntoView(true);
							});

							found = true;
							break;
						}
					}
					if (!found) _this3.select_line(0);
				} else {
					_this3.select_line(0);
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	created: function created() {},
	mounted: function mounted() {
		var _this4 = this;

		this.$parent.lastJournalURL = '/main/states';

		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on('filter' + this.journalSuffix + '_list', function (f) {
			_this4.filter[f.field] = f.value !== '' ? f.value : null;
			_this4.active = 1;
			if (f.cf) //clearFilters
				{
					_this4.cf_count++;
					if (_this4.cf_count == COUNT_OF_FILTERS) _this4.filter_lines();
				} else _this4.filter_lines();
		});

		this.page_num = this.$parent.page_num_states ? this.$parent.page_num_states : 1;

		if (this.$parent.selected_filters) {
			for (var field in this.$parent.selected_filters) {
				if (field.includes(this.journalSuffix)) this.filter[field] = this.$parent.selected_filters[field].value;
			}
		}
		this.filter_lines();

		// const w = document.documentElement.clientWidth - 50
		// document.querySelector('.main_table_wrapper').style.width = `${w}px`

		////////////////////////////////////////////

		var dispay_width = document.documentElement.clientWidth;
		// const dispay_height = document.documentElement.clientHeight - 146
		var dispay_height = document.documentElement.clientHeight - 225;
		var scroll_width = 17;

		var ua = navigator.userAgent;

		if (ua.search('OPR/') > 0) {
			scroll_width = 15;
		}

		var table_width = dispay_width - scroll_width;
		var col_width = Math.floor(table_width / COUNT_OF_FILTERS);
		// 
		var large_width = table_width - col_width * 9;

		// console.log(col_width, large_width, table_width, col_width * 9 + large_width)


		document.querySelectorAll('.l-td').forEach(function (td) {
			td.width = col_width;
		});
		document.querySelectorAll('.large-td').forEach(function (td) {
			td.width = large_width;
		});
		document.querySelector('.l-header-wrapper').width = dispay_width;
		document.querySelector('.l-body-wrapper').width = dispay_width;
		document.querySelector('.l-body-wrapper').style.maxHeight = dispay_height + 'px';

		// console.log(dispay_height, dispay_width, col_width, table_width)
		// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))

		document.querySelector('.l-scroll').width = scroll_width;
	},
	beforeDestroy: function beforeDestroy() {
		//this.lines = []
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('filter' + this.journalSuffix + '_list');
		//EventBus.$emit('save-filter-states', {f: this.filter})
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('save-page' + this.journalSuffix, this.active);
	}
});

/***/ }),

/***/ "RuC4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tooltipWarn_vue__ = __webpack_require__("OLPc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e1d0a29_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_tooltipWarn_vue__ = __webpack_require__("uc+W");
function injectStyle (ssrContext) {
  __webpack_require__("FCR+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e1d0a29"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tooltipWarn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e1d0a29_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_tooltipWarn_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S1jb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_region_vue__ = __webpack_require__("lOxY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75516aa1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_region_vue__ = __webpack_require__("Su1P");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_region_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75516aa1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_region_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SCZq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var ACT_INFO = 'get_act_info.php';
var LPO_METHOD = 'get_lpo_method.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'lpoMethod',
	data: function data() {
		return {
			selected: '',
			options: []
		};
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('edit_lpo_method', this.selected);
		}
	},
	created: function created() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + ACT_INFO + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			return res[0].f_89;
		}).then(function (id) {
			fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + LPO_METHOD, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.options = data;
					_this.selected = id ? id : data[0].id;
					_this.change();
				} else {
					_this.options = [];
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}).catch(function (err) {
			return console.log(err);
		});
	}
});

/***/ }),

/***/ "SQ6o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
// src/auth/index.js




// URL and endpoint constants
//const API_URL = 'http://localhost/garbage/vbtest/src/php/'
var LOGIN_URL = __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + 'auth.php';
var CHECK_AUTH = __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + 'check_auth.php';
var LOGOUT = __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + 'logout.php';

/* harmony default export */ __webpack_exports__["a"] = ({

  // User object will let us check authentication status
  user: {
    authenticated: false,
    id: -1,
    error: false
  },

  // Send a request to the login URL and save the returned JWT
  login: function login(context, creds, redirect) {
    var _this = this;

    var form = new FormData();
    form.append('login', creds.login);
    form.append('password', creds.password);
    form.append('remember', creds.remember);

    fetch(LOGIN_URL, {
      method: 'post',
      body: form,
      credentials: 'include'
    }).then(function (res) {
      return res.text();
    }).then(function (res) {
      // console.log(res, +res)
      if (!isNaN(+res)) {
        if (res !== '-1') {
          _this.user.authenticated = true;
          _this.user.id = res;
          if (redirect) {
            __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace(redirect);
          }
        } else {
          context._self.error = true;
        }
      } else {
        context._self.error_db = true;
      }
    }).catch(function (err) {
      context.error = err;
    });
  },


  // To log out, we just need to remove the token
  logout: function logout() {
    fetch(LOGOUT, {
      method: 'post',
      credentials: 'include'
    }).catch(function (err) {
      return console.log(err);
    });
    this.user.authenticated = false;
    //router.replace('/login')
  },
  checkAuth: function checkAuth() {
    var _this2 = this;

    if (this.user.authenticated) {
      return true;
    }
    var result = fetch(CHECK_AUTH, {
      method: 'post',
      credentials: 'include'
    }).then(function (res) {
      return res.text();
    }).then(function (res) {
      if (!isNaN(+res)) {
        if (res !== '-1') {
          _this2.user.authenticated = true;
          _this2.user.id = res;
        } else {
          _this2.user.authenticated = false;
          _this2.user.id = -1;
        }
      } else {
        _this2.user.authenticated = false;
        _this2.user.id = -1;
      }
      return _this2.user.authenticated;
    }).catch(function (err) {
      return console.log(err);
    });
    return result;
  }
});

/***/ }),

/***/ "Sdi2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control",class:_vm.field_class,on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Su1P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control",class:_vm.field_class,attrs:{"id":_vm.id,"data-num":"f_12","data-table":"1"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T/XK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{attrs:{"disabled":option.id == 2 && _vm.remote_sensing},domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T7Xe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T8Q6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var ACTION_TYPE = 'get_action_type.php';
var LOCATION = 'get_conclusion_location.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'actionType',
	data: function data() {
		return {
			selected: '0',
			options: []
		};
	},
	props: {
		line_count: ''
	},
	created: function created() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + LOCATION + '?id=' + this.$parent.selected_act, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			var at = res.filter(function (item) {
				return item.field == 'f_16';
			});
			//console.log(at[this.line_count], this.line_count)

			if (at.length !== 0) return at[_this.line_count].val;else {
				return '0';
			}
		}).then(function (id) {
			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + ACTION_TYPE, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.options = [{ id: '0', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
					_this.selected = id;
				} else {
					_this.options = [];
					_this.selected = '0';
				}
			}).catch(function (err) {
				return console.log('7', err);
			});
		}).catch(function (err) {
			return console.log('8', err);
		});
	}
});

/***/ }),

/***/ "TN+K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonitoringV2_vue__ = __webpack_require__("7jbk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe91ecee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringV2_vue__ = __webpack_require__("jXty");
function injectStyle (ssrContext) {
  __webpack_require__("xPiU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fe91ecee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonitoringV2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe91ecee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringV2_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TUcQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TXeP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_locationTableField_vue__ = __webpack_require__("dE47");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_593a110e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_locationTableField_vue__ = __webpack_require__("iPfR");
function injectStyle (ssrContext) {
  __webpack_require__("Rhmw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-593a110e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_locationTableField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_593a110e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_locationTableField_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ThaU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TiF/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var LPO_MODE = 'get_lpo_mode.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'lpoMode',
	data: function data() {
		return {
			selected: '',
			options: []
		};
	},
	props: {
		method: null
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('lpo_mode', this.selected);
		},
		getOptions: function getOptions(id) {
			var _this = this;

			fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + LPO_MODE + '?id=' + id, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.options = data;
					_this.selected = data[0].id;
					_this.change();
				} else {
					_this.options = [];
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	created: function created() {
		var _this2 = this;

		if (this.method) {
			this.getOptions(this.method);
		} else {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$on('lpo_method', function (id) {
				_this2.getOptions(id);
			});
		}

		/*EventBus.$on('lpo_method', id => {
  	if(id == 1)
  	{
  		if(this.selected == 2)
  		{
  			this.selected = 1
  			this.change()
  		}
  		this.remote_sensing = true
  	}
  	else
  		this.remote_sensing = false
  })
  	fetch(DB + LPO_MODE, {
  	credentials: 'include'
  })
  .then(data => data.json())
  .then(data => {
  	if (data) {
  		this.options = data
  		this.selected = data[1].id //инструментальный
  		this.change()
  	}
  	else {
  		this.options = []
  	}
  })
  .catch(err => console.log(err))*/
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$off('lpo_method');
	}
});

/***/ }),

/***/ "UX6m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uhku":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth__ = __webpack_require__("SQ6o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EditReportsModal_vue__ = __webpack_require__("YSak");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

__webpack_require__("7Qk3");







// import $ from 'jquery';






var CAN_EDIT = 'can_edit_unit.php';
var GET_NAME = 'get_name.php';
var CHANGE_PASSWORD = 'change_password.php';
var GET_USER_REPORTS = 'get_user_reports.php';
var CAN_REG_USER = 'can_reg_user.php';
var GET_AVALIABLE_UNITS = 'get_avaliable_units.php';
//const GENERATE_CONCLUSION = 'report_the_conclusion.php'

var GENERATE_CONCLUSION_SSR_VSR_UND = 'report_the_conclusion.php';
var GENERATE_CONCLUSION_AM_PM_RAD = 'report_the_conclusion_am_pm_rad.php';
var GENERATE_CONCLUSION_BN = 'report_the_conclusion_bn.php';

var GENERATE_CONCLUSION_SSR_VSR_UND_FOR_GROUP = 'report_the_conclusion_for_group.php';
var GENERATE_CONCLUSION_AM_PM_RAD_FOR_GROUP = 'report_the_conclusion_am_pm_rad_for_group.php';
var GENERATE_CONCLUSION_BN_FOR_GROUP = 'report_the_conclusion_bn_for_group.php';

var GET_POSSIBLE_CONLUSION_TYPES = 'get_possible_conclusion_types.php';
var GET_POSSIBLE_CONLUSION_TYPES_FOR_GROUP = 'get_possible_conclusion_types_group.php';
var CAN_CHANGE_CONCLUSION_USER = 'can_change_conclusion_user.php';
var MAKE_GROUP = 'make_group.php';
var GET_GROUP = 'get_group.php';
var MAKE_GROUP_FROM_FILTER = 'make_group_from_filter.php';

var CAN_EDIT_WARRNAT = 3;
var CAN_EDIT_REPORTS_ID = 8;
var CAN_EDIT_ADDRESS = 9;

var IMPORT_XML = 'import_xml.php';

/*const REPORT_WEEK = 'report_week.php'
const REPORT_CONCLUSION = 'report_conclusion.php'
const REPORT_SOM = 'report_som.php'*/

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'main',
	data: function data() {
		return {
			id: 1,
			act_id: null,
			selected: 0,
			db: __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */],

			lastJournalURL: '/main',

			supervisory_id: null,
			supervisory_obj: null,

			editPath: '',
			conclusionPath: '',
			warrantPath: '',
			supervisionPath: '#/main/supervision',
			help: __WEBPACK_IMPORTED_MODULE_4__constants__["c" /* HELP */],

			/*can_edit_act: false,
   can_edit_conclusion: false,
   can_edit_warrant: false,*/

			can_create_act: false,
			can_reg_user: false,

			value: '',
			format: 'dd.MM.yyyy',

			user_name: '',
			showUserModal: false,
			showHelpModal: false,
			activeTab: 0,
			old_password: { status: 'default', value: '' },
			new_password: { status: 'default', value: '' },
			repeat_new_password: { status: 'default', value: '' },
			change_result: { status: 'default', value: '' },
			avaliable_units: [],
			showEditReportsModal: false,

			can_change_pass: false,
			can_save_db: false,

			filter: [],
			selected_filters: {},
			filter_drafts: [],
			selected_filters_drafts: {},
			filter_states: [],
			selected_filters_states: {},
			filter_decisions: [],
			selected_filters_decisions: {},

			filter_supervisory: [],
			selected_filters_supervisory: {},

			reports: [],
			currentPath: '',

			loading: false,
			showIncorrectDataGroupConclusion: false,
			incorrectDataGroupConclusionMessage: '',

			makeGroupFromFilterDisabled: true,
			displayPossibleConclusionTypes: false,
			displayPossibleConclusionTypesGroup: false,
			possibleConclusionTypes: {
				ssr_vsr_und: false,
				am_pm_rad: false,
				bn: false
			},
			possibleConclusionTypesGroup: {
				ssr_vsr_und: false,
				am_pm_rad: false,
				bn: false
			},
			displayImportingModal: false
			/*
   	showWeekModal: false,
   	startWeekDate: moment().subtract(7,'days').format('DD.MM.YYYY'),
   	endWeekDate: moment().format('DD.MM.YYYY'),
   		showConclusionModal: false,
   	startConclusionDate: moment().subtract(7,'days').format('DD.MM.YYYY'),
   	endConclusionDate: moment().format('DD.MM.YYYY'),
   		showSomModal: false,
   	startSomDate: moment().subtract(7,'days').format('DD.MM.YYYY'),
   	endSomDate: moment().format('DD.MM.YYYY'),
   */
		};
	},

	components: {
		EditReportsModal: __WEBPACK_IMPORTED_MODULE_7__EditReportsModal_vue__["a" /* default */],
		navbar: __WEBPACK_IMPORTED_MODULE_5_vue_strap__["navbar"],
		dropdown: __WEBPACK_IMPORTED_MODULE_5_vue_strap__["dropdown"],
		datepicker: __WEBPACK_IMPORTED_MODULE_5_vue_strap__["datepicker"],
		modal: __WEBPACK_IMPORTED_MODULE_5_vue_strap__["modal"],
		tabs: __WEBPACK_IMPORTED_MODULE_5_vue_strap__["tabs"],
		tab: __WEBPACK_IMPORTED_MODULE_5_vue_strap__["tab"],
		alert: __WEBPACK_IMPORTED_MODULE_5_vue_strap__["alert"]
	},
	computed: {
		canEditReports: function canEditReports() {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.avaliable_units), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var unit = _step.value;

					if (unit.id == CAN_EDIT_REPORTS_ID) return true;
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return false;
		},
		canEditWarrant: function canEditWarrant() {
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.avaliable_units), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var unit = _step2.value;

					if (unit.id == CAN_EDIT_WARRNAT) return true;
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			return false;
		},
		canEditAddress: function canEditAddress() {
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.avaliable_units), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var unit = _step3.value;

					if (unit.id == CAN_EDIT_ADDRESS) return true;
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			return false;
		},
		canDeleteAct: function canDeleteAct() {
			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;

			try {
				for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.avaliable_units), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var unit = _step4.value;

					if (unit.id == 10) //10 - удаление
						return true && Boolean(this.act_id);
				}
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}

			return false;
		},
		displayTheConclusion: function displayTheConclusion() {
			var found = this.reports.find(function (e) {
				return e.id == 6; //
			});
			return found && this.act_id;
		},
		isReport: function isReport() {
			var names = ['editReports', 'reports', 'Monitoring', 'ConclusionReport', 'Mzl', 'MonitoringRlh', 'NpaMzl', 'WarrantsCount'];
			return names.includes(this.currentPath);
		},
		groupDisabled: function groupDisabled() {
			// return true
			return !(this.act_id || this.currentPath == "list" || this.currentPath == "group_conclusion");
		}
	},
	watch: {
		'$route.name': function $routeName(str) {
			this.currentPath = str;
		}
	},
	methods: {
		logout: function logout() {
			document.body.removeAttribute('style');
			__WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].logout();
			__WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].replace('/login');
		},
		importAct: function importAct() {
			this.$refs.xml_input.click();
		},
		changeXmlFile: function changeXmlFile(event) {
			var _this = this;

			if (event.target.files && event.target.files[0]) {
				this.displayImportingModal = true;
				var formData = new FormData();
				formData.append('xml', event.target.files[0]);

				event.target.value = '';

				fetch(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + IMPORT_XML, {
					method: 'post',
					body: formData,
					credentials: 'include'
				}).then(function (res) {
					return res.json();
				}).then(function (json) {
					_this.displayImportingModal = false;
					__WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'add', params: json });
				}).catch(function (e) {
					_this.displayImportingModal = false;
				});
			}
		},
		changePassword: function changePassword() {
			var _this2 = this;

			// this.new_password.status = 'has-success'
			// this.old_password.status = 'has-error'

			if (this.old_password.value === '') {
				this.old_password.status = 'has-error';
				this.change_result.value = 'Вы должны ввести старый пароль';
				this.change_result.status = 'danger';
			} else if (this.new_password.value === '') {
				this.new_password.status = 'has-error';
				this.change_result.value = 'Вы должны ввести новый пароль';
				this.change_result.status = 'danger';
			} else if (this.repeat_new_password.value === '') {
				this.repeat_new_password.status = 'has-error';
				this.change_result.value = 'Вы должны ввести подтверждение пароля';
				this.change_result.status = 'danger';
			} else if (this.new_password.value !== this.repeat_new_password.value) {
				this.change_result.value = 'Подтверждение не совпадает с паролем';
				this.change_result.status = 'danger';
				this.new_password.status = 'has-error';
				this.repeat_new_password.status = 'has-error';
				this.old_password.status = '';
			} else {
				this.new_password.status = 'has-success';
				this.repeat_new_password.status = 'has-success';

				var form = new FormData();
				form.append('old', this.old_password.value);
				form.append('new', this.new_password.value);

				fetch(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + CHANGE_PASSWORD, {
					credentials: 'include',
					method: 'post',
					body: form
				}).then(function (res) {
					return res.json();
				}).then(function (res) {
					if (res) {
						switch (res[0].code) {
							case '1':
								_this2.old_password.status = 'has-error';
								_this2.change_result.status = 'danger';
								break;
							case '0':
								_this2.old_password.status = 'has-success';
								_this2.change_result.status = 'success';
								break;
							default:
								_this2.old_password.status = '';
								break;
						}
						_this2.change_result.value = res[0].name;
					}
				}).catch(function (err) {
					return console.log(err);
				});
			}
		},
		clearModal: function clearModal() {
			this.old_password.value = '';
			this.new_password.value = '';
			this.repeat_new_password.value = '';

			this.old_password.status = 'default';
			this.new_password.status = 'default';
			this.repeat_new_password.status = 'default';

			this.change_result.value = '';
			this.change_result.status = '';
		},
		makeGroup: function makeGroup() {
			fetch(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + MAKE_GROUP + '?act_id=' + this.act_id, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				//console.log(res)
				var group_id = res[0].czl_make_group;

				__WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/main/group_conclusion/' + group_id);
			}).catch(function (err) {
				return console.log(err);
			});
		},
		makeGroupFromFilter: function makeGroupFromFilter() {
			//if(this.makeGroupFromFilterDisabled)
			//	return false

			var where = '(';
			for (var f in this.selected_filters) {
				if (this.selected_filters[f]) {
					if (f == 'act_placement_date' && this.selected_filters[f].value.length == 2) {
						var from = this.selected_filters[f].value[0];
						var to = this.selected_filters[f].value[1];
						where += 'act_placement_date BETWEEN \'' + from + '\' AND \'' + to + '\'  or ';
					} else {
						for (var i = 0; i < this.selected_filters[f].value.length; i++) {
							if (this.selected_filters[f]) where += this.selected_filters[f].value[i] !== '' ? f + '=\'' + this.selected_filters[f].value[i] + '\' or ' : f + ' is null or ';
						}
					}
				}
				where = this.selected_filters[f].length !== 0 ? where.slice(0, -4) : where;
				if (this.selected_filters[f]) where += this.selected_filters[f].value.length !== 0 ? ') and (' : '';
			}
			where = where.slice(0, -6);

			fetch(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + MAKE_GROUP_FROM_FILTER + '?filter=' + where, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				//console.log(res)
				var group_id = res[0].czl_make_group_from_journal;

				if (group_id == -1) window.alert('Не найдено актов, которые можно объединить в группу');else __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/main/group_conclusion/' + group_id);
			}).catch(function (err) {
				return console.log(err);
			});
		},
		generate_conclusion: function generate_conclusion() {
			var _this3 = this;

			fetch('' + __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + GET_POSSIBLE_CONLUSION_TYPES + '?ids=' + this.act_id, { credentials: 'include' }).then(function (res) {
				return res.json();
			}).then(function (json) {
				_this3.displayPossibleConclusionTypes = true;
				_this3.possibleConclusionTypes.ssr_vsr_und = false;
				_this3.possibleConclusionTypes.am_pm_rad = false;
				_this3.possibleConclusionTypes.bn = false;
				if (json) {
					var _iteratorNormalCompletion5 = true;
					var _didIteratorError5 = false;
					var _iteratorError5 = undefined;

					try {
						for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(json), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
							var type = _step5.value;

							if (type.id == 1) _this3.possibleConclusionTypes.ssr_vsr_und = true;
							if (type.id == 2) _this3.possibleConclusionTypes.am_pm_rad = true;
							if (type.id == 3) _this3.possibleConclusionTypes.bn = true;
						}
					} catch (err) {
						_didIteratorError5 = true;
						_iteratorError5 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion5 && _iterator5.return) {
								_iterator5.return();
							}
						} finally {
							if (_didIteratorError5) {
								throw _iteratorError5;
							}
						}
					}
				} //console.warn(json)
			});
			//window.location.href=`${DB}${GENERATE_CONCLUSION}?act_id=${this.act_id}`
		},
		generate_ssr_vsr_und_conclusion: function generate_ssr_vsr_und_conclusion() {
			window.location.href = '' + __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + GENERATE_CONCLUSION_SSR_VSR_UND + '?act_id=' + this.act_id;
		},
		generate_am_pm_rad_conclusion: function generate_am_pm_rad_conclusion() {
			window.location.href = '' + __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + GENERATE_CONCLUSION_AM_PM_RAD + '?act_id=' + this.act_id;
		},
		generate_bn_conclusion: function generate_bn_conclusion() {
			window.location.href = '' + __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + GENERATE_CONCLUSION_BN + '?act_id=' + this.act_id;
		},
		generate_ssr_vsr_und_for_group_conclusion: function generate_ssr_vsr_und_for_group_conclusion() {
			window.location.href = '' + __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + GENERATE_CONCLUSION_SSR_VSR_UND_FOR_GROUP + '?act_id=' + this.act_id;
		},
		generate_am_pm_rad_for_group_conclusion: function generate_am_pm_rad_for_group_conclusion() {
			window.location.href = '' + __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + GENERATE_CONCLUSION_AM_PM_RAD_FOR_GROUP + '?act_id=' + this.act_id;
		},
		generate_bn_for_group_conclusion: function generate_bn_for_group_conclusion() {
			window.location.href = '' + __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + GENERATE_CONCLUSION_BN_FOR_GROUP + '?act_id=' + this.act_id;
		},
		get_possible_conclusion_for_group: function get_possible_conclusion_for_group() {
			var _this4 = this;

			fetch('' + __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + GET_POSSIBLE_CONLUSION_TYPES_FOR_GROUP + '?ids=' + this.act_id, { credentials: 'include' }).then(function (res) {
				return res.json();
			}).then(function (json) {
				console.warn(json);
				if (json) {
					if (json.error) {
						_this4.incorrectDataGroupConclusionMessage = json.error;
						_this4.showIncorrectDataGroupConclusion = true;
						return;
					} else {
						_this4.displayPossibleConclusionTypesGroup = true;
						_this4.possibleConclusionTypesGroup.ssr_vsr_und = false;
						_this4.possibleConclusionTypesGroup.am_pm_rad = false;
						_this4.possibleConclusionTypesGroup.bn = false;

						var _iteratorNormalCompletion6 = true;
						var _didIteratorError6 = false;
						var _iteratorError6 = undefined;

						try {
							for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(json), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
								var type = _step6.value;

								if (type.id == 1) _this4.possibleConclusionTypesGroup.ssr_vsr_und = true;
								if (type.id == 2) _this4.possibleConclusionTypesGroup.am_pm_rad = true;
								if (type.id == 3) _this4.possibleConclusionTypesGroup.bn = true;
							}
						} catch (err) {
							_didIteratorError6 = true;
							_iteratorError6 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion6 && _iterator6.return) {
									_iterator6.return();
								}
							} finally {
								if (_didIteratorError6) {
									throw _iteratorError6;
								}
							}
						}
					}
				}
			});
		},
		generate_conclusion_for_group: function generate_conclusion_for_group() {
			var _this5 = this;

			this.loading = true;

			//console.log('generate conclusion for group');
			var url = __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + GENERATE_CONCLUSION_FOR_GROUP; //?act_id=${this.act_id}`;
			// window.location.href = url;

			var form = new FormData();
			form.append('act_id', this.act_id);

			fetch(url, {
				credentials: 'include',
				method: 'post',
				body: form
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				//console.log('data');
				//console.log(data);
				_this5.loading = false;

				if (data.code == -1) {
					_this5.incorrectDataGroupConclusionMessage = data.message;
					_this5.showIncorrectDataGroupConclusion = true;
					_this5.loading = false;
					return;
				}

				var a = document.createElement('a');
				a.setAttribute('href', data.file);
				document.body.append(a);
				a.setAttribute("download", data.name);
				a.click();
				a.parentElement.removeChild(a);
				_this5.loading = false;
			});
		},
		showSimilarActs: function showSimilarActs() {
			__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$emit('showSimilarActs');
		},
		deleteAct: function deleteAct() {
			if (this.act_id) {
				var c = confirm("Вы уверены, что хотите удалить акт? Это действие является необратимым.");
				if (c) {
					var formData = new FormData();
					formData.append('act_id', this.act_id);

					fetch(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + 'delete_act.php', {
						method: 'post',
						body: formData,
						credentials: 'include'
					}).then(function (res) {
						return res.json();
					}).then(function (json) {
						if (json) {
							if (json.Error) {
								__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vue_strap__["alert"])('Произошла ошибка при удалении акта. ' + json.Error);
							} else {
								__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$emit('delete_act');
							}
						}
					});
				}
			}
		}
	},
	mounted: function mounted() {
		this.currentPath = this.$route.name;
	},
	created: function created() {
		var _this6 = this;

		window.onresize = function (e) {
			if (window.timeout_id) clearTimeout(window.timeout_id);

			window.timeout_id = setTimeout(function () {
				document.body.style = 'padding-top: ' + document.querySelector('nav').offsetHeight + 'px;';
			}, 100);
		};
		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$on('act_id', function (id) {
			_this6.editPath = '#/main/edit/' + id;
			_this6.conclusionPath = '#/main/conclusion/' + id;
			_this6.warrantPath = '#/main/warrant/' + id;
			_this6.act_id = id;
		});

		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$on('supervisory_id', function (obj) {
			_this6.supervisionPath = '#/main/supervision/' + obj.id;
			_this6.supervisory_id = obj.id;
			_this6.supervisory_obj = obj;

			/*console.log('--------------');
   console.log('supervisory event');
   console.log(this.supervisory_obj.id);
   console.log(this.supervisory_obj);
   console.log('--------------');*/
		});

		/* EventBus.$on('save-filter', data => {
  	this.filter = data.f
  	if(data.name)
  		this.selected_filters[data.name] = data.s
  }) */

		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$on('save-page', function (num) {
			_this6.page_num = num;
		});

		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$on('filter', function (f) {
			_this6.selected_filters[f.field] = {};
			_this6.selected_filters[f.field].value = f.value;
			_this6.selected_filters[f.field].filtered = f.filtered;
			if (_this6.selected_filters.fo && _this6.selected_filters.fo.value && _this6.selected_filters.fo.value.length == 1 && _this6.selected_filters.region && _this6.selected_filters.region.value && _this6.selected_filters.region.value.length == 1 && _this6.selected_filters.forestry && _this6.selected_filters.forestry.value && _this6.selected_filters.forestry.value.length == 1) {
				_this6.makeGroupFromFilterDisabled = false;
			} else {
				_this6.makeGroupFromFilterDisabled = true;
			}
		});
		// ---------------------------------------
		/* EventBus.$on('save-filter-drafts', data => {
  	this.filter_drafts = data.f
  	this.selected_filters_drafts[data.name] = data.s
  }) */

		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$on('save-page-drafts', function (num) {
			_this6.page_num_drafts = num;
		});

		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$on('filter-drafts', function (f) {
			_this6.selected_filters[f.field + '-drafts'] = {};
			_this6.selected_filters[f.field + '-drafts'].value = f.value;
			_this6.selected_filters[f.field + '-drafts'].filtered = f.filtered;
		});
		// ---------------------------------------
		/*EventBus.$on('save-filter-states', data => {
  	this.filter_states = data.f
  	this.selected_filters_states[data.name] = data.s
  })*/

		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$on('save-page-states', function (num) {
			_this6.page_num_states = num;
		});

		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$on('filter-states', function (f) {
			_this6.selected_filters[f.field + '-states'] = {};
			_this6.selected_filters[f.field + '-states'].value = f.value;
			_this6.selected_filters[f.field + '-states'].filtered = f.filtered;
		});
		// ---------------------------------------
		/*EventBus.$on('save-filter-decisions', data => {
  	this.filter_decisions = data.f
  	this.selected_filters_decisions[data.name] = data.s
  })*/

		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$on('save-page-decisions', function (num) {
			_this6.page_num_decisions = num;
		});

		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$on('filter-decisions', function (f) {
			_this6.selected_filters[f.field + '-decisions'] = {};
			_this6.selected_filters[f.field + '-decisions'].value = f.value;
			_this6.selected_filters[f.field + '-decisions'].filtered = f.filtered;
		});

		// ---------------------------------------
		/* 	EventBus.$on('save-filter-interactions', data => {
  		this.filter_interactions = data.f
  		this.selected_filters_interactions[data.name] = data.s
  	})
  		EventBus.$on('save-page-interactions', num => {
  		this.page_num_interactions = num
  	})
  		EventBus.$on('filter-interactions', f => {
  		this.selected_filters_interactions[f.field + '-interactions'] = {}
  		this.selected_filters_interactions[f.field + '-interactions'].value = f.value
  		this.selected_filters_interactions[f.field + '-interactions'].filtered = f.filtered
  	}) */
		// ---------------------------------------
		/* EventBus.$on('save-filter-supervisory', data => {
  	this.filter_supervisory = data.f
  	this.selected_filters_supervisory[data.name] = data.s
  }) */

		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$on('save-page-supervisory', function (num) {
			_this6.page_num_supervisory = num;
		});

		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$on('filter-supervisory', function (f) {
			_this6.selected_filters[f.field + '-supervisory'] = {};
			_this6.selected_filters[f.field + '-supervisory'].value = f.value;
			_this6.selected_filters[f.field + '-supervisory'].filtered = f.filtered;
		});

		/*EventBus.$on('can_edit', data => {
  	this.can_edit_act = data.act === 't' ? true : false
  	this.can_edit_conclusion = data.conclusion === 't' ? true : false
  	this.can_edit_warrant = data.warrant === 't' ? true : false
  })*/

		fetch(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + GET_AVALIABLE_UNITS, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			_this6.avaliable_units = res || [];
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + CAN_EDIT + '?act_id=0&unit_id=1', { //Can create act?
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			_this6.can_create_act = res[0].czl_check_can_edit_unit !== null ? true : false;
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + CAN_REG_USER, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			_this6.can_reg_user = res[0].czl_check_can_reg_user == 't' ? true : false;
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + GET_USER_REPORTS, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			if (res) {
				_this6.reports = res;
			} else _this6.reports = [];
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + GET_NAME, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			_this6.user_name = res[0].name;
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + CAN_CHANGE_CONCLUSION_USER, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			_this6.can_save_db = res[0].value == 't';
		});

		this.can_change_pass = __WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].user.id === '42';
	},
	beforeDestroy: function beforeDestroy() {
		window.onresize = function () {};
		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$off('act_id');
		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$off('supervisory_id');
		//EventBus.$off('can_edit')
		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$off('save-filter');
		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$off('save-page');
		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$off('save-filter-drafts');
		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$off('save-page-drafts');
		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$off('save-page-supervisory');
		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$off('filter');
		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$off('filter-drafts');
		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$off('filter-supervisory');
	}
});

/***/ }),

/***/ "UkrR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var ACTION_TYPE = 'get_action_type.php';
var LOCATION = 'get_act_location.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'actionType',
	data: function data() {
		return {
			selected: '0',
			options: []
		};
	},
	props: {
		line_count: '',
		at_id: ''
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('edit_action_type', { index: this.line_count, value: this.selected });
		}
	},
	created: function created() {
		var _this = this;

		if (this.$parent.data_location.action_type == null) {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$on('fetch_action_type_complete', function (data) {
				if (data) {
					_this.selected = _this.at_id ? _this.at_id : '0';
					_this.options = data;
				} else {
					_this.options = [];
					_this.selected = '0';
				}
				__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$off('fetch_action_type_complete');
			});
		} else {
			var data = this.$parent.data_location.action_type;
			if (data) {
				this.selected = this.at_id ? this.at_id : '0';
				this.options = data;
			} else {
				this.options = [];
				this.selected = '0';
			}
		}
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$off('fetch_action_type_complete');
	}
});

/***/ }),

/***/ "UqYO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var REASON = 'get_decision_reason.php';
var CONCLUSION_INFO = 'get_conclusion_info.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'decisionReason',
	data: function data() {
		return {
			selected: '',
			options: [],
			savedOptions: [],
			savedId: ''
		};
	},
	props: {
		disabled: false,
		error: false
	},
	watch: {
		disabled: function disabled(newVal, oldVal) {
			if (newVal) {
				this.savedOptions = this.options;
				this.savedId = this.selected;
				this.options = [{ id: '', name: '' }];
				this.selected = '';
			} else {
				this.options = this.savedOptions;
				this.selected = this.savedId ? this.savedId : this.options[0] ? this.options[0].id : '';
			}
			this.change();
		}
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('decision_reason', this.selected);
		}
	},
	mounted: function mounted() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + CONCLUSION_INFO + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			return res[0].f_42;
		}).then(function (set_id) {
			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + REASON, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.savedOptions = data;
					_this.options = set_id ? data : [{ id: '', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
					_this.selected = set_id ? set_id : '';
					_this.savedId = _this.selected;
				} else {
					_this.options = [];
					_this.selected = '';
				}
				_this.change();
			}).catch(function (err) {
				return console.log(err);
			});
		}).catch(function (err) {
			return console.log(err);
		});
	},
	created: function created() {
		var _this2 = this;

		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on('set_decision_reason', function (id) {
			_this2.selected = id;
		});
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('set_decision_reason');
	}
});

/***/ }),

/***/ "Us5u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subforestry_vue__ = __webpack_require__("CDOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96443cea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_subforestry_vue__ = __webpack_require__("KLW5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subforestry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96443cea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_subforestry_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V11d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Monitoring_vue__ = __webpack_require__("ohbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11ea3e2d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Monitoring_vue__ = __webpack_require__("8bM+");
function injectStyle (ssrContext) {
  __webpack_require__("o7L1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11ea3e2d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Monitoring_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11ea3e2d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Monitoring_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V5LQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_protectiveCatExt_vue__ = __webpack_require__("mGXz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c399663e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_protectiveCatExt_vue__ = __webpack_require__("M+g5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_protectiveCatExt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c399663e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_protectiveCatExt_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V7ym":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"s-body-wrapper"},[_c('table',{staticClass:"s-body"},[_c('tbody',_vm._l((_vm.rows),function(row,i){return _c('tr',[(row.flag)?_c('td',{attrs:{"colspan":"17"}},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(row.fo))])]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"left s-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.region))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.lpo_volume))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_published))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_som))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_prof))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_agit))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_ssr))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_vsr))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_und))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_rad))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_others))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_negative_ssr))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_negative_vsr))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_negative_und))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_negative_rad))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right s-td-small",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.mzl_volume_obtained_negative_others))]):_vm._e()])}))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-header-wrapper"},[_c('table',{staticClass:"s-header"},[_c('thead',{staticClass:"bold"},[_c('tr',[_c('td',{staticClass:"s-td",attrs:{"rowspan":"2"}},[_vm._v("Субъекты, федеральные округа")]),_vm._v(" "),_c('td',{staticClass:"s-td",attrs:{"rowspan":"2"}},[_vm._v("Объёмы выполненных л.п. обследований (в соответствии с опубликованными на сайтах Актах ЛПО), га")]),_vm._v(" "),_c('td',{staticClass:"s-td",attrs:{"rowspan":"2"}},[_vm._v("Назначено мероприятий (в соответствии с опубликованными Актами ЛПО), га")]),_vm._v(" "),_c('td',{staticClass:"s-td",attrs:{"rowspan":"2"}},[_vm._v("Назначено мероприятий (в соответствии с поступившими Актами ЛПО), га")]),_vm._v(" "),_c('td',{attrs:{"colspan":"3"}},[_vm._v("из них")]),_vm._v(" "),_c('td',{attrs:{"colspan":"5"}},[_vm._v("в т.ч. по видам мероприятий")]),_vm._v(" "),_c('td',{attrs:{"colspan":"5"}},[_vm._v("в т.ч. по актам с отрицательными заключениями, га")]),_vm._v(" "),_c('td',{staticClass:"s-scroll",attrs:{"rowspan":"2"}})]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"s-td-small"},[_vm._v("СОМ, га")]),_vm._v(" "),_c('td',{staticClass:"s-td"},[_vm._v("профилактические мероприятия")]),_vm._v(" "),_c('td',{staticClass:"s-td"},[_vm._v("Агитационные мероприятия")]),_vm._v(" "),_c('td',{staticClass:"s-td-small"},[_vm._v("ССР, га")]),_vm._v(" "),_c('td',{staticClass:"s-td-small"},[_vm._v("ВСР, га")]),_vm._v(" "),_c('td',{staticClass:"s-td-small"},[_vm._v("УНД, га")]),_vm._v(" "),_c('td',{staticClass:"s-td-small"},[_vm._v("РАД, га")]),_vm._v(" "),_c('td',{staticClass:"s-td-small"},[_vm._v("Иные, га")]),_vm._v(" "),_c('td',{staticClass:"s-td-small"},[_vm._v("ССР, га")]),_vm._v(" "),_c('td',{staticClass:"s-td-small"},[_vm._v("ВСР, га")]),_vm._v(" "),_c('td',{staticClass:"s-td-small"},[_vm._v("УНД, га")]),_vm._v(" "),_c('td',{staticClass:"s-td-small"},[_vm._v("РАД, га")]),_vm._v(" "),_c('td',{staticClass:"s-td-small"},[_vm._v("Иные, га")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("2")]),_vm._v(" "),_c('td',[_vm._v("3")]),_vm._v(" "),_c('td',[_vm._v("4")]),_vm._v(" "),_c('td',[_vm._v("5")]),_vm._v(" "),_c('td',[_vm._v("6")]),_vm._v(" "),_c('td',[_vm._v("7")]),_vm._v(" "),_c('td',[_vm._v("8")]),_vm._v(" "),_c('td',[_vm._v("9")]),_vm._v(" "),_c('td',[_vm._v("10")]),_vm._v(" "),_c('td',[_vm._v("11")]),_vm._v(" "),_c('td',[_vm._v("12")]),_vm._v(" "),_c('td',[_vm._v("13")]),_vm._v(" "),_c('td',[_vm._v("14")]),_vm._v(" "),_c('td',[_vm._v("15")]),_vm._v(" "),_c('td',[_vm._v("16")]),_vm._v(" "),_c('td',[_vm._v("17")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V98W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var USERS = 'get_users.php';
var ACT_INFO = 'get_act_info.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'conclusionUsers',
	data: function data() {
		return {
			selected: '0',
			options: []
		};
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('edit_conclusion_user', this.selected);
		}
	},
	created: function created() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + ACT_INFO + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			return res[0].f_6;
		}).then(function (id) {
			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + USERS, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.options = [{ id: '0', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
					_this.selected = id;
				} else {
					_this.options = [];
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}).catch(function (err) {
			return console.log(err);
		});
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('set_conclusion_user');
	}
});

/***/ }),

/***/ "VGNK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center list-title"},[_vm._v("\n\t\t\tРеестр черновиков заключений\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"l-header-wrapper"},[_c('table',{staticClass:"header"},[_c('thead',[_vm._m(0),_vm._v(" "),_c('tr',[_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"act_num","filter":_vm.filter,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"fo","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"region","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"forestry","filter":_vm.filter,"wideWindow":true,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"sites_count","filter":_vm.filter,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"user_name","filter":_vm.filter,"suffix":_vm.journalSuffix}})],1),_vm._v(" "),_c('th',{staticClass:"l-scroll",on:{"click":_vm.clearFilters}},[_c('span',{staticClass:"glyphicon glyphicon-remove pointer",attrs:{"title":"Сбросить фильтры"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"l-body-wrapper"},[_c('table',{staticClass:"body"},[_c('tbody',_vm._l((_vm.lines),function(line,i){return _c('tr',{class:{ selected: line.selected },on:{"click":function($event){_vm.select_line(i)}}},[(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.act_num))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.fo))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.region))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.forestry))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.sites_count))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.user_name))]):_vm._e()])}))])]),_vm._v(" "),_c('div',[(_vm.can_change)?_c('div',{staticClass:"pull-left change-conclusion-user-button"},[(_vm.lines.length)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.showChangeConclusionUser}},[_vm._v("Назначить ответственного")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center"},[(_vm.pages)?_c('ul',{staticClass:"pagination"},_vm._l((_vm.pages),function(page){return _c('li',{class:{ active: page.active }},[(_vm.isNumeric(page.num))?_c('a',{attrs:{"href":"#","data-value":page.num},on:{"click":_vm.select_page}},[_vm._v(_vm._s(page.num))]):_c('span',{staticClass:"disabled_page",attrs:{"href":"#"}},[_vm._v(_vm._s(page.num))])])})):_vm._e()])]),_vm._v(" "),_c('modal',{attrs:{"backdrop":false,"medium":""},model:{value:(_vm.showChangeConclusionUserValue),callback:function ($$v) {_vm.showChangeConclusionUserValue=$$v},expression:"showChangeConclusionUserValue"}},[_c('div',{staticClass:"modal-header",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_c('b',[_vm._v("Назначить ответственного за заключения")])])]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"15px"}},[_c('ul',{staticClass:"user-list"},_vm._l((_vm.users),function(user){return _c('li',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.conclusion_user),expression:"conclusion_user"}],attrs:{"type":"radio","id":user.id},domProps:{"value":user.id,"checked":_vm._q(_vm.conclusion_user,user.id)},on:{"change":function($event){_vm.conclusion_user=user.id}}}),_vm._v(" "),_c('label',{attrs:{"for":user.id}},[_vm._v(_vm._s(user.name))])])}))]),_vm._v(" "),_c('div',{staticClass:"modal-footer",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":_vm.closeChangeConclusionUser}},[_vm._v("Отмена")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.conclusion_user},on:{"click":_vm.changeConclusionUser}},[_vm._v("Ок")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"center l-td"},[_vm._v("№ акта")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("ФО")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Субъект РФ")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Лесничество")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Количество участков")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Пользователь")]),_vm._v(" "),_c('th',{staticClass:"l-scroll"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VfPe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VtK6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_npaViolation_vue__ = __webpack_require__("shda");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b547f8b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_npaViolation_vue__ = __webpack_require__("cCmS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_npaViolation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b547f8b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_npaViolation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W34n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_decisionReason_vue__ = __webpack_require__("F9gM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46923385_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_decisionReason_vue__ = __webpack_require__("Hyik");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_decisionReason_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46923385_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_decisionReason_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WA+y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control form-control my-control table-control",attrs:{"disabled":_vm.disabled},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WAYN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Filter__ = __webpack_require__("XKhj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_strap__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var USERS = 'get_users.php';
var CAN_CHANGE_CONCLUSION_USER = 'can_change_conclusion_user.php';
var CHANGE_CONCLUSION_USER = 'change_conclusion_user.php';
var TABLE = 'get_journal_supervisory.php';
var FILTER_TABLE = 'get_journal_supervisory.php';
var COUNT_OF_FILTERS = 6;
var PADDING = 3;






/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'ListSupervisory',
	data: function data() {
		return {
			lines: [],
			selected: 0,
			pages: [],
			active: 1,
			pages_count: 1,
			cf_count: 0,
			total_count: null,
			can_change: false,

			filter: {
				fo: [],
				region: [],
				act_nums: [],
				supervisory: [],
				letter_date_txt: [],
				letter_num: []
			},

			users: [],
			conclusion_user: null,
			showChangeConclusionUserValue: false,

			journalSuffix: '-supervisory'
		};
	},

	components: {
		filterTable: __WEBPACK_IMPORTED_MODULE_3__Filter__["a" /* default */], modal: __WEBPACK_IMPORTED_MODULE_5_vue_strap__["modal"]
	},
	methods: {
		isNumeric: function isNumeric(x) {
			return !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(+x);
		},
		getNumEnding: function getNumEnding(iNumber, aEndings) {
			var sEnding, i;
			iNumber = iNumber % 100;
			if (iNumber >= 11 && iNumber <= 19) {
				sEnding = aEndings[2];
			} else {
				i = iNumber % 10;
				switch (i) {
					case 1:
						sEnding = aEndings[0];break;
					case 2:
					case 3:
					case 4:
						sEnding = aEndings[1];break;
					default:
						sEnding = aEndings[2];
				}
			}
			return sEnding;
		},
		showChangeConclusionUser: function showChangeConclusionUser() {
			this.conclusion_user = null;
			this.showChangeConclusionUserValue = true;
		},
		closeChangeConclusionUser: function closeChangeConclusionUser() {
			document.querySelector('.user-list').scrollTop = 0;
			this.showChangeConclusionUserValue = false;
		},
		changeConclusionUser: function changeConclusionUser() {
			var _this = this;

			var arr_endings = ['заключения', 'заключений', 'заключений'];
			var change = confirm('Вы уверены, что хотите назначить ответственного для ' + this.total_count + ' ' + this.getNumEnding(this.total_count, arr_endings) + '?');
			if (!change) return false;

			var where = '(';
			for (var f in this.filter) {
				for (var i = 0; i < this.filter[f].length; i++) {
					var field_name = f;
					field_name = field_name.replace(this.journalSuffix, '');
					where += this.filter[f][i] !== '' ? field_name + '=\'' + this.filter[f][i] + '\' or ' : field_name + ' is null or ';
				}

				where = this.filter[f].length !== 0 ? where.slice(0, -4) : where;
				where += this.filter[f].length !== 0 ? ') and (' : '';
			}
			where = where.slice(0, -6);

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + CHANGE_CONCLUSION_USER + '?filter=' + where + '&user_id=' + this.conclusion_user, { credentials: 'include' }).then(function (res) {
				return res.json();
			}).then(function (res) {
				//console.warn(this.active)
				_this.fetch_lines((_this.active - 1) * __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */] + 1);
			});

			this.conclusion_user = null;
			document.querySelector('.user-list').scrollTop = 0;
			this.showChangeConclusionUserValue = false;
		},
		select_line: function select_line(i) {
			if (!this.lines[i].flag) {
				var k = i;
				while (!this.lines[k].flag) {
					k--;
				}

				i = k;
			}

			this.selected = i;

			for (var j = 0; j < this.lines.length; j++) {
				if (this.lines[j].flag) {
					this.lines[j].selected = i === j;
				} else {
					var _k = j;
					while (!this.lines[_k].flag) {
						_k--;
					}
					for (var l = 0; l < this.lines[_k].count; l++) {
						this.lines[j].selected = i === _k;
					}
				}
			}

			// console.log('line: ');
			// console.log(this.lines[i]);

			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('supervisory_id', this.lines[i]);

			// document.getElementById(i).checked = true
			//EventBus.$emit('can_edit', {act: this.lines[i].can_edit_act, conclusion: this.lines[i].can_edit_conclusion, warrant: this.lines[i].can_edit_warrant})
		},
		fetch_lines: function fetch_lines(start) {
			var _this2 = this;

			//console.log('fetch_lines');
			var temp_lines = [];
			var temp_pages = [];

			var where = '(';
			for (var f in this.filter) {
				for (var i = 0; i < this.filter[f].length; i++) {
					var field_name = f;
					field_name = field_name.replace(this.journalSuffix, '');
					where += this.filter[f][i] !== '' ? field_name + '=\'' + this.filter[f][i] + '\' or ' : field_name + ' is null or ';
				}

				where = this.filter[f].length !== 0 ? where.slice(0, -4) : where;
				where += this.filter[f].length !== 0 ? ') and (' : '';
			}
			where = where.slice(0, -6);
			if (where) where = '&filter=' + where;

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + FILTER_TABLE + ('?start=' + start + '&rows=' + __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */] + where), {
				// fetch(DB + TABLE, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				var prev_id = -1;
				var prev_localforestry_id = -1;
				var prev_subforestry_id = -1;

				if (res[res.length - 1].count) _this2.total_count = res[res.length - 1].count;

				for (var _i = 0; _i < res.length - 1; _i++) {

					var act = {};

					var start_fo = _i;
					while (_i > 0 && res[start_fo - 1].act_id === res[_i].act_id && start_fo > 1) {
						start_fo--;
					}

					var curr = start_fo;
					while (curr < res.length && res[curr].act_id === res[start_fo].act_id) {
						curr++;
					}
					act.count = curr - start_fo;

					if (res[_i].act_id === prev_id) {
						act.flag = false;
					} else {
						act.flag = true;
					}
					//////////////////

					var start_lf = _i;
					while (_i > 0 && res[start_lf - 1].localforestry_id === res[_i].localforestry_id && start_lf > 1 && res[start_lf - 1].act_id === res[_i].act_id) {
						start_lf--;
					}

					var curr_lf = start_lf;
					while (curr_lf < res.length && res[curr_lf].act_id === res[start_lf].act_id && res[curr_lf].localforestry_id === res[_i].localforestry_id) {
						curr_lf++;
					}
					act.count_lf = curr_lf - start_lf;

					if (res[_i].act_id === prev_id && prev_localforestry_id === res[_i].localforestry_id) {
						act.flag_lf = false;
					} else {
						act.flag_lf = true;
					}

					////////////////////////
					var start_sf = _i;
					while (_i > 0 && res[start_sf - 1].localforestry_id === res[_i].localforestry_id && start_sf > 1 && res[start_sf - 1].act_id === res[_i].act_id) {
						start_sf--;
					}

					var curr_sf = start_sf;
					while (curr_sf < res.length && res[curr_sf].act_id === res[start_sf].act_id && res[curr_sf].localforestry_id === res[_i].localforestry_id) {
						curr_sf++;
					}
					act.count_sf = curr_sf - start_sf;

					if (res[_i].act_id === prev_id && prev_localforestry_id === res[_i].localforestry_id) {
						act.flag_sf = false;
					} else {
						act.flag_sf = true;
					}
					////////////////////////


					prev_id = res[_i].supervisory_id;

					act.id = res[_i].supervisory_id;
					act.supervisory_id = res[_i].supervisory_id;

					act.fo = res[_i].fo;
					act.fo_id = res[_i].fo_id;
					act.region = res[_i].region;
					act.region_id = res[_i].region_id;
					act.forestry = res[_i].forestry;
					act.forestry_id = res[_i].forestry_id;

					act.act_nums = res[_i].act_nums;
					act.supervisory = res[_i].supervisory;
					act.letter_num = res[_i].letter_num;
					act.letter_date_txt = res[_i].letter_date_txt;
					//act.localforestry = res[i].localforestry
					//act.subforestry = res[i].subforestry
					//act.area = res[i].area
					//act.section = res[i].section
					//act.section_lp = res[i].section_lp
					act.selected = false;

					temp_lines.push(act);
				}

				_this2.lines = temp_lines;

				temp_lines = [];

				// this.pages = temp_pages

				_this2.lines[0].selected = true;

				if (_this2.lines[1] && !_this2.lines[1].flag) {
					var k = 1;
					while (!_this2.lines[k].flag) {
						_this2.lines[k].selected = true;
						k++;
					}
				}

				__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('act_id', _this2.lines[0].id);
			}).catch(function (err) {
				return console.log(err);
			});
		},
		select_page: function select_page(e) {
			var _this3 = this;

			var value = +e.target.getAttribute('data-value');
			this.fetch_lines((value - 1) * __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */] + 1);
			this.active = value;
			var temp_pages = [];

			if (this.active - 1 > PADDING) {
				temp_pages.push({ active: false, num: 1 });
				temp_pages.push({ active: false, num: '...' });
			}

			for (var i = this.active - PADDING - 1; i < this.active + PADDING; i++) {
				if (i >= 0 && i < this.pages_count) temp_pages.push({ active: false, num: i + 1 });
			}if (this.active < this.pages_count - PADDING) {
				temp_pages.push({ active: false, num: '...' });
				temp_pages.push({ active: false, num: this.pages_count });
			}

			this.pages = temp_pages;

			this.pages.forEach(function (p) {
				p.active = p.num == _this3.active;
			});

			//this.pages[value - 1].active = true
		},
		clearFilters: function clearFilters() {
			this.cf_count = 0;
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('clearFilters' + this.journalSuffix);
		},
		filter_lines: function filter_lines() {
			var _this4 = this;

			//console.log('filter_lines');
			var temp_lines = [];
			var temp_pages = [];

			var where = '(';
			for (var f in this.filter) {
				for (var i = 0; i < this.filter[f].length; i++) {
					var field_name = f;
					field_name = field_name.replace(this.journalSuffix, '');
					where += this.filter[f][i] !== '' ? field_name + '=\'' + this.filter[f][i] + '\' or ' : field_name + ' is null or ';
				}

				where = this.filter[f].length !== 0 ? where.slice(0, -4) : where;
				where += this.filter[f].length !== 0 ? ') and (' : '';
			}
			where = where.slice(0, -6);

			//console.log('where');
			//console.log(where);

			var start = 1;

			if (this.$route.params.id || this.$parent.act_id) {
				start = (this.page_num - 1) * __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */] + 1;
				this.active = this.page_num;
			}

			var t = TABLE + ('?start=' + start + '&rows=' + __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */]);
			if (where) {
				t = FILTER_TABLE + ('?start=' + start + '&rows=' + __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */] + '&filter=' + where);
			}

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + t, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				var prev_id = -1;
				var prev_localforestry_id = -1;
				var prev_subforestry_id = -1;

				var length = !!where ? res.length : res.length - 1;

				if (res[res.length - 1].count) _this4.total_count = res[res.length - 1].count;

				for (var _i2 = 0; _i2 < length; _i2++) {
					var act = {};

					var start_fo = _i2;
					while (_i2 > 0 && res[start_fo - 1].act_id === res[_i2].act_id && start_fo > 1) {
						start_fo--;
					}

					var curr = start_fo;
					while (curr < res.length && res[curr].act_id === res[start_fo].act_id) {
						curr++;
					}
					act.count = curr - start_fo;

					if (res[_i2].act_id === prev_id) {
						act.flag = false;
					} else {
						act.flag = true;
					}
					//////////////////

					var start_lf = _i2;
					while (_i2 > 0 && res[start_lf - 1].localforestry_id === res[_i2].localforestry_id && start_lf > 1 && res[start_lf - 1].act_id === res[_i2].act_id) {
						start_lf--;
					}

					var curr_lf = start_lf;
					while (curr_lf < res.length && res[curr_lf].act_id === res[start_lf].act_id && res[curr_lf].localforestry_id === res[_i2].localforestry_id) {
						curr_lf++;
					}
					act.count_lf = curr_lf - start_lf;

					if (res[_i2].act_id === prev_id && prev_localforestry_id === res[_i2].localforestry_id) {
						act.flag_lf = false;
					} else {
						act.flag_lf = true;
					}

					////////////////////////
					var start_sf = _i2;
					while (_i2 > 0 && res[start_sf - 1].localforestry_id === res[_i2].localforestry_id && start_sf > 1 && res[start_sf - 1].act_id === res[_i2].act_id) {
						start_sf--;
					}

					var curr_sf = start_sf;
					while (curr_sf < res.length && res[curr_sf].act_id === res[start_sf].act_id && res[curr_sf].localforestry_id === res[_i2].localforestry_id) {
						curr_sf++;
					}
					act.count_sf = curr_sf - start_sf;

					if (res[_i2].act_id === prev_id && prev_localforestry_id === res[_i2].localforestry_id) {
						act.flag_sf = false;
					} else {
						act.flag_sf = true;
					}
					////////////////////////


					prev_id = res[_i2].supervisory_id;

					act.id = res[_i2].supervisory_id;
					act.supervisory_id = res[_i2].supervisory_id;

					act.fo = res[_i2].fo;
					act.fo_id = res[_i2].fo_id;
					act.region = res[_i2].region;
					act.region_id = res[_i2].region_id;
					act.forestry = res[_i2].forestry;
					act.forestry_id = res[_i2].forestry_id;

					act.act_nums = res[_i2].act_nums;
					act.supervisory = res[_i2].supervisory;
					act.letter_num = res[_i2].letter_num;
					act.letter_date_txt = res[_i2].letter_date_txt;

					//act.localforestry = res[i].localforestry
					//act.subforestry = res[i].subforestry
					//act.area = res[i].area
					////act.section = res[i].section
					//act.section_lp = res[i].section_lp
					act.selected = false;

					temp_lines.push(act);
				}

				//if (!where) {
				//let count = Math.round(res[res.length - 1].count / ROWS_ON_PAGE)
				_this4.pages_count = Math.ceil(res[res.length - 1].count / __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */]);
				temp_pages = [];

				if (_this4.active > PADDING) {
					temp_pages.push({ active: false, num: 1 });
					temp_pages.push({ active: false, num: '...' });
				}

				for (var _i3 = _this4.active - PADDING; _i3 < _this4.active + PADDING; _i3++) {
					if (_i3 >= 0 && _i3 < _this4.pages_count) temp_pages.push({ active: false, num: _i3 + 1 });
				}

				if (_this4.active < _this4.pages_count - PADDING) {
					temp_pages.push({ active: false, num: '...' });
					temp_pages.push({ active: false, num: _this4.pages_count });
				}

				_this4.pages = temp_pages;
				_this4.pages.forEach(function (p) {
					p.active = p.num == _this4.active;
				});
				//}

				_this4.lines = temp_lines;

				if (_this4.$route.params.id || _this4.$parent.act_id) {
					var act_id = _this4.$route.params.id || _this4.$parent.act_id;
					var found = false;
					for (var _i4 = 0; _i4 < _this4.lines.length; _i4++) {
						if (_this4.lines[_i4].id == act_id) {
							_this4.select_line(_i4);

							_this4.$nextTick(function () {
								var selected_row = document.querySelector("tr.selected");
								if (selected_row) selected_row.scrollIntoView(true);
							});

							found = true;
							break;
						}
					}
					if (!found) _this4.select_line(0);
				} else {
					_this4.select_line(0);
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	created: function created() {},
	mounted: function mounted() {
		var _this5 = this;

		this.$parent.lastJournalURL = '/main/supervisory';

		fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + USERS, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			_this5.users = res;
		});

		fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + CAN_CHANGE_CONCLUSION_USER, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			_this5.can_change = res[0].value == 't';
		});

		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on('filter' + this.journalSuffix + '_list', function (f) {
			_this5.filter[f.field] = f.value !== '' ? f.value : null;
			_this5.active = 1;
			if (f.cf) //clearFilters
				{
					_this5.cf_count++;
					if (_this5.cf_count == COUNT_OF_FILTERS) _this5.filter_lines();
				} else _this5.filter_lines();
		});

		this.page_num = this.$parent.page_num_supervisory ? this.$parent.page_num_supervisory : 1;

		if (this.$parent.selected_filters) {
			for (var field in this.$parent.selected_filters) {
				if (field.includes(this.journalSuffix)) this.filter[field] = this.$parent.selected_filters[field].value;
			}
		}
		this.filter_lines();

		// const w = document.documentElement.clientWidth - 50
		// document.querySelector('.main_table_wrapper').style.width = `${w}px`

		////////////////////////////////////////////

		var dispay_width = document.documentElement.clientWidth;
		// const dispay_height = document.documentElement.clientHeight - 146
		var dispay_height = document.documentElement.clientHeight - 208;
		var scroll_width = 17;

		var ua = navigator.userAgent;

		if (ua.search('OPR/') > 0) {
			scroll_width = 15;
		}

		var table_width = dispay_width - scroll_width;
		var col_width = Math.floor(table_width / COUNT_OF_FILTERS);
		// 
		var large_width = table_width - col_width * 9;

		// console.log(col_width, large_width, table_width, col_width * 9 + large_width)


		document.querySelectorAll('.l-td').forEach(function (td) {
			td.width = col_width;
		});
		document.querySelectorAll('.large-td').forEach(function (td) {
			td.width = large_width;
		});
		document.querySelector('.l-header-wrapper').width = dispay_width;
		document.querySelector('.l-body-wrapper').width = dispay_width;
		document.querySelector('.l-body-wrapper').style.maxHeight = dispay_height + 'px';

		// console.log(dispay_height, dispay_width, col_width, table_width)
		// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))

		document.querySelector('.l-scroll').width = scroll_width;
	},
	beforeDestroy: function beforeDestroy() {
		//this.lines = []
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('filter' + this.journalSuffix + '_list');
		//EventBus.$emit('save-filter-supervisory', {f: this.filter})
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('save-page' + this.journalSuffix, this.active);
	}
});

/***/ }),

/***/ "WFQ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subforestry_vue__ = __webpack_require__("XlCu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e0fb007_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_subforestry_vue__ = __webpack_require__("1lZM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subforestry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e0fb007_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_subforestry_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WGXW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_select2__ = __webpack_require__("hv7s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_select2_dist_css_select2_css__ = __webpack_require__("+3jA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_select2_dist_css_select2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_select2_dist_css_select2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var SPECIES = 'get_species.php';
//const ACT_LOCATION = 'get_act_location.php'



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'species',
	data: function data() {
		return {
			selected: '0',
			options: []
		};
	},
	props: {
		line_count: '',
		sp_id: ''
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('edit_species', { index: this.line_count, value: this.selected });
		},
		fill: function fill() {
			var _this = this;

			this.options = this.$parent.data_location.species_list;
			this.selected = this.sp_id ? this.sp_id : '';

			var data = { id: this.selected, text: this.options[1].children.find(function (e) {
					return e.id == _this.selected;
				}) };

			if (data.id) {
				data.text = data.text.name;
				if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#species_' + this.$props.line_count).find("option[value='" + data.id + "']").length) {
					__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#species_' + this.$props.line_count).val(data.id).trigger('change');
				} else {
					var newOption = new Option(data.text, data.id, true, true);
					__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#species_' + this.$props.line_count).append(newOption).trigger('change');
				}
			}
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		//let region_id = this.$parent.f_12
		if (this.$parent.data_location.species_list.length) {
			this.fill();
		} else {
			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$on('fetch_species_complete', function () {
				_this2.fill();

				__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$off('fetch_species_complete');
			});
		}

		__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).ready(function () {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#species_' + _this2.$props.line_count).select2({});
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#species_' + _this2.$props.line_count).on('change', function (e) {
				_this2.$emit('input', e.target.value);
			});
		});

		this.$on('input', function (id) {
			__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$emit('edit_species', { index: _this2.$props.line_count, value: id });
		});
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_4__lib_EventBus__["a" /* EventBus */].$off('fetch_species_complete');
	}
});

/***/ }),

/***/ "WGk3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var LOCALFORESTRY = 'localforestrie_list.php';
var HEADER = 'get_header.php';
var LOCATION = 'get_conclusion_location.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'localforestry',
	data: function data() {
		return {
			selected: '0',
			options: [],
			id: this.type + '_localforestry_' + this.line_count
		};
	},
	props: {
		line_count: 0,
		type: ''
	},
	created: function created() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + HEADER + '?id=' + this.$parent.selected_act, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			return res[2].val;
		}).then(function (id) {
			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + LOCALFORESTRY + '?id=' + id).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.options = [{ id: '0', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
				} else {
					_this.selected = '0';
					_this.options = [];
				}
			}).then(function () {
				fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + LOCATION + '?id=' + _this.$route.params.id, {
					credentials: 'include'
				}).then(function (res) {
					return res.json();
				}).then(function (res) {
					var lf = res.filter(function (item) {
						return item.field == 'f_20';
					});

					_this.selected = lf[_this.line_count] ? lf[_this.line_count].val : '0';
				}).catch(function (err) {
					return console.log('1', err);
				});
			}).catch(function (err) {
				return console.log('2', err);
			});
		}).catch(function (err) {
			return console.log('3', err);
		});
	}

});

/***/ }),

/***/ "WJ8b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.id)+" — "+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wf+r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forestry_vue__ = __webpack_require__("HccC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a509191_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_forestry_vue__ = __webpack_require__("NL6A");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forestry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a509191_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_forestry_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WyJT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_officialDocs_vue__ = __webpack_require__("/MHW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84e22ca2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_officialDocs_vue__ = __webpack_require__("5+Uu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_officialDocs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84e22ca2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_officialDocs_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XKhj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filter_vue__ = __webpack_require__("raWs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e72668d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Filter_vue__ = __webpack_require__("it07");
function injectStyle (ssrContext) {
  __webpack_require__("6VXu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e72668d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Filter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XMGQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_protectiveCat_vue__ = __webpack_require__("sAI+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72699260_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_protectiveCat_vue__ = __webpack_require__("bjRF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_protectiveCat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72699260_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_protectiveCat_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XlCu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var SUBFORESTRY = 'subforestrie_list.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'subforestry',
	data: function data() {
		return {
			id: this.type + '_localforestry_' + this.line_count,
			selected: '0',
			options: []
		};
	},
	props: {
		line_count: 0,
		lf_id: null,
		sf_id: null,
		type: ''
	},
	methods: {
		fill: function fill(id) {
			var _this = this;

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + SUBFORESTRY + '?id=' + id).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					if (_this.$props.sf_id) _this.selected = _this.$props.sf_id;
					_this.options = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
				} else {
					_this.options = [];
				}
			}).catch(function (err) {
				return console.log(err);
			});
		},
		change: function change() {
			console.warn(this.selected);
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit(this.type + '_subforestry', { index: this.line_count, value: this.selected });
		}
	},
	created: function created() {
		var _this2 = this;

		//console.log('on', 'localforestry_id_' + this.id)
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on(this.type + '_localforestry_' + this.line_count, function (id) {
			_this2.fill(id);
		});

		if (this.$props.lf_id && this.$props.sf_id) {
			this.fill(this.$props.lf_id);
		}
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off(this.type + '_localforestry_' + this.line_count);
	}
});

/***/ }),

/***/ "YQ32":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control",class:_vm.field_class,on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YSak":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditReportsModal_vue__ = __webpack_require__("/Yg9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f1bee2d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EditReportsModal_vue__ = __webpack_require__("ipTV");
function injectStyle (ssrContext) {
  __webpack_require__("8IsD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f1bee2d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditReportsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f1bee2d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EditReportsModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YXqo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 text-right"},[_vm._v("\n\t\t\tСубъект РФ\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRegion),expression:"selectedRegion"}],staticClass:"form-control my-control",attrs:{"disabled":_vm.disabledRegion},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedRegion=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeRegion]}},_vm._l((_vm.regions_list),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t\t\t\t"+_vm._s(option.name)+"\n\t\t\t\t")])}))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 text-right"},[_vm._v("\n\t\t\tЛесничество\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"col-sm-7 no-right-padding"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedForestrie),expression:"selectedForestrie"}],staticClass:"form-control my-control",attrs:{"disabled":_vm.disabledForestrie},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedForestrie=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeForestrie]}},_vm._l((_vm.forestries_list),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t\t\t\t"+_vm._s(option.name)+"\n\t\t\t\t")])}))]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 action_icons"},[_c('i',{staticClass:"fas fa-pencil-alt",class:{disabled: _vm.disabledForestrie || _vm.selectedForestrie == 0},staticStyle:{"margin-right":"10px"},on:{"click":_vm.editForestrie}}),_vm._v(" "),_c('i',{staticClass:"fa fa-plus",class:{disabled: _vm.disabledRegion},on:{"click":_vm.addForestrie}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 text-right"},[_vm._v("\n\t\t\tУч. лесничество\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"col-sm-7 no-right-padding"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocalforestrie),expression:"selectedLocalforestrie"}],staticClass:"form-control my-control",attrs:{"disabled":_vm.disabledLocalforestrie},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocalforestrie=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeLocalforestrie]}},_vm._l((_vm.localforestries_list),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t\t\t\t"+_vm._s(option.name)+"\n\t\t\t\t")])}))]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 action_icons"},[_c('i',{staticClass:"fas fa-pencil-alt",class:{disabled: _vm.disabledLocalforestrie || _vm.selectedLocalforestrie == 0},staticStyle:{"margin-right":"10px"},on:{"click":_vm.editLocalForestrie}}),_vm._v(" "),_c('i',{staticClass:"fa fa-plus",class:{disabled: _vm.disabledForestrie},on:{"click":_vm.addLocalForestrie}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 text-right"},[_vm._v("\n\t\t\tПодлесничество\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"col-sm-7 no-right-padding"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSubForestrie),expression:"selectedSubForestrie"}],staticClass:"form-control my-control",attrs:{"disabled":_vm.disabledSubforestrie},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedSubForestrie=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeSubforestrie]}},_vm._l((_vm.subforestries_list),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t\t\t\t"+_vm._s(option.name)+"\n\t\t\t\t")])}))]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 action_icons"},[_c('i',{staticClass:"fas fa-pencil-alt",class:{disabled: _vm.disabledSubforestrie || _vm.selectedSubForestrie == 0},staticStyle:{"margin-right":"10px"},on:{"click":_vm.editSubForestrie}}),_vm._v(" "),_c('i',{staticClass:"fa fa-plus",class:{disabled: _vm.disabledLocalforestrie},on:{"click":_vm.addSubForestrie}})])]),_vm._v(" "),_c('modal',{staticStyle:{"overflow":"visible"},attrs:{"backdrop":false,"effect":"fade","width":"400px"},model:{value:(_vm.displayModal),callback:function ($$v) {_vm.displayModal=$$v},expression:"displayModal"}},[_c('div',{staticClass:"modal-header",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('h3',{staticClass:"modal-title",staticStyle:{"font-size":"22px"}},[_vm._v("\n\t\t    \t"+_vm._s(_vm.modalTitle)+"\n\t\t    ")])]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newName),expression:"newName"}],staticClass:"form-control",staticStyle:{"font-size":"14px"},attrs:{"type":"text","placeholder":"Введите название..."},domProps:{"value":(_vm.newName)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.modalCallback($event)},"input":function($event){if($event.target.composing){ return; }_vm.newName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.displayModal = false}}},[_vm._v("Отмена")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","disabled":!_vm.newName.length},on:{"click":_vm.modalCallback}},[_vm._v("Сохранить")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Main__ = __webpack_require__("s6+2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_List__ = __webpack_require__("tcnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_add_addForm__ = __webpack_require__("/tat");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_edit_editForm__ = __webpack_require__("NOV8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_conclusion_conclusionForm__ = __webpack_require__("B4IV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_group_conclusion_groupConclusionForm__ = __webpack_require__("juAD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_warrant_warrantForm__ = __webpack_require__("+Ftn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_warrant_group_WarrantGroupForm__ = __webpack_require__("ZBt/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_NotFound__ = __webpack_require__("YcJa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_reg_Reg__ = __webpack_require__("+bB7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ListDrafts__ = __webpack_require__("+d+a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ListStates__ = __webpack_require__("BLNQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ListDecisions__ = __webpack_require__("uKak");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ListSupervisory__ = __webpack_require__("vRcf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_reports_Reports__ = __webpack_require__("GFu2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_reports_Monitoring__ = __webpack_require__("V11d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_reports_MonitoringRlh__ = __webpack_require__("vmUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_reports_Conclusion__ = __webpack_require__("MUnB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_reports_Mzl__ = __webpack_require__("oyOU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_reports_NpaMzl__ = __webpack_require__("4/07");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_reports_WarrantsCount__ = __webpack_require__("k5om");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_reports_Stat__ = __webpack_require__("LJ/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_reports_StatLpo__ = __webpack_require__("zLbM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_reports_MonitoringV2__ = __webpack_require__("TN+K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_reports_MonitoringRlhV2__ = __webpack_require__("O/fP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_reports_ConclusionV2__ = __webpack_require__("JANY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_reports_MzlV2__ = __webpack_require__("bCiw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_supervision_supervisionForm__ = __webpack_require__("hFA5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_catalog_TerritoryCatalog__ = __webpack_require__("CKjs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__auth__ = __webpack_require__("SQ6o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__lib_EventBus__ = __webpack_require__("O67w");








































var router = new __WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]({
	mode: 'hash',
	routes: [{
		path: '/',
		redirect: '/main'
	}, {
		path: '/main',
		component: __WEBPACK_IMPORTED_MODULE_2__components_Main__["a" /* default */],
		children: [{
			path: '/',
			name: 'list',
			component: __WEBPACK_IMPORTED_MODULE_3__components_List__["a" /* default */],
			beforeEnter: function beforeEnter(to, from, next) {
				if (from.name === 'edit' || from.name === 'conclusion' || from.name === 'warrant') {
					to.params.id = from.params.id;
				} else {
					to.params.id = null;
				}
				next();
			}
		}, {
			path: 'drafts',
			name: 'drafts',
			component: __WEBPACK_IMPORTED_MODULE_12__components_ListDrafts__["a" /* default */]
		}, {
			path: 'states',
			name: 'states',
			component: __WEBPACK_IMPORTED_MODULE_13__components_ListStates__["a" /* default */]
		}, {
			path: 'decisions',
			name: 'decisions',
			component: __WEBPACK_IMPORTED_MODULE_14__components_ListDecisions__["a" /* default */]
		}, {
			path: 'supervisory',
			name: 'supervisory',
			component: __WEBPACK_IMPORTED_MODULE_15__components_ListSupervisory__["a" /* default */]
		}, {
			path: 'add',
			name: 'add',
			component: __WEBPACK_IMPORTED_MODULE_4__components_add_addForm__["a" /* default */]
		}, {
			path: 'edit/:id',
			name: 'edit',
			component: __WEBPACK_IMPORTED_MODULE_5__components_edit_editForm__["a" /* default */]
		}, {
			path: 'conclusion/:id',
			name: 'conclusion',
			component: __WEBPACK_IMPORTED_MODULE_6__components_conclusion_conclusionForm__["a" /* default */]
		}, {
			path: 'group_conclusion/:id',
			name: 'group_conclusion',
			component: __WEBPACK_IMPORTED_MODULE_7__components_group_conclusion_groupConclusionForm__["a" /* default */]
		}, {
			path: 'warrant/:id',
			name: 'warrant',
			component: __WEBPACK_IMPORTED_MODULE_8__components_warrant_warrantForm__["a" /* default */]
		}, {
			path: 'warrant_group',
			name: 'warrant_group',
			component: __WEBPACK_IMPORTED_MODULE_9__components_warrant_group_WarrantGroupForm__["a" /* default */]
		}, {
			path: 'reports',
			name: 'reports',
			component: __WEBPACK_IMPORTED_MODULE_16__components_reports_Reports__["a" /* default */],
			children: [{
				path: 'monitoring/',
				component: __WEBPACK_IMPORTED_MODULE_17__components_reports_Monitoring__["a" /* default */],
				name: 'Monitoring'
			}, {
				path: 'conclusion/',
				component: __WEBPACK_IMPORTED_MODULE_19__components_reports_Conclusion__["a" /* default */],
				name: 'ConclusionReport'
			}, {
				path: 'mzl/',
				component: __WEBPACK_IMPORTED_MODULE_20__components_reports_Mzl__["a" /* default */],
				name: 'Mzl'
			}, {
				path: 'monitoring-rlh/',
				component: __WEBPACK_IMPORTED_MODULE_18__components_reports_MonitoringRlh__["a" /* default */],
				name: 'MonitoringRlh'
			}, {
				path: 'monitoring-v2/',
				component: __WEBPACK_IMPORTED_MODULE_25__components_reports_MonitoringV2__["a" /* default */],
				name: 'MonitoringV2'
			}, {
				path: 'conclusion-v2/',
				component: __WEBPACK_IMPORTED_MODULE_27__components_reports_ConclusionV2__["a" /* default */],
				name: 'ConclusionReportV2'
			}, {
				path: 'mzl-v2/',
				component: __WEBPACK_IMPORTED_MODULE_28__components_reports_MzlV2__["a" /* default */],
				name: 'MzlV2'
			}, {
				path: 'monitoring-rlh-v2/',
				component: __WEBPACK_IMPORTED_MODULE_26__components_reports_MonitoringRlhV2__["a" /* default */],
				name: 'MonitoringRlhV2'
			}, {
				path: 'npa-mzl/',
				component: __WEBPACK_IMPORTED_MODULE_21__components_reports_NpaMzl__["a" /* default */],
				name: 'NpaMzl'
			}, {
				path: 'warrants-count/',
				component: __WEBPACK_IMPORTED_MODULE_22__components_reports_WarrantsCount__["a" /* default */],
				name: 'WarrantsCount'
			}, {
				path: 'stat/',
				component: __WEBPACK_IMPORTED_MODULE_23__components_reports_Stat__["a" /* default */],
				name: 'Stat'
			}, {
				path: 'stat_lpo/',
				component: __WEBPACK_IMPORTED_MODULE_24__components_reports_StatLpo__["a" /* default */],
				name: 'StatLpo'
			}]
		}, {
			path: 'reg',
			name: 'reg',
			component: __WEBPACK_IMPORTED_MODULE_11__components_reg_Reg__["a" /* default */]
		}, {
			path: 'supervision',
			name: 'supervision',
			component: __WEBPACK_IMPORTED_MODULE_29__components_supervision_supervisionForm__["a" /* default */]
		}, {
			path: 'supervision/:id',
			name: 'supervision',
			component: __WEBPACK_IMPORTED_MODULE_29__components_supervision_supervisionForm__["a" /* default */]
		}, {
			path: 'catalog',
			name: 'catalog',
			component: __WEBPACK_IMPORTED_MODULE_30__components_catalog_TerritoryCatalog__["a" /* default */]
		}],
		meta: { requiresAuth: true }
	}, {
		path: '/login',
		name: 'login',
		component: __WEBPACK_IMPORTED_MODULE_1__components_Login__["a" /* default */],
		beforeEnter: function beforeEnter(to, from, next) {
			if (!__WEBPACK_IMPORTED_MODULE_31__auth__["a" /* default */].user.authenticated) {
				next();
			} else {
				next('/main');
			}
		}
	}, {
		path: '/*',
		name: 'not-found',
		component: __WEBPACK_IMPORTED_MODULE_10__components_NotFound__["a" /* default */]
	}]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Yblq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var LOCALFORESTRY = 'localforestrie_list.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'localforestry',
	data: function data() {
		return {
			selected: '0',
			options: [],
			id: this.type + '_localforestry_' + this.line_count
		};
	},
	methods: {
		fill: function fill(id) {
			var _this = this;

			//console.log(id)
			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + LOCALFORESTRY + '?id=' + id).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					if (_this.$props.lf_id) {
						_this.selected = _this.$props.lf_id;
						_this.change();
					}

					_this.options = [{ id: '0', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
				} else {
					_this.options = [];
					_this.selected = '0';
				}
			}).catch(function (err) {
				return console.log(err);
			});
		},
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit(this.type + '_localforestry_' + this.line_count, this.selected);
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit(this.type + '_localforestry', { index: this.line_count, value: this.selected });
		}
	},
	props: {
		line_count: 0,
		lf_id: null,
		forestry_id: null,
		type: ''
	},
	created: function created() {
		var _this2 = this;

		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on(this.type + '_forestry', function (id) {
			_this2.fill(id);
		});

		this.fill(this.forestry_id);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off(this.type + '_forestry');
	}
});

/***/ }),

/***/ "YcJa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7df2e4c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__("69oF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7df2e4c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YmFx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control",class:_vm.field_class,on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZAGF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control",attrs:{"id":_vm.id,"data-num":"f_9","data-table":"1"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZBt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WarrantGroupForm_vue__ = __webpack_require__("kF6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23b0c366_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_WarrantGroupForm_vue__ = __webpack_require__("o8b1");
function injectStyle (ssrContext) {
  __webpack_require__("nMCY")
  __webpack_require__("3uqE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23b0c366"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WarrantGroupForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23b0c366_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_WarrantGroupForm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZNIz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var NPA_VIOLATION_NEW = 'get_npa_violation_new.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'npaViolation',
	data: function data() {
		return {
			selected: '',
			options: [],
			internal_id: null
		};
	},
	props: {
		id: null,
		line_count: null,
		disabled: false
	},
	watch: {
		'$props.id': function $propsId(val) {
			this.selected = this.$props.id;
		}
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('npa_violation', { index: this.$props.line_count, value: this.selected });
		}
	},
	created: function created() {
		var _this = this;

		/*fetch(DB + NPA_VIOLATION_NEW, {
  	credentials: 'include'
  })
  .then(data => data.json())
  .then(data => {
  	if (data) {
  		this.options = data
  		this.selected = this.internal_id ? this.internal_id : data[0].id
  		this.internal_id = null
  	}
  	else {
  		this.options = []
  	}
  })
  .catch(err => console.log(err))*/

		this.internal_id = this.$props.id;
		if (this.$parent.npa_violations.length) {
			this.options = this.$parent.npa_violations;
			this.selected = this.internal_id ? this.internal_id : this.options[0].id;
			this.internal_id = null;
		} else {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$on('fetch_npa_violations_complete', function () {
				_this.options = _this.$parent.npa_violations;
				_this.selected = _this.internal_id ? _this.internal_id : _this.options[0].id;
				_this.internal_id = null;
			});
		}
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$off('fetch_npa_violations_complete');
	}
});

/***/ }),

/***/ "ZjKP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zshe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a1nV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{key:option.id,domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aUIB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_localforestry_vue__ = __webpack_require__("FPpz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f9df276_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_localforestry_vue__ = __webpack_require__("jIvA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_localforestry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f9df276_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_localforestry_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aUj4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aWQz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("qI5z");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var NPA_VIOLATION = 'get_npa_violation.php';
//const WARRANT_INFO = 'get_warrant_info.php'

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'npaViolation',
	data: function data() {
		return {
			display_npa_modal: false,
			items: [],
			names: '',
			names_obj: {},
			val: false,
			sel: false
		};
	},

	props: {
		disabled: false,
		npa: {},
		act_num: null
	},
	components: {
		dropdown: __WEBPACK_IMPORTED_MODULE_0_vue_strap__["dropdown"],
		checkbox: __WEBPACK_IMPORTED_MODULE_0_vue_strap__["checkbox"],
		modal: __WEBPACK_IMPORTED_MODULE_0_vue_strap__["modal"]
	},
	watch: {
		sel: function sel(e) {
			this.items.map(function (t) {
				t.checked = e;
			});
		}
	},
	methods: {
		toggleModal: function toggleModal() {
			this.display_npa_modal = !this.display_npa_modal;

			if (this.display_npa_modal && this.npa) {
				for (var i = 0; i < this.npa.length; i++) {
					for (var j = 0; j < this.items.length; j++) {
						if (this.npa[i] == this.items[j].id) {
							//console.warn(this.items[j])
							this.items[j].checked = true;
						}
					}
				}
			}
		},
		check: function check(id, name, value) {
			if (value) this.names_obj[id] = name;else this.names_obj[id] = null;

			var text = '';
			var ids = [];
			for (var key in this.names_obj) {
				if (typeof this.names_obj[key] != 'undefined' && this.names_obj[key] != null) {
					text += this.names_obj[key] + ', ';
					ids.push(key);
				}
			}

			text = text.slice(0, -2);

			if (text.length > 105) this.names = text.slice(0, 105) + '...';else this.names = text;

			//console.warn(ids)
			this.$emit('change', ids);
		},
		open: function open(show) {
			//console.warn(this.npa)
			if (show && this.npa) {
				/*let _ids = ''
    for (let i = 0; i < this.npa.length; i++) {
    	_ids += this.npa[i]
    }
    	_ids = _ids.slice(1,-1).split(',')*/
				//console.warn(this.npa)
				for (var i = 0; i < this.npa.length; i++) {
					for (var j = 0; j < this.items.length; j++) {
						if (this.npa[i] == this.items[j].id) {
							//console.warn(this.items[j])
							this.items[j].checked = true;
						}
					}
				}
			}
		},
		fill: function fill(ids) {
			var _this = this;

			fetch(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DB */] + NPA_VIOLATION).then(function (res) {
				return res.json();
			}).then(function (res) {
				if (res) {
					var arr = res.map(function (r) {
						return {
							id: r.id,
							name: r.name,
							violation: r.violation,
							checked: false
						};
					});

					//console.warn(ids)
					if (typeof ids != 'undefined') {
						var text = '';
						for (var i = 0; i < ids.length; i++) {
							for (var j = 0; j < arr.length; j++) {
								if (ids[i] == arr[j].id) {
									text += arr[j].name + ', ';
								}
							}
						}

						text = text.slice(0, -2);

						if (text.length > 105) _this.names = text.slice(0, 105) + '...';else _this.names = text;
					}

					_this.items = arr;
				} else {
					_this.items = [];
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	mounted: function mounted() {
		/*fetch(DB + WARRANT_INFO + '?id=' + this.$route.params.id, {
  	credentials: 'include'
  })
  .then(res => res.json())
  .then(res => {
  	return res[0].f_92
  })
  .then(ids => {
  	if (ids) {
  		ids = ids.slice(1,-1).split(',')
  		this.fill(ids)
  	}
  	else {
  		this.fill()
  	}
  })*/
		if (this.npa) this.fill(this.npa);else this.fill();

		//this.fill()
	}
});

/***/ }),

/***/ "aXJq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_actionType_vue__ = __webpack_require__("oO+5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09ff87b9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_actionType_vue__ = __webpack_require__("G4I8");
function injectStyle (ssrContext) {
  __webpack_require__("GkOP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09ff87b9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_actionType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09ff87b9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_actionType_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aXt2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterDateRange_vue__ = __webpack_require__("mrkg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04b318d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FilterDateRange_vue__ = __webpack_require__("PbVx");
function injectStyle (ssrContext) {
  __webpack_require__("o8pT")
  __webpack_require__("UX6m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04b318d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterDateRange_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04b318d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FilterDateRange_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "afdD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegionsList_vue__ = __webpack_require__("HEn/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1c4a0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_RegionsList_vue__ = __webpack_require__("4ga3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegionsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1c4a0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_RegionsList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "atfw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr'),_vm._v(" "),_c('div',{staticClass:"m-header-wrapper",staticStyle:{"/*width":"3800px"}},[_c('table',{staticClass:"m-header"},[_c('thead',{staticClass:"bold"},[_vm._m(0),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"4"}},[_vm._v("количество актов, размещенных на сайтах субъетов")]),_vm._v(" "),_c('td',{attrs:{"colspan":"4"}},[_vm._v("количество представленных от ДЛХ по ФО актов ЛПО ")]),_vm._v(" "),_c('td',{attrs:{"colspan":"4"}},[_vm._v("количество рассмотренных актов ЛПО")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2","rowspan":"2"}},[_vm._v("количество заключений о"),_c('br'),_vm._v("рассмотрении актов ЛПО"),_c('br'),_vm._v("нарастающим итогом с"),_c('br'),_vm._v("01.01."+_vm._s(_vm.endYear))]),_vm._v(" "),_c('td',{attrs:{"colspan":"2","rowspan":"2"}},[_vm._v("согласовано актов ЛПО")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2","rowspan":"2"}},[_vm._v("не согласовано актов ЛПО")]),_vm._v(" "),_c('td',{attrs:{"colspan":"10"}},[_vm._v("в том числе по причинам (нарастающим итогом с 01.01."+_vm._s(_vm.endYear)+"):")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("количество выездных проверок, шт")]),_vm._v(" "),_c('td',{staticClass:"m-scroll",attrs:{"rowspan":"3"}})]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("c 01.01."+_vm._s(_vm.endYear)+" по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("отчётный период (c"),_c('br'),_vm._v(_vm._s(_vm.start)+" по "+_vm._s(_vm.end)+")")]),_vm._v(" "),_c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("c 01.01."+_vm._s(_vm.endYear)+" по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("отчётный период (c"),_c('br'),_vm._v(_vm._s(_vm.start)+" по "+_vm._s(_vm.end)+")")]),_vm._v(" "),_c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("c 01.01."+_vm._s(_vm.endYear)+" по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("отчётный период (c"),_c('br'),_vm._v(_vm._s(_vm.start)+" по "+_vm._s(_vm.end)+")")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("c 01.01."+_vm._s(_vm.endYear)),_c('br'),_vm._v("по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("отчётный"),_c('br'),_vm._v("период (c"),_c('br'),_vm._v(_vm._s(_vm.start)+" по"),_c('br'),_vm._v(_vm._s(_vm.end)+")")]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("c 01.01."+_vm._s(_vm.endYear)),_c('br'),_vm._v("по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("отчётный"),_c('br'),_vm._v("период (c"),_c('br'),_vm._v(_vm._s(_vm.start)+" по"),_c('br'),_vm._v(_vm._s(_vm.end)+")")])]),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8)])])]),_vm._v(" "),_c('div',{staticClass:"m-body-wrapper",staticStyle:{"/*width":"3800px"}},[_c('table',{staticClass:"m-body"},[_c('tbody',_vm._l((_vm.rows),function(row,i){return _c('tr',[(row.flag)?_c('td',{attrs:{"colspan":"33"}},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(row.fo))])]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"left m-td wide_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.region))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.placement_all_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.placement_all_ga))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.placement_week_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.placement_week_ga))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.entrance_all_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.entrance_all_ga))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.entrance_week_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.entrance_week_ga))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.consideration_all_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.consideration_all_ga))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.consideration_week_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.consideration_week_ga))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.conclusion_consideration_all_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.conclusion_consideration_all_s_mzl))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_good_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_good_s_mzl))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_s_mzl))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_count_sved_glpm))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_s_mzl_sved_glpm))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_count_mer_glpm))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_s_mzl_mer_glpm))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_count_sved_to))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_s_mzl_sved_to))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_count_sved_sansost))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_s_mzl_sved_sansost))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_count_zak_rf))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_s_mzl_zak_rf))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.needs_verification_all_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.needs_verification_week_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.warrant_real_check_count_all_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.warrant_real_check_count_week_count))]):_vm._e()])}))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"wide_col",attrs:{"rowspan":"3"}},[_vm._v("Субъекты, федеральные округа")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"2"}},[_vm._v("количество заключений с"),_c('br'),_vm._v("рекомендациями к"),_c('br'),_vm._v("проведению выездных"),_c('br'),_vm._v("проверок")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("несоответствие сведений"),_c('br'),_vm._v("данным ГЛПМ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("несоответствие"),_c('br'),_vm._v("мероприятий данным"),_c('br'),_vm._v("ГЛПМ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("несоответствие сведений"),_c('br'),_vm._v("таксационным"),_c('br'),_vm._v("характеристикам лесного"),_c('br'),_vm._v("участка")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("недостоверность"),_c('br'),_vm._v("сведений о санитарном"),_c('br'),_vm._v("лесопатологическом"),_c('br'),_vm._v("состоянии лесов (при"),_c('br'),_vm._v("выездной проверке)")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("запрещение или"),_c('br'),_vm._v("ограничение"),_c('br'),_vm._v("законодательством"),_c('br'),_vm._v("Российской Федерации")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("ед. изм.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("актов ЛПО,"),_c('br'),_vm._v("шт")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("актов ЛПО,"),_c('br'),_vm._v("шт")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("актов ЛПО,"),_c('br'),_vm._v("шт")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("актов ЛПО,"),_c('br'),_vm._v("шт")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("актов ЛПО,"),_c('br'),_vm._v("шт")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("актов ЛПО,"),_c('br'),_vm._v("шт")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("актов ЛПО,"),_c('br'),_vm._v("шт")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("2")]),_vm._v(" "),_c('td',[_vm._v("3")]),_vm._v(" "),_c('td',[_vm._v("4")]),_vm._v(" "),_c('td',[_vm._v("5")]),_vm._v(" "),_c('td',[_vm._v("6")]),_vm._v(" "),_c('td',[_vm._v("7")]),_vm._v(" "),_c('td',[_vm._v("8")]),_vm._v(" "),_c('td',[_vm._v("9")]),_vm._v(" "),_c('td',[_vm._v("10")]),_vm._v(" "),_c('td',[_vm._v("11")]),_vm._v(" "),_c('td',[_vm._v("12")]),_vm._v(" "),_c('td',[_vm._v("13")]),_vm._v(" "),_c('td',[_vm._v("14")]),_vm._v(" "),_c('td',[_vm._v("15")]),_vm._v(" "),_c('td',[_vm._v("16")]),_vm._v(" "),_c('td',[_vm._v("17")]),_vm._v(" "),_c('td',[_vm._v("18")]),_vm._v(" "),_c('td',[_vm._v("19")]),_vm._v(" "),_c('td',[_vm._v("20")]),_vm._v(" "),_c('td',[_vm._v("21")]),_vm._v(" "),_c('td',[_vm._v("22")]),_vm._v(" "),_c('td',[_vm._v("23")]),_vm._v(" "),_c('td',[_vm._v("24")]),_vm._v(" "),_c('td',[_vm._v("25")]),_vm._v(" "),_c('td',[_vm._v("26")]),_vm._v(" "),_c('td',[_vm._v("27")]),_vm._v(" "),_c('td',[_vm._v("28")]),_vm._v(" "),_c('td',[_vm._v("29")]),_vm._v(" "),_c('td',[_vm._v("30")]),_vm._v(" "),_c('td',[_vm._v("31")]),_vm._v(" "),_c('td',[_vm._v("32")]),_vm._v(" "),_c('td',[_vm._v("33")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aycJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bCiw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MzlV2_vue__ = __webpack_require__("hjNQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fee6634_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MzlV2_vue__ = __webpack_require__("7LcB");
function injectStyle (ssrContext) {
  __webpack_require__("usgw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fee6634"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MzlV2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fee6634_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MzlV2_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bPM2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bbli":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reg"},[_c('div',{staticClass:"reg-wrapper"},[_c('form',{attrs:{"id":"reg-form","role":"form"},on:{"submit":_vm.submit}},[_c('h4',{staticClass:"form-signin-heading"},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),(_vm.stage == 1)?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 text-right top-offset"},[_vm._v("Фамилия")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.f_93),expression:"user.f_93"}],staticClass:"form-control reg-control",attrs:{"type":"text"},domProps:{"value":(_vm.user.f_93)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "f_93", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 text-right top-offset"},[_vm._v("Имя")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.f_94),expression:"user.f_94"}],staticClass:"form-control reg-control",attrs:{"type":"text"},domProps:{"value":(_vm.user.f_94)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "f_94", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 text-right top-offset"},[_vm._v("Отчество")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.f_95),expression:"user.f_95"}],staticClass:"form-control reg-control",attrs:{"type":"text"},domProps:{"value":(_vm.user.f_95)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "f_95", $event.target.value)}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 text-right top-offset"},[_vm._v("Организация")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('reg-organization',{attrs:{"id":_vm.user.f_96}})],1)]),_vm._v(" "),(_vm.user.f_96 == 1)?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 text-right top-offset"},[_vm._v("Филиал")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('reg-organization-property',{key:"1",attrs:{"org_id":"1","id":_vm.user.f_97}})],1)])]:_vm._e(),_vm._v(" "),(_vm.user.f_96 == 2)?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 text-right top-offset"},[_vm._v("ФО")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('reg-organization-property',{key:"2",attrs:{"org_id":"2","id":_vm.user.f_97}})],1)])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 text-right top-offset"},[_vm._v("Должность")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.f_98),expression:"user.f_98"}],staticClass:"form-control reg-control",attrs:{"type":"text"},domProps:{"value":(_vm.user.f_98)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "f_98", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 text-right top-offset"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.f_100),expression:"user.f_100"}],staticClass:"form-control reg-control",attrs:{"type":"text","placeholder":"example@example.com"},domProps:{"value":(_vm.user.f_100)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "f_100", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 text-right top-offset"},[_vm._v("Дополнительные контакты")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.f_99),expression:"user.f_99"}],staticClass:"form-control reg-control",attrs:{"type":"text"},domProps:{"value":(_vm.user.f_99)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "f_99", $event.target.value)}}})])])]:_vm._e(),_vm._v(" "),(_vm.stage == 2)?[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"15px"}},[_c('div',{staticClass:"col-sm-12"},[_c('table',{staticClass:"dateTable"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.units),function(unit,index){return _c('tr',{key:unit.id},[_c('td',[_vm._v(_vm._s(unit.name))]),_vm._v(" "),_c('td',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.units[index].state !== null},on:{"change":function($event){_vm.canUpdateUnitChange(index, $event.target.checked)}}})]),_vm._v(" "),_c('td',[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabledBox(index)},domProps:{"checked":_vm.units[index].state === true},on:{"change":function($event){_vm.canAdministrateUnitChange(index, $event.target.checked)}}})])])}))])])])]:_vm._e(),_vm._v(" "),(_vm.stage == 3)?[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"15px"}},[_c('div',{staticClass:"col-sm-12"},[_c('table',{staticClass:"dateTable"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.reports),function(report,index){return _c('tr',{key:report.id},[_c('td',[_vm._v(_vm._s(report.name))]),_vm._v(" "),_c('td',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.reports[index].state == true},on:{"change":function($event){_vm.canVievReportChange(index, $event.target.checked)}}})])])}))])])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.stage > 1)?_c('button',{staticClass:"btn btn-primary btn-color",attrs:{"type":"button"},on:{"click":function($event){_vm.stage = _vm.stage - 1}}},[_vm._v("Назад")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-color pull-right",attrs:{"type":"button","disabled":_vm.disableButton},on:{"click":function($event){_vm.nextStage()}}},[_vm._v(_vm._s(_vm.button_label))]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary pull-right",staticStyle:{"margin-right":"10px"},attrs:{"type":"button"},on:{"click":function($event){_vm.cancel()}}},[_vm._v("Отмена")])])])],2)]),_vm._v(" "),_c('modal',{attrs:{"title":"","backdrop":false,"medium":""},on:{"ok":function($event){_vm.showErrorModal = false}},model:{value:(_vm.showErrorModal),callback:function ($$v) {_vm.showErrorModal=$$v},expression:"showErrorModal"}},[_c('div',{staticStyle:{"margin-bottom":"5px","font-size":"120%"}},[_c('span',[_vm._v("Был автоматически сгенерирован логин")]),_vm._v(" "),_c('span',{staticClass:"new_login"},[_vm._v(_vm._s(_vm.double_login))])]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"5px","font-size":"120%"}},[_c('span',[_vm._v("Этот логин уже занят пользователем")]),_vm._v(" "),_c('span',{staticClass:"new_login"},[_vm._v(_vm._s(_vm.double_user))]),_c('br')]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"120%"}},[_c('span',[_vm._v("Для регистрации обратитесь к администратору")])]),_vm._v(" "),_c('div',{staticClass:"modal-footer",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.showErrorModal = false}}},[_vm._v("Ок")])])]),_vm._v(" "),_c('modal',{attrs:{"title":"","backdrop":false,"small":""},on:{"ok":function($event){_vm.showRegModal = false}},model:{value:(_vm.showRegModal),callback:function ($$v) {_vm.showRegModal=$$v},expression:"showRegModal"}},[_c('div',{staticStyle:{"margin-bottom":"15px","font-size":"120%"}},[_c('span',{staticStyle:{"width":"65px","display":"inline-block"}},[_vm._v("Логин:")]),_vm._v(" "),_c('span',{staticClass:"new_login"},[_vm._v(_vm._s(_vm.new_login))])]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"120%"}},[_c('span',{staticStyle:{"width":"65px","display":"inline-block"}},[_vm._v("Пароль:")]),_vm._v(" "),_c('span',{staticClass:"new_login"},[_vm._v(_vm._s(_vm.new_pass))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.showRegModal = false}}},[_vm._v("Ок")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Название модуля")]),_vm._v(" "),_c('th',[_vm._v("Может редактировать")]),_vm._v(" "),_c('th',[_vm._v("Может редактировать всё")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Название отчёта")]),_vm._v(" "),_c('th',[_vm._v("Может просматривать")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bjRF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bnjB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_organizationProperty_vue__ = __webpack_require__("2wgW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d65a210_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_organizationProperty_vue__ = __webpack_require__("YQ32");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_organizationProperty_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d65a210_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_organizationProperty_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c8CE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var GET_CONCLUSION_REPORT = 'get_conclusion_report_v2.php';
var REPORT_ID = 2;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Conclusion',
	data: function data() {
		return {
			rows: []
		};
	},

	props: ['start', 'end'],
	methods: {
		fillTable: function fillTable(start, end) {
			var _this = this;

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + GET_CONCLUSION_REPORT + '?start=' + start + '&end=' + end).then(function (res) {
				return res.json();
			}).then(function (res) {
				var temp_rows = [{}];
				var flag = true;
				var total_summ = {};
				total_summ.region = 'Итого по РФ';
				total_summ.sending_conclusion = 0;
				total_summ.decision_true = 0;
				total_summ.decision_false = 0;
				total_summ.decision_false_glpm = 0;
				total_summ.decision_false_tax = 0;
				total_summ.decision_false_som = 0;
				total_summ.decision_false_law = 0;

				var fo_summ = {};
				fo_summ.region = 'Итого по округу';
				fo_summ.sending_conclusion = 0;
				fo_summ.decision_true = 0;
				fo_summ.decision_false = 0;
				fo_summ.decision_false_glpm = 0;
				fo_summ.decision_false_tax = 0;
				fo_summ.decision_false_som = 0;
				fo_summ.decision_false_law = 0;

				var i = 0;

				while (i < res.length - 1) {

					if (res[i].fo === res[i + 1].fo && flag) {
						var obj = {};
						obj.fo = res[i].fo;
						obj.flag = true;
						flag = false;

						if (i !== 0) {
							var _clone_fo = {}; //клонируем объект для передачи по значению
							for (var key in fo_summ) {
								_clone_fo[key] = fo_summ[key];
							}

							temp_rows.push(_clone_fo);

							fo_summ.sending_conclusion = 0;
							fo_summ.decision_true = 0;
							fo_summ.decision_false = 0;
							fo_summ.decision_false_glpm = 0;
							fo_summ.decision_false_tax = 0;
							fo_summ.decision_false_som = 0;
							fo_summ.decision_false_law = 0;
						}

						temp_rows.push(obj);
					} else {
						total_summ.sending_conclusion += +res[i].sending_conclusion;
						total_summ.decision_true += +res[i].decision_true;
						total_summ.decision_false += +res[i].decision_false;
						total_summ.decision_false_glpm += +res[i].decision_false_glpm;
						total_summ.decision_false_tax += +res[i].decision_false_tax;
						total_summ.decision_false_som += +res[i].decision_false_som;
						total_summ.decision_false_law += +res[i].decision_false_law;

						fo_summ.sending_conclusion += +res[i].sending_conclusion;
						fo_summ.decision_true += +res[i].decision_true;
						fo_summ.decision_false += +res[i].decision_false;
						fo_summ.decision_false_glpm += +res[i].decision_false_glpm;
						fo_summ.decision_false_tax += +res[i].decision_false_tax;
						fo_summ.decision_false_som += +res[i].decision_false_som;
						fo_summ.decision_false_law += +res[i].decision_false_law;

						temp_rows.push(res[i]);
						if (res[i].fo !== res[i + 1].fo) {
							flag = true;
						}
						i++;
					}
				}

				var last = res.length - 1;
				temp_rows.push(res[last]);

				total_summ.sending_conclusion += +res[last].sending_conclusion;
				total_summ.decision_true += +res[last].decision_true;
				total_summ.decision_false += +res[last].decision_false;
				total_summ.decision_false_glpm += +res[last].decision_false_glpm;
				total_summ.decision_false_tax += +res[last].decision_false_tax;
				total_summ.decision_false_som += +res[last].decision_false_som;
				total_summ.decision_false_law += +res[last].decision_false_law;

				fo_summ.sending_conclusion += +res[last].sending_conclusion;
				fo_summ.decision_true += +res[last].decision_true;
				fo_summ.decision_false += +res[last].decision_false;
				fo_summ.decision_false_glpm += +res[last].decision_false_glpm;
				fo_summ.decision_false_tax += +res[last].decision_false_tax;
				fo_summ.decision_false_som += +res[last].decision_false_som;
				fo_summ.decision_false_law += +res[last].decision_false_law;

				var clone_fo = {}; //клонируем объект для передачи по значению
				for (var _key in fo_summ) {
					clone_fo[_key] = fo_summ[_key];
				}

				temp_rows.push(clone_fo);

				temp_rows[0] = total_summ;

				_this.rows = temp_rows;
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		this.fillTable(this.start, this.end);

		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on('conclusion-date', function (date) {
			// console.log('con',date)
			_this2.fillTable(date.start, date.end);
		});

		var dispay_width = document.documentElement.clientWidth;
		var dispay_height = document.documentElement.clientHeight;
		var scroll_width = 17;

		var ua = navigator.userAgent;

		if (ua.search('OPR/') > 0) {
			scroll_width = 15;
		}

		var table_width = dispay_width - 30 - scroll_width;
		var col_width = Math.round(table_width / 8);

		document.querySelectorAll('.c-td').forEach(function (td) {
			td.width = col_width;
		});
		document.querySelector('.c-header-wrapper').width = table_width;
		document.querySelector('.c-body-wrapper').width = table_width;
		document.querySelector('.c-body-wrapper').style.maxHeight = dispay_height - 370 + 'px';

		// console.log(dispay_height, dispay_width, col_width, table_width)
		// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))

		document.querySelector('.c-scroll').width = scroll_width;
	},
	created: function created() {
		/*if(!this.$parent.$parent.reports.some((e) => {
  	return e.id == REPORT_ID
  }))
  	router.replace('/main')*/
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('conclusion-date');
	}
});

/***/ }),

/***/ "cCmS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control form-control my-control table-control",attrs:{"disabled":_vm.disabled},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cN80":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth__ = __webpack_require__("SQ6o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__edit_fetch_data_region__ = __webpack_require__("hLYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__edit_fetch_data_organization__ = __webpack_require__("Ha1D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__edit_fetch_data_fo__ = __webpack_require__("60jp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fetch_data_forestry__ = __webpack_require__("Ne53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fetch_data_localforestry__ = __webpack_require__("aUIB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fetch_data_subforestry__ = __webpack_require__("Us5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fetch_data_actionType__ = __webpack_require__("aXJq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fetch_data_warrantTableField__ = __webpack_require__("20Kl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fetch_data_npaViolation__ = __webpack_require__("dMpf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fetch_data_officialDocs__ = __webpack_require__("WyJT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fetch_data_discoveredViolations__ = __webpack_require__("BI/C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__constants__ = __webpack_require__("qI5z");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















// import jQuery from "jquery"; 
// import datePicker from 'vue-bootstrap-datetimepicker';






var HEADER = 'get_header.php';
//const LOCATION = 'get_location.php'
var ACT_DECISION = 'get_act_decision.php';
var WARRANT_LOCATION = 'get_warrant_location.php';
var WARRANT_INFO = 'get_warrant_info.php';
var CAN_EDIT = 'can_edit_unit.php';
var REASON = 'get_decision_reason.php';
var UNIT_ID = 3;
// const INSERT_JSON = 'insert_json.php'
var UPDATE_JSON = 'update_json.php';
// const DELETE_JSON = 'delete_json.php'
// const GET_WARRANT_PARENT = 'get_warrant_parent.php'
//const JSON_U2 = 'get_json_u2.php'

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'warrantModal',
	data: function data() {
		return {
			scroll_width: 17,
			readonly: true,
			line_count: 0,
			lines: [],
			lines_copy: [],
			act_id: '',

			f_2: '',
			f_4: '',
			f_11: '',
			f_9: '',
			f_12: '',

			f_20: [],
			f_27: [],
			f_16: [],
			f_17: [],
			f_24: [],
			f_25: [],

			location_id: [], //f_0
			f_21: [],
			f_22: [],
			f_23: [],
			f_41: [],

			f_42: 0,
			f_42_text: '',

			f_76: [],
			f_77: [],
			f_78: [],
			f_79: [],
			f_80: [],
			f_81: [],
			f_82: [],
			f_83: [],
			f_84: [],
			f_85: [],
			f_86: [],

			f_51: '',
			f_52: '',
			f_53: '',

			f_54: '',
			f_55: '',
			f_56: '',

			f_57: '',
			f_58: '',
			f_59: '',

			f_60: '',
			f_61: '',
			f_62: '',

			f_63: '',
			f_64: '',
			f_65: '',

			f_66: '',
			f_67: '',
			f_68: '',

			f_69: 2,
			f_70: '',

			f_71: 1,

			f_72: '',
			f_73: '',
			f_74: '',

			f_75: 1,

			f_87: __WEBPACK_IMPORTED_MODULE_4__auth__["a" /* default */].user.id,

			f_92: '',

			npa_violation_text: '',
			npa_disabled: true,

			decisions: [],
			errorDecisionReason: false,
			f_125: ''
		};
	},
	computed: {
		npa_disabled_comp: function npa_disabled_comp() {
			var f_79 = false;
			var f_81 = false;
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.lines), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var line = _step.value;

					f_79 = line.f_79 == 0 || f_79;
					f_81 = line.f_81 == 0 || f_81;
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			if (this.f_69 == 0 && f_79 && f_81) return false;else return true;
		}
	},
	components: {
		region: __WEBPACK_IMPORTED_MODULE_5__edit_fetch_data_region__["a" /* default */],
		forestry: __WEBPACK_IMPORTED_MODULE_8__fetch_data_forestry__["a" /* default */],
		localforestry: __WEBPACK_IMPORTED_MODULE_9__fetch_data_localforestry__["a" /* default */],
		subforestry: __WEBPACK_IMPORTED_MODULE_10__fetch_data_subforestry__["a" /* default */],
		organization: __WEBPACK_IMPORTED_MODULE_6__edit_fetch_data_organization__["a" /* default */],
		fo: __WEBPACK_IMPORTED_MODULE_7__edit_fetch_data_fo__["a" /* default */],
		actionType: __WEBPACK_IMPORTED_MODULE_11__fetch_data_actionType__["a" /* default */],
		datepicker: __WEBPACK_IMPORTED_MODULE_17_vue_strap__["datepicker"],
		npaViolation: __WEBPACK_IMPORTED_MODULE_13__fetch_data_npaViolation__["a" /* default */],
		officialDocs: __WEBPACK_IMPORTED_MODULE_14__fetch_data_officialDocs__["a" /* default */],
		discoveredViolations: __WEBPACK_IMPORTED_MODULE_15__fetch_data_discoveredViolations__["a" /* default */],
		warrantTableField: __WEBPACK_IMPORTED_MODULE_12__fetch_data_warrantTableField__["a" /* default */]
	},
	watch: {
		//[35,36,38,39,44,45,48,49]
		lines: {
			handler: function handler() {
				this.errorDecisionReasonHandler();
			},
			deep: true
		}
	},
	methods: {
		errorDecisionReasonHandler: function errorDecisionReasonHandler() {
			this.errorDecisionReason = false;
			if (Number(this.f_69) == 0) {
				var array = [];

				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;

				try {
					for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.lines), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var line = _step2.value;

						for (var i = 76; i <= 80; i++) {
							array[i] = array[i] || line['f_' + i] == 0;
						}
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}

				if (this.f_125 == 1) this.errorDecisionReason = !array[79];
				if (this.f_125 == 2) this.errorDecisionReason = !array[78];
				if (this.f_125 == 3) this.errorDecisionReason = !array[76];
				if (this.f_125 == 4) this.errorDecisionReason = !array[77];
				if (!this.f_125) this.errorDecisionReason = true;
			}
		},
		setAccordanceToLocations: function setAccordanceToLocations(data) {
			for (var line in this.lines) {
				this.lines[line][data.field] = data.value;
			}
		},
		mainDecisionChange: function mainDecisionChange(e) {
			this.f_69 = e.target.value;
			this.errorDecisionReasonHandler();
			/*if(e.target.value == 0 || e.target.value == 1)
   	for(let line in this.lines)
   	{
   		this.lines[line].f_76 = this.f_69
   		this.lines[line].f_77 = this.f_69
   		this.lines[line].f_78 = this.f_69
   		this.lines[line].f_79 = this.f_69
   		this.lines[line].f_80 = this.f_69
   		this.lines[line].f_81 = this.f_69
   		//this.lines[line][`correct_f_33`] = 'place-success'
   	}*/
		},
		pushLine: function pushLine(e) {
			var index = e.target.getAttribute('data-index');

			if (e.target.checked) {
				var place = {};

				place.index = index;
				for (var i = 16; i <= 27; i++) {
					//console.log(i,this.lines[index][`f_${i}`])
					place['f_' + i] = this.lines[index]['f_' + i];
				}

				this.lines_copy.push(place);
			} else {
				//console.warn(this.lines_copy)
				var lines_temp = this.lines_copy.filter(function (item) {
					return item.index != index;
				});

				this.lines_copy = lines_temp;
				//console.warn(this.lines_copy)
			}
			this.$forceUpdate();
		},
		checkFields: function checkFields() {
			var have_negative = false;
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.lines), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var line = _step3.value;

					if (!(line.f_76 && line.f_77 && line.f_78 && line.f_79 && line.f_80 && line.f_81)) {
						have_negative = true;
						break;
					}
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			if (this.f_69 == 0 && !have_negative || this.f_69 == 1 && have_negative) return false;

			return true;
		},
		submit: function submit() {
			var _this = this;

			if (document.querySelector('.field-error-warrant') !== null) {
				alert('Часть полей содержит некорректные данные. Сохранение невозможно');
				return;
			}

			if (document.querySelector('.field-error-warrant-optional') !== null || !this.checkFields()) {
				var answer = confirm('Часть полей может содержать некорректную информацию. Вы уверены, что хотите сохранить?');
				if (!answer) return;
			}

			var obj = [{}];
			obj[0].tab_id = 1;
			obj[0].f_v = {};
			obj[0].f_v.f_c = this.$route.params.id;

			for (var i = 51; i <= 75; i++) {
				if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this['f_' + i]) !== 'object') {
					if (i === 69 || i === 75) obj[0].f_v['f_' + i] = this['f_' + i] != '2' ? this['f_' + i] == '1' ? true : false : null;else if (i === 52 || i === 55 || i === 58 || i === 61 || i === 64 || i === 67 || i === 73) obj[0].f_v['f_' + i] = this['f_' + i] ? commaToPeriod(this['f_' + i]) : null;else obj[0].f_v['f_' + i] = this['f_' + i] ? this['f_' + i] : null;
				} else {
					obj[0].f_v['f_' + i] = this['f_' + i] ? this['f_' + i].format('DD.MM.YYYY') : null;
				}
			}
			obj[0].f_v.f_87 = this.f_87;
			obj[0].f_v.f_125 = this.f_125 || null;

			if (this.f_92.length) {
				if (this.f_92[0] == '{' && this.f_92[this.f_92.length - 1] == '}') {
					obj[0].f_v.f_92 = this.f_92;
				} else {
					obj[0].f_v.f_92 = '{' + this.f_92.join(',') + '}';
				}
			} else obj[0].f_v.f_92 = null;

			for (var _i = 0; _i < this.lines.length; _i++) {
				obj.push({});

				obj[_i + 1].tab_id = 2;
				obj[_i + 1].f_v = {};
				obj[_i + 1].f_v.f_c = this.lines[_i].f_c;

				for (var j = 76; j <= 81; j++) {
					if (this.lines[_i]['f_' + j] != '2') obj[_i + 1].f_v['f_' + j] = this.lines[_i]['f_' + j] == '1' ? true : false;else obj[_i + 1].f_v['f_' + j] = null;
				}

				obj[_i + 1].f_v.f_82 = this.lines[_i].f_82 ? this.lines[_i].f_82 : null;
				obj[_i + 1].f_v.f_83 = this.lines[_i].f_83;
				obj[_i + 1].f_v.f_110 = this.lines[_i].f_110 ? this.lines[_i].f_110 : null;

				//obj[i + 1].f_v.f_110 = this.lines[i].f_110 ? `{${this.lines[i].f_110.join(',')}}` : null

				for (var _j = 84; _j <= 86; _j++) {
					if (_j === 85) {
						obj[_i + 1].f_v.f_85 = this.lines[_i].f_85 ? commaToPeriod(this.lines[_i].f_85) : null;
					} else {
						obj[_i + 1].f_v['f_' + _j] = this.lines[_i]['f_' + _j] ? this.lines[_i]['f_' + _j] : null;
					}
				}
			}
			// console.log(JSON.stringify(obj)) 

			var form = new FormData();
			form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));

			fetch(__WEBPACK_IMPORTED_MODULE_19__constants__["a" /* DB */] + UPDATE_JSON, {
				credentials: 'include',
				method: 'post',
				body: form
			}).then(function (result) {
				return result.json();
			}).then(function (result) {
				if (result[0].code === '0') {
					alert('Предписание сохранено');

					if (_this.$parent.lastJournalURL) __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace(_this.$parent.lastJournalURL);else __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace('/main');
				} else {
					alert(result[0].name);
				}
			}).catch(function (err) {
				return console.log(err);
			});
		},
		close: function close() {
			if (this.$parent.lastJournalURL) __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace(this.$parent.lastJournalURL);else __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace('/main');
		},
		updateViolations: function updateViolations() {
			var npa_violations = [];
			var npa_list = {
				'f_76': '4а',
				'f_77': '4б',
				'f_78': '5б',
				'f_79': '8в',
				'f_80': '8а'
			};

			var discovered_list = {
				'1': '8а',
				'2': '8б',
				'3': '8в'
			};

			for (var i = 0; i < this.lines.length; i++) {
				for (var j = 76; j <= 80; j++) {
					if (this.lines[i]['f_' + j] == '0') {
						if (!npa_violations.includes(npa_list['f_' + j])) npa_violations.push(npa_list['f_' + j]);
					}
				}

				var row = this.lines[i];
				if (row.f_83) {
					var list = row.f_110 ? row.f_110.slice(1, -1).split(',') : undefined;
					if (list) {
						var _iteratorNormalCompletion4 = true;
						var _didIteratorError4 = false;
						var _iteratorError4 = undefined;

						try {
							for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(list), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
								var e = _step4.value;

								if (e) if (!npa_violations.includes(discovered_list[e])) npa_violations.push(discovered_list[e]);
							}
						} catch (err) {
							_didIteratorError4 = true;
							_iteratorError4 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion4 && _iterator4.return) {
									_iterator4.return();
								}
							} finally {
								if (_didIteratorError4) {
									throw _iteratorError4;
								}
							}
						}
					}
				}
			}

			this.npa_violation_text = npa_violations.sort().join(', ');

			/*
   for (let key in npa_violations) {
   	text = text + npa_violations[key] + ', '
   }*/

			//if (text.length > 2)
			//	this.npa_violation_text = text.slice(0,-2)
			//else
			//	 = ''

			//this.npa_disabled = typeof npa_violations.f_79 == 'undefined'
		}
	},
	created: function created() {
		var _this2 = this;

		__WEBPACK_IMPORTED_MODULE_18__lib_EventBus__["a" /* EventBus */].$on('warrant_action_type', function (data) {
			_this2.lines[data.index].f_84 = data.value;
		});

		__WEBPACK_IMPORTED_MODULE_18__lib_EventBus__["a" /* EventBus */].$on('warrant_npa_violation_ids', function (ids) {
			_this2.f_92 = ids;
		});

		__WEBPACK_IMPORTED_MODULE_18__lib_EventBus__["a" /* EventBus */].$on('official_docs', function (id) {
			_this2.f_71 = id;
		});

		__WEBPACK_IMPORTED_MODULE_18__lib_EventBus__["a" /* EventBus */].$on('warrant_discovered_violations', function (data) {
			_this2.lines[data.index].f_110 = data.ids ? '{' + data.ids.join(',') + '}' : null;
			_this2.updateViolations();
		});

		__WEBPACK_IMPORTED_MODULE_18__lib_EventBus__["a" /* EventBus */].$on('warrant_discovered_violations_update', function () {
			_this2.updateViolations();
		});

		fetch(__WEBPACK_IMPORTED_MODULE_19__constants__["a" /* DB */] + REASON, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			_this2.decisions = res;
		});

		fetch(__WEBPACK_IMPORTED_MODULE_19__constants__["a" /* DB */] + CAN_EDIT + '?act_id=' + this.$route.params.id + '&unit_id=' + UNIT_ID, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			// console.log(res)
			_this2.readonly = res[0].czl_check_can_edit_unit == 't' ? false : true;
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_19__constants__["a" /* DB */] + HEADER + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			for (var i in res[0]) {
				_this2[i] = res[0][i];
			}
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_19__constants__["a" /* DB */] + WARRANT_LOCATION + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			if (res) {
				_this2.lines = res;
			}

			var row_count = 0;

			var npa_violations = {};
			var npa_list = {
				'f_76': '4а',
				'f_77': '4б',
				'f_78': '5б',
				'f_79': '8в',
				'f_80': '8а'
			};

			for (var i = 0; i < res.length; i++) {
				for (var j = 76; j <= 80; j++) {
					if (res[i]['f_' + j] && res[i]['f_' + j] === 'f') {
						npa_violations['f_' + j] = npa_list['f_' + j];
					}
				}

				for (var _j2 = 76; _j2 <= 81; _j2++) {
					_this2.lines[i]['f_' + _j2] = res[i]['f_' + _j2] ? res[i]['f_' + _j2] === 't' ? 1 : 0 : 2;
				}
				_this2.lines[i].f_33 = res[i].f_33 ? res[i].f_33 === 't' ? 1 : 0 : 2;
				_this2.lines[i].f_91 = res[i].f_91 ? res[i].f_91 === 't' ? true : false : false;
				_this2.lines[i].f_c = res[i].f_c;

				if (res[i].f_83 === 't') {
					_this2.lines[i].f_83 = true;
					var place = {};

					place.index = row_count;
					for (var k = 16; k <= 27; k++) {
						place['f_' + k] = _this2.lines[i]['f_' + k];
					}

					_this2.lines_copy.push(place);
				} else {
					_this2.lines[i].f_83 = false;
				}
				row_count++;
			}

			var text = '';
			for (var key in npa_violations) {
				text = text + npa_violations[key] + ', ';
			}
			if (text.length > 2) _this2.npa_violation_text = text.slice(0, -2);else _this2.npa_violation_text = '';

			_this2.npa_disabled = typeof npa_violations.f_79 == 'undefined';
		}).catch(function (err) {
			return console.log('9', err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_19__constants__["a" /* DB */] + WARRANT_INFO + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			for (var i in res[0]) {
				if (res[0][i]) {
					if (i === 'f_51' || i === 'f_54' || i === 'f_57' || i === 'f_60' || i === 'f_63' || i === 'f_66' || i === 'f_72') {
						var d = __WEBPACK_IMPORTED_MODULE_16_moment___default()(res[0][i], 'YYYY-MM-DD');
						// console.log(res[0][i], d.format('DD.MM.YYYY'))
						_this2[i] = res[0][i] ? d.format('DD.MM.YYYY') : '';
					} else if (i === 'f_75' || i === 'f_69') {
						_this2[i] = res[0][i] === 't' ? 1 : 0;
					} else {
						_this2[i] = res[0][i];
					}
				}
			}
		}).catch(function (err) {
			return console.log(err);
		});

		var ua = navigator.userAgent;

		if (ua.search('OPR/') > 0) {
			this.scroll_width = 15;
		}
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_18__lib_EventBus__["a" /* EventBus */].$off('warrant_action_type');
		__WEBPACK_IMPORTED_MODULE_18__lib_EventBus__["a" /* EventBus */].$off('warrant_npa_violation_ids');
		__WEBPACK_IMPORTED_MODULE_18__lib_EventBus__["a" /* EventBus */].$off('official_docs');
		__WEBPACK_IMPORTED_MODULE_18__lib_EventBus__["a" /* EventBus */].$off('warrant_discovered_violations');
		__WEBPACK_IMPORTED_MODULE_18__lib_EventBus__["a" /* EventBus */].$off('warrant_discovered_violations_update');
	}
});

function commaToPeriod(str) {
	return str.replace(/,/g, ".");
}

/***/ }),

/***/ "cgn1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cpQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeNumsHint),expression:"closeNumsHint"}],staticClass:"col-md-2 col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.act_num),expression:"act_num"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"№ Акта"},domProps:{"value":(_vm.act_num)},on:{"focus":_vm.searchInputFocus,"input":[function($event){if($event.target.composing){ return; }_vm.act_num=$event.target.value},_vm.inputActNum],"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.closeNumsHint(); _vm.search();}}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.display_nums_hint),expression:"display_nums_hint"}],staticClass:"acts_nums"},_vm._l((_vm.similar_nums),function(num){return _c('li',{key:num.num,class:{"selected": _vm.isNumIsSelected(num.num)},domProps:{"textContent":_vm._s(num.num)},on:{"click":function($event){_vm.selectActNum(num.num)}}})}))]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col text-left"},[_c('datepicker',{staticClass:"datepicker-nums",attrs:{"placeholder":"Дата размещения","format":"dd.MM.yyyy"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-default small-button search-button",attrs:{"disabled":_vm.searchButtonDisabled},on:{"click":_vm.search}},[_vm._v("\n            Поиск "),(_vm.acts_is_loading)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col"},[_c('div',{staticClass:"selected_nums_wrap"},[_vm._l((_vm.acts_nums_to_search),function(num,index){return _c('span',{key:num + index,staticClass:"num_to_search"},[_vm._v("\n                "+_vm._s(num)+"\n                "),_c('span',{staticClass:"delete_num",on:{"click":function($event){_vm.deleteNum(num)}}},[_vm._v("x")])])}),_vm._v(" "),_c('span',{staticStyle:{"opacity":"0"}},[_vm._v("0")])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d/61":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_localforestry_vue__ = __webpack_require__("xpPz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08fccb8f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_localforestry_vue__ = __webpack_require__("GPnH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_localforestry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08fccb8f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_localforestry_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d6dh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr'),_vm._v(" "),_c('div',{staticClass:"m-header-wrapper",staticStyle:{"/*width":"3800px"}},[_c('table',{staticClass:"m-header"},[_c('thead',{staticClass:"bold"},[_vm._m(0),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"4"}},[_vm._v("количество актов, размещенных на сайтах субъетов")]),_vm._v(" "),_c('td',{attrs:{"colspan":"4"}},[_vm._v("количество представленных от ДЛХ по ФО актов ЛПО ")]),_vm._v(" "),_c('td',{attrs:{"colspan":"4"}},[_vm._v("количество рассмотренных актов ЛПО")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2","rowspan":"2"}},[_vm._v("количество заключений о"),_c('br'),_vm._v("рассмотрении актов ЛПО"),_c('br'),_vm._v("нарастающим итогом с"),_c('br'),_vm._v("01.01."+_vm._s(_vm.endYear))]),_vm._v(" "),_c('td',{attrs:{"colspan":"2","rowspan":"2"}},[_vm._v("согласовано актов ЛПО")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2","rowspan":"2"}},[_vm._v("не согласовано актов ЛПО")]),_vm._v(" "),_c('td',{attrs:{"colspan":"10"}},[_vm._v("в том числе по причинам (нарастающим итогом с 01.01."+_vm._s(_vm.endYear)+"):")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('td',{staticClass:"m-scroll",attrs:{"rowspan":"3"}})]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("c 01.01."+_vm._s(_vm.endYear)+" по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("отчётный период (c"),_c('br'),_vm._v(_vm._s(_vm.start)+" по "+_vm._s(_vm.end)+")")]),_vm._v(" "),_c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("c 01.01."+_vm._s(_vm.endYear)+" по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("отчётный период (c"),_c('br'),_vm._v(_vm._s(_vm.start)+" по "+_vm._s(_vm.end)+")")]),_vm._v(" "),_c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("c 01.01."+_vm._s(_vm.endYear)+" по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("отчётный период (c"),_c('br'),_vm._v(_vm._s(_vm.start)+" по "+_vm._s(_vm.end)+")")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("c 01.01."+_vm._s(_vm.endYear)),_c('br'),_vm._v("по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("отчётный"),_c('br'),_vm._v("период (c"),_c('br'),_vm._v(_vm._s(_vm.start)+" по"),_c('br'),_vm._v(_vm._s(_vm.end)+")")]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("c 01.01."+_vm._s(_vm.endYear)),_c('br'),_vm._v("по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("отчётный"),_c('br'),_vm._v("период (c"),_c('br'),_vm._v(_vm._s(_vm.start)+" по"),_c('br'),_vm._v(_vm._s(_vm.end)+")")])]),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9)])])]),_vm._v(" "),_c('div',{staticClass:"m-body-wrapper",staticStyle:{"/*width":"3800px"}},[_c('table',{staticClass:"m-body"},[_c('tbody',_vm._l((_vm.rows),function(row,i){return _c('tr',[(row.flag)?_c('td',{attrs:{"colspan":"33"}},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(row.fo))])]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"left m-td wide_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.region))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.placement_all_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.placement_all_ga))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.placement_week_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.placement_week_ga))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.entrance_all_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.entrance_all_ga))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.entrance_week_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.entrance_week_ga))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.consideration_all_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.consideration_all_ga))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.consideration_week_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.consideration_week_ga))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.conclusion_consideration_all_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.conclusion_consideration_all_s_mzl))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_good_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_good_s_mzl))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_s_mzl))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_count_sved_glpm))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_s_mzl_sved_glpm))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_count_mer_glpm))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_s_mzl_mer_glpm))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_count_sved_to))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_s_mzl_sved_to))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_count_sved_sansost))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_s_mzl_sved_sansost))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_count_zak_rf))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_bad_s_mzl_zak_rf))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.needs_verification_all_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.needs_verification_week_count))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""}):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td medium_col",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""}):_vm._e()])}))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"wide_col",attrs:{"rowspan":"3"}},[_vm._v("Субъекты, федеральные округа")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"2"}},[_vm._v("количество заключений с"),_c('br'),_vm._v("рекомендациями к"),_c('br'),_vm._v("проведению выездных"),_c('br'),_vm._v("проверок")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"2"}},[_vm._v("участие в проведении"),_c('br'),_vm._v("выездных проверок"),_c('br'),_vm._v("обоснованности"),_c('br'),_vm._v("назначения мероприятий"),_c('br'),_vm._v("по актам ЛПО, шт")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("несоответствие сведений"),_c('br'),_vm._v("данным ГЛПМ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("несоответствие"),_c('br'),_vm._v("мероприятий данным"),_c('br'),_vm._v("ГЛПМ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("несоответствие сведений"),_c('br'),_vm._v("таксационным"),_c('br'),_vm._v("характеристикам лесного"),_c('br'),_vm._v("участка")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("недостоверность"),_c('br'),_vm._v("сведений о санитарном"),_c('br'),_vm._v("лесопатологическом"),_c('br'),_vm._v("состоянии лесов (при"),_c('br'),_vm._v("выездной проверке)")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"m-td",attrs:{"colspan":"2"}},[_vm._v("запрещение или"),_c('br'),_vm._v("ограничение"),_c('br'),_vm._v("законодательством"),_c('br'),_vm._v("Российской Федерации")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("ед. изм.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("актов ЛПО,"),_c('br'),_vm._v("шт")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("актов ЛПО,"),_c('br'),_vm._v("шт")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("актов ЛПО,"),_c('br'),_vm._v("шт")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("актов ЛПО,"),_c('br'),_vm._v("шт")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("актов ЛПО,"),_c('br'),_vm._v("шт")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("актов ЛПО,"),_c('br'),_vm._v("шт")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("актов ЛПО,"),_c('br'),_vm._v("шт")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("га")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")]),_vm._v(" "),_c('td',{staticClass:"medium_col"},[_vm._v("шт.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("2")]),_vm._v(" "),_c('td',[_vm._v("3")]),_vm._v(" "),_c('td',[_vm._v("4")]),_vm._v(" "),_c('td',[_vm._v("5")]),_vm._v(" "),_c('td',[_vm._v("6")]),_vm._v(" "),_c('td',[_vm._v("7")]),_vm._v(" "),_c('td',[_vm._v("8")]),_vm._v(" "),_c('td',[_vm._v("9")]),_vm._v(" "),_c('td',[_vm._v("10")]),_vm._v(" "),_c('td',[_vm._v("11")]),_vm._v(" "),_c('td',[_vm._v("12")]),_vm._v(" "),_c('td',[_vm._v("13")]),_vm._v(" "),_c('td',[_vm._v("14")]),_vm._v(" "),_c('td',[_vm._v("15")]),_vm._v(" "),_c('td',[_vm._v("16")]),_vm._v(" "),_c('td',[_vm._v("17")]),_vm._v(" "),_c('td',[_vm._v("18")]),_vm._v(" "),_c('td',[_vm._v("19")]),_vm._v(" "),_c('td',[_vm._v("20")]),_vm._v(" "),_c('td',[_vm._v("21")]),_vm._v(" "),_c('td',[_vm._v("22")]),_vm._v(" "),_c('td',[_vm._v("23")]),_vm._v(" "),_c('td',[_vm._v("24")]),_vm._v(" "),_c('td',[_vm._v("25")]),_vm._v(" "),_c('td',[_vm._v("26")]),_vm._v(" "),_c('td',[_vm._v("27")]),_vm._v(" "),_c('td',[_vm._v("28")]),_vm._v(" "),_c('td',[_vm._v("29")]),_vm._v(" "),_c('td',[_vm._v("30")]),_vm._v(" "),_c('td',[_vm._v("31")]),_vm._v(" "),_c('td',[_vm._v("32")]),_vm._v(" "),_c('td',[_vm._v("33")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dE47":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_CancelIcon__ = __webpack_require__("0KnF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_CheckIcon__ = __webpack_require__("xhmk");
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'locationTableField',
	data: function data() {
		return {
			tooltipIsVisible: false
		};
	},
	components: {
		CheckIcon: __WEBPACK_IMPORTED_MODULE_3__assets_CheckIcon__["a" /* default */], CancelIcon: __WEBPACK_IMPORTED_MODULE_2__assets_CancelIcon__["a" /* default */]
	},
	computed: {
		slotText: function slotText() {
			return this.$slots.default[0].text;
		}
	},
	props: {
		field_name: ''
	},
	methods: {
		showTooltip: function showTooltip() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('closeOtherTooltip');
			this.tooltipIsVisible = true;
		},
		hideTooltip: function hideTooltip(e) {
			if (e && (e.target.classList.contains('field_tooltip_parent') || e.target.classList.contains('field_tooltip'))) return 0;

			this.tooltipIsVisible = false;
		},
		sendZero: function sendZero() {
			this.$emit('set', { field: this.field_name, value: '0' });
		}
	},
	created: function created() {
		window.addEventListener('click', this.hideTooltip);
		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$on('closeOtherTooltip', this.hideTooltip);
	},
	beforeDestroy: function beforeDestroy() {
		window.removeEventListener('click', this.hideTooltip);
		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$off('closeOtherTooltip');
	}
});

/***/ }),

/***/ "dMpf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_npaViolation_vue__ = __webpack_require__("sFFk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e44a6ef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_npaViolation_vue__ = __webpack_require__("4v1F");
function injectStyle (ssrContext) {
  __webpack_require__("KNgc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_npaViolation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e44a6ef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_npaViolation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dV9c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dWXX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 426.667 426.667"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 426.667 426.667","xml:space":"preserve"}},[_c('path',{staticStyle:{"fill":"#6AC259"},attrs:{"d":"M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333\r\n\tc117.828,0,213.333-95.514,213.333-213.333S331.157,0,213.333,0z M174.199,322.918l-93.935-93.931l31.309-31.309l62.626,62.622\r\n\tl140.894-140.898l31.309,31.309L174.199,322.918z"}}),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e8if":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoList_vue__ = __webpack_require__("rQ6f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0991428_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FoList_vue__ = __webpack_require__("LCLF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0991428_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FoList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eNuE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();_vm.submit($event)}}},[_c('h4',[_vm._v("Результаты взаимодействия ДЛХ с правоохранительными и надзорными органами")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fo_id),expression:"fo_id"}],staticClass:"form-control my-control",attrs:{"disabled":!_vm.fo_options || !_vm.fo_options.length},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.fo_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onChangeFO]}},_vm._l((_vm.fo_options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t\t\t\t"+_vm._s(option.name)+"\n\t\t\t\t")])}))]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.region_id),expression:"region_id"}],staticClass:"form-control my-control",attrs:{"disabled":!_vm.fo_id || !_vm.region_options || !_vm.region_options.length},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.region_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onChangeRegion]}},_vm._l((_vm.region_options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t\t\t\t"+_vm._s(option.name)+"\n\t\t\t\t")])}))])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.forestry_id),expression:"forestry_id"}],staticClass:"form-control my-control",attrs:{"disabled":!_vm.region_id || !_vm.forestry_options || !_vm.forestry_options.length},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.forestry_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onChangeForestry]}},_vm._l((_vm.forestry_options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t\t\t\t"+_vm._s(option.name)+"\n\t\t\t\t")])}))]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_c('button',{staticClass:"form-control my-control",attrs:{"type":"button","title":_vm.selectedActsIds,"disabled":!_vm.forestry_id || !_vm.acts_short || !_vm.acts_short.length},on:{"click":_vm.openActsModal}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.selectedActsIdsShort)+"\n\t\t\t")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form_wrap",class:{'disabled': _vm.form_disabled}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"overflow":"hidden"}},[_c('div',{staticClass:"table_head_wrap"},[_c('table',{staticClass:"acts_table place_table__top"},[_c('thead',[_c('tr',[_c('th',{staticClass:"form_td"},[_vm._v("№ акта ЛПО")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Участковое лесничество")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Урочище")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Квартал")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Выдел")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Лп. выдел")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("МЗЛ")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("S МЗЛ")]),_vm._v(" "),_c('th',{attrs:{"width":_vm.scroll_width}})]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("1")]),_vm._v(" "),_c('th',[_vm._v("2")]),_vm._v(" "),_c('th',[_vm._v("3")]),_vm._v(" "),_c('th',[_vm._v("4")]),_vm._v(" "),_c('th',[_vm._v("5")]),_vm._v(" "),_c('th',[_vm._v("6")]),_vm._v(" "),_c('th',[_vm._v("7")]),_vm._v(" "),_c('th',[_vm._v("8")]),_vm._v(" "),_c('th',{attrs:{"width":_vm.scroll_width}})])])])]),_vm._v(" "),_c('div',{staticClass:"table_body_wrap"},[_c('table',{staticClass:"acts_table place_table__bottom"},[_c('tbody',_vm._l((_vm.acts_full),function(line){return _c('tr',[(line.flag)?_c('td',{staticClass:"form_td",attrs:{"rowspan":line.count}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(line.num)+"\n\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(line.flag_lf)?_c('td',{staticClass:"form_td",attrs:{"rowspan":line.count_lf}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(line.localforestry)+"\n\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(line.flag_sf)?_c('td',{staticClass:"form_td",attrs:{"rowspan":line.count_sf}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(line.subforestry)+"\n\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"form_td"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(line.area)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(line.section)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(line.section_lp)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(line.mzl)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(line.s_mzl)+"\n\t\t\t\t\t\t\t\t")])])}))])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"45px"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_118),expression:"f_118"}],staticClass:"form-control",class:_vm.fields_correct.f_118,staticStyle:{"margin-top":"5px"},attrs:{"rows":"2","disabled":_vm.form_disabled},domProps:{"value":(_vm.f_118)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.f_118=$event.target.value},function($event){_vm.checkInput("f_118")}]}})])]),_vm._v(" "),_c('h5',{staticStyle:{"margin-top":"20px"}},[_vm._v("\n\t\t\tРеквизиты исходящего письма из ДЛХ в правоохранительные органы\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('table',{staticClass:"dateTable"},[_vm._m(3),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('datepicker',{staticClass:"table-control",class:_vm.fields_correct.f_119,attrs:{"format":"yyyy-MM-dd","disabled":_vm.readonly || _vm.form_disabled},on:{"input":function($event){_vm.checkInput("f_119")}},model:{value:(_vm.f_119),callback:function ($$v) {_vm.f_119=$$v},expression:"f_119"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_120),expression:"f_120"}],staticClass:"form-control my-control table-control",class:_vm.fields_correct.f_120,attrs:{"disabled":_vm.form_disabled},domProps:{"value":(_vm.f_120)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.f_120=$event.target.value},function($event){_vm.checkInput("f_120")}]}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_121),expression:"f_121"}],staticClass:"form-control my-control table-control",class:_vm.fields_correct.f_121,attrs:{"disabled":_vm.form_disabled},domProps:{"value":(_vm.f_121)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.f_121=$event.target.value},function($event){_vm.checkInput("f_121")}]}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"25px"}},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_122),expression:"f_122"}],staticClass:"form-control",staticStyle:{"margin-top":"5px"},attrs:{"rows":"2","disabled":_vm.form_disabled},domProps:{"value":(_vm.f_122)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_122=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin":"5px"}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"btnPanel"},[_c('input',{staticClass:"btn btn-secondary",attrs:{"type":"button","value":"Отмена","disabled":_vm.readonly},on:{"click":function($event){$event.preventDefault();_vm.close($event)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.submit_disabled || _vm.readonly},on:{"click":function($event){$event.preventDefault();_vm.submit($event)}}},[(_vm.submit_disabled)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v("\n\t\t\t"+_vm._s(_vm.submit_disabled ? 'Сохранение' : 'Сохранить')+"\n\t\t")])]),_vm._v(" "),_c('modal',{attrs:{"title":"","medium":"","backdrop":false},model:{value:(_vm.showActsModal),callback:function ($$v) {_vm.showActsModal=$$v},expression:"showActsModal"}},[_c('div',{staticClass:"modal-header",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Выбор актов")])]),_vm._v(" "),_c('div',{staticClass:"modal-body",attrs:{"slot":"modal-body"},slot:"modal-body"},[_c('ul',{staticClass:"act_nums"},_vm._l((_vm.acts_short),function(act,index){return _c('li',{key:act.main_id,class:_vm.checkIsActInGroup(index)},[_c('checkbox',{attrs:{"type":"info"},on:{"input":function (e){ return _vm.changeActCheckbox(e,index); }},model:{value:(act.checked),callback:function ($$v) {_vm.$set(act, "checked", $$v)},expression:"act.checked"}},[_vm._v(_vm._s(act.act_num))])],1)}))]),_vm._v(" "),_c('div',{staticClass:"modal-footer",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.cancelActsModal}},[_vm._v("Отмена")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.okActsModal}},[_vm._v("Ок")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col"},[_c('span',{staticClass:"bold"},[_vm._v("Федеральный округ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_c('span',{staticClass:"bold"},[_vm._v("Субъект РФ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col"},[_c('span',{staticClass:"bold"},[_vm._v("Лесничество")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_c('span',{staticClass:"bold"},[_vm._v("№ актов ЛПО")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 text-right",staticStyle:{"line-height":"24px"}},[_c('span',{staticClass:"bold"},[_vm._v("Наименование правоохранительного органа*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"15%"}},[_vm._v("Дата*")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("Номер*")]),_vm._v(" "),_c('th',{staticStyle:{"width":"70%"}},[_vm._v("Краткое содержание письма, комментарии*")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 text-right",staticStyle:{"line-height":"24px"}},[_c('span',{staticClass:"bold"},[_vm._v("Результаты рассмотрения направленных ДЛХ материалов")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ePV6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eTRH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main",class:{list_wrapper: _vm.currentPath == "list" || _vm.currentPath == "drafts" || _vm.currentPath == "states" || _vm.currentPath == "decisions"}},[_c('navbar',{attrs:{"placement":"top","type":"inverse"}},[(_vm.can_create_act)?_c('dropdown',{class:{underlined: _vm.isReport},attrs:{"text":"Новый акт"}},[_c('li',[_c('a',{staticClass:"collapse",attrs:{"href":"#/main/add"}},[_vm._v("Создать")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"collapse",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.importAct($event)}}},[_vm._v("Импортировать")]),_vm._v(" "),_c('input',{ref:"xml_input",staticClass:"xml_input",attrs:{"type":"file","accept":"text/xml"},on:{"change":_vm.changeXmlFile}})])]):_vm._e(),_vm._v(" "),_c('dropdown',{class:{underlined: _vm.currentPath == "edit" || _vm.currentPath == "conclusion" || _vm.currentPath == "warrant"},attrs:{"text":"Редактировать"}},[_c('li',[_c('a',{attrs:{"href":_vm.editPath}},[_vm._v("Акт ЛПО")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.conclusionPath}},[_vm._v("Заключение на Акт ЛПО")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.warrantPath}},[_vm._v("Документарная проверка")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.supervisionPath}},[_vm._v("Взаимодействие с надзорными органами")])]),_vm._v(" "),(_vm.canEditWarrant)?_c('li',[_c('a',{attrs:{"href":"#/main/warrant_group"}},[_vm._v("Документарная проверка на группу актов")])]):_vm._e(),_vm._v(" "),(_vm.canDeleteAct && _vm.currentPath == "list")?_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.deleteAct($event)}}},[_vm._v("Удалить")])]):_vm._e()]),_vm._v(" "),_c('dropdown',{class:{underlined: _vm.currentPath == "group_conclusion"},attrs:{"text":"Группировка","disabled":_vm.groupDisabled}},[_c('li',[_c('a',{on:{"click":_vm.makeGroup}},[_vm._v("Сгруппировать")])]),_vm._v(" "),_c('li',{class:{ 'disabled': _vm.makeGroupFromFilterDisabled }},[_c('a',{on:{"click":_vm.makeGroupFromFilter}},[_vm._v("Сгруппировать отфильтрованные")])]),_vm._v(" "),_c('li',{staticClass:"disabled"},[_c('a',[_vm._v("Разгруппировать")])]),_vm._v(" "),(_vm.currentPath == "group_conclusion")?_c('li',[_c('a',{on:{"click":_vm.showSimilarActs}},[_vm._v("Редактировать группу")])]):_vm._e()]),_vm._v(" "),_c('dropdown',{class:{underlined: _vm.currentPath == "list" || _vm.currentPath == "drafts" || _vm.currentPath == "states" || _vm.currentPath == "decisions" || _vm.currentPath == "supervisory"},attrs:{"text":"Реестры"}},[_c('li',[_c('a',{attrs:{"href":"#/main"}},[_vm._v("Реестр актов")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#/main/drafts"}},[_vm._v("Реестр черновиков")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#/main/states"}},[_vm._v("Реестр состояний")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#/main/decisions"}},[_vm._v("Реестр результатов оценки актов ЛПО")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#/main/supervisory"}},[_vm._v("Реестр взаимодействия")])])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),(_vm.canEditReports)?[_c('dropdown',{class:{underlined: _vm.isReport},attrs:{"text":"Отчёты"}},[_c('li',[_c('a',{attrs:{"href":"#/main/reports"}},[_vm._v("Отчёты")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showEditReportsModal = true}}},[_vm._v("Управление отчётами")])])])]:[(_vm.reports.length)?_c('li',{class:{underlined: _vm.isReport}},[_c('a',{staticClass:"collapse",attrs:{"href":"#/main/reports"}},[_vm._v("Отчёты")])]):_vm._e()],_vm._v(" "),(_vm.can_reg_user)?_c('li',{class:{underlined: _vm.currentPath == "reg"}},[_c('a',{staticClass:"collapse",attrs:{"href":"#/main/reg"}},[_vm._v("Регистрация")])]):_vm._e(),_vm._v(" "),(_vm.displayTheConclusion)?_c('dropdown',{attrs:{"text":"Заключение"}},[_c('li',[_c('a',{on:{"click":_vm.generate_conclusion}},[_vm._v("Заключение на акт")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":_vm.get_possible_conclusion_for_group}},[_vm._v("Заключение на группу актов")])])]):_vm._e(),_vm._v(" "),(_vm.can_save_db)?_c('li',[_c('a',{staticClass:"collapse pointer",attrs:{"href":_vm.db + 'db_to_csv.php',"target":"_blank"}},[_vm._v("Выгрузка базы")])]):_vm._e(),_vm._v(" "),(_vm.canEditAddress)?_c('li',[_c('a',{staticClass:"collapse",attrs:{"href":"#/main/catalog"}},[_vm._v("Справочник")])]):_vm._e(),_vm._v(" "),_c('li',{attrs:{"slot":"right"},slot:"right"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showUserModal = true}}},[_vm._v(_vm._s(_vm.user_name)+" "),_c('span',{staticClass:"caret"})])]),_vm._v(" "),_c('li',{staticStyle:{"margin-left":"20px"},attrs:{"slot":"right"},slot:"right"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showHelpModal = true}}},[_c('i',[_vm._v("Справка")])])])],2),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading-wrap"},[_c('i',{staticClass:"fa fa-spinner fa-spin",staticStyle:{"font-size":"48px"}})]):_vm._e(),_vm._v(" "),_c('modal',{attrs:{"title":"Выберите действие","backdrop":false,"small":""},on:{"ok":function($event){_vm.showUserModal = false},"closed":_vm.clearModal},model:{value:(_vm.showUserModal),callback:function ($$v) {_vm.showUserModal=$$v},expression:"showUserModal"}},[_c('tabs',{attrs:{"nav-style":"tabs"},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('tab',{attrs:{"header":"Выход"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 center large-font"},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.user_name))])])])]),_vm._v(" "),_c('tab',{attrs:{"header":"Сменить пароль","disabled":_vm.can_change_pass}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 center"},[_c('label',[_vm._v("Старый пароль")])])]),_vm._v(" "),_c('div',{staticClass:"row",class:_vm.old_password.status},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.old_password.value),expression:"old_password.value"}],staticClass:"form-control",attrs:{"type":"password","required":""},domProps:{"value":(_vm.old_password.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.old_password, "value", $event.target.value)}}}),_vm._v(" "),(_vm.old_password.status == "has-error")?_c('span',{staticClass:"glyphicon glyphicon-remove form-control-feedback"}):_vm._e(),_vm._v(" "),(_vm.old_password.status == "has-success")?_c('span',{staticClass:"glyphicon glyphicon-ok form-control-feedback"}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 center"},[_c('label',[_vm._v("Новый пароль")])])]),_vm._v(" "),_c('div',{staticClass:"row",class:_vm.new_password.status},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_password.value),expression:"new_password.value"}],staticClass:"form-control",attrs:{"type":"password","required":""},domProps:{"value":(_vm.new_password.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.new_password, "value", $event.target.value)}}}),_vm._v(" "),(_vm.new_password.status == "has-error")?_c('span',{staticClass:"glyphicon glyphicon-remove form-control-feedback"}):_vm._e(),_vm._v(" "),(_vm.new_password.status == "has-success")?_c('span',{staticClass:"glyphicon glyphicon-ok form-control-feedback"}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 center"},[_c('label',[_vm._v("Повторите новый пароль")])])]),_vm._v(" "),_c('div',{staticClass:"row",class:_vm.repeat_new_password.status},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.repeat_new_password.value),expression:"repeat_new_password.value"}],staticClass:"form-control",attrs:{"type":"password","required":""},domProps:{"value":(_vm.repeat_new_password.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.repeat_new_password, "value", $event.target.value)}}}),_vm._v(" "),(_vm.repeat_new_password.status == "has-error")?_c('span',{staticClass:"glyphicon glyphicon-remove form-control-feedback"}):_vm._e(),_vm._v(" "),(_vm.repeat_new_password.status == "has-success")?_c('span',{staticClass:"glyphicon glyphicon-ok form-control-feedback"}):_vm._e()])]),_vm._v(" "),_c('alert',{attrs:{"type":_vm.change_result.status}},[_vm._v(_vm._s(_vm.change_result.value))])],1)],1),_vm._v(" "),_c('div',{staticClass:"modal-footer",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.showUserModal = false}}},[_vm._v("Отмена")]),_vm._v(" "),(_vm.activeTab == 0)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.logout}},[_vm._v("Выйти")]):_vm._e(),_vm._v(" "),(_vm.activeTab == 1)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.changePassword}},[_vm._v("Сменить пароль")]):_vm._e()])],1),_vm._v(" "),_c('modal',{attrs:{"title":"","backdrop":false,"medium":""},on:{"ok":function($event){_vm.showHelpModal = false}},model:{value:(_vm.showHelpModal),callback:function ($$v) {_vm.showHelpModal=$$v},expression:"showHelpModal"}},[_c('a',{attrs:{"href":_vm.help}},[_vm._v("Руководство пользователя")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("\n\t\t\tПри возникновении трудностей с заполнением системы обращайтесь по номеру 8-495-993-34-07 доб. 156\n\t\t")]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("\n\t\t\tАнисимова Анастасия Игоревна  - заместитель начальника отдела оценки назначения мероприятий по защите лесов\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"modal-footer",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.showHelpModal = false}}},[_vm._v("Ок")])])]),_vm._v(" "),_c('modal',{attrs:{"title":"Ошибка формирования заключения","backdrop":false,"medium":""},on:{"ok":function($event){_vm.showIncorrectDataGroupConclusion = false}},model:{value:(_vm.showIncorrectDataGroupConclusion),callback:function ($$v) {_vm.showIncorrectDataGroupConclusion=$$v},expression:"showIncorrectDataGroupConclusion"}},[_c('div',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("\n\t\t\t"+_vm._s(_vm.incorrectDataGroupConclusionMessage)+"\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"modal-footer",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.showIncorrectDataGroupConclusion = false}}},[_vm._v("Ок")])])]),_vm._v(" "),_c('modal',{attrs:{"title":"Доступные для выгрузки типы заключения","backdrop":false,"medium":""},on:{"ok":function($event){_vm.displayPossibleConclusionTypes = false}},model:{value:(_vm.displayPossibleConclusionTypes),callback:function ($$v) {_vm.displayPossibleConclusionTypes=$$v},expression:"displayPossibleConclusionTypes"}},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px","line-height":"30px"}},[_c('div',{staticClass:"col col-md-6 text-right-important"},[_vm._v("\n\t\t\t\t\tЗаключение - ВСР, ССР, УНД\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"col col-md-4"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":!_vm.possibleConclusionTypes.ssr_vsr_und},on:{"click":_vm.generate_ssr_vsr_und_conclusion}},[_vm._v("\n\t\t\t\t\t\tВыгрузить\n\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px","line-height":"30px"}},[_c('div',{staticClass:"col col-md-6 text-right-important"},[_vm._v("\n\t\t\t\t\tЗаключение - АМ, ПМ, РАД\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"col col-md-4"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":!_vm.possibleConclusionTypes.am_pm_rad},on:{"click":_vm.generate_am_pm_rad_conclusion}},[_vm._v("\n\t\t\t\t\t\tВыгрузить\n\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"line-height":"30px"}},[_c('div',{staticClass:"col col-md-6 text-right-important"},[_vm._v("\n\t\t\t\t\tЗаключение - Б.Н.\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"col col-md-4"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":!_vm.possibleConclusionTypes.bn},on:{"click":_vm.generate_bn_conclusion}},[_vm._v("\n\t\t\t\t\t\tВыгрузить\n\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.displayPossibleConclusionTypes = false}}},[_vm._v("Отмена")])])]),_vm._v(" "),_c('modal',{attrs:{"title":"Доступные для выгрузки типы заключения на группу актов","backdrop":false,"medium":""},on:{"ok":function($event){_vm.displayPossibleConclusionTypesGroup = false}},model:{value:(_vm.displayPossibleConclusionTypesGroup),callback:function ($$v) {_vm.displayPossibleConclusionTypesGroup=$$v},expression:"displayPossibleConclusionTypesGroup"}},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px","line-height":"30px"}},[_c('div',{staticClass:"col col-md-6 text-right-important"},[_vm._v("\n\t\t\t\t\tЗаключение - ВСР, ССР, УНД\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"col col-md-4"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":!_vm.possibleConclusionTypesGroup.ssr_vsr_und},on:{"click":_vm.generate_ssr_vsr_und_for_group_conclusion}},[_vm._v("\n\t\t\t\t\t\tВыгрузить\n\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px","line-height":"30px"}},[_c('div',{staticClass:"col col-md-6 text-right-important"},[_vm._v("\n\t\t\t\t\tЗаключение - АМ, ПМ, РАД\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"col col-md-4"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":!_vm.possibleConclusionTypesGroup.am_pm_rad},on:{"click":_vm.generate_am_pm_rad_for_group_conclusion}},[_vm._v("\n\t\t\t\t\t\tВыгрузить\n\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"line-height":"30px"}},[_c('div',{staticClass:"col col-md-6 text-right-important"},[_vm._v("\n\t\t\t\t\tЗаключение - Б.Н.\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"col col-md-4"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":!_vm.possibleConclusionTypesGroup.bn},on:{"click":_vm.generate_bn_for_group_conclusion}},[_vm._v("\n\t\t\t\t\t\tВыгрузить\n\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.displayPossibleConclusionTypesGroup = false}}},[_vm._v("Отмена")])])]),_vm._v(" "),_c('edit-reports-modal',{attrs:{"show":_vm.showEditReportsModal},on:{"close":function($event){_vm.showEditReportsModal = false}}}),_vm._v(" "),(_vm.displayImportingModal)?_c('div',{staticClass:"importing_modal_bg"},[_vm._m(0)]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"importing_modal_content"},[_c('div',[_vm._v("Идёт обработка акта.")]),_vm._v(" "),_c('div',[_vm._v("Пожалуйста, подождите...")]),_vm._v(" "),_c('i',{staticClass:"fa fa-spinner fa-spin",staticStyle:{"font-size":"48px"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f9q1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Filter__ = __webpack_require__("XKhj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_strap__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var USERS = 'get_users.php';
var CAN_CHANGE_CONCLUSION_USER = 'can_change_conclusion_user.php';
var CHANGE_CONCLUSION_USER = 'change_conclusion_user.php';
var TABLE = 'get_journal_drafts.php';
var FILTER_TABLE = 'get_journal_drafts.php';
var COUNT_OF_FILTERS = 6;
var PADDING = 3;






/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'ListDrafts',
	data: function data() {
		return {
			lines: [],
			selected: 0,
			pages: [],
			active: 1,
			pages_count: 1,
			cf_count: 0,
			total_count: null,
			can_change: false,

			filter: {
				act_num: [],
				sites_count: [],
				fo: [],
				region: [],
				forestry: [],
				user_name: []
			},

			users: [],
			conclusion_user: null,
			showChangeConclusionUserValue: false,

			journalSuffix: '-drafts'
		};
	},

	components: {
		filterTable: __WEBPACK_IMPORTED_MODULE_3__Filter__["a" /* default */], modal: __WEBPACK_IMPORTED_MODULE_5_vue_strap__["modal"]
	},
	methods: {
		isNumeric: function isNumeric(x) {
			return !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(+x);
		},
		getNumEnding: function getNumEnding(iNumber, aEndings) {
			var sEnding, i;
			iNumber = iNumber % 100;
			if (iNumber >= 11 && iNumber <= 19) {
				sEnding = aEndings[2];
			} else {
				i = iNumber % 10;
				switch (i) {
					case 1:
						sEnding = aEndings[0];break;
					case 2:
					case 3:
					case 4:
						sEnding = aEndings[1];break;
					default:
						sEnding = aEndings[2];
				}
			}
			return sEnding;
		},
		showChangeConclusionUser: function showChangeConclusionUser() {
			this.conclusion_user = null;
			this.showChangeConclusionUserValue = true;
		},
		closeChangeConclusionUser: function closeChangeConclusionUser() {
			document.querySelector('.user-list').scrollTop = 0;
			this.showChangeConclusionUserValue = false;
		},
		changeConclusionUser: function changeConclusionUser() {
			var _this = this;

			var arr_endings = ['заключения', 'заключений', 'заключений'];
			var change = confirm('Вы уверены, что хотите назначить ответственного для ' + this.total_count + ' ' + this.getNumEnding(this.total_count, arr_endings) + '?');
			if (!change) return false;

			var where = '(';
			for (var f in this.filter) {
				for (var i = 0; i < this.filter[f].length; i++) {
					var field_name = f;
					field_name = field_name.replace(this.journalSuffix, '');
					where += this.filter[f][i] !== '' ? field_name + '=\'' + this.filter[f][i] + '\' or ' : field_name + ' is null or ';
				}

				where = this.filter[f].length !== 0 ? where.slice(0, -4) : where;
				where += this.filter[f].length !== 0 ? ') and (' : '';
			}

			where = where.slice(0, -6);

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + CHANGE_CONCLUSION_USER + '?filter=' + where + '&user_id=' + this.conclusion_user, { credentials: 'include' }).then(function (res) {
				return res.json();
			}).then(function (res) {
				//console.warn(this.active)
				_this.fetch_lines((_this.active - 1) * __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */] + 1);
			});

			this.conclusion_user = null;
			document.querySelector('.user-list').scrollTop = 0;
			this.showChangeConclusionUserValue = false;
		},
		select_line: function select_line(i) {
			if (!this.lines[i].flag) {
				var k = i;
				while (!this.lines[k].flag) {
					k--;
				}

				i = k;
			}

			this.selected = i;

			for (var j = 0; j < this.lines.length; j++) {
				if (this.lines[j].flag) {
					this.lines[j].selected = i === j;
				} else {
					var _k = j;
					while (!this.lines[_k].flag) {
						_k--;
					}
					for (var l = 0; l < this.lines[_k].count; l++) {
						this.lines[j].selected = i === _k;
					}
				}
			}

			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('act_id', this.lines[i].id);

			// document.getElementById(i).checked = true
			//EventBus.$emit('can_edit', {act: this.lines[i].can_edit_act, conclusion: this.lines[i].can_edit_conclusion, warrant: this.lines[i].can_edit_warrant})
		},
		fetch_lines: function fetch_lines(start) {
			var _this2 = this;

			var temp_lines = [];
			var temp_pages = [];

			var where = '(';
			for (var f in this.filter) {
				for (var i = 0; i < this.filter[f].length; i++) {
					var field_name = f;
					field_name = field_name.replace(this.journalSuffix, '');
					where += this.filter[f][i] !== '' ? field_name + '=\'' + this.filter[f][i] + '\' or ' : field_name + ' is null or ';
				}

				where = this.filter[f].length !== 0 ? where.slice(0, -4) : where;
				where += this.filter[f].length !== 0 ? ') and (' : '';
			}

			where = where.slice(0, -6);
			if (where) where = '&filter=' + where;

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + FILTER_TABLE + ('?start=' + start + '&rows=' + __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */] + where), {
				// fetch(DB + TABLE, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				var prev_id = -1;
				var prev_localforestry_id = -1;
				var prev_subforestry_id = -1;

				if (res[res.length - 1].count) _this2.total_count = res[res.length - 1].count;

				for (var _i = 0; _i < res.length - 1; _i++) {

					var act = {};

					var start_fo = _i;
					while (_i > 0 && res[start_fo - 1].act_id === res[_i].act_id && start_fo > 1) {
						start_fo--;
					}

					var curr = start_fo;
					while (curr < res.length && res[curr].act_id === res[start_fo].act_id) {
						curr++;
					}
					act.count = curr - start_fo;

					if (res[_i].act_id === prev_id) {
						act.flag = false;
					} else {
						act.flag = true;
					}
					//////////////////

					var start_lf = _i;
					while (_i > 0 && res[start_lf - 1].localforestry_id === res[_i].localforestry_id && start_lf > 1 && res[start_lf - 1].act_id === res[_i].act_id) {
						start_lf--;
					}

					var curr_lf = start_lf;
					while (curr_lf < res.length && res[curr_lf].act_id === res[start_lf].act_id && res[curr_lf].localforestry_id === res[_i].localforestry_id) {
						curr_lf++;
					}
					act.count_lf = curr_lf - start_lf;

					if (res[_i].act_id === prev_id && prev_localforestry_id === res[_i].localforestry_id) {
						act.flag_lf = false;
					} else {
						act.flag_lf = true;
					}

					////////////////////////
					var start_sf = _i;
					while (_i > 0 && res[start_sf - 1].localforestry_id === res[_i].localforestry_id && start_sf > 1 && res[start_sf - 1].act_id === res[_i].act_id) {
						start_sf--;
					}

					var curr_sf = start_sf;
					while (curr_sf < res.length && res[curr_sf].act_id === res[start_sf].act_id && res[curr_sf].localforestry_id === res[_i].localforestry_id) {
						curr_sf++;
					}
					act.count_sf = curr_sf - start_sf;

					if (res[_i].act_id === prev_id && prev_localforestry_id === res[_i].localforestry_id) {
						act.flag_sf = false;
					} else {
						act.flag_sf = true;
					}
					////////////////////////


					prev_id = res[_i].act_id;
					prev_localforestry_id = res[_i].localforestry_id;
					prev_subforestry_id = res[_i].subforestry_id;

					act.id = res[_i].act_id;
					//act.act_placement_date = res[i].act_placement_date
					act.act_num = res[_i].act_num;
					act.sites_count = res[_i].sites_count;
					//act.url = res[i].url
					act.fo = res[_i].fo;
					act.region = res[_i].region;
					act.forestry = res[_i].forestry;
					act.user_name = res[_i].user_name;
					//act.localforestry = res[i].localforestry
					//act.subforestry = res[i].subforestry
					//act.area = res[i].area
					//act.section = res[i].section
					//act.section_lp = res[i].section_lp
					act.selected = false;

					temp_lines.push(act);
				}

				_this2.lines = temp_lines;

				temp_lines = [];

				// this.pages = temp_pages

				_this2.lines[0].selected = true;

				if (_this2.lines[1] && !_this2.lines[1].flag) {
					var k = 1;
					while (!_this2.lines[k].flag) {
						_this2.lines[k].selected = true;
						k++;
					}
				}

				__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('act_id', _this2.lines[0].id);
			}).catch(function (err) {
				return console.log(err);
			});
		},
		select_page: function select_page(e) {
			var _this3 = this;

			var value = +e.target.getAttribute('data-value');
			this.fetch_lines((value - 1) * __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */] + 1);
			this.active = value;
			var temp_pages = [];

			if (this.active - 1 > PADDING) {
				temp_pages.push({ active: false, num: 1 });
				temp_pages.push({ active: false, num: '...' });
			}

			for (var i = this.active - PADDING - 1; i < this.active + PADDING; i++) {
				if (i >= 0 && i < this.pages_count) temp_pages.push({ active: false, num: i + 1 });
			}if (this.active < this.pages_count - PADDING) {
				temp_pages.push({ active: false, num: '...' });
				temp_pages.push({ active: false, num: this.pages_count });
			}

			this.pages = temp_pages;

			this.pages.forEach(function (p) {
				p.active = p.num == _this3.active;
			});

			//this.pages[value - 1].active = true
		},
		clearFilters: function clearFilters() {
			this.cf_count = 0;
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('clearFilters' + this.journalSuffix);
		},
		filter_lines: function filter_lines() {
			var _this4 = this;

			var temp_lines = [];
			var temp_pages = [];

			var where = '(';
			for (var f in this.filter) {
				for (var i = 0; i < this.filter[f].length; i++) {
					var field_name = f;
					field_name = field_name.replace(this.journalSuffix, '');
					where += this.filter[f][i] !== '' ? field_name + '=\'' + this.filter[f][i] + '\' or ' : field_name + ' is null or ';
				}

				where = this.filter[f].length !== 0 ? where.slice(0, -4) : where;
				where += this.filter[f].length !== 0 ? ') and (' : '';
			}
			where = where.slice(0, -6);

			var start = 1;

			if (this.$route.params.id || this.$parent.act_id) {
				start = (this.page_num - 1) * __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */] + 1;
				this.active = this.page_num;
			}

			var t = TABLE + ('?start=' + start + '&rows=' + __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */]);
			if (where) {
				t = FILTER_TABLE + ('?start=' + start + '&rows=' + __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */] + '&filter=' + where);
			}

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + t, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				var prev_id = -1;
				var prev_localforestry_id = -1;
				var prev_subforestry_id = -1;

				var length = !!where ? res.length : res.length - 1;

				if (res[res.length - 1].count) _this4.total_count = res[res.length - 1].count;

				for (var _i2 = 0; _i2 < length; _i2++) {
					var act = {};

					var start_fo = _i2;
					while (_i2 > 0 && res[start_fo - 1].act_id === res[_i2].act_id && start_fo > 1) {
						start_fo--;
					}

					var curr = start_fo;
					while (curr < res.length && res[curr].act_id === res[start_fo].act_id) {
						curr++;
					}
					act.count = curr - start_fo;

					if (res[_i2].act_id === prev_id) {
						act.flag = false;
					} else {
						act.flag = true;
					}
					//////////////////

					var start_lf = _i2;
					while (_i2 > 0 && res[start_lf - 1].localforestry_id === res[_i2].localforestry_id && start_lf > 1 && res[start_lf - 1].act_id === res[_i2].act_id) {
						start_lf--;
					}

					var curr_lf = start_lf;
					while (curr_lf < res.length && res[curr_lf].act_id === res[start_lf].act_id && res[curr_lf].localforestry_id === res[_i2].localforestry_id) {
						curr_lf++;
					}
					act.count_lf = curr_lf - start_lf;

					if (res[_i2].act_id === prev_id && prev_localforestry_id === res[_i2].localforestry_id) {
						act.flag_lf = false;
					} else {
						act.flag_lf = true;
					}

					////////////////////////
					var start_sf = _i2;
					while (_i2 > 0 && res[start_sf - 1].localforestry_id === res[_i2].localforestry_id && start_sf > 1 && res[start_sf - 1].act_id === res[_i2].act_id) {
						start_sf--;
					}

					var curr_sf = start_sf;
					while (curr_sf < res.length && res[curr_sf].act_id === res[start_sf].act_id && res[curr_sf].localforestry_id === res[_i2].localforestry_id) {
						curr_sf++;
					}
					act.count_sf = curr_sf - start_sf;

					if (res[_i2].act_id === prev_id && prev_localforestry_id === res[_i2].localforestry_id) {
						act.flag_sf = false;
					} else {
						act.flag_sf = true;
					}
					////////////////////////


					prev_id = res[_i2].act_id;
					prev_localforestry_id = res[_i2].localforestry_id;
					prev_subforestry_id = res[_i2].subforestry_id;

					act.id = res[_i2].act_id;
					act.act_num = res[_i2].act_num;
					act.sites_count = res[_i2].sites_count;
					act.act_placement_date = res[_i2].act_placement_date ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(res[_i2].act_placement_date, 'YYYY-MM-DD').format('DD.MM.YYYY') : '';
					//act.url = res[i].url
					act.fo = res[_i2].fo;
					act.region = res[_i2].region;
					act.forestry = res[_i2].forestry;
					act.user_name = res[_i2].user_name;
					//act.localforestry = res[i].localforestry
					//act.subforestry = res[i].subforestry
					//act.area = res[i].area
					////act.section = res[i].section
					//act.section_lp = res[i].section_lp
					act.selected = false;

					temp_lines.push(act);
				}

				//if (!where) {
				//let count = Math.round(res[res.length - 1].count / ROWS_ON_PAGE)
				_this4.pages_count = Math.round(res[res.length - 1].count / __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ROWS_ON_PAGE */]);
				temp_pages = [];

				if (_this4.active > PADDING) {
					temp_pages.push({ active: false, num: 1 });
					temp_pages.push({ active: false, num: '...' });
				}

				for (var _i3 = _this4.active - PADDING; _i3 < _this4.active + PADDING; _i3++) {
					if (_i3 >= 0 && _i3 < _this4.pages_count) temp_pages.push({ active: false, num: _i3 + 1 });
				}

				if (_this4.active < _this4.pages_count - PADDING) {
					temp_pages.push({ active: false, num: '...' });
					temp_pages.push({ active: false, num: _this4.pages_count });
				}

				_this4.pages = temp_pages;
				_this4.pages.forEach(function (p) {
					p.active = p.num == _this4.active;
				});
				//}

				_this4.lines = temp_lines;

				if (_this4.$route.params.id || _this4.$parent.act_id) {
					var act_id = _this4.$route.params.id || _this4.$parent.act_id;
					var found = false;
					for (var _i4 = 0; _i4 < _this4.lines.length; _i4++) {
						if (_this4.lines[_i4].id == act_id) {
							_this4.select_line(_i4);

							_this4.$nextTick(function () {
								var selected_row = document.querySelector("tr.selected");
								if (selected_row) selected_row.scrollIntoView(true);
							});

							found = true;
							break;
						}
					}
					if (!found) _this4.select_line(0);
				} else {
					_this4.select_line(0);
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	created: function created() {},
	mounted: function mounted() {
		var _this5 = this;

		this.$parent.lastJournalURL = '/main/drafts';

		fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + USERS, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			_this5.users = res;
		});

		fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + CAN_CHANGE_CONCLUSION_USER, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			_this5.can_change = res[0].value == 't';
		});

		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on('filter' + this.journalSuffix + '_list', function (f) {
			_this5.filter[f.field + _this5.journalSuffix] = f.value !== '' ? f.value : null;
			_this5.active = 1;
			if (f.cf) //clearFilters
				{
					_this5.cf_count++;
					if (_this5.cf_count == COUNT_OF_FILTERS) _this5.filter_lines();
				} else _this5.filter_lines();
		});

		this.page_num = this.$parent.page_num_drafts ? this.$parent.page_num_drafts : 1;

		if (this.$parent.selected_filters) {
			for (var field in this.$parent.selected_filters) {
				if (field.includes(this.journalSuffix)) this.filter[field] = this.$parent.selected_filters[field].value;
			}
		}
		this.filter_lines();

		// const w = document.documentElement.clientWidth - 50
		// document.querySelector('.main_table_wrapper').style.width = `${w}px`

		////////////////////////////////////////////

		var dispay_width = document.documentElement.clientWidth;
		// const dispay_height = document.documentElement.clientHeight - 146
		var dispay_height = document.documentElement.clientHeight - 208;
		var scroll_width = 17;

		var ua = navigator.userAgent;

		if (ua.search('OPR/') > 0) {
			scroll_width = 15;
		}

		var table_width = dispay_width - scroll_width;
		var col_width = Math.floor(table_width / COUNT_OF_FILTERS);
		// 
		var large_width = table_width - col_width * 9;

		// console.log(col_width, large_width, table_width, col_width * 9 + large_width)


		document.querySelectorAll('.l-td').forEach(function (td) {
			td.width = col_width;
		});
		document.querySelectorAll('.large-td').forEach(function (td) {
			td.width = large_width;
		});
		document.querySelector('.l-header-wrapper').width = dispay_width;
		document.querySelector('.l-body-wrapper').width = dispay_width;
		document.querySelector('.l-body-wrapper').style.maxHeight = dispay_height + 'px';

		// console.log(dispay_height, dispay_width, col_width, table_width)
		// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))

		document.querySelector('.l-scroll').width = scroll_width;
	},
	beforeDestroy: function beforeDestroy() {
		//this.lines = []
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('filter' + this.journalSuffix + '_list');
		//EventBus.$emit('save-filter-drafts', {f: this.filter})
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('save-page' + this.journalSuffix, this.active);
	}
});

/***/ }),

/***/ "fraP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"form_td field_tooltip_parent",on:{"click":_vm.showTooltip}},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"field_tooltip",class:{"visible": _vm.tooltipIsVisible}},[_c('span',[_vm._v("Установить для всех участков")]),_vm._v(" "),_c('button',{attrs:{"type":"button"},on:{"click":_vm.sendAccordance}},[_c('CheckIcon',{staticClass:"icon"}),_vm._v(" Соответствие\n\t\t\t")],1),_vm._v(" "),_c('button',{attrs:{"type":"button"},on:{"click":_vm.sendNotAccordance}},[_c('CancelIcon',{staticClass:"icon"}),_vm._v(" Несоответствие\n\t\t\t")],1)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gDJV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gOFJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control table-control my-control",attrs:{"id":_vm.id,"data-num":"f_20","data-table":"1"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gPHc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var FILTER = 'get_territory_filter.php';

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'TerritoryFilter',
	data: function data() {
		return {
			items: [],
			sel: true,
			val: false,
			filtered: false,
			saved_items: []
		};
	},

	props: {
		name: '',
		field: '',
		filter: '',
		right_align: {
			default: false
		}
	},
	components: {
		dropdown: __WEBPACK_IMPORTED_MODULE_0_vue_strap__["dropdown"],
		checkbox: __WEBPACK_IMPORTED_MODULE_0_vue_strap__["checkbox"]
	},
	watch: {
		sel: function sel(e) {
			this.items.map(function (t) {
				t.checked = e;
			});
		}
	},
	methods: {
		ok: function ok() {
			this.val = false;
			var result = [];
			for (var i = 0; i < this.items.length; i++) {
				if (this.items[i].checked) {
					result.push(this.items[i].value);
				}
			}

			this.filtered = result.length !== this.items.length && result.length !== 0;

			if (!this.filtered) {
				__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('territory_filter', { field: this.field, value: [], filtered: this.filtered });
				//this.sel = true
			} else {
				__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('territory_filter', { field: this.field, value: result, filtered: this.filtered });
				//this.sel = false
			}
		},
		cancel: function cancel() {
			this.val = false;
		},
		open: function open(show) {
			var _this = this;

			if (show) {
				var where = '(';
				for (var f in this.filter) {
					for (var i = 0; i < this.filter[f].length; i++) {
						if (f !== this.field) where += f + ' = \'' + this.filter[f][i] + '\' or ';
					}
					if (f !== this.field) {
						where = this.filter[f].length !== 0 ? where.slice(0, -4) : where;
						where += this.filter[f].length !== 0 ? ') and (' : '';
					}
				}
				where = where.slice(0, -6);

				var where_range = [];
				for (var _f in this.$parent.filterRange) {
					var filter_name = _f;
					if (filter_name == 'forest_age') filter_name = 'forest_age::int';
					if (this.$parent.filterRange[_f].min) where_range.push(filter_name + ' >= ' + this.$parent.filterRange[_f].min);
					if (this.$parent.filterRange[_f].max) where_range.push(filter_name + ' <= ' + this.$parent.filterRange[_f].max);
				}

				var joined = where_range.join(' and ');
				if (where) {
					if (joined) where = where + ' and ' + joined;
				} else {
					if (joined) where = joined;
				}

				var params = '?field=' + this.field + '&filter=' + where;

				fetch(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DB */] + FILTER + params, { credentials: 'include' }).then(function (res) {
					return res.json();
				}).then(function (res) {
					if (res) {
						var arr = res.map(function (r, i) {
							return {
								value: r[_this.field] ? _this.field !== 'act_placement_date' ? r[_this.field] : __WEBPACK_IMPORTED_MODULE_3_moment___default()(r[_this.field], 'YYYY-MM-DD').format('DD.MM.YYYY') : '',
								checked: true
							};
						});

						for (var _i = 0; _i < arr.length; _i++) {
							for (var j = 0; j < _this.items.length; j++) {

								if (arr[_i].value === _this.items[j].value) {
									arr[_i].checked = _this.items[j].checked;
								}
							}
						}

						_this.items = arr;
					} else {
						_this.items = [];
					}
				}).catch(function (err) {
					return console.log(err);
				});
			}
		}
	},
	created: function created() {
		var _this2 = this;

		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$on('clearTerritoryFilters', function (f) {
			_this2.filtered = false;
			_this2.sel = true;
			_this2.items = [];
		});
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$off('clearTerritoryFilters');
	}
});

/***/ }),

/***/ "golU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control",class:_vm.field_class,attrs:{"id":_vm.id,"data-num":"f_12","data-table":"1"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h+JD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"select2-enable",attrs:{"id":("species_" + _vm.line_count)},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.options),function(group){return _c('optgroup',{key:group.text,attrs:{"label":group.text}},_vm._l((group.children),function(option){return _c('option',{key:option.id,domProps:{"value":option.id}},[_vm._v("\n        "+_vm._s(option.name)+"\n      ")])}))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h6Wo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("qI5z");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var DISCOVERED_VIOLATIONS = 'get_discovered_violations.php';
//const WARRANT_INFO = 'get_warrant_info.php'

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'discoveredViolations',
	data: function data() {
		return {
			items: [],
			names: 'н/д',
			names_obj: {},
			val: false,
			sel: false
		};
	},

	props: {
		disabled: false,
		ids: '',
		index: null
	},
	components: {
		dropdown: __WEBPACK_IMPORTED_MODULE_0_vue_strap__["dropdown"],
		checkbox: __WEBPACK_IMPORTED_MODULE_0_vue_strap__["checkbox"]
	},
	methods: {
		check: function check(id, name, value) {
			if (value) this.names_obj[id] = name;else this.names_obj[id] = null;

			var text = '';
			var ids = [];
			for (var key in this.names_obj) {
				if (typeof this.names_obj[key] != 'undefined' && this.names_obj[key] != null) {
					text += this.names_obj[key] + ', ';
					ids.push(key);
				}
			}

			text = text.slice(0, -2);

			if (text.length > 12) this.names = text.slice(0, 12) + '...';else this.names = text;

			if (!this.names.length) this.names = 'н/д';

			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('warrant_discovered_violations', { index: this.$props.index, ids: ids });
		},
		open: function open(show) {
			if (show) {
				var _ids = '';
				if (this.ids) for (var i = 0; i < this.ids.length; i++) {
					_ids += this.ids[i];
				}

				_ids = _ids.slice(1, -1).split(',');
				for (var _i = 0; _i < _ids.length; _i++) {
					for (var j = 0; j < this.items.length; j++) {
						if (_ids[_i] == this.items[j].id) {
							this.items[j].checked = true;
						}
					}
				}
			}
		},
		fill: function fill(ids) {
			var _this = this;

			fetch(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DB */] + DISCOVERED_VIOLATIONS, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				if (res) {
					var arr = res.map(function (r) {
						return {
							id: r.id,
							name_short: r.name_short,
							name: r.name,
							checked: false
						};
					});

					if (typeof ids != 'undefined') {
						var text = '';
						for (var i = 0; i < ids.length; i++) {
							for (var j = 0; j < arr.length; j++) {
								if (ids[i] == arr[j].id) {
									text += arr[j].name_short + ', ';
								}
							}
						}

						text = text.slice(0, -2);

						if (text.length > 12) _this.names = text.slice(0, 12) + '...';else _this.names = text;
					}

					_this.items = arr;
				} else {
					_this.items = [];
				}

				__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('warrant_discovered_violations', { index: _this.$props.index, ids: ids });
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	created: function created() {
		/*fetch(DB + WARRANT_INFO + '?id=' + this.$route.params.id, {
  	credentials: 'include'
  })
  .then(res => res.json())
  .then(res => {
  	return res[0].f_92
  })
  .then(ids => {
  	if (ids) {
  		ids = ids.slice(1,-1).split(',')
  		this.fill(ids)
  	}
  	else {
  		this.fill()
  	}
  })*/
		//console.warn(this.$props.ids)
		var ids = this.$props.ids ? this.$props.ids.length > 2 ? this.$props.ids.slice(1, -1).split(',') : undefined : undefined;
		//console.warn(ids)
		this.fill(ids);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('warrant_discovered_violations_update');
	}
});

/***/ }),

/***/ "h8Ot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hFA5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_supervisionForm_vue__ = __webpack_require__("w8zh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3727f714_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_supervisionForm_vue__ = __webpack_require__("eNuE");
function injectStyle (ssrContext) {
  __webpack_require__("t+BB")
  __webpack_require__("dV9c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3727f714"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_supervisionForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3727f714_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_supervisionForm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hJCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hLYa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_region_vue__ = __webpack_require__("yDFC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f1cd0b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_region_vue__ = __webpack_require__("golU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_region_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f1cd0b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_region_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hY8M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"form_td field_tooltip_parent",on:{"click":_vm.showTooltip}},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"field_tooltip",class:{"visible": _vm.tooltipIsVisible}},[_c('span',[_vm._v("Установить для всех участков")]),_vm._v(" "),_c('button',{attrs:{"type":"button"},on:{"click":_vm.sendZero}},[_vm._v("\n\t\t\t    0\n\t\t\t")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hfaA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"m-body-wrapper"},[_c('table',{staticClass:"m-body"},[_c('tbody',_vm._l((_vm.rows),function(row,i){return _c('tr',{key:row.region + i,class:(row.bold ? "bold" :"")},[(row.new_fo)?_c('td',{staticStyle:{"padding-top":"7px","padding-bottom":"7px"},attrs:{"colspan":"4"}},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(row.fo))])]):_vm._e(),_vm._v(" "),(!row.new_fo)?_c('td',{staticClass:"left m-td"},[_vm._v(_vm._s(row.region))]):_vm._e(),_vm._v(" "),(!row.new_fo)?_c('td',{staticClass:"right m-td"},[_vm._v(_vm._s(row.lpo_volume_plan))]):_vm._e(),_vm._v(" "),(!row.new_fo)?_c('td',{staticClass:"right m-td"},[_vm._v(_vm._s(row.lpo_volume))]):_vm._e(),_vm._v(" "),(!row.new_fo)?_c('td',{staticClass:"right m-td"},[_vm._v(_vm._s(row.proc))]):_vm._e()])}))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-header-wrapper"},[_c('table',{staticClass:"m-header"},[_c('thead',{staticClass:"bold"},[_c('tr',[_c('th',[_vm._v("Федеральные округа, Субъекты Российской Федерации")]),_vm._v(" "),_c('th',[_vm._v("Плановые годовые объёмы лесопатологических обследований(в соответствии с бюджетными проектировками), га")]),_vm._v(" "),_c('th',[_vm._v("Объёмы выполненных лесопатологических обследований (в соответствии с опубликованными на сайтах актами ЛПО), га")]),_vm._v(" "),_c('th',[_vm._v("% выполнения")]),_vm._v(" "),_c('td',{staticClass:"m-scroll"})]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("2")]),_vm._v(" "),_c('td',[_vm._v("3")]),_vm._v(" "),_c('td',[_vm._v("4")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hjNQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var GET_MZL_REPORT = 'get_mzl_report_v2.php';
var REPORT_ID = 3;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Mzl',
	data: function data() {
		return {
			rows: []
		};
	},
	props: ['start', 'end'],
	methods: {
		fillTable: function fillTable(start, end) {
			var _this = this;

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + GET_MZL_REPORT + '?start=' + start + '&end=' + end).then(function (res) {
				return res.json();
			}).then(function (res) {
				var temp_rows = [{}];
				var flag = true;
				var total_summ = {};
				total_summ.region = 'Итого по РФ';
				total_summ.lpo_volume = 0;
				total_summ.mzl_volume_published = 0;
				total_summ.mzl_volume_obtained = 0;
				total_summ.mzl_volume_obtained_som = 0;
				total_summ.mzl_volume_obtained_prof = 0;
				total_summ.mzl_volume_obtained_agit = 0;
				total_summ.mzl_volume_obtained_ssr = 0;
				total_summ.mzl_volume_obtained_vsr = 0;
				total_summ.mzl_volume_obtained_und = 0;
				total_summ.mzl_volume_obtained_rad = 0;
				total_summ.mzl_volume_obtained_others = 0;
				total_summ.mzl_volume_obtained_negative_ssr = 0;
				total_summ.mzl_volume_obtained_negative_vsr = 0;
				total_summ.mzl_volume_obtained_negative_und = 0;
				total_summ.mzl_volume_obtained_negative_rad = 0;
				total_summ.mzl_volume_obtained_negative_others = 0;

				var fo_summ = {};
				fo_summ.region = 'Итого по округу';
				fo_summ.lpo_volume = 0;
				fo_summ.mzl_volume_published = 0;
				fo_summ.mzl_volume_obtained = 0;
				fo_summ.mzl_volume_obtained_som = 0;
				fo_summ.mzl_volume_obtained_prof = 0;
				fo_summ.mzl_volume_obtained_agit = 0;
				fo_summ.mzl_volume_obtained_ssr = 0;
				fo_summ.mzl_volume_obtained_vsr = 0;
				fo_summ.mzl_volume_obtained_und = 0;
				fo_summ.mzl_volume_obtained_rad = 0;
				fo_summ.mzl_volume_obtained_others = 0;
				fo_summ.mzl_volume_obtained_negative_ssr = 0;
				fo_summ.mzl_volume_obtained_negative_vsr = 0;
				fo_summ.mzl_volume_obtained_negative_und = 0;
				fo_summ.mzl_volume_obtained_negative_rad = 0;
				fo_summ.mzl_volume_obtained_negative_others = 0;

				var i = 0;

				while (i < res.length - 1) {

					if (res[i].fo === res[i + 1].fo && flag) {
						var obj = {};
						obj.fo = res[i].fo;
						obj.flag = true;
						flag = false;

						if (i !== 0) {
							var _clone_fo = {}; //клонируем объект для передачи по значению
							for (var key in fo_summ) {
								_clone_fo[key] = fo_summ[key];
							}

							temp_rows.push(_clone_fo);

							fo_summ.lpo_volume = 0;
							fo_summ.mzl_volume_published = 0;
							fo_summ.mzl_volume_obtained = 0;
							fo_summ.mzl_volume_obtained_som = 0;
							fo_summ.mzl_volume_obtained_prof = 0;
							fo_summ.mzl_volume_obtained_agit = 0;
							fo_summ.mzl_volume_obtained_ssr = 0;
							fo_summ.mzl_volume_obtained_vsr = 0;
							fo_summ.mzl_volume_obtained_und = 0;
							fo_summ.mzl_volume_obtained_rad = 0;
							fo_summ.mzl_volume_obtained_others = 0;
							fo_summ.mzl_volume_obtained_negative_ssr = 0;
							fo_summ.mzl_volume_obtained_negative_vsr = 0;
							fo_summ.mzl_volume_obtained_negative_und = 0;
							fo_summ.mzl_volume_obtained_negative_rad = 0;
							fo_summ.mzl_volume_obtained_negative_others = 0;
						}

						temp_rows.push(obj);
					} else {
						total_summ.lpo_volume += +res[i].lpo_volume;
						total_summ.mzl_volume_published += +res[i].mzl_volume_published;
						total_summ.mzl_volume_obtained += +res[i].mzl_volume_obtained;
						total_summ.mzl_volume_obtained_som += +res[i].mzl_volume_obtained_som;
						total_summ.mzl_volume_obtained_prof += +res[i].mzl_volume_obtained_prof;
						total_summ.mzl_volume_obtained_agit += +res[i].mzl_volume_obtained_agit;
						total_summ.mzl_volume_obtained_ssr += +res[i].mzl_volume_obtained_ssr;
						total_summ.mzl_volume_obtained_vsr += +res[i].mzl_volume_obtained_vsr;
						total_summ.mzl_volume_obtained_und += +res[i].mzl_volume_obtained_und;
						total_summ.mzl_volume_obtained_rad += +res[i].mzl_volume_obtained_rad;
						total_summ.mzl_volume_obtained_others += +res[i].mzl_volume_obtained_others;
						total_summ.mzl_volume_obtained_negative_ssr += +res[i].mzl_volume_obtained_negative_ssr;
						total_summ.mzl_volume_obtained_negative_vsr += +res[i].mzl_volume_obtained_negative_vsr;
						total_summ.mzl_volume_obtained_negative_und += +res[i].mzl_volume_obtained_negative_und;
						total_summ.mzl_volume_obtained_negative_rad += +res[i].mzl_volume_obtained_negative_rad;
						total_summ.mzl_volume_obtained_negative_others += +res[i].mzl_volume_obtained_negative_others;

						fo_summ.lpo_volume += +res[i].lpo_volume;
						fo_summ.mzl_volume_published += +res[i].mzl_volume_published;
						fo_summ.mzl_volume_obtained += +res[i].mzl_volume_obtained;
						fo_summ.mzl_volume_obtained_som += +res[i].mzl_volume_obtained_som;
						fo_summ.mzl_volume_obtained_prof += +res[i].mzl_volume_obtained_prof;
						fo_summ.mzl_volume_obtained_agit += +res[i].mzl_volume_obtained_agit;
						fo_summ.mzl_volume_obtained_ssr += +res[i].mzl_volume_obtained_ssr;
						fo_summ.mzl_volume_obtained_vsr += +res[i].mzl_volume_obtained_vsr;
						fo_summ.mzl_volume_obtained_und += +res[i].mzl_volume_obtained_und;
						fo_summ.mzl_volume_obtained_rad += +res[i].mzl_volume_obtained_rad;
						fo_summ.mzl_volume_obtained_others += +res[i].mzl_volume_obtained_others;
						fo_summ.mzl_volume_obtained_negative_ssr += +res[i].mzl_volume_obtained_negative_ssr;
						fo_summ.mzl_volume_obtained_negative_vsr += +res[i].mzl_volume_obtained_negative_vsr;
						fo_summ.mzl_volume_obtained_negative_und += +res[i].mzl_volume_obtained_negative_und;
						fo_summ.mzl_volume_obtained_negative_rad += +res[i].mzl_volume_obtained_negative_rad;
						fo_summ.mzl_volume_obtained_negative_others += +res[i].mzl_volume_obtained_negative_others;

						for (var _key in fo_summ) {
							if (_key !== 'region') fo_summ[_key] = +fo_summ[_key].toFixed(2);
						}

						temp_rows.push(res[i]);
						if (res[i].fo !== res[i + 1].fo) {
							flag = true;
						}
						i++;
					}
				}

				var last = res.length - 1;

				temp_rows.push(res[last]);

				total_summ.lpo_volume += +res[last].lpo_volume;
				total_summ.mzl_volume_published += +res[last].mzl_volume_published;
				total_summ.mzl_volume_obtained += +res[last].mzl_volume_obtained;
				total_summ.mzl_volume_obtained_som += +res[last].mzl_volume_obtained_som;
				total_summ.mzl_volume_obtained_prof += +res[last].mzl_volume_obtained_prof;
				total_summ.mzl_volume_obtained_agit += +res[last].mzl_volume_obtained_agit;
				total_summ.mzl_volume_obtained_ssr += +res[last].mzl_volume_obtained_ssr;
				total_summ.mzl_volume_obtained_vsr += +res[last].mzl_volume_obtained_vsr;
				total_summ.mzl_volume_obtained_und += +res[last].mzl_volume_obtained_und;
				total_summ.mzl_volume_obtained_rad += +res[last].mzl_volume_obtained_rad;
				total_summ.mzl_volume_obtained_others += +res[last].mzl_volume_obtained_others;
				total_summ.mzl_volume_obtained_negative_ssr += +res[last].mzl_volume_obtained_negative_ssr;
				total_summ.mzl_volume_obtained_negative_vsr += +res[last].mzl_volume_obtained_negative_vsr;
				total_summ.mzl_volume_obtained_negative_und += +res[last].mzl_volume_obtained_negative_und;
				total_summ.mzl_volume_obtained_negative_rad += +res[last].mzl_volume_obtained_negative_rad;
				total_summ.mzl_volume_obtained_negative_others += +res[last].mzl_volume_obtained_negative_others;

				fo_summ.lpo_volume += +res[last].lpo_volume;
				fo_summ.mzl_volume_published += +res[last].mzl_volume_published;
				fo_summ.mzl_volume_obtained += +res[last].mzl_volume_obtained;
				fo_summ.mzl_volume_obtained_som += +res[last].mzl_volume_obtained_som;
				fo_summ.mzl_volume_obtained_prof += +res[last].mzl_volume_obtained_prof;
				fo_summ.mzl_volume_obtained_agit += +res[last].mzl_volume_obtained_agit;
				fo_summ.mzl_volume_obtained_ssr += +res[last].mzl_volume_obtained_ssr;
				fo_summ.mzl_volume_obtained_vsr += +res[last].mzl_volume_obtained_vsr;
				fo_summ.mzl_volume_obtained_und += +res[last].mzl_volume_obtained_und;
				fo_summ.mzl_volume_obtained_rad += +res[last].mzl_volume_obtained_rad;
				fo_summ.mzl_volume_obtained_others += +res[last].mzl_volume_obtained_others;
				fo_summ.mzl_volume_obtained_negative_ssr += +res[last].mzl_volume_obtained_negative_ssr;
				fo_summ.mzl_volume_obtained_negative_vsr += +res[last].mzl_volume_obtained_negative_vsr;
				fo_summ.mzl_volume_obtained_negative_und += +res[last].mzl_volume_obtained_negative_und;
				fo_summ.mzl_volume_obtained_negative_rad += +res[last].mzl_volume_obtained_negative_rad;
				fo_summ.mzl_volume_obtained_negative_others += +res[last].mzl_volume_obtained_negative_others;

				for (var _key2 in fo_summ) {
					if (_key2 !== 'region') fo_summ[_key2] = +fo_summ[_key2].toFixed(2);
				}

				var clone_fo = {}; //клонируем объект для передачи по значению
				for (var _key3 in fo_summ) {
					clone_fo[_key3] = fo_summ[_key3];
				}

				for (var _key4 in total_summ) {
					if (_key4 !== 'region') total_summ[_key4] = +total_summ[_key4].toFixed(2);
					// total_summ[key] = total_summ[key]
				}

				temp_rows.push(clone_fo);

				temp_rows[0] = total_summ;

				_this.rows = temp_rows;
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		this.fillTable(this.start, this.end);

		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on('mzl-date', function (date) {
			_this2.fillTable(date.start, date.end);
		});

		var dispay_width = document.documentElement.clientWidth;
		var dispay_height = document.documentElement.clientHeight;
		var scroll_width = 17;

		var ua = navigator.userAgent;
		if (ua.search('OPR/') > 0) {
			scroll_width = 15;
		}

		var table_width = dispay_width - 30 - scroll_width;
		var col_width = Math.ceil(table_width / 23);
		var double_col_width = 2 * col_width;

		document.querySelectorAll('.s-td-small').forEach(function (td) {
			td.width = col_width;
		});

		document.querySelectorAll('.s-td').forEach(function (td) {
			td.width = double_col_width;
		});

		document.querySelector('.s-header-wrapper').width = table_width;
		document.querySelector('.s-body-wrapper').width = table_width;
		document.querySelector('.s-body-wrapper').style.maxHeight = dispay_height - 340 + 'px';

		// console.log(dispay_width, col_width, table_width)


		// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))
		document.querySelector('.s-scroll').width = scroll_width;
	},
	updated: function updated() {
		var dispay_width = document.documentElement.clientWidth;
		var dispay_height = document.documentElement.clientHeight;
		var scroll_width = 17;

		var ua = navigator.userAgent;
		if (ua.search('OPR/') > 0) {
			scroll_width = 15;
		}

		var table_width = dispay_width - 30 - scroll_width;
		var col_width = Math.ceil(table_width / 23);
		var double_col_width = 2 * col_width;

		document.querySelectorAll('.s-td-small').forEach(function (td) {
			td.width = col_width;
		});
	},
	created: function created() {
		/*if(!this.$parent.$parent.reports.some((e) => {
  	return e.id == REPORT_ID
  }))
  	router.replace('/main')*/
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('mzl-date');
	}
});

/***/ }),

/***/ "hoGZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control table-control my-control",attrs:{"id":'subforestry_id_' + this.id,"data-num":"f_27","data-table":"1","disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hyCX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control table-control my-control",attrs:{"id":'subforestry_id_' + this.id,"data-num":"f_27","data-table":"1","disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i+9f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_deletionReason_vue__ = __webpack_require__("1Fbt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_479dcd3c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_deletionReason_vue__ = __webpack_require__("hJCZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_deletionReason_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_479dcd3c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_deletionReason_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i49r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control",class:{"field-error": _vm.error},attrs:{"disabled":_vm.disabled},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{key:option.id,attrs:{"disabled":option.id == 5},domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iEyu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center list-title"},[_vm._v("\n\t\t\tРеестр актов\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"year-wrap"},[_c('label',[_vm._v("\n\t\t\t\tГод размещения\n\t\t\t\t"),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_year),expression:"selected_year"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected_year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.years),function(year){return _c('option',{key:year},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(year)+"\n\t\t\t\t\t")])}))])]),_vm._v(" "),_c('div',{staticClass:"l-header-wrapper"},[_c('table',{staticClass:"header"},[_c('thead',[_vm._m(0),_vm._v(" "),_c('tr',[_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"num","filter":_vm.filter,"year":_vm.selected_year}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table-date-range',{attrs:{"field":"act_placement_date","filter":_vm.filter}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"url","filter":_vm.filter,"year":_vm.selected_year}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"fo","filter":_vm.filter,"year":_vm.selected_year}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"region","filter":_vm.filter,"wideWindow":true,"year":_vm.selected_year}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"forestry","filter":_vm.filter,"year":_vm.selected_year}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"localforestry","filter":_vm.filter,"year":_vm.selected_year}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"subforestry","filter":_vm.filter,"year":_vm.selected_year}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"area","filter":_vm.filter,"year":_vm.selected_year}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"section","filter":_vm.filter,"year":_vm.selected_year}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"section_lp","filter":_vm.filter,"year":_vm.selected_year}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table-date-range',{attrs:{"field":"conclusion_date","rightAlign":true,"filter":_vm.filter,"year":_vm.selected_year}})],1),_vm._v(" "),_c('th',{staticClass:"l-td"},[_c('filter-table',{attrs:{"field":"conclusion_num","filter":_vm.filter,"rightAlign":true,"year":_vm.selected_year}})],1),_vm._v(" "),_c('th',{staticClass:"l-scroll",on:{"click":_vm.clearFilters}},[_c('span',{staticClass:"glyphicon glyphicon-remove pointer",attrs:{"title":"Сбросить фильтры"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"l-body-wrapper",class:{"no_scroll": _vm.loading}},[_c('table',{staticClass:"body"},[_c('tbody',_vm._l((_vm.lines),function(line,i){return _c('tr',{key:line.act_id,class:{ selected: line.selected },on:{"click":function($event){_vm.select_line(i)}}},[(line.flag)?_c('td',{staticClass:"td-num l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.num))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.act_placement_date))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"td-url large-td",attrs:{"rowspan":line.count}},[_c('a',{attrs:{"href":line.url}},[_vm._v(_vm._s(line.url))])]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.fo))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.region))]):_vm._e(),_vm._v(" "),(line.flag)?_c('td',{staticClass:"l-td",attrs:{"rowspan":line.count}},[_vm._v(_vm._s(line.forestry))]):_vm._e(),_vm._v(" "),(line.flag_lf)?_c('td',{staticClass:"l-td",attrs:{"rowspan":line.count_lf}},[_vm._v(_vm._s(line.localforestry))]):_vm._e(),_vm._v(" "),(line.flag_sf)?_c('td',{staticClass:"l-td",attrs:{"rowspan":line.count_sf}},[_vm._v(_vm._s(line.subforestry))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"l-td"},[_vm._v(_vm._s(line.area))]),_vm._v(" "),_c('td',{staticClass:"l-td"},[_vm._v(_vm._s(line.section))]),_vm._v(" "),_c('td',{staticClass:"l-td"},[_vm._v(_vm._s(line.section_lp))]),_vm._v(" "),_c('td',{staticClass:"l-td"},[_vm._v(_vm._s(line.conclusion_date))]),_vm._v(" "),_c('td',{staticClass:"l-td"},[_vm._v(_vm._s(line.conclusion_num))]),_vm._v(" "),(_vm.loading)?_c('td',{attrs:{"width":"17"}}):_vm._e()])}))]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading-wrap"},[_c('i',{staticClass:"fa fa-spinner fa-spin",staticStyle:{"font-size":"48px"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"text-center"},[(_vm.pages)?_c('ul',{staticClass:"pagination"},_vm._l((_vm.pages),function(page){return _c('li',{class:{ active: page.active }},[(_vm.isNumeric(page.num))?_c('a',{attrs:{"href":"#","data-value":page.num},on:{"click":_vm.select_page}},[_vm._v(_vm._s(page.num))]):_c('span',{staticClass:"disabled_page",attrs:{"href":"#"}},[_vm._v(_vm._s(page.num))])])})):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"center l-td"},[_vm._v("№ акта")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Дата размещения")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Ссылка")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("ФО")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Субъект РФ")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Лесничество")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Уч. лесничество")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Подлесничество")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Квартал")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Выдел")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Л.п. выдел")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Дата заключения")]),_vm._v(" "),_c('th',{staticClass:"center l-td"},[_vm._v("Номер заключения")]),_vm._v(" "),_c('th',{staticClass:"l-scroll"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iPfR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"form_td field_tooltip_parent",on:{"click":_vm.showTooltip}},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"field_tooltip",class:{"visible": _vm.tooltipIsVisible}},[_c('span',[_vm._v("Установить для всех участков")]),_vm._v(" "),_c('button',{attrs:{"type":"button"},on:{"click":_vm.sendZero}},[_vm._v("\n\t\t\t    0\n\t\t\t")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iQxQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth__ = __webpack_require__("SQ6o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fetch_data_fo__ = __webpack_require__("60jp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fetch_data_region__ = __webpack_require__("hLYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fetch_data_forestry__ = __webpack_require__("/wky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fetch_data_localforestry__ = __webpack_require__("d/61");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fetch_data_subforestry__ = __webpack_require__("19Ik");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fetch_data_species__ = __webpack_require__("Rp/j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fetch_data_conclusionUser__ = __webpack_require__("6OcU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fetch_data_organization__ = __webpack_require__("Ha1D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__fetch_data_actionType__ = __webpack_require__("5XhY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__fetch_data_damageReason__ = __webpack_require__("5o/A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__fetch_data_deletionReason__ = __webpack_require__("i+9f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__fetch_data_lpoReason__ = __webpack_require__("E4hU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__fetch_data_lpoMethod__ = __webpack_require__("PV4o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__fetch_data_lpoMode__ = __webpack_require__("Kj4/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__fetch_data_forestPurpose__ = __webpack_require__("MXRL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__fetch_data_protectiveCat__ = __webpack_require__("K/Ax");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__fetch_data_protectiveCatExt__ = __webpack_require__("xdC7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__fetch_data_tooltipWarn__ = __webpack_require__("RuC4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__fetch_data_locationTableField__ = __webpack_require__("A+Qq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__constants__ = __webpack_require__("qI5z");






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





























// import jQuery from "jquery";  
// import datePicker from 'vue-bootstrap-datetimepicker';
// import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';






var HEADER = 'get_header.php';
var ACT_INFO = 'get_act_info.php';
var ACT_LOCATION = 'get_act_location.php';
var GROUP_JSON = 'group_json.php';
var CAN_EDIT = 'can_edit_unit.php';
var ACTION_TYPE = 'get_action_type.php';
var CONCLUSION_EXIST = 'get_conclusion_exist.php';
var DAMAGES = 'get_damages.php';
var LOCALFORESTRY = 'localforestrie_list.php';
var SUBFORESTRY = 'subforestrie_list.php';
var SPECIES = 'get_species.php';
var OZU = 'get_ozu.php';
var PROTECTIVE_CAT = 'get_protective_cat.php';
var FOREST_PURPOSE = 'get_forest_purpose.php';
var LPO_FILIALS = 'get_lpo_filials.php';
var ORGANIZATION_LPO = 'get_organization_lpo.php';
var UNIT_ID = 1;
var TIMEOUT = 10 * 60 * 1000; //10 минут
/*	const UPDATE_JSON = 'update_json.php'
	const INSERT_JSON = 'insert_json.php'
	const DELETE_JSON = 'delete_json.php'*/

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'editModal',
	data: function data() {
		return {
			scroll_width: 17,
			readonly: true,
			line_count: 0,
			lines: [],
			mzl: [],
			mzlNoRAD: [],
			mzlRAD: [],
			lines_loaded: false,
			mzl_loaded: false,
			//rec_id: '',
			//old_obj: '',

			f_1: '',
			f_2: '',
			f_3: '',
			f_4: '',
			f_5: '',
			f_6: 0,
			f_7: '',
			f_8: 0,
			f_9: '',
			f_10: 1,
			f_11: '',
			f_12: '',
			f_13: '',
			f_115: '',
			f_14: '',
			f_15: __WEBPACK_IMPORTED_MODULE_7__auth__["a" /* default */].user.id,
			f_89: null,

			f_126: null,
			f_127: null,

			f_128: null,
			f_129: null, //organization_lpo_id
			f_130: null, //lpo_filial_id

			/*f_16: [],
   f_17: [],
   f_18: [],
   f_19: [],
   f_20: [],
   f_21: [],
   f_22: [],
   f_23: [],
   f_24: [],
   f_25: [],
   f_26: [],
   f_27: [],*/

			f_r: '',
			f_p: '',
			row_id: [],

			controlTwenty: '',
			daysLeft: '',
			prepareToDelete: [],
			act_id: this.$route.params.id,
			summ_s_lp: 0,
			summ_s_action_type: 0,
			value_summ: 0,
			td_correct: '',
			conclusion_user_disabled: false,

			fields_correct: {
				f_1: 'field-error',
				f_2: 'field-error',
				f_3: 'field-error',
				f_5: 'field-error',
				f_9: 'field-error',
				f_11: 'field-error',
				f_12: 'field-error',
				f_13: 'field-error',
				f_115: '',
				f_126: 'field-error',
				f_127: 'field-error',
				f_128: 'field-error',
				f_130: 'field-error'
			},

			submit_disabled: false,

			lines_correct: 'field-error',

			data_location: {
				action_type: null,
				damage_reason: null,
				localforestry: null,
				subforestry: null,
				species_list: [],
				ozu: [],
				protective_cat: [],
				forest_purpose: [],
				subforestrie_list: [],
				subforestrie_list_queue: []
			},

			organization_types: [],
			lpo_filials: []
		};
	},
	components: {
		region: __WEBPACK_IMPORTED_MODULE_9__fetch_data_region__["a" /* default */],
		forestry: __WEBPACK_IMPORTED_MODULE_10__fetch_data_forestry__["a" /* default */],
		localforestry: __WEBPACK_IMPORTED_MODULE_11__fetch_data_localforestry__["a" /* default */],
		subforestry: __WEBPACK_IMPORTED_MODULE_12__fetch_data_subforestry__["a" /* default */],
		fo: __WEBPACK_IMPORTED_MODULE_8__fetch_data_fo__["a" /* default */],
		species: __WEBPACK_IMPORTED_MODULE_13__fetch_data_species__["a" /* default */],
		conclusionUser: __WEBPACK_IMPORTED_MODULE_14__fetch_data_conclusionUser__["a" /* default */],
		organization: __WEBPACK_IMPORTED_MODULE_15__fetch_data_organization__["a" /* default */],
		actionType: __WEBPACK_IMPORTED_MODULE_16__fetch_data_actionType__["a" /* default */],
		damageReason: __WEBPACK_IMPORTED_MODULE_17__fetch_data_damageReason__["a" /* default */],
		deletionReason: __WEBPACK_IMPORTED_MODULE_18__fetch_data_deletionReason__["a" /* default */],
		datepicker: __WEBPACK_IMPORTED_MODULE_28_vue_strap__["datepicker"],
		lpoReason: __WEBPACK_IMPORTED_MODULE_19__fetch_data_lpoReason__["a" /* default */],
		lpoMethod: __WEBPACK_IMPORTED_MODULE_20__fetch_data_lpoMethod__["a" /* default */],
		lpoMode: __WEBPACK_IMPORTED_MODULE_21__fetch_data_lpoMode__["a" /* default */],
		forestPurpose: __WEBPACK_IMPORTED_MODULE_22__fetch_data_forestPurpose__["a" /* default */],
		protectiveCat: __WEBPACK_IMPORTED_MODULE_23__fetch_data_protectiveCat__["a" /* default */],
		protectiveCatExt: __WEBPACK_IMPORTED_MODULE_24__fetch_data_protectiveCatExt__["a" /* default */],
		tooltipWarn: __WEBPACK_IMPORTED_MODULE_25__fetch_data_tooltipWarn__["a" /* default */],
		locationTableField: __WEBPACK_IMPORTED_MODULE_26__fetch_data_locationTableField__["a" /* default */]
	},
	computed: {},
	methods: {
		tryBlurMzl: function tryBlurMzl(e, val, type) {
			//if(type && !Number.isInteger(Number(val)))
			//	setTimeout(() => e.target.focus(), 30)
		},
		floatConvert: function floatConvert(number) {
			return +parseFloat(number).toPrecision(12);
		},
		filterInput: function filterInput(e) {
			e.target.value = e.target.value.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "");
		},
		calcSLP: function calcSLP(e) {
			if (typeof e !== 'undefined') {
				e.target.value = e.target.value.replace(/[,-]/g, ".");
				var f = e.target.getAttribute('data-field');
				var l = e.target.getAttribute('data-line');
				this.lines[l][f] = e.target.value;
			}

			var s = 0;
			for (var i = 0; i < this.lines.length; i++) {
				s += +this.lines[i].f_23;
			}

			this.summ_s_lp = this.floatConvert(s); //7.00000000001 FIX
		},
		calcSAT: function calcSAT(e) {
			if (typeof e !== 'undefined') {
				e.target.value = e.target.value.replace(/[,-]/g, ".");
				var f = e.target.getAttribute('data-field');
				var l = e.target.getAttribute('data-line');
				this.lines[l][f] = e.target.value;
			}

			for (var i = 0; i < this.mzl.length; i++) {
				this.mzl[i].value = 0;
			}

			for (var j = 0; j < this.lines.length; j++) {
				for (var _i = 0; _i < this.mzl.length; _i++) {
					if (this.mzl[_i].id == this.lines[j].f_16) {
						this.mzl[_i].value += +this.lines[j].f_22;
					}
				}
			}

			for (var _i2 = 0; _i2 < this.mzl.length; _i2++) {
				this.mzl[_i2].value = this.floatConvert(this.mzl[_i2].value);
			}

			var s = 0;
			for (var _i3 = 0; _i3 < this.lines.length; _i3++) {
				s += +this.lines[_i3].f_22;
			}

			this.summ_s_action_type = this.floatConvert(s); //7.00000000001 FIX
		},
		addLine: function addLine() {
			var obj = {};
			for (var i = 16; i <= 27; i++) {
				obj['f_' + i] = '';
			}

			obj.correct_f_16 = 'field-error';
			obj.correct_f_17 = 'field-error';
			obj.correct_f_20 = 'field-error';
			obj.correct_f_21 = 'field-error';
			obj.correct_f_24 = 'field-error';

			this.lines.push(obj);

			this.lines_correct = '';
		},
		copyLine: function copyLine() {
			var _this = this;

			//console.warn(this.lines)
			document.querySelectorAll('tbody .checkbox').forEach(function (checkbox) {
				if (checkbox.checked) {
					checkbox.checked = false;
					var index = checkbox.getAttribute('data-index');
					var line_to_copy = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, _this.lines[index]);
					line_to_copy.f_c = null;

					for (var l in line_to_copy) {
						if (line_to_copy[l] == null) delete line_to_copy[l];
					}_this.lines.push(line_to_copy);
				}
			});
			document.getElementById('chkBoxSelAll').checked = false;
		},
		deleteLine: function deleteLine() {
			var _this2 = this;

			document.querySelectorAll('tbody .checkbox').forEach(function (checkbox) {
				if (checkbox.checked) {
					var index = checkbox.getAttribute('data-index');

					checkbox.parentNode.parentNode.remove();

					for (var i = 16; i <= 27; i++) {
						_this2.lines[index]['f_' + i] = null;
					}

					if (_this2.lines[index].f_c) {
						_this2.prepareToDelete.push(_this2.lines[index].f_c);
					}
					//this.lines.splice(index,1)

					_this2.lines[index].f_d = true;
					//console.log(this.lines)
				}

				var c = true;
				for (var _i4 = 0; _i4 < _this2.lines.length; _i4++) {
					//console.log(this.lines[i].f_d )
					if (typeof _this2.lines[_i4].f_d === 'undefined') {
						c = false;
						break;
					}
				}
				_this2.lines_correct = c ? 'field-error' : '';
			});
			document.getElementById('chkBoxSelAll').checked = false;
			/*let index = this.lines.indexOf(item);		где item - индекс строки для удаления 
   this.lines.splice(index, 1);*/
		},
		selectAll: function selectAll() {
			document.querySelectorAll('tbody .checkbox').forEach(function (checkbox) {
				checkbox.checked = document.getElementById('chkBoxSelAll').checked;
			});
		},
		clear: function clear() {
			this.lines.forEach(function (line) {
				line.f_d = true;
			});

			document.querySelectorAll('tbody .checkbox').forEach(function (checkbox) {
				checkbox.parentNode.parentNode.remove();
			});
		},
		checkFields: function checkFields() {
			var main_fields = [1, 2, 3, 5, 9, 11, 12, 13];
			var location_fields = [17, 20, 21, 24];
			var result = true;

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(main_fields), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var i = _step.value;

					result = result && !!this['f_' + i]; //one false = result false, all true = result true
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			result = result && !!this.lines.length; //lines.length == 0 => result false

			var deleted_lines_count = 0;
			for (var j = 0; j < this.lines.length; j++) {
				if (this.lines[j].f_d) deleted_lines_count++;
			}

			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(location_fields), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var _i5 = _step2.value;

					for (var _j = 0; _j < this.lines.length; _j++) {
						if (!this.lines[_j].f_d) result = result && !!this.lines[_j]['f_' + _i5];
					}
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			if (deleted_lines_count === this.lines.length) //all lines is deleted => result false
				result = false;

			return result;
		},
		submit: function submit() {
			var _this3 = this;

			this.submit_disabled = true;

			for (var i = 0; i < this.lines.length; i++) {
				if (this.lines[i].f_16 == this.mzlRAD.id && !__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default()(Number(this.lines[i].f_22))) {
					__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$emit('show_tooltip_mzl_edit', { id: i });
					this.submit_disabled = false;
					return false;
				}
			}

			var obj = [{}];
			obj[0].u = [];
			obj[0].d = [];
			//obj[0].i = []
			obj[0].i = {};
			obj[0].i.tab = [];

			obj[0].u.push({});

			obj[0].u[obj[0].u.length - 1].tab_id = 1;
			obj[0].u[obj[0].u.length - 1].f_v = {};
			obj[0].u[obj[0].u.length - 1].f_v.f_c = this.$route.params.id;

			for (var _i6 = 1; _i6 <= 15; _i6++) {
				if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this['f_' + _i6]) !== 'object') {
					if (_i6 === 13 || _i6 === 14) {
						obj[0].u[obj[0].u.length - 1].f_v['f_' + _i6] = this['f_' + _i6] ? commaToPeriod(this['f_' + _i6]) : null;
					} else if (_i6 === 10) {
						obj[0].u[obj[0].u.length - 1].f_v.f_10 = this.f_10 == '1' ? true : false;
					} else {
						obj[0].u[obj[0].u.length - 1].f_v['f_' + _i6] = this['f_' + _i6] ? this['f_' + _i6] : null;
					}
				} else {
					obj[0].u[obj[0].u.length - 1].f_v['f_' + _i6] = this['f_' + _i6] ? this['f_' + _i6].format('DD.MM.YYYY') : null;
				}
			}

			obj[0].u[obj[0].u.length - 1].f_v['f_115'] = this['f_115'] ? commaToPeriod(this['f_115']) : null;

			obj[0].u[obj[0].u.length - 1].f_v.f_88 = this.f_88;
			obj[0].u[obj[0].u.length - 1].f_v.f_89 = this.f_89;
			obj[0].u[obj[0].u.length - 1].f_v.f_90 = this.f_90;

			obj[0].u[obj[0].u.length - 1].f_v.f_126 = this.f_126;
			obj[0].u[obj[0].u.length - 1].f_v.f_127 = this.f_127;
			obj[0].u[obj[0].u.length - 1].f_v.f_128 = this.f_128;
			obj[0].u[obj[0].u.length - 1].f_v.f_129 = this.f_129;
			obj[0].u[obj[0].u.length - 1].f_v.f_130 = this.f_130;

			for (var _i7 = 0; _i7 < this.lines.length; _i7++) {
				if (this.lines[_i7].f_c && !this.lines[_i7].f_d) {
					obj[0].u.push({});

					obj[0].u[obj[0].u.length - 1].tab_id = 2;
					obj[0].u[obj[0].u.length - 1].f_v = {};
					obj[0].u[obj[0].u.length - 1].f_v.f_c = this.lines[_i7].f_c;

					for (var j = 16; j <= 26; j++) {
						if (j === 21 || j === 22 || j === 23) {
							obj[0].u[obj[0].u.length - 1].f_v['f_' + j] = this.lines[_i7]['f_' + j] ? commaToPeriod(this.lines[_i7]['f_' + j]) : null;
						} else {
							obj[0].u[obj[0].u.length - 1].f_v['f_' + j] = this.lines[_i7]['f_' + j] ? this.lines[_i7]['f_' + j] : null;
						}
					}

					obj[0].u[obj[0].u.length - 1].f_v['f_27'] = Number(this.lines[_i7]['f_27']) ? this.lines[_i7]['f_27'] : null;

					obj[0].u[obj[0].u.length - 1].f_v['f_104'] = this.lines[_i7]['f_104'];
					obj[0].u[obj[0].u.length - 1].f_v['f_105'] = this.lines[_i7]['f_105'];
					obj[0].u[obj[0].u.length - 1].f_v['f_106'] = this.lines[_i7]['f_106'] ? this.lines[_i7]['f_106'] : null;

					obj[0].u[obj[0].u.length - 1].f_v['f_111'] = this.lines[_i7]['f_111'] ? this.lines[_i7]['f_111'] : null;
					obj[0].u[obj[0].u.length - 1].f_v['f_112'] = this.lines[_i7]['f_112'] ? this.lines[_i7]['f_112'] : null;
					obj[0].u[obj[0].u.length - 1].f_v['f_113'] = this.lines[_i7]['f_113'] ? this.lines[_i7]['f_113'] : null;
					obj[0].u[obj[0].u.length - 1].f_v['f_114'] = this.lines[_i7]['f_114'] ? this.lines[_i7]['f_114'] : null;
					obj[0].u[obj[0].u.length - 1].f_v['f_116'] = this.lines[_i7]['f_116'] ? this.lines[_i7]['f_116'] : null;
					obj[0].u[obj[0].u.length - 1].f_v['f_131'] = this.lines[_i7]['f_131'] ? this.lines[_i7]['f_131'] : null;
				} else if (this.lines[_i7].f_d) {
					obj[0].d.push({});

					obj[0].d[obj[0].d.length - 1].tab_id = 2;
					obj[0].d[obj[0].d.length - 1].f_c = this.lines[_i7].f_c;
				} else {
					//obj[0].i.push({})
					obj[0].i.tab.push({});

					obj[0].i.tab[obj[0].i.tab.length - 1].tab_id = 2;
					obj[0].i.tab[obj[0].i.tab.length - 1].f_v = {};
					obj[0].i.tab[obj[0].i.tab.length - 1].f_v.f_p = this.$route.params.id;
					//console.log(this.$route.params.id)

					for (var _j2 = 16; _j2 <= 26; _j2++) {
						if (this.lines[_i7]['f_' + _j2]) if (_j2 === 21 || _j2 === 22 || _j2 === 23) {
							obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_' + _j2] = commaToPeriod(this.lines[_i7]['f_' + _j2]);
						} else {
							obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_' + _j2] = this.lines[_i7]['f_' + _j2];
						}
					}
					if (Number(this.lines[_i7]['f_27'])) obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_27'] = this.lines[_i7]['f_27'];

					obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_104'] = this.lines[_i7]['f_104'];
					obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_105'] = this.lines[_i7]['f_105'];
					if (this.lines[_i7]['f_106']) obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_106'] = this.lines[_i7]['f_106'];

					if (this.lines[_i7]['f_111']) obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_111'] = this.lines[_i7]['f_111'];
					if (this.lines[_i7]['f_112']) obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_112'] = this.lines[_i7]['f_112'];
					if (this.lines[_i7]['f_113']) obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_113'] = this.lines[_i7]['f_113'];
					if (this.lines[_i7]['f_114']) obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_114'] = this.lines[_i7]['f_114'];
					if (this.lines[_i7]['f_116']) obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_116'] = this.lines[_i7]['f_116'];
					if (this.lines[_i7]['f_131']) obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_131'] = this.lines[_i7]['f_131'];
				}
			}

			// console.log(JSON.stringify(obj)) 
			var submit_act_info = function submit_act_info() {
				var form = new FormData();
				form.append('json', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj));

				var first_check_result = null;
				var second_check_result = null;

				var first_check = setTimeout(function () {
					if (first_check_result === null) {
						first_check_result = false;
						var save = confirm('Во время сохранения акта произошла ошибка. Сохранить файл с отладочной информацией для отправки разработчикам?');

						if (save) _this3.download(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj) + '_timeout', 'edit_' + Date() + '.json', 'text/json');

						_this3.submit_disabled = false;
					}
				}, TIMEOUT);

				fetch(__WEBPACK_IMPORTED_MODULE_30__constants__["a" /* DB */] + GROUP_JSON, {
					credentials: 'include',
					method: 'post',
					body: form
				}).then(function (result) {
					return result.json();
				}).then(function (result) {
					if (first_check_result === null) {
						first_check_result = true;
						clearTimeout(first_check);

						if (result[0].code === '0') {
							alert('Акт сохранен');

							if (_this3.$parent.lastJournalURL) __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].replace(_this3.$parent.lastJournalURL);else __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].replace('/main');
						} else {
							alert('Во время сохранения акта произошла ошибка. На Ваш компьютер будет сохранён файл с отладочной информацией. Перешлите данный файл вместе со скриншотом экрана разработчикам для выявления и устранения ошибки.');
							_this3.download(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj) + '_' + result[0].name, 'edit_' + Date() + '.json', 'text/json');
						}
						_this3.submit_disabled = false;
					}
				}).catch(function (err) {
					console.log(err);
					_this3.submit_disabled = false;
				});
			};
			if (this.checkFields()) {
				if (document.querySelector('.field-error') !== null) {
					var b = confirm('Часть полей может содержать некорректные данные. Вы уверены, что хотите продолжить?');
					if (b) {
						submit_act_info();
					} else {
						this.submit_disabled = false;
					}
				} else {
					submit_act_info();
				}
			} else {
				alert('Поля, отмеченные звёздочкой, обязательны к заполнению.');
				this.submit_disabled = false;
			}

			//console.log(this.prepareToDelete)
		},
		close: function close() {
			if (this.$parent.lastJournalURL) __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].replace(this.$parent.lastJournalURL);else __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].replace('/main');
		},
		download: function download(content, fileName, contentType) {
			var a = document.createElement("a");
			var file = new Blob([content], { type: contentType });
			a.href = URL.createObjectURL(file);
			a.download = fileName;
			var event = document.createEvent("MouseEvents");
			event.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
			a.dispatchEvent(event);
		},
		adoptionChange: function adoptionChange(e) {
			var dp_adoption = document.getElementById('edit_datepicker_f_5').firstChild;
			var dp_placement = document.getElementById('edit_datepicker_f_3').firstChild;

			if (e) {
				if (this.f_3) {
					var adoption = __WEBPACK_IMPORTED_MODULE_27_moment___default()(e, 'DD.MM.YYYY');
					var place = __WEBPACK_IMPORTED_MODULE_27_moment___default()(this.f_3, 'DD.MM.YYYY');
					var diff = place.diff(adoption, 'days');

					if (diff < 0 || diff > 3) {
						if (!dp_adoption.classList.contains('error')) {
							dp_adoption.classList.add('error');
							dp_placement.classList.add('error');
							this.fields_correct.f_3 = 'error';
							this.fields_correct.f_5 = 'error';
						}
					} else {
						dp_adoption.classList.remove('error');
						dp_placement.classList.remove('error');
						this.fields_correct.f_3 = '';
						this.fields_correct.f_5 = '';
					}
				} else {
					this.fields_correct.f_5 = 'field-success';
				}
			} else {
				dp_adoption.classList.remove('error');
				dp_placement.classList.remove('error');
				this.fields_correct.f_5 = 'field-error';
				this.fields_correct.f_3 = this.fields_correct.f_3 !== 'field-error' ? 'field-success' : 'field-error';
			}
		},
		placeChange: function placeChange(e) {
			if (e) {
				var d = __WEBPACK_IMPORTED_MODULE_27_moment___default()(e, 'DD.MM.YYYY');
				d.add(20, 'd');
				var now = __WEBPACK_IMPORTED_MODULE_27_moment___default()();

				this.controlTwenty = d.format('DD.MM.YYYY');
				this.daysLeft = d.diff(now, 'days');

				if (this.f_5) {
					var adoption = __WEBPACK_IMPORTED_MODULE_27_moment___default()(this.f_5, 'DD.MM.YYYY');
					var place = __WEBPACK_IMPORTED_MODULE_27_moment___default()(e, 'DD.MM.YYYY');
					var diff = place.diff(adoption, 'days');

					var dp_adoption = document.getElementById('edit_datepicker_f_5').firstChild;
					var dp_placement = document.getElementById('edit_datepicker_f_3').firstChild;

					if (diff < 0 || diff > 3) {
						if (!dp_adoption.classList.contains('error')) {
							dp_adoption.classList.add('error');
							dp_placement.classList.add('error');
							this.fields_correct.f_3 = 'error';
							this.fields_correct.f_5 = 'error';
						}
					} else {
						dp_adoption.classList.remove('error');
						dp_placement.classList.remove('error');
						this.fields_correct.f_3 = '';
						this.fields_correct.f_5 = '';
					}
				} else {
					this.fields_correct.f_3 = '';
				}
			} else {
				this.controlTwenty = '';
				this.daysLeft = '';

				document.getElementById('edit_datepicker_f_3').firstChild.classList.remove('error');
				document.getElementById('edit_datepicker_f_5').firstChild.classList.remove('error');
				this.fields_correct.f_3 = 'field-error';
				this.fields_correct.f_5 = this.fields_correct.f_5 !== 'field-error' ? 'field-success' : 'field-error';
			}
		},
		checkS_LPO: function checkS_LPO() {
			var locations_S_sum = this.lines.length ? this.lines.reduce(function (a, cur) {
				return a + Number(cur.f_21);
			}, 0) : 0;
			var locations_S_MZL_sum = this.lines.length ? this.lines.reduce(function (a, cur) {
				//console.warn(cur)
				return a + (cur.f_16 == 563 ? 0 : Number(cur.f_22)); //Для всех, кроме РАД
			}, 0) : 0;
			//console.warn(Number(this.f_13), locations_S_sum, locations_S_MZL_sum)
			this.fields_correct.f_13 = this.f_13 === '' || this.f_13 === null || Number(this.f_13) > locations_S_sum || Number(this.f_13) < locations_S_MZL_sum ? 'field-error' : '';
		},
		tdChange: function tdChange(e) {
			var f = e.target.getAttribute('data-field');
			var l = e.target.getAttribute('line_count');
			if (f === 'f_21') {
				e.target.value = e.target.value.replace(/[,-]/g, ".");
			}

			this.lines[l]['correct_' + f] = e.target.value === '' ? 'field-error' : 'place-success';
		},
		change_f_129: function change_f_129() {
			this.f_130 = null;
			this.f_128 = "";
		},
		setSKSAllLocations: function setSKSAllLocations(val) {
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.lines), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var iterator = _step3.value;

					iterator[val.field] = val.value;
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}
		}
	},
	created: function created() {
		var _this4 = this;

		fetch(__WEBPACK_IMPORTED_MODULE_30__constants__["a" /* DB */] + ACTION_TYPE, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			if (res) {
				_this4.data_location.action_type = res;
				__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$emit('fetch_action_type_complete', { data: res });

				var tmp = [];
				for (var i = 1; i < res.length; i++) {
					tmp.push({ id: +res[i].id, name: res[i].name, value: 0 });
				}
				_this4.mzl = tmp;
			} else _this4.mzl = [];
			_this4.mzl_loaded = true;
			if (_this4.lines_loaded) {
				_this4.calcSLP();
				_this4.calcSAT();
			}
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_30__constants__["a" /* DB */] + DAMAGES, {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (data) {
			if (data) {
				_this4.data_location.damage_reason = data;
				__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$emit('fetch_damage_reason_complete', data);
			}
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_30__constants__["a" /* DB */] + LPO_FILIALS, {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (data) {
			if (data) {
				_this4.lpo_filials = data;
			}
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_30__constants__["a" /* DB */] + ORGANIZATION_LPO, {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (data) {
			if (data) {
				_this4.organization_types = data;
			}
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_30__constants__["a" /* DB */] + OZU, {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (data) {
			if (data) {
				_this4.data_location.ozu = data;
				__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$emit('fetch_ozu_complete', data);
			}
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_30__constants__["a" /* DB */] + PROTECTIVE_CAT, {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (data) {
			if (data) {
				_this4.data_location.protective_cat = data;
				__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$emit('fetch_protective_cat_complete', data);
			}
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_30__constants__["a" /* DB */] + FOREST_PURPOSE, {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (data) {
			if (data) {
				_this4.data_location.forest_purpose = data;
				__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$emit('fetch_forest_purpose_complete', data);
			}
		}).catch(function (err) {
			return console.log(err);
		});

		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$on('edit_region', function (id) {
			_this4.f_12 = id;
			_this4.f_9 = 0;
			_this4.clear();
			_this4.fields_correct.f_12 = id === '0' ? 'field-error' : '';
			_this4.fields_correct.f_9 = 'field-error';
		});
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$on('init_region_correct', function (id) {
			_this4.fields_correct.f_12 = id === '0' ? 'field-error' : '';
		});
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$on('edit_forestry', function (id) {
			_this4.f_9 = id;

			fetch(__WEBPACK_IMPORTED_MODULE_30__constants__["a" /* DB */] + LOCALFORESTRY + '?id=' + _this4.f_9) //forestry_id - f_9
			.then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this4.data_location.localforestry = data;
					__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$emit('fetch_localforestry_complete', data);
				}
			}).catch(function (err) {
				return console.log(err);
			});

			_this4.clear();
			_this4.fields_correct.f_9 = id === '0' ? 'field-error' : '';

			_this4.addLine();
		});
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$on('init_forestry_correct', function (id) {
			_this4.fields_correct.f_9 = id === '0' ? 'field-error' : '';
		});
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$on('edit_localforestry', function (data) {
			_this4.lines[data.index].f_20 = data.value;
			_this4.lines[data.index].correct_f_20 = +data.value === 0 ? 'field-error' : 'place-success';
		});
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$on('edit_subforestry', function (data) {
			_this4.lines[data.index].f_27 = data.value;
		});
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$on('edit_conclusion_user', function (id) {
			_this4.f_6 = id;
		});
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$on('edit_species', function (data) {
			_this4.lines[data.index].f_26 = data.value;
		});
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$on('edit_organization', function (id) {
			_this4.f_11 = id;
			_this4.fields_correct.f_11 = id === '0' ? 'field-error' : '';
		});
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$on('edit_action_type', function (data) {
			_this4.lines[data.index].f_16 = +data.value;

			for (var i = 0; i < _this4.mzl.length; i++) {
				_this4.mzl[i].value = 0;
			}

			for (var j = 0; j < _this4.lines.length; j++) {
				for (var _i8 = 0; _i8 < _this4.mzl.length; _i8++) {
					if (_this4.mzl[_i8].id == _this4.lines[j].f_16) {
						_this4.mzl[_i8].value += +_this4.lines[j].f_22;
					}
				}
			}

			for (var _i9 = 0; _i9 < _this4.mzl.length; _i9++) {
				_this4.mzl[_i9].value = _this4.floatConvert(_this4.mzl[_i9].value);
			}

			_this4.checkS_LPO();
		});
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$on('edit_deletion_reason', function (id) {
			_this4.f_8 = id;
		});
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$on('edit_damages', function (data) {
			_this4.lines[data.index].f_19 = data.value;
		});

		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$on('edit_lpo_reason', function (id) {
			_this4.f_88 = id;
		});

		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$on('edit_lpo_method', function (id) {
			_this4.f_89 = id;
		});

		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$on('edit_lpo_mode', function (id) {
			_this4.f_90 = id;
		});

		//---------------------
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$on('edit_forest_purpose', function (data) {
			_this4.lines[data.index].f_104 = data.value;
		});
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$on('edit_protective_cat', function (data) {
			_this4.lines[data.index].f_105 = data.value;
		});
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$on('edit_protective_cat_ext', function (data) {
			_this4.lines[data.index].f_106 = data.value;
		});

		fetch(__WEBPACK_IMPORTED_MODULE_30__constants__["a" /* DB */] + CAN_EDIT + '?act_id=' + this.$route.params.id + '&unit_id=' + UNIT_ID, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			_this4.readonly = res[0].czl_check_can_edit_unit == 't' ? false : true;
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_30__constants__["a" /* DB */] + HEADER + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			if (res) {
				for (var i in res[0]) {
					_this4[i] = res[0][i];
				}

				fetch(__WEBPACK_IMPORTED_MODULE_30__constants__["a" /* DB */] + LOCALFORESTRY + '?id=' + _this4.f_9) //forestry_id - f_9
				.then(function (data) {
					return data.json();
				}).then(function (data) {
					if (data) {
						_this4.data_location.localforestry = data;
						__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$emit('fetch_localforestry_complete', data);
					}
				}).catch(function (err) {
					return console.log(err);
				});

				var region_id = _this4.f_12;
				fetch(__WEBPACK_IMPORTED_MODULE_30__constants__["a" /* DB */] + SPECIES + ('?region_id=' + region_id), {
					credentials: 'include'
				}).then(function (data) {
					return data.json();
				}).then(function (data) {
					if (data) {
						_this4.data_location.species_list = data;
						__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$emit('fetch_species_complete', data);
					}
				}).catch(function (err) {
					return console.log(err);
				});
			}
		}).catch(function (err) {
			return console.log(err);
		});

		//---------------------


		//---------------------

		fetch(__WEBPACK_IMPORTED_MODULE_30__constants__["a" /* DB */] + ACT_INFO + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			for (var i in res[0]) {
				//console.log(i, res[0][i])
				if (i === 'f_1' || i === 'f_3' || i === 'f_5' || i === 'f_7') {
					var d = __WEBPACK_IMPORTED_MODULE_27_moment___default()(res[0][i], 'YYYY-MM-DD');
					// console.log(res[0][i], d.format('DD.MM.YYYY'))
					_this4[i] = res[0][i] ? d.format('DD.MM.YYYY') : '';
				} else if (i === 'f_10') {
					_this4.f_10 = res[0][i] === 't' ? 1 : 0;
				} else if (i === 'f_126') {
					if (res[0][i] === 't') {
						_this4.f_126 = true;
					}
					if (res[0][i] === 'f') {
						_this4.f_126 = false;
					}
				} else {
					_this4[i] = res[0][i];
				}
			}
			if (_this4.f_129 === null) {
				_this4.f_129 = 2;
			}
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_30__constants__["a" /* DB */] + ACT_LOCATION + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			if (res) {
				var tmp = [];
				for (var i = 0; i < res.length; i++) {
					tmp.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
						correct_f_16: res[i].f_16 === null ? 'field-error' : 'place-success',
						correct_f_17: res[i].f_17 === null ? 'field-error' : 'place-success',
						correct_f_20: res[i].f_20 === null ? 'field-error' : 'place-success',
						correct_f_21: res[i].f_21 === null ? 'field-error' : 'place-success',
						correct_f_24: res[i].f_24 === null ? 'field-error' : 'place-success'
					}, res[i]));
				}
				_this4.lines = tmp;
				_this4.lines_correct = '';
				_this4.lines_loaded = true;
				if (_this4.mzl_loaded) {
					_this4.calcSLP();
					_this4.calcSAT();
				}
			}
		}).catch(function (err) {
			return console.log(err);
		});

		fetch(__WEBPACK_IMPORTED_MODULE_30__constants__["a" /* DB */] + CONCLUSION_EXIST + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			if (res) _this4.conclusion_user_disabled = res[0].czl_if_conclusion_exist === 't';
		}).catch(function (err) {
			return console.log(err);
		});

		var ua = navigator.userAgent;

		if (ua.search('OPR/') > 0) {
			this.scroll_width = 15;
		}

		/*for (let i = 0; i < this.mzl.length; i++) {
  		this.mzl[i].value = 0
  	}
  		for (let j = 0; j < this.lines.length; j++) {
  		for (let i = 0; i < this.mzl.length; i++) {
  			if (this.mzl[i].id == this.lines[j].f_16) {
  				this.mzl[i].value += +this.lines[j].f_22
  			}
  		}
  	}
  	for (let i = 0; i < this.mzl.length; i++) {
  		this.mzl[i].value = this.floatConvert(this.mzl[i])
  	}*/
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$off('edit_region');
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$off('init_region_correct');
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$off('edit_forestry');
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$off('edit_localforestry');
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$off('edit_subforestry');
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$off('edit_conclusion_user');
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$off('edit_species');
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$off('edit_organization');
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$off('edit_action_type');
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$off('edit_deletion_reason');
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$off('edit_damages');

		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$off('edit_lpo_reason');
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$off('edit_lpo_method');
		__WEBPACK_IMPORTED_MODULE_29__lib_EventBus__["a" /* EventBus */].$off('edit_lpo_mode');
	},

	watch: {
		lines: {
			handler: function handler(val, oldVal) {
				this.checkS_LPO();
				this.value_summ = 0;
				for (var line in this.lines) {
					if (this.lines[line].f_21 != undefined) this.lines[line].f_21 = this.lines[line].f_21.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "");

					if (this.lines[line].f_112 != undefined) this.lines[line].f_112 = this.lines[line].f_112.replace(/[^\d]/g, "");

					if (this.lines[line].f_113 != undefined) this.lines[line].f_113 = this.lines[line].f_113.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "");

					if (this.lines[line].f_114 != undefined) this.lines[line].f_114 = this.lines[line].f_114.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "");

					if (this.lines[line].f_131 != undefined) this.lines[line].f_131 = this.lines[line].f_131.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "");

					if (this.lines[line].f_116 != undefined) {
						this.lines[line].f_116 = this.lines[line].f_116.replace(/[,]/g, ".").replace(/[.]{2,}/g, ".").replace(/[^\.\d]/g, "");
						this.value_summ += Number(this.lines[line].f_116);
					}

					this.lines[line].correct_f_23 = Number(this.lines[line].f_23) > Number(this.lines[line].f_21) ? 'field-error' : 'place-success';
				}
				this.value_summ = this.floatConvert(this.value_summ);
			},
			deep: true
		},
		f_2: function f_2(e) {
			this.fields_correct.f_2 = e === '' || e === null ? 'field-error' : '';
		},
		f_13: function f_13(e) {
			this.checkS_LPO();
		},
		f_115: function f_115(e) {
			if (!e) {
				this.fields_correct.f_115 = '';
				return;
			}

			var r = new RegExp("^-?\\d*(\\.\\d+)?$", "g"); //numeric
			this.fields_correct.f_115 = r.test(e) ? '' : 'field-error';
		},
		f_1: function f_1(e) {
			var arr_f_5 = this.f_5.split('.');
			var date_f_5 = new Date(+arr_f_5[2], +arr_f_5[1] - 1, +arr_f_5[0]);
			var arr_f_1 = this.f_1.split('.');
			var date_f_1 = new Date(+arr_f_1[2], +arr_f_1[1] - 1, +arr_f_1[0]);
			if (date_f_5 < date_f_1) {
				this.fields_correct.f_1 = 'field-error';
				this.fields_correct.f_5 = 'field-error';
			} else {
				this.fields_correct.f_1 = e === '' || e === null ? 'field-error' : 'field-success';
				this.fields_correct.f_5 = this.f_5 === '' || this.f_5 === null ? 'field-error' : 'field-success';
				//this.fields_correct.f_5 = 'field-success'
			}
		},
		f_5: function f_5(e) {
			//debugger;
			var arr_f_5 = this.f_5.split('.');
			var date_f_5 = new Date(+arr_f_5[2], +arr_f_5[1] - 1, +arr_f_5[0]);
			var arr_f_1 = this.f_1.split('.');
			var date_f_1 = new Date(+arr_f_1[2], +arr_f_1[1] - 1, +arr_f_1[0]);
			if (date_f_5 < date_f_1) {
				this.fields_correct.f_1 = 'field-error';
				this.fields_correct.f_5 = 'field-error';
			} else {
				//this.fields_correct.f_1 = 'field-success'
				this.fields_correct.f_1 = this.f_5 === '' || this.f_5 === null ? 'field-error' : 'field-success';
				this.fields_correct.f_5 = e === '' || e === null ? 'field-error' : 'field-success';
			}
		},
		mzl: function mzl(e) {
			var result = this.mzl.slice(0);
			for (var _e in result) {
				if (result[_e].name == 'РАД') {
					this.mzlRAD = result[_e];
					result.splice(_e, 1);
				}
			}
			this.mzlNoRAD = result;
			this.mzlRAD = this.mzlRAD ? this.mzlRAD : { name: 'РАД', value: '0' };
		},
		f_126: function f_126(e) {
			this.fields_correct.f_126 = e === null ? 'field-error' : 'field-success';
		},
		f_127: function f_127(e) {
			this.fields_correct.f_127 = !e ? 'field-error' : 'field-success';
		},
		f_128: function f_128(e) {
			this.fields_correct.f_128 = !e ? 'field-error' : 'field-success';
		},
		f_130: function f_130(e) {
			this.fields_correct.f_130 = !e ? 'field-error' : 'field-success';
		}
	},
	updated: function updated() {
		/*if(document.querySelector('.table_body_wrap').scrollHeight > document.querySelector('.table_body_wrap').clientHeight)
  	this.scroll_width = 17
  else
  	this.scroll_width = 0
  console.warn(this.scroll_width)*/
	}
});

function commaToPeriod(str) {
	return str.replace(/,/g, ".");
}

/***/ }),

/***/ "igSH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var ACTION_TYPE = 'get_action_type.php';
var LOCATION = 'get_conclusion_location.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'actionType',
	data: function data() {
		return {
			selected: '0',
			options: []
		};
	},
	props: {
		line_count: ''
	},
	created: function created() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + LOCATION + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			var at = res.filter(function (item) {
				return item.field == 'f_16';
			});
			//console.log(at[this.line_count], this.line_count)

			if (at.length !== 0) return at[_this.line_count].val;else {
				return '0';
			}
		}).then(function (id) {
			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + ACTION_TYPE, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.options = [{ id: '0', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
					_this.selected = id;
				} else {
					_this.options = [];
					_this.selected = '0';
				}
			}).catch(function (err) {
				return console.log('7', err);
			});
		}).catch(function (err) {
			return console.log('8', err);
		});
	}
});

/***/ }),

/***/ "ipTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"title":"Управление отчётами","backdrop":false,"width":"800px"},on:{"close":function($event){_vm.$emit("close")}},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('div',{staticClass:"modal-body",attrs:{"slot":"modal-body"},slot:"modal-body"},[(_vm.sortedReports.length)?_c('table',{staticClass:"reports_table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Название")]),_vm._v(" "),_c('th',[_vm._v("Актуальность")]),_vm._v(" "),_c('th',[_vm._v("Приоритет")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.sortedReports),function(report){return _c('tr',{key:report.id},[_c('td',{domProps:{"textContent":_vm._s(report.name)}}),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(report.is_actual),expression:"report.is_actual"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(report.is_actual)?_vm._i(report.is_actual,null)>-1:(report.is_actual)},on:{"change":[function($event){var $$a=report.is_actual,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(report.is_actual=$$a.concat([$$v]))}else{$$i>-1&&(report.is_actual=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(report, "is_actual", $$c)}},function($event){_vm.changeReport(report.id, $event.target.checked, 0)}]}})]),_vm._v(" "),_c('td',[_c('span',{staticClass:"priority_control plus",on:{"click":function($event){_vm.changeReport(report.id, report.is_actual, -1)}}}),_vm._v(" "),_c('span',{staticClass:"priority_control minus",on:{"click":function($event){_vm.changeReport(report.id, report.is_actual, 1)}}})])])}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.saveReports}},[_vm._v("Сохранить")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.$emit("close")}}},[_vm._v("Закрыть")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "it07":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dropdown',{class:{wide: _vm.wideWindow, activeFilter: _vm.filtered, right_align: _vm.rightAlign, filter: _vm.filter},attrs:{"text":_vm.name},on:{"input":_vm.open},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},[(_vm.loading)?_c('div',{staticClass:"loading-wrap"},[_c('i',{staticClass:"fa fa-spinner fa-spin",staticStyle:{"font-size":"26px"}})]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.text),expression:"text"}],staticStyle:{"margin-top":"5px","width":"100%"},attrs:{"type":"text","placeholder":"Поиск..."},domProps:{"value":(_vm.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.text=$event.target.value}}}),_vm._v(" "),_c('li',[_c('checkbox',{attrs:{"type":"info"},model:{value:(_vm.sel),callback:function ($$v) {_vm.sel=$$v},expression:"sel"}},[_vm._v("Выбрать всё")])],1),_vm._v(" "),_c('li',{staticClass:"divider",attrs:{"role":"separator"}}),_vm._v(" "),(_vm.items.length)?_c('div',{staticStyle:{"overflow-y":"auto","max-height":"400px"},on:{"scroll":_vm.listScrollHandler}},_vm._l((_vm.items),function(i){return _c('li',{key:i.rank},[_c('checkbox',{attrs:{"type":"info"},on:{"input":function (e) { return _vm.checkboxInput(e, i.rank); }},model:{value:(i.checked),callback:function ($$v) {_vm.$set(i, "checked", $$v)},expression:"i.checked"}},[_c('span',{class:{colored: (_vm.text && _vm.text.length)},domProps:{"innerHTML":_vm._s(i.show_value ? i.show_value : i.value)}})])],1)})):_vm._e(),_vm._v(" "),(!_vm.loading && !_vm.items.length)?_c('div',[_vm._v("\n\t\tНет результатов для отображения\n\t")]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"divider",attrs:{"role":"separator"}}),_vm._v(" "),_c('li',{staticClass:"pull-right"},[_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Ок"},on:{"click":_vm.ok}}),_vm._v(" "),_c('input',{staticClass:"btn btn-default",attrs:{"type":"button","value":"Отмена"},on:{"click":_vm.cancel}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ixZc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_organization_vue__ = __webpack_require__("Ahfj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9760c590_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_organization_vue__ = __webpack_require__("IFg0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_organization_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9760c590_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_organization_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j3u3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"c-body-wrapper"},[_c('table',{staticClass:"body"},[_c('tbody',_vm._l((_vm.rows),function(row,i){return _c('tr',[(row.flag)?_c('td',{attrs:{"colspan":"8"}},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(row.fo))])]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"left c-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.region))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right c-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.sending_conclusion))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right c-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_true))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right c-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_false))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right c-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_false_glpm))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right c-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_false_tax))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right c-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_false_som))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right c-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_false_law))]):_vm._e()])}))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-header-wrapper"},[_c('table',{staticClass:"header"},[_c('thead',{staticClass:"bold"},[_c('tr',[_c('td',{staticClass:"c-td",attrs:{"rowspan":"4"}},[_vm._v("Субъекты, федеральные округа")]),_vm._v(" "),_c('td',{attrs:{"colspan":"7"}},[_vm._v("Количество Актов ЛПО, на которые были направлены заключения")]),_vm._v(" "),_c('td',{staticClass:"c-scroll",attrs:{"rowspan":"4"}})]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"c-td",attrs:{"rowspan":"3"}},[_vm._v("Всего")]),_vm._v(" "),_c('td',{staticClass:"c-td",attrs:{"rowspan":"3"}},[_vm._v("положительных "),_c('br'),_vm._v(" (наличие в реестре "),_c('br'),_vm._v(" ГЛПМ)")]),_vm._v(" "),_c('td',{attrs:{"colspan":"5"}},[_vm._v("отрицательных")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"c-td",attrs:{"rowspan":"2"}},[_vm._v("Всего")]),_vm._v(" "),_c('td',{attrs:{"colspan":"4"}},[_vm._v("в том числе по главным причинам")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"c-td"},[_vm._v("несоответствия сведений данным государственного лесопатологического мониторинга (1)")]),_vm._v(" "),_c('td',{staticClass:"c-td"},[_vm._v("несоответствия сведений таксационным характеристикам лесного участка (2)")]),_vm._v(" "),_c('td',{staticClass:"c-td"},[_vm._v("несоответствия запланированных мероприятий санитарному и лесопатологическому состоянию лесов(3)")]),_vm._v(" "),_c('td',{staticClass:"c-td"},[_vm._v("запрещения или ограничения законодательством Российской Федерации запланированных мероприятий (4)")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("2")]),_vm._v(" "),_c('td',[_vm._v("3")]),_vm._v(" "),_c('td',[_vm._v("4")]),_vm._v(" "),_c('td',[_vm._v("5")]),_vm._v(" "),_c('td',[_vm._v("6")]),_vm._v(" "),_c('td',[_vm._v("7")]),_vm._v(" "),_c('td',[_vm._v("8")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jIvA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{staticClass:"table-control my-control",attrs:{"id":_vm.id,"data-num":"f_20","data-table":"1","disabled":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jKLE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var GET_MONITORING_RLH_REPORT = 'get_monitoring_rlh_report_v2.php';
var REPORT_ID = 1;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'MonitoringRlh',
	data: function data() {
		return {
			rows: []
		};
	},
	props: ['start', 'end'],
	computed: {
		endYear: function endYear() {
			return this.$props.end.split('.')[2];
		}
	},
	methods: {
		floatConvert: function floatConvert(number) {
			return +parseFloat(number).toPrecision(12);
		},
		fillTable: function fillTable(start, end) {
			var _this = this;

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + GET_MONITORING_RLH_REPORT + '?start=' + start + '&end=' + end).then(function (res) {
				return res.json();
			}).then(function (res) {
				var temp_rows = [{}];
				var flag = true;
				var total_summ = {};
				total_summ.region = 'Итого по РФ';
				total_summ.placement_all_count = 0;
				total_summ.placement_all_ga = 0;
				total_summ.placement_week_count = 0;
				total_summ.placement_week_ga = 0;
				total_summ.entrance_all_count = 0;
				total_summ.entrance_all_ga = 0;
				total_summ.entrance_week_count = 0;
				total_summ.entrance_week_ga = 0;
				total_summ.consideration_all_count = 0;
				total_summ.consideration_all_ga = 0;
				total_summ.consideration_week_count = 0;
				total_summ.consideration_week_ga = 0;
				total_summ.conclusion_consideration_all_count = 0;
				total_summ.conclusion_consideration_all_s_mzl = 0;
				total_summ.decision_good_count = 0;
				total_summ.decision_good_s_mzl = 0;
				total_summ.decision_bad_count = 0;
				total_summ.decision_bad_s_mzl = 0;
				total_summ.decision_bad_count_sved_glpm = 0;
				total_summ.decision_bad_s_mzl_sved_glpm = 0;
				total_summ.decision_bad_count_mer_glpm = 0;
				total_summ.decision_bad_s_mzl_mer_glpm = 0;
				total_summ.decision_bad_count_sved_to = 0;
				total_summ.decision_bad_s_mzl_sved_to = 0;
				total_summ.decision_bad_count_sved_sansost = 0;
				total_summ.decision_bad_s_mzl_sved_sansost = 0;
				total_summ.decision_bad_count_zak_rf = 0;
				total_summ.decision_bad_s_mzl_zak_rf = 0;
				total_summ.needs_verification_all_count = 0;
				total_summ.needs_verification_week_count = 0;

				total_summ.warrant_real_check_count_all_count = 0;
				total_summ.warrant_real_check_count_week_count = 0;

				var fo_summ = {};
				fo_summ.region = 'Итого по округу';
				fo_summ.placement_all_count = 0;
				fo_summ.placement_all_ga = 0;
				fo_summ.placement_week_count = 0;
				fo_summ.placement_week_ga = 0;
				fo_summ.entrance_all_count = 0;
				fo_summ.entrance_all_ga = 0;
				fo_summ.entrance_week_count = 0;
				fo_summ.entrance_week_ga = 0;
				fo_summ.consideration_all_count = 0;
				fo_summ.consideration_all_ga = 0;
				fo_summ.consideration_week_count = 0;
				fo_summ.consideration_week_ga = 0;
				fo_summ.conclusion_consideration_all_count = 0;
				fo_summ.conclusion_consideration_all_s_mzl = 0;
				fo_summ.decision_good_count = 0;
				fo_summ.decision_good_s_mzl = 0;
				fo_summ.decision_bad_count = 0;
				fo_summ.decision_bad_s_mzl = 0;
				fo_summ.decision_bad_count_sved_glpm = 0;
				fo_summ.decision_bad_s_mzl_sved_glpm = 0;
				fo_summ.decision_bad_count_mer_glpm = 0;
				fo_summ.decision_bad_s_mzl_mer_glpm = 0;
				fo_summ.decision_bad_count_sved_to = 0;
				fo_summ.decision_bad_s_mzl_sved_to = 0;
				fo_summ.decision_bad_count_sved_sansost = 0;
				fo_summ.decision_bad_s_mzl_sved_sansost = 0;
				fo_summ.decision_bad_count_zak_rf = 0;
				fo_summ.decision_bad_s_mzl_zak_rf = 0;
				fo_summ.needs_verification_all_count = 0;
				fo_summ.needs_verification_week_count = 0;

				fo_summ.warrant_real_check_count_all_count = 0;
				fo_summ.warrant_real_check_count_week_count = 0;

				var i = 0;

				while (i < res.length - 1) {

					if (res[i].fo === res[i + 1].fo && flag) {
						var obj = {};
						obj.fo = res[i].fo;
						obj.flag = true;
						flag = false;

						if (i !== 0) {
							var _clone_fo = {}; //клонируем объект для передачи по значению
							for (var key in fo_summ) {
								_clone_fo[key] = fo_summ[key];
							}

							temp_rows.push(_clone_fo);

							fo_summ.placement_all_count = 0;
							fo_summ.placement_all_ga = 0;
							fo_summ.placement_week_count = 0;
							fo_summ.placement_week_ga = 0;
							fo_summ.entrance_all_count = 0;
							fo_summ.entrance_all_ga = 0;
							fo_summ.entrance_week_count = 0;
							fo_summ.entrance_week_ga = 0;
							fo_summ.consideration_all_count = 0;
							fo_summ.consideration_all_ga = 0;
							fo_summ.consideration_week_count = 0;
							fo_summ.consideration_week_ga = 0;
							fo_summ.conclusion_consideration_all_count = 0;
							fo_summ.conclusion_consideration_all_s_mzl = 0;
							fo_summ.decision_good_count = 0;
							fo_summ.decision_good_s_mzl = 0;
							fo_summ.decision_bad_count = 0;
							fo_summ.decision_bad_s_mzl = 0;
							fo_summ.decision_bad_count_sved_glpm = 0;
							fo_summ.decision_bad_s_mzl_sved_glpm = 0;
							fo_summ.decision_bad_count_mer_glpm = 0;
							fo_summ.decision_bad_s_mzl_mer_glpm = 0;
							fo_summ.decision_bad_count_sved_to = 0;
							fo_summ.decision_bad_s_mzl_sved_to = 0;
							fo_summ.decision_bad_count_sved_sansost = 0;
							fo_summ.decision_bad_s_mzl_sved_sansost = 0;
							fo_summ.decision_bad_count_zak_rf = 0;
							fo_summ.decision_bad_s_mzl_zak_rf = 0;
							fo_summ.needs_verification_all_count = 0;
							fo_summ.needs_verification_week_count = 0;

							fo_summ.warrant_real_check_count_all_count = 0;
							fo_summ.warrant_real_check_count_week_count = 0;
						}

						temp_rows.push(obj);
					} else {
						fo_summ.placement_all_count += +res[i].placement_all_count;
						fo_summ.placement_all_ga += +res[i].placement_all_ga;
						fo_summ.placement_week_count += +res[i].placement_week_count;
						fo_summ.placement_week_ga += +res[i].placement_week_ga;
						fo_summ.entrance_all_count += +res[i].entrance_all_count;
						fo_summ.entrance_all_ga += +res[i].entrance_all_ga;
						fo_summ.entrance_week_count += +res[i].entrance_week_count;
						fo_summ.entrance_week_ga += +res[i].entrance_week_ga;
						fo_summ.consideration_all_count += +res[i].consideration_all_count;
						fo_summ.consideration_all_ga += +res[i].consideration_all_ga;
						fo_summ.consideration_week_count += +res[i].consideration_week_count;
						fo_summ.consideration_week_ga += +res[i].consideration_week_ga;
						fo_summ.conclusion_consideration_all_count += +res[i].conclusion_consideration_all_count;
						fo_summ.conclusion_consideration_all_s_mzl += +res[i].conclusion_consideration_all_s_mzl;
						fo_summ.decision_good_count += +res[i].decision_good_count;
						fo_summ.decision_good_s_mzl += +res[i].decision_good_s_mzl;
						fo_summ.decision_bad_count += +res[i].decision_bad_count;
						fo_summ.decision_bad_s_mzl += +res[i].decision_bad_s_mzl;
						fo_summ.decision_bad_count_sved_glpm += +res[i].decision_bad_count_sved_glpm;
						fo_summ.decision_bad_s_mzl_sved_glpm += +res[i].decision_bad_s_mzl_sved_glpm;
						fo_summ.decision_bad_count_mer_glpm += +res[i].decision_bad_count_mer_glpm;
						fo_summ.decision_bad_s_mzl_mer_glpm += +res[i].decision_bad_s_mzl_mer_glpm;
						fo_summ.decision_bad_count_sved_to += +res[i].decision_bad_count_sved_to;
						fo_summ.decision_bad_s_mzl_sved_to += +res[i].decision_bad_s_mzl_sved_to;
						fo_summ.decision_bad_count_sved_sansost += +res[i].decision_bad_count_sved_sansost;
						fo_summ.decision_bad_s_mzl_sved_sansost += +res[i].decision_bad_s_mzl_sved_sansost;
						fo_summ.decision_bad_count_zak_rf += +res[i].decision_bad_count_zak_rf;
						fo_summ.decision_bad_s_mzl_zak_rf += +res[i].decision_bad_s_mzl_zak_rf;
						fo_summ.needs_verification_all_count += +res[i].needs_verification_all_count;
						fo_summ.needs_verification_week_count += +res[i].needs_verification_week_count;

						fo_summ.warrant_real_check_count_all_count += +res[i].warrant_real_check_count_all_count;
						fo_summ.warrant_real_check_count_week_count += +res[i].warrant_real_check_count_week_count;

						total_summ.placement_all_count += +res[i].placement_all_count;
						total_summ.placement_all_ga += +res[i].placement_all_ga;
						total_summ.placement_week_count += +res[i].placement_week_count;
						total_summ.placement_week_ga += +res[i].placement_week_ga;
						total_summ.entrance_all_count += +res[i].entrance_all_count;
						total_summ.entrance_all_ga += +res[i].entrance_all_ga;
						total_summ.entrance_week_count += +res[i].entrance_week_count;
						total_summ.entrance_week_ga += +res[i].entrance_week_ga;
						total_summ.consideration_all_count += +res[i].consideration_all_count;
						total_summ.consideration_all_ga += +res[i].consideration_all_ga;
						total_summ.consideration_week_count += +res[i].consideration_week_count;
						total_summ.consideration_week_ga += +res[i].consideration_week_ga;
						total_summ.conclusion_consideration_all_count += +res[i].conclusion_consideration_all_count;
						total_summ.conclusion_consideration_all_s_mzl += +res[i].conclusion_consideration_all_s_mzl;
						total_summ.decision_good_count += +res[i].decision_good_count;
						total_summ.decision_good_s_mzl += +res[i].decision_good_s_mzl;
						total_summ.decision_bad_count += +res[i].decision_bad_count;
						total_summ.decision_bad_s_mzl += +res[i].decision_bad_s_mzl;
						total_summ.decision_bad_count_sved_glpm += +res[i].decision_bad_count_sved_glpm;
						total_summ.decision_bad_s_mzl_sved_glpm += +res[i].decision_bad_s_mzl_sved_glpm;
						total_summ.decision_bad_count_mer_glpm += +res[i].decision_bad_count_mer_glpm;
						total_summ.decision_bad_s_mzl_mer_glpm += +res[i].decision_bad_s_mzl_mer_glpm;
						total_summ.decision_bad_count_sved_to += +res[i].decision_bad_count_sved_to;
						total_summ.decision_bad_s_mzl_sved_to += +res[i].decision_bad_s_mzl_sved_to;
						total_summ.decision_bad_count_sved_sansost += +res[i].decision_bad_count_sved_sansost;
						total_summ.decision_bad_s_mzl_sved_sansost += +res[i].decision_bad_s_mzl_sved_sansost;
						total_summ.decision_bad_count_zak_rf += +res[i].decision_bad_count_zak_rf;
						total_summ.decision_bad_s_mzl_zak_rf += +res[i].decision_bad_s_mzl_zak_rf;
						total_summ.needs_verification_all_count += +res[i].needs_verification_all_count;
						total_summ.needs_verification_week_count += +res[i].needs_verification_week_count;

						total_summ.warrant_real_check_count_all_count += +res[i].warrant_real_check_count_all_count;
						total_summ.warrant_real_check_count_week_count += +res[i].warrant_real_check_count_week_count;

						for (var _key in fo_summ) {
							if (_key !== 'region') fo_summ[_key] = +_this.floatConvert(fo_summ[_key]);
						}

						for (var _key2 in total_summ) {
							if (_key2 !== 'region') total_summ[_key2] = +_this.floatConvert(total_summ[_key2]);
						}

						temp_rows.push(res[i]);
						if (res[i].fo !== res[i + 1].fo) {
							flag = true;
						}
						i++;
					}
				}

				var last = res.length - 1;

				temp_rows.push(res[last]);

				fo_summ.placement_all_count += +res[last].placement_all_count;
				fo_summ.placement_all_ga += +res[last].placement_all_ga;
				fo_summ.placement_week_count += +res[last].placement_week_count;
				fo_summ.placement_week_ga += +res[last].placement_week_ga;
				fo_summ.entrance_all_count += +res[last].entrance_all_count;
				fo_summ.entrance_all_ga += +res[last].entrance_all_ga;
				fo_summ.entrance_week_count += +res[last].entrance_week_count;
				fo_summ.entrance_week_ga += +res[last].entrance_week_ga;
				fo_summ.consideration_all_count += +res[last].consideration_all_count;
				fo_summ.consideration_all_ga += +res[last].consideration_all_ga;
				fo_summ.consideration_week_count += +res[last].consideration_week_count;
				fo_summ.consideration_week_ga += +res[last].consideration_week_ga;
				fo_summ.conclusion_consideration_all_count += +res[last].conclusion_consideration_all_count;
				fo_summ.conclusion_consideration_all_s_mzl += +res[last].conclusion_consideration_all_s_mzl;
				fo_summ.decision_good_count += +res[last].decision_good_count;
				fo_summ.decision_good_s_mzl += +res[last].decision_good_s_mzl;
				fo_summ.decision_bad_count += +res[last].decision_bad_count;
				fo_summ.decision_bad_s_mzl += +res[last].decision_bad_s_mzl;
				fo_summ.decision_bad_count_sved_glpm += +res[last].decision_bad_count_sved_glpm;
				fo_summ.decision_bad_s_mzl_sved_glpm += +res[last].decision_bad_s_mzl_sved_glpm;
				fo_summ.decision_bad_count_mer_glpm += +res[last].decision_bad_count_mer_glpm;
				fo_summ.decision_bad_s_mzl_mer_glpm += +res[last].decision_bad_s_mzl_mer_glpm;
				fo_summ.decision_bad_count_sved_to += +res[last].decision_bad_count_sved_to;
				fo_summ.decision_bad_s_mzl_sved_to += +res[last].decision_bad_s_mzl_sved_to;
				fo_summ.decision_bad_count_sved_sansost += +res[last].decision_bad_count_sved_sansost;
				fo_summ.decision_bad_s_mzl_sved_sansost += +res[last].decision_bad_s_mzl_sved_sansost;
				fo_summ.decision_bad_count_zak_rf += +res[last].decision_bad_count_zak_rf;
				fo_summ.decision_bad_s_mzl_zak_rf += +res[last].decision_bad_s_mzl_zak_rf;
				fo_summ.needs_verification_all_count += +res[last].needs_verification_all_count;
				fo_summ.needs_verification_week_count += +res[last].needs_verification_week_count;

				fo_summ.warrant_real_check_count_all_count += +res[i].warrant_real_check_count_all_count;
				fo_summ.warrant_real_check_count_week_count += +res[i].warrant_real_check_count_week_count;

				total_summ.placement_all_count += +res[last].placement_all_count;
				total_summ.placement_all_ga += +res[last].placement_all_ga;
				total_summ.placement_week_count += +res[last].placement_week_count;
				total_summ.placement_week_ga += +res[last].placement_week_ga;
				total_summ.entrance_all_count += +res[last].entrance_all_count;
				total_summ.entrance_all_ga += +res[last].entrance_all_ga;
				total_summ.entrance_week_count += +res[last].entrance_week_count;
				total_summ.entrance_week_ga += +res[last].entrance_week_ga;
				total_summ.consideration_all_count += +res[last].consideration_all_count;
				total_summ.consideration_all_ga += +res[last].consideration_all_ga;
				total_summ.consideration_week_count += +res[last].consideration_week_count;
				total_summ.consideration_week_ga += +res[last].consideration_week_ga;
				total_summ.conclusion_consideration_all_count += +res[last].conclusion_consideration_all_count;
				total_summ.conclusion_consideration_all_s_mzl += +res[last].conclusion_consideration_all_s_mzl;
				total_summ.decision_good_count += +res[last].decision_good_count;
				total_summ.decision_good_s_mzl += +res[last].decision_good_s_mzl;
				total_summ.decision_bad_count += +res[last].decision_bad_count;
				total_summ.decision_bad_s_mzl += +res[last].decision_bad_s_mzl;
				total_summ.decision_bad_count_sved_glpm += +res[last].decision_bad_count_sved_glpm;
				total_summ.decision_bad_s_mzl_sved_glpm += +res[last].decision_bad_s_mzl_sved_glpm;
				total_summ.decision_bad_count_mer_glpm += +res[last].decision_bad_count_mer_glpm;
				total_summ.decision_bad_s_mzl_mer_glpm += +res[last].decision_bad_s_mzl_mer_glpm;
				total_summ.decision_bad_count_sved_to += +res[last].decision_bad_count_sved_to;
				total_summ.decision_bad_s_mzl_sved_to += +res[last].decision_bad_s_mzl_sved_to;
				total_summ.decision_bad_count_sved_sansost += +res[last].decision_bad_count_sved_sansost;
				total_summ.decision_bad_s_mzl_sved_sansost += +res[last].decision_bad_s_mzl_sved_sansost;
				total_summ.decision_bad_count_zak_rf += +res[last].decision_bad_count_zak_rf;
				total_summ.decision_bad_s_mzl_zak_rf += +res[last].decision_bad_s_mzl_zak_rf;
				total_summ.needs_verification_all_count += +res[last].needs_verification_all_count;
				total_summ.needs_verification_week_count += +res[last].needs_verification_week_count;

				total_summ.warrant_real_check_count_all_count += +res[i].warrant_real_check_count_all_count;
				total_summ.warrant_real_check_count_week_count += +res[i].warrant_real_check_count_week_count;

				for (var _key3 in fo_summ) {
					if (_key3 !== 'region') fo_summ[_key3] = +_this.floatConvert(fo_summ[_key3]);
				}

				for (var _key4 in total_summ) {
					if (_key4 !== 'region') total_summ[_key4] = +_this.floatConvert(total_summ[_key4]);
				}

				var clone_fo = {}; //клонируем объект для передачи по значению
				for (var _key5 in fo_summ) {
					clone_fo[_key5] = fo_summ[_key5];
				}

				temp_rows.push(clone_fo);

				temp_rows[0] = total_summ;

				_this.rows = temp_rows;
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		this.rows = [];
		this.fillTable(this.start, this.end);

		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on('monitoring-rlh-date', function (date) {
			// console.log('mon',date)
			_this2.fillTable(date.start, date.end);
		});

		var dispay_width = document.documentElement.clientWidth;
		var dispay_height = document.documentElement.clientHeight;
		var scroll_width = 17;

		var ua = navigator.userAgent;
		if (ua.search('OPR/') > 0) {
			scroll_width = 15;
		}

		//const table_width = dispay_width - 30 - scroll_width
		//const col_width = Math.ceil((table_width) / 23)

		document.querySelectorAll('.wide_col').forEach(function (td) {
			td.width = 215;
		});

		document.querySelectorAll('.medium_col').forEach(function (td) {
			td.width = 95;
		});

		//document.querySelector('.m-header-wrapper').width = table_width
		//document.querySelector('.m-body-wrapper').width = table_width
		document.querySelector('.m-body-wrapper').style.maxHeight = dispay_height - 440 + 'px';

		// console.log(dispay_width, col_width, table_width)

		document.querySelector('.m-scroll').width = scroll_width;
		//document.querySelector('.m-body-wrapper').style.paddingRight = `${scroll_width}px`

		var f = false;
		document.querySelector('.m-header-wrapper').addEventListener('scroll', function (e) {
			if (f) {
				f = false;
				return;
			}
			f = true;
			document.querySelector('.m-body-wrapper').scrollLeft = e.target.scrollLeft;
		});
		document.querySelector('.m-body-wrapper').addEventListener('scroll', function (e) {
			if (f) {
				f = false;
				return;
			}
			f = true;
			document.querySelector('.m-header-wrapper').scrollLeft = e.target.scrollLeft;
		});
	},
	updated: function updated() {
		document.querySelectorAll('.wide_col').forEach(function (td) {
			td.width = 215;
		});

		document.querySelectorAll('.medium_col').forEach(function (td) {
			td.width = 95;
		});
	},
	created: function created() {
		/*if(!this.$parent.$parent.reports.some((e) => {
  	return e.id == REPORT_ID
  })) {
  	router.replace('/main')
  }*/

	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('monitoring-rlh-date');
	}
});

/***/ }),

/***/ "jW3/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"npa_violations"},[_c('button',{staticClass:"dropdown-toggle",attrs:{"disabled":_vm.disabled},on:{"click":_vm.toggleModal}},[_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('modal',{attrs:{"backdrop":false,"width":"85%"},model:{value:(_vm.display_npa_modal),callback:function ($$v) {_vm.display_npa_modal=$$v},expression:"display_npa_modal"}},[_c('div',{staticClass:"modal-header",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_c('b',[_vm._v("Акт "+_vm._s(_vm.act_num))])])]),_vm._v(" "),_c('table',{staticClass:"npa-violation-table"},[_c('thead',[_c('th'),_vm._v(" "),_c('th',[_vm._v("НПА")]),_vm._v(" "),_c('th',[_vm._v("Нарушение")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(i){return _c('tr',{key:i.id},[_c('td',{staticClass:"npa-violation-td-checkbox"},[_c('checkbox',{staticClass:"npa-violation-checkbox",attrs:{"type":"info"},on:{"input":function($event){_vm.check(i.id, i.name, i.checked)}},model:{value:(i.checked),callback:function ($$v) {_vm.$set(i, "checked", $$v)},expression:"i.checked"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(i.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(i.violation))])])}))]),_vm._v(" "),_c('div',{staticClass:"modal-footer",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"btn btn-default small-button",on:{"click":function($event){_vm.display_npa_modal = false}}},[_vm._v("Закрыть")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jXty":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr'),_vm._v(" "),_c('div',{staticClass:"m-header-wrapper"},[_c('table',{staticClass:"m-header"},[_c('thead',{staticClass:"bold"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('tr',[_c('td',{staticClass:"m-td"},[_vm._v("c 01.01."+_vm._s(_vm.endYear)+" по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("отчётный период (c "+_vm._s(_vm.start)+" по "+_vm._s(_vm.end)+")")]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("c 01.01."+_vm._s(_vm.endYear)+" по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("отчётный период (c "+_vm._s(_vm.start)+" по "+_vm._s(_vm.end)+")")]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("c 01.01."+_vm._s(_vm.endYear)+" по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("отчётный период (c "+_vm._s(_vm.start)+" по "+_vm._s(_vm.end)+")")]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("c 01.01."+_vm._s(_vm.endYear)+" по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("отчётный период (c "+_vm._s(_vm.start)+" по "+_vm._s(_vm.end)+")")]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("c 01.01."+_vm._s(_vm.endYear)+" по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("отчётный период (c "+_vm._s(_vm.start)+" по "+_vm._s(_vm.end)+")")]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("c 01.01."+_vm._s(_vm.endYear)+" по "+_vm._s(_vm.end))]),_vm._v(" "),_c('td',{staticClass:"m-td"},[_vm._v("отчётный период (c "+_vm._s(_vm.start)+" по "+_vm._s(_vm.end)+")")])]),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"m-body-wrapper"},[_c('table',{staticClass:"m-body"},[_c('tbody',_vm._l((_vm.rows),function(row,i){return _c('tr',[(row.flag)?_c('td',{attrs:{"colspan":"13"}},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(row.fo))])]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"left m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.region))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.placement_all))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.placement_week))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.entrance_all))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.entrance_week))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.sending_conclusion_all))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.sending_conclusion_week))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_false_all))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""},[_vm._v(_vm._s(row.decision_false_week))]):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""}):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""}):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""}):_vm._e(),_vm._v(" "),(!row.flag)?_c('td',{staticClass:"right m-td",class:(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""}):_vm._e()])}))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"m-td",attrs:{"rowspan":"3"}},[_vm._v("Субъекты, федеральные округа")]),_vm._v(" "),_c('td',{attrs:{"colspan":"12"}},[_vm._v("Количество актов ЛПО")]),_vm._v(" "),_c('td',{staticClass:"m-scroll",attrs:{"rowspan":"4"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"2"}},[_vm._v("Размещённых на сайтах")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("Поступивших на заключение")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("По которым были направлены заключения")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("в т.ч. отрицательных заключений")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("Снятых с сайта")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("Находящихся на сайте на конец периода мониторинга размещённых")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("2")]),_vm._v(" "),_c('td',[_vm._v("3")]),_vm._v(" "),_c('td',[_vm._v("4")]),_vm._v(" "),_c('td',[_vm._v("5")]),_vm._v(" "),_c('td',[_vm._v("6")]),_vm._v(" "),_c('td',[_vm._v("7")]),_vm._v(" "),_c('td',[_vm._v("8")]),_vm._v(" "),_c('td',[_vm._v("9")]),_vm._v(" "),_c('td',[_vm._v("10")]),_vm._v(" "),_c('td',[_vm._v("11")]),_vm._v(" "),_c('td',[_vm._v("12")]),_vm._v(" "),_c('td',[_vm._v("13")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "juAD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_groupConclusionForm_vue__ = __webpack_require__("9Zs4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_166ea6e7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_groupConclusionForm_vue__ = __webpack_require__("mvGh");
function injectStyle (ssrContext) {
  __webpack_require__("lbft")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_groupConclusionForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_166ea6e7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_groupConclusionForm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k5om":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WarrantsCount_vue__ = __webpack_require__("+XBq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c5ce538_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_WarrantsCount_vue__ = __webpack_require__("3Y0u");
function injectStyle (ssrContext) {
  __webpack_require__("kOFz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c5ce538"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WarrantsCount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c5ce538_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_WarrantsCount_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kEvE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lpoReason_vue__ = __webpack_require__("MZAy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_042a7972_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_lpoReason_vue__ = __webpack_require__("lIDv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lpoReason_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_042a7972_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_lpoReason_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kF6s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth__ = __webpack_require__("SQ6o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fetch_data_npaViolations__ = __webpack_require__("qm+7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fetch_data_actsNumsSelector__ = __webpack_require__("2MEK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_css_fontawesome_all_min_css__ = __webpack_require__("ThaU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_css_fontawesome_all_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__lib_css_fontawesome_all_min_css__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var GET_FO = 'get_fo.php';
var GET_REGIONS = 'region_list.php';
var GET_ACTS_NUMS = 'get_acts_nums.php';
var GET_JOURNAL_FILTER = 'get_journal_filter.php';
var GET_WARRANT_LOCATIONS = 'get_warrant_locations.php';
var DOCS = 'get_official_docs.php';
var REASON = 'get_decision_reason.php';

var PRINT_WARRANT = 'warrant_report.php';
var PRINT_DOCUMENT_CHECK = 'document_check_report.php';

var UPDATE_JSON = 'update_json.php';



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'warrantGroupForm',
    data: function data() {
        return {
            scroll_width: 17,
            letter_num: '',
            letter_date: __WEBPACK_IMPORTED_MODULE_9_moment___default()().format('DD.MM.YYYY'),
            fo_list: [],
            fo_id: 0,
            regions_list: [],
            region_id: 0,
            year: null,
            display_acts_modal: false,

            acts_nums_is_loading: false,
            acts_is_loading: false,

            selected_acts_ids: [],
            warrant_locations: [],

            acts_nums_is_loaded: false,
            act_num_to_search: '',
            acts_nums: [],
            act_placement_date: '',
            display_nums_hint: false,
            //similar_nums: [],
            found_acts: [],
            official_docs: [],
            hovered_act_in_found: false,
            selected_act_in_found: false,

            readonly: false,
            submit_disabled: false,

            f_51: '',
            f_52: '',

            f_54: '',
            f_55: '',

            f_57: '',
            f_58: '',

            f_71: '',
            f_72: '',
            f_73: '',

            f_92: [],

            f_87: null,

            decisions: [],
            errorDecisionReason: false
        };
    },
    components: {
        datepicker: __WEBPACK_IMPORTED_MODULE_8_vue_strap__["datepicker"], modal: __WEBPACK_IMPORTED_MODULE_8_vue_strap__["modal"], npaViolations: __WEBPACK_IMPORTED_MODULE_10__fetch_data_npaViolations__["a" /* default */], actsNumsSelector: __WEBPACK_IMPORTED_MODULE_11__fetch_data_actsNumsSelector__["a" /* default */], dropdown: __WEBPACK_IMPORTED_MODULE_8_vue_strap__["dropdown"]
    },
    computed: {
        actsWithPositiveDecision: function actsWithPositiveDecision() {
            return this.warrant_locations.filter(function (e) {
                return e.main_decision == 1 || e.main_decision == 't';
            });
        },
        actsWithNegativeDecision: function actsWithNegativeDecision() {
            return this.warrant_locations.filter(function (e) {
                return e.main_decision == 0 || e.main_decision == 'f';
            });
        },
        actsWithoutDecision: function actsWithoutDecision() {
            return this.warrant_locations.filter(function (e) {
                return e.main_decision == 2 || e.main_decision === null;
            });
        },
        checkedPositiveActs: function checkedPositiveActs() {
            return this.actsWithPositiveDecision.filter(function (e) {
                return e.checked;
            });
        },
        checkedNegativeActs: function checkedNegativeActs() {
            return this.actsWithNegativeDecision.filter(function (e) {
                return e.checked;
            });
        },
        checkedNeutralActs: function checkedNeutralActs() {
            return this.actsWithoutDecision.filter(function (e) {
                return e.checked;
            });
        },
        npaDisabled: function npaDisabled() {
            return !this.actsWithNegativeDecision.some(function (e) {
                return e.f_79 == 0;
            });
        }
    },
    methods: {
        formSubmit: function formSubmit() {},
        updateViolations: function updateViolations() {
            this.checkF125Field();
        },
        checkedToNegative: function checkedToNegative() {
            var neutralActs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var clone = this.warrant_locations.slice();
            for (var i in clone) {
                if (clone[i].checked) {
                    if (neutralActs !== true || neutralActs === true && clone[i].main_decision == 2) {
                        clone[i].main_decision = 0;
                        //clone[i].f_81 = 0
                        clone[i].checked = false;
                    }
                }
            }
            this.warrant_locations = clone;
            this.checkF125Field();
        },
        checkedToPositive: function checkedToPositive() {
            var neutralActs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var clone = this.warrant_locations.slice();
            for (var i in clone) {
                if (clone[i].checked) {
                    if (neutralActs !== true || neutralActs === true && clone[i].main_decision == 2) {
                        clone[i].main_decision = 1;
                        clone[i].f_125 = null;
                        //clone[i].f_81 = 1
                        clone[i].checked = false;
                    }
                }
            }
            this.warrant_locations = clone;
        },
        deleteCheckedActsFromNegative: function deleteCheckedActsFromNegative() {
            var ids_to_delete = {};
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.checkedNegativeActs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var location = _step.value;

                    ids_to_delete[location.f_p] = true;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            ids_to_delete = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(ids_to_delete);
            this.selected_acts_ids = this.selected_acts_ids.filter(function (e) {
                return !ids_to_delete.includes(e);
            });
            this.warrant_locations = this.warrant_locations.filter(function (e) {
                return !ids_to_delete.includes(e.f_p);
            });
        },
        deleteCheckedActsFromPositive: function deleteCheckedActsFromPositive() {
            var ids_to_delete = {};
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.checkedPositiveActs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var location = _step2.value;

                    ids_to_delete[location.f_p] = true;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            ids_to_delete = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(ids_to_delete);
            this.selected_acts_ids = this.selected_acts_ids.filter(function (e) {
                return !ids_to_delete.includes(e);
            });
            this.warrant_locations = this.warrant_locations.filter(function (e) {
                return !ids_to_delete.includes(e.f_p);
            });
        },
        deleteCheckedActsFromNeutral: function deleteCheckedActsFromNeutral() {
            var ids_to_delete = {};
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.checkedNeutralActs), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var location = _step3.value;

                    ids_to_delete[location.f_p] = true;
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            ids_to_delete = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(ids_to_delete);
            this.selected_acts_ids = this.selected_acts_ids.filter(function (e) {
                return !ids_to_delete.includes(e);
            });
            this.warrant_locations = this.warrant_locations.filter(function (e) {
                return !ids_to_delete.includes(e.f_p);
            });
        },
        getNpaDisabledForAct: function getNpaDisabledForAct(act_id) {
            var found = this.actsWithNegativeDecision.filter(function (e) {
                return e.f_p == act_id;
            });
            if (found) {
                //console.warn(act_id, !found.some(e => e.f_79 == 0))
                return !found.some(function (e) {
                    return e.f_79 == 0;
                });
            }
            return true;
        },
        getNpaForAct: function getNpaForAct(act_id) {
            var act_info = this.f_92.filter(function (e) {
                return e.id == act_id;
            });
            if (act_info && act_info[0]) return act_info[0].npa;else return [];

            //return act_info ? act_info[0].npa : []
        },
        actCheckChange: function actCheckChange(e, act_id) {
            var checkbox_state = e.target.checked;
            var clone = this.warrant_locations.slice();

            for (var i in clone) {
                if (clone[i].f_p == act_id) {
                    clone[i].checked = checkbox_state;
                }
            }
            this.warrant_locations = clone;
        },
        idToBoolean: function idToBoolean(id) {
            if (id != '2') {
                return id == '1';
            } else return null;
        },
        printWarrant: function printWarrant() {
            var ids = this.selected_acts_ids.join(',');
            window.location.href = __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DB */] + PRINT_WARRANT + '?ids=' + ids + '&type=' + this.f_71 + '&fo=' + this.fo_id;
        },
        printDocumentCheck: function printDocumentCheck() {
            var ids = this.selected_acts_ids.join(',');
            window.location.href = __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DB */] + PRINT_DOCUMENT_CHECK + '?ids=' + ids + '&date=' + this.f_57 + '&num=' + this.f_58 + '&fo=' + this.fo_id + '&region=' + this.region_id;
        },
        submit: function submit(f_75) {
            var _this = this;

            if (document.querySelector('.field-error-warrant') !== null) {
                alert('Часть полей содержит некорректные данные. Сохранение невозможно');
                return;
            }

            if (document.querySelector('.field-error-warrant-optional') !== null) {
                var answer = confirm('Часть полей может содержать некорректную информацию. Вы уверены, что хотите сохранить?');
                if (!answer) return;
            }
            this.submit_disabled = true;

            var obj = [];
            var counter = 0;

            var _loop = function _loop(act_id) {
                obj.push({});
                obj[counter].tab_id = 1;
                obj[counter].f_v = {};
                obj[counter].f_v.f_c = act_id;

                obj[counter].f_v.f_51 = _this.f_51;
                obj[counter].f_v.f_52 = _this.f_52;

                if (_this.f_54) obj[counter].f_v.f_54 = _this.f_54;
                obj[counter].f_v.f_55 = _this.f_55;

                obj[counter].f_v.f_57 = _this.f_57 || null;
                obj[counter].f_v.f_58 = _this.f_58;

                if (_this.isActIsPositive(act_id)) {
                    obj[counter].f_v.f_71 = null;
                    obj[counter].f_v.f_73 = null;
                    obj[counter].f_v.f_72 = null;
                } else if (_this.isActIsNegative(act_id)) {
                    obj[counter].f_v.f_71 = _this.f_71;
                    if (_this.f_72) obj[counter].f_v.f_72 = _this.f_72;
                    obj[counter].f_v.f_73 = _this.f_73;
                }

                obj[counter].f_v.f_75 = f_75;

                obj[counter].f_v.f_87 = __WEBPACK_IMPORTED_MODULE_7__auth__["a" /* default */].user.id;

                var found_npa = _this.f_92.find(function (e) {
                    return e.id == act_id;
                });
                if (found_npa && !_this.getNpaDisabledForAct(act_id)) obj[counter].f_v.f_92 = '{' + found_npa.npa.join(',') + '}';

                if (_this.isActIsPositive(act_id)) obj[counter].f_v.f_69 = 1;else if (_this.isActIsNegative(act_id)) obj[counter].f_v.f_69 = 0;

                obj[counter].f_v.f_125 = _this.warrant_locations.find(function (e) {
                    return e.f_p == act_id;
                }).f_125 || null;

                counter++;
            };

            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.selected_acts_ids), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var act_id = _step4.value;

                    _loop(act_id);
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.warrant_locations), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var location = _step5.value;

                    obj.push({});
                    obj[counter].tab_id = 2;
                    obj[counter].f_v = {};
                    obj[counter].f_v.f_c = location.f_c;

                    obj[counter].f_v.f_76 = this.idToBoolean(location.f_76);
                    obj[counter].f_v.f_77 = this.idToBoolean(location.f_77);
                    obj[counter].f_v.f_78 = this.idToBoolean(location.f_78);
                    obj[counter].f_v.f_79 = this.idToBoolean(location.f_79);
                    obj[counter].f_v.f_80 = this.idToBoolean(location.f_80);
                    obj[counter].f_v.f_81 = this.idToBoolean(location.f_81);

                    counter++;
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            var form = new FormData();
            form.append('json', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(obj));

            fetch(__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DB */] + UPDATE_JSON, {
                credentials: 'include',
                method: 'post',
                body: form
            }).then(function (result) {
                return result.json();
            }).then(function (result) {
                if (result[0].code === '0') {
                    alert('Предписание на группу актов сохранено');

                    /*if(this.$parent.lastJournalURL)
                        router.replace(this.$parent.lastJournalURL)
                    else
                        router.replace('/main')*/
                } else {
                    alert(result[0].name);
                }
                _this.submit_disabled = false;
            }).catch(function (err) {
                return console.log(err);
            });
        },
        handle125Change: function handle125Change(event, act_id) {
            for (var i in this.warrant_locations) {
                if (this.warrant_locations[i].f_p == act_id) {
                    this.warrant_locations[i].f_125 = event.target.value;
                }
            }
            this.checkF125Field();
        },
        checkF125Field: function checkF125Field() {
            var locations = [];
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.warrant_locations), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var loc = _step6.value;

                    for (var i = 76; i <= 80; i++) {
                        if (loc['f_' + i] == 0) {
                            if (!locations[loc.f_p]) {
                                locations[loc.f_p] = {};
                            }
                            locations[loc.f_p][i] = true;
                        }
                    }
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            for (var loc_id in this.warrant_locations) {
                var act_id = this.warrant_locations[loc_id].f_p;
                if (!this.warrant_locations[loc_id].f_125) this.warrant_locations[loc_id].errorDecisionReason = true;
                if (this.warrant_locations[loc_id].f_125 == 1) this.warrant_locations[loc_id].errorDecisionReason = locations[act_id] ? !locations[act_id][79] : true;
                if (this.warrant_locations[loc_id].f_125 == 2) this.warrant_locations[loc_id].errorDecisionReason = locations[act_id] ? !locations[act_id][78] : true;
                if (this.warrant_locations[loc_id].f_125 == 3) this.warrant_locations[loc_id].errorDecisionReason = locations[act_id] ? !locations[act_id][76] : true;
                if (this.warrant_locations[loc_id].f_125 == 4) this.warrant_locations[loc_id].errorDecisionReason = locations[act_id] ? !locations[act_id][77] : true;
            }
        },
        test: function test() {
            console.warn(this.warrant_locations);
            console.warn(this.actsWithPositiveDecision);
            console.warn(this.actsWithNegativeDecision);
            /*console.warn(this.actsWithPositiveDecision.filter(e => {
                return e.checked
            }))
            console.warn(this.checkedPositiveActs)*/
            //console.warn(this.actsWithPositiveDecision)
        },
        hideActsModal: function hideActsModal() {
            var _this2 = this;

            this.display_acts_modal = false;
            setTimeout(function () {
                _this2.hovered_act_in_found = false;
                _this2.selected_act_in_found = false;
                _this2.act_num_to_search = '';
                _this2.display_nums_hint = false;
                _this2.similar_nums = [];
                _this2.found_acts = [];
            }, 300);
        },
        isActInBasket: function isActInBasket(act_id) {
            return this.selected_acts_ids.includes(act_id);
        },
        isActIsPositive: function isActIsPositive(act_id) {
            return this.actsWithPositiveDecision.filter(function (e) {
                return e.f_p == act_id;
            }).length > 0;
        },
        isActIsNegative: function isActIsNegative(act_id) {
            return this.actsWithNegativeDecision.filter(function (e) {
                return e.f_p == act_id;
            }).length > 0;
        },
        addAllActsToBasket: function addAllActsToBasket() {
            this.selected_acts_ids = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(this.found_acts.map(function (e) {
                return e.id;
            }))));
            this.addActToBasket(false);
        },
        addActToBasket: function addActToBasket() {
            var _this3 = this;

            var add_id_to_selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            if (add_id_to_selected) this.selected_acts_ids.push(this.selected_act_in_found);

            var joined_ids = '{' + this.selected_acts_ids.join(',') + '}';
            fetch('' + __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DB */] + GET_WARRANT_LOCATIONS + '?ids=' + joined_ids, { credentials: 'include' }).then(function (res) {
                return res.json();
            }).then(function (json) {
                var temp_lines = [];
                var length = json.length;

                var prev_id = -1;
                var prev_localforestry_id = -1;
                var prev_subforestry_id = -1;

                var _loop2 = function _loop2(i) {
                    var location = {};

                    var start_fo = i;
                    while (i > 0 && json[start_fo - 1].f_p === json[i].f_p && start_fo > 1) {
                        start_fo--;
                    }

                    var curr = start_fo;
                    while (curr < json.length && json[curr].f_p === json[start_fo].f_p) {
                        curr++;
                    }
                    location.count = curr - start_fo;

                    if (json[i].f_p === prev_id) {
                        location.flag = false;
                    } else {
                        location.flag = true;
                    }

                    var start_lf = i;
                    while (i > 0 && json[start_lf - 1].f_20 === json[i].f_20 && start_lf > 1 && json[start_lf - 1].f_p === json[i].f_p) {
                        start_lf--;
                    }

                    var curr_lf = start_lf;
                    while (curr_lf < json.length && json[curr_lf].f_p === json[start_lf].f_p && json[curr_lf].f_20 === json[i].f_20) {
                        curr_lf++;
                    }
                    location.count_lf = curr_lf - start_lf;

                    if (json[i].f_p === prev_id && prev_localforestry_id === json[i].f_20) {
                        location.flag_lf = false;
                    } else {
                        location.flag_lf = true;
                    }

                    ////////////////////////
                    var start_sf = i;
                    while (i > 0 && json[start_sf - 1].f_27 === json[i].f_27 && start_sf > 1 && json[start_sf - 1].f_p === json[i].f_p) {
                        start_sf--;
                    }

                    var curr_sf = start_sf;
                    while (curr_sf < json.length && json[curr_sf].f_p === json[start_sf].f_p && json[curr_sf].f_27 === json[i].f_27) {
                        curr_sf++;
                    }
                    location.count_sf = curr_sf - start_sf;

                    if (json[i].f_p === prev_id && prev_subforestry_id === json[i].f_27) {
                        location.flag_sf = false;
                    } else {
                        location.flag_sf = true;
                    }

                    prev_id = json[i].f_p;
                    prev_localforestry_id = json[i].f_20;
                    prev_subforestry_id = json[i].f_27;

                    location = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(location, json[i]);

                    if (!_this3.f_92.filter(function (e) {
                        return e.id == json[i].f_p;
                    }).length && json[i].f_92) {
                        _this3.f_92.push({
                            id: json[i].f_p,
                            npa: json[i].f_92.slice(1, -1).split(',')
                        });
                    }

                    temp_lines.push(location);
                };

                for (var i = 0; i < length; i++) {
                    _loop2(i);
                }
                //

                for (var i in temp_lines) {
                    for (var j = 76; j <= 80; j++) {
                        temp_lines[i]['f_' + j] = temp_lines[i]['f_' + j] ? temp_lines[i]['f_' + j] === 't' ? 1 : 0 : 2;
                    }
                    if (temp_lines[i]['f_69']) temp_lines[i]['f_81'] = temp_lines[i]['f_69'] === 't' ? 1 : 0;else temp_lines[i]['f_81'] = temp_lines[i]['f_41'] ? temp_lines[i]['f_41'] === 't' ? 1 : 0 : 2;

                    temp_lines[i].main_decision = temp_lines[i]['f_81'];

                    temp_lines[i]['f_91'] = temp_lines[i]['f_91'] ? temp_lines[i]['f_91'] === 't' ? true : false : false;
                }

                _this3.warrant_locations = temp_lines;
            });
        },
        mouseOverActInFound: function mouseOverActInFound(act_id) {
            this.hovered_act_in_found = act_id;
        },
        selectActInFound: function selectActInFound(act_id) {
            this.selected_act_in_found = act_id;
        },
        changeSearchIds: function changeSearchIds(data) {
            //console.warn(data)
            this.act_placement_date = data.date;
            this.act_num_to_search = data.nums;
        },
        findActs: function findActs() {
            var _this4 = this;

            this.acts_is_loading = true;
            this.selected_act_in_found = false;
            var act_num_to_search_quoted = this.act_num_to_search.map(function (e) {
                return "'" + e + "'";
            });

            var filter = '(fo_id = ' + this.fo_id + ' and region_id = ' + this.region_id;
            if (this.act_num_to_search.length) filter += ' and num in (' + act_num_to_search_quoted.join(',') + ')';
            if (this.year) filter += ' and act_placement_date >= \'01.01.' + this.year + '\' and act_placement_date <= \'31.12.' + this.year + '\'';
            if (this.act_placement_date) filter += ' and act_placement_date = \'' + this.act_placement_date + '\'';
            filter += ')';

            fetch('' + __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DB */] + GET_JOURNAL_FILTER + '?filter=' + filter + '&start=1&rows=9999', { credentials: 'include' }).then(function (res) {
                return res.json();
            }).then(function (res) {
                _this4.acts_is_loading = false;
                var temp_lines = [];
                var length = res.length - 1;

                var prev_id = -1;
                var prev_localforestry_id = -1;
                var prev_subforestry_id = -1;

                for (var i = 0; i < length; i++) {
                    var act = {};

                    var _start_fo = i;
                    while (i > 0 && res[_start_fo - 1].act_id === res[i].act_id && _start_fo > 1) {
                        _start_fo--;
                    }

                    var _curr = _start_fo;
                    while (_curr < res.length && res[_curr].act_id === res[_start_fo].act_id) {
                        _curr++;
                    }
                    act.count = _curr - _start_fo;

                    if (res[i].act_id === prev_id) {
                        act.flag = false;
                    } else {
                        act.flag = true;
                    }
                    //////////////////

                    var _start_lf = i;
                    while (i > 0 && res[_start_lf - 1].localforestry_id === res[i].localforestry_id && _start_lf > 1 && res[_start_lf - 1].act_id === res[i].act_id) {
                        _start_lf--;
                    }

                    var _curr_lf = _start_lf;
                    while (_curr_lf < res.length && res[_curr_lf].act_id === res[_start_lf].act_id && res[_curr_lf].localforestry_id === res[i].localforestry_id) {
                        _curr_lf++;
                    }
                    act.count_lf = _curr_lf - _start_lf;

                    if (res[i].act_id === prev_id && prev_localforestry_id === res[i].localforestry_id) {
                        act.flag_lf = false;
                    } else {
                        act.flag_lf = true;
                    }

                    ////////////////////////
                    var _start_sf = i;
                    while (i > 0 && res[_start_sf - 1].localforestry_id === res[i].localforestry_id && _start_sf > 1 && res[_start_sf - 1].act_id === res[i].act_id) {
                        _start_sf--;
                    }

                    var _curr_sf = _start_sf;
                    while (_curr_sf < res.length && res[_curr_sf].act_id === res[_start_sf].act_id && res[_curr_sf].localforestry_id === res[i].localforestry_id) {
                        _curr_sf++;
                    }
                    act.count_sf = _curr_sf - _start_sf;

                    if (res[i].act_id === prev_id && prev_localforestry_id === res[i].localforestry_id) {
                        act.flag_sf = false;
                    } else {
                        act.flag_sf = true;
                    }

                    prev_id = res[i].act_id;
                    prev_localforestry_id = res[i].localforestry_id;
                    prev_subforestry_id = res[i].subforestry_id;

                    act.id = res[i].act_id;
                    act.num = res[i].num;
                    act.act_placement_date = res[i].act_placement_date ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(res[i].act_placement_date, 'YYYY-MM-DD').format('DD.MM.YYYY') : '';
                    //act.url = res[i].url
                    act.fo = res[i].fo;
                    act.region = res[i].region;
                    act.forestry = res[i].forestry;
                    act.localforestry = res[i].localforestry;
                    act.subforestry = res[i].subforestry;
                    act.area = res[i].area;
                    act.section = res[i].section;
                    act.section_lp = res[i].section_lp;
                    //act.conclusion_date = res[i].conclusion_date ? moment(res[i].conclusion_date, 'YYYY-MM-DD').format('DD.MM.YYYY') : '';
                    //act.conclusion_num = res[i].conclusion_num;
                    //act.selected = false

                    temp_lines.push(act);
                }

                _this4.found_acts = temp_lines;
                _this4.found_acts.length;
            });
        },
        showActsModal: function showActsModal() {
            this.display_acts_modal = true;
        },
        loadOfficialDocs: function loadOfficialDocs() {
            var _this5 = this;

            fetch('' + __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DB */] + DOCS, {
                credentials: 'include'
            }).then(function (data) {
                return data.json();
            }).then(function (data) {
                _this5.official_docs = data;
                _this5.f_71 = _this5.official_docs[0].id;
            });
        },
        loadFoList: function loadFoList() {
            var _this6 = this;

            fetch('' + __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DB */] + GET_FO).then(function (res) {
                return res.json();
            }).then(function (json) {
                _this6.fo_list = json;
            });
        },
        loadRegionsList: function loadRegionsList(fo_id) {
            var _this7 = this;

            fetch('' + __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DB */] + GET_REGIONS + '?id=' + fo_id, { credentials: 'include' }).then(function (res) {
                return res.json();
            }).then(function (json) {
                _this7.regions_list = json;
            });
        },
        foChange: function foChange() {
            if (this.fo_id) {
                this.region_id = 0;
                this.loadRegionsList(this.fo_id);
            }
        },
        regionChange: function regionChange() {
            if (this.region_id) {
                this.acts_nums_is_loaded = false;
                this.getActsNums();
            }
        },
        yearChange: function yearChange() {
            if (this.year && this.region_id) {
                this.acts_nums_is_loaded = false;
                this.getActsNums();
            }
        },
        getActsNums: function getActsNums() {
            var _this8 = this;

            this.acts_nums_is_loading = true;
            this.selected_act_in_found = false;
            var filter = '(fo_id = ' + this.fo_id + ' and region_id = ' + this.region_id;
            if (this.year) filter += ' and act_placement_date >= \'01.01.' + this.year + '\' and act_placement_date <= \'31.12.' + this.year + '\'';
            filter += ')';

            fetch('' + __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DB */] + GET_ACTS_NUMS + '?filter=' + filter).then(function (res) {
                return res.json();
            }).then(function (json) {
                _this8.acts_nums_is_loading = false;
                _this8.acts_nums = json || [];
                _this8.acts_nums_is_loaded = true;
            });
        },
        handleNpaChange: function handleNpaChange(data, act_id) {
            var f = false;
            for (var i in this.f_92) {
                if (this.f_92[i].id == act_id) {
                    this.f_92[i].npa = data;
                    f = true;
                }
            }
            if (!f) {
                this.f_92.push({
                    id: act_id,
                    npa: data
                });
            }
            //console.warn(this.f_92)
            //this.f_92 = ids
        },
        loadDecisions: function loadDecisions() {
            var _this9 = this;

            fetch(__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DB */] + REASON, {
                credentials: 'include'
            }).then(function (res) {
                return res.json();
            }).then(function (res) {
                _this9.decisions = res;
            });
        }
    },
    mounted: function mounted() {
        this.loadFoList();
        this.loadOfficialDocs();
        this.loadDecisions();
    },
    beforeDestroy: function beforeDestroy() {}
});

/***/ }),

/***/ "kOFz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l6fI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_conclusionUser_vue__ = __webpack_require__("4jb0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1d22392_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_conclusionUser_vue__ = __webpack_require__("Dyyd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_conclusionUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1d22392_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_conclusionUser_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lIDv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lKmh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lOxY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var REGION = 'region_list.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'region',
	data: function data() {
		return {
			selected: '0',
			options: [],
			id: this.type + '_region',
			k: this.set_id
		};
	},
	props: {
		type: '',
		set_id: '',
		field_class: '',
		region_id: null
	},
	watch: {
		region_id: function region_id(val) {
			this.selected = val;
		}
	},
	methods: {
		fill: function fill(select) {
			var _this = this;

			//console.log(id)
			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + REGION, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.options = [{ id: '0', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
					_this.selected = _this.region_id ? _this.region_id : '0';
				} else {
					_this.options = [];
				}
			}).catch(function (err) {
				return console.log(err);
			});
		},
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit(this.type + '_region', this.selected);
		}
	},
	mounted: function mounted() {
		this.fill();
	}
});

/***/ }),

/***/ "lbft":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mGXz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var OZU = 'get_ozu.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'protectiveCatExt',
	data: function data() {
		return {
			selected: '',
			options: []
		};
	},
	props: {
		line_count: 0,
		type: '',
		id: null
	},
	watch: {
		id: function id(val) {
			if (val) {
				this.selected = val;
			}
		}
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit(this.type + '_protective_cat_ext', { index: this.line_count, value: this.selected });
		},
		fill: function fill() {
			var _this = this;

			fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + OZU, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.options = data;
					_this.selected = _this.id ? _this.id : data[0].id;
				} else {
					_this.options = [];
					_this.selected = null;
				}
				_this.change();
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	created: function created() {
		//EventBus.$on(`${this.type}_protective_cat_${this.line_count}`, id => {
		//	this.fill(id)
		//})

		this.fill();
	},
	beforeDestroy: function beforeDestroy() {
		//EventBus.$off(`${this.type}_protective_cat_${this.line_count}`)
	}
});

/***/ }),

/***/ "mXRx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mrkg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var FILTER = 'get_filter.php';
var LIST_OFFSET = 20;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'FilterDateRange',
	data: function data() {
		return {
			from: '',
			to: '',
			all_items: [],
			items: [],
			offset: 0,
			sel: true,
			val: false,
			filtered: false,
			saved_items: [],
			loading: false,
			text: '',
			scrollDebounce: false,
			FILTER: null,
			flag: false
		};
	},

	props: ['name', 'field', 'filter', 'suffix', 'wideWindow', 'rightAlign'],
	components: {
		dropdown: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["dropdown"],
		checkbox: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["checkbox"],
		datepicker: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["datepicker"]
	},
	watch: {
		sel: function sel(e) {
			this.all_items.map(function (t) {
				t.checked = e;
			});
		},
		text: function text(s) {
			if (s && s.length) {
				this.items = [];
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.all_items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var line = _step.value;

						var needle = s.toLowerCase();
						if (line.value.toLowerCase().indexOf(needle) !== -1) {
							var temp_line = line;
							var regexp = new RegExp('(' + needle + ')', "i");
							temp_line.show_value = temp_line.value.replace(regexp, '<span class="needle">$1</span>');
							this.items.push(temp_line);
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				this.setCheckedToItems();
			} else {
				this.items = this.all_items.slice(0, this.offset);
			}
			this.$forceUpdate();
		}
	},
	methods: {
		checkboxInput: function checkboxInput(value, rank) {
			//console.warn(value, rank)
			//const
			//for(let i in this.all_items)
			//	if(this.all_items[i].dense_rank == rank)

			//console.warn(value, rank)

			this.all_items[+rank].checked = value;

			var result = [];
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.all_items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var item = _step2.value;

					if (item.checked) result.push(item.value);
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			this.filtered = result.length !== this.all_items.length && result.length !== 0;
			//EventBus.$emit('filter' + (this.suffix ? this.suffix : ''), {field: this.field, value: this.filtered ? result : [], filtered: this.filtered})

			//console.warn(this.all_items[81])
		},
		setCheckedToItems: function setCheckedToItems() {
			for (var i = 0; i < this.items.length; i++) {
				//if (typeof this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')] !== 'undefined') {
				/*this.sel = false
    this.items[i].checked = false
    let flag = false
    for (let j = 0; j < this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')].value.length; j++) {
    	if (this.items[i].value === this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')].value[j]) {
    		this.items[i].checked = true
    		flag = true
    	}
    	else if (!flag) {
    		this.items[i].checked = false
    		flag = false
    	}
    }*/
				// else {
				//	const rank = this.items[i].rank
				//	this.items[i].checked = this.sel ? true : this.all_items[+rank].checked
				//}
			}
		},
		listScrollHandler: function listScrollHandler(e) {
			var _this = this;

			if (this.text) return false;

			if (this.scrollDebounce) {
				setTimeout(function () {
					_this.scrollDebounce = false;
					_this.listScrollHandler(e);
				}, 500);
				return false;
			}

			if (e.target.scrollTop + e.target.clientHeight + 100 >= e.target.scrollHeight && this.offset < this.all_items.length) {
				this.scrollDebounce = true;
				setTimeout(function () {
					return _this.scrollDebounce = false;
				}, 500);

				this.offset += LIST_OFFSET;
				this.items = this.all_items.slice(0, this.offset);
				this.setCheckedToItems();
			}
		},
		ok: function ok() {
			this.val = false;
			this.text = '';
			var result = [];

			result.push(this.from, this.to);
			this.filtered = true;

			__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$emit('filter' + (this.suffix ? this.suffix : ''), { field: this.field, value: this.filtered ? result : [], filtered: this.filtered });
			__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$emit('filter' + (this.suffix ? this.suffix : '') + '_list', { field: this.field, value: this.filtered ? result : [], filtered: this.filtered });
		},
		cancel: function cancel() {
			this.val = false;
		},
		open: function open(show) {
			if (show) {
				if (typeof this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')] !== 'undefined') {
					var _$parent$$parent$sele = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')].value, 2);

					this.from = _$parent$$parent$sele[0];
					this.to = _$parent$$parent$sele[1];
				}
			}
		},
		fill: function fill() {
			var _this2 = this;

			fetch(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DB */] + this.FILTER + '?field=' + this.field + '&filter=').then(function (res) {
				return res.json();
			}).then(function (res) {
				if (res) {
					var arr = res.map(function (r) {
						return {
							value: r[_this2.field] ? _this2.field !== 'act_placement_date' ? r[_this2.field] : __WEBPACK_IMPORTED_MODULE_5_moment___default()(r[_this2.field], 'YYYY-MM-DD').format('DD.MM.YYYY') : '',
							checked: true
						};
					});
					_this2.all_items = arr;
				} else {
					_this2.all_items = [];
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	created: function created() {
		var _this3 = this;

		if (typeof this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')] !== 'undefined') {
			this.filtered = this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')].filtered;
		} else {
			this.saved_items = [];
		}

		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$on('clearFilters' + (this.suffix ? this.suffix : ''), function (f) {
			_this3.filtered = false;
			_this3.sel = true;
			_this3.all_items = [];
			_this3.fill();
			__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$emit('filter' + (_this3.suffix ? _this3.suffix : ''), { field: _this3.field, value: [], filtered: false, cf: true });
			__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$emit('filter' + (_this3.suffix ? _this3.suffix : '') + '_list', { field: _this3.field, value: [], filtered: false, cf: true });
		});
	},
	mounted: function mounted() {
		this.FILTER = 'get_filter' + (this.suffix ? this.suffix : '') + '.php';
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$off('clearFilters' + (this.suffix ? this.suffix : ''));
	}
});

/***/ }),

/***/ "mtrZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control",class:_vm.field_class,on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mvGh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selected_act)?_c('form',{staticClass:"form",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();_vm.submit($event)}}},[_c('h4',[_vm._v("Заключение на группу актов ЛПО")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1 col"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_act),expression:"selected_act"}],staticClass:"form-control form-control my-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected_act=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.group_acts),function(act){return _c('option',{domProps:{"value":act.act_id}},[_vm._v("\n\t\t\t\t\t"+_vm._s(act.act_num)+"\n\t\t\t\t")])}))]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col"},[_c('organization',{attrs:{"id":_vm.selected_act,"org_id":_vm.f_11,"disabled":""}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col"},[_c('input',{staticClass:"form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.f_4}})])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col"},[_c('fo',{attrs:{"reg_id":_vm.f_12,"disabled":""}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_c('region',{attrs:{"type":"conclusion","reg_id":_vm.f_12,"disabled":""}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_c('forestry',{attrs:{"type":"conclusion","reg_id":_vm.f_12,"f_id":_vm.f_9,"disabled":""}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('table',{staticClass:"documentsTable"},[_vm._m(2),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border-right":"none"}},[_vm._v("Реквизиты исходящего из ДЛХ")]),_vm._v(" "),_c('td',{class:_vm.fields_correct.f_35},[_c('datepicker',{staticClass:"table-control",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly},model:{value:(_vm.f_35),callback:function ($$v) {_vm.f_35=$$v},expression:"f_35"}})],1),_vm._v(" "),_c('td',{class:_vm.fields_correct.f_36},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_36),expression:"f_36"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_36)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_36=$event.target.value}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_37),expression:"f_37"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_37)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_37=$event.target.value}}})])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"border-right":"none"}},[_vm._v("Реквизиты входящего в Рослесозащиту")]),_vm._v(" "),_c('td',[_c('datepicker',{staticClass:"table-control",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly},model:{value:(_vm.f_38),callback:function ($$v) {_vm.f_38=$$v},expression:"f_38"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_39),expression:"f_39"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_39)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_39=$event.target.value}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_40),expression:"f_40"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_40)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_40=$event.target.value}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('table',{staticClass:"documentsTable",staticStyle:{"margin-top":"28px"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border-right":"none"}},[_vm._v("Заключение на Акт ЛПО")]),_vm._v(" "),_c('td',{class:_vm.fields_correct.f_48},[_c('datepicker',{staticClass:"table-control",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly},model:{value:(_vm.f_48),callback:function ($$v) {_vm.f_48=$$v},expression:"f_48"}})],1),_vm._v(" "),_c('td',{class:_vm.fields_correct.f_49},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_49),expression:"f_49"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_49)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_49=$event.target.value}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_50),expression:"f_50"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_50)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_50=$event.target.value}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2",staticStyle:{"margin-top":"20px"}},[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();_vm.setRegistryAccordance($event)}}},[_vm._v("Установить соответствие")])]),_vm._v(" "),_c('div',{staticClass:"col-md-1",staticStyle:{"margin-top":"20px"}},[_c('span',{staticClass:"registry_stat_wrap"},[_c('span',{staticClass:"registry_stat_title"},[_vm._v("Статистика")]),_vm._v(" "),_c('div',{staticClass:"registry_stat_popup"},[_c('table',[_vm._m(3),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Количество участков")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.upp_count))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.mzl_count))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Дата обновления")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.upp_lastdate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.mzl_lastdate))])])])])])])]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"20px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"table_head_wrap"},[_c('table',{staticClass:"conclusion_place_table conclusion_place_table__top"},[_c('thead',[_c('tr',[_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Участковое лесничество")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Подлес-во")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Квартал")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Выдел")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Лп. выдел")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("МЗЛ")]),_vm._v(" "),_c('th',{staticClass:"colspan_td",attrs:{"colspan":"5"}},[_vm._v("Соответствие")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Нарушение НПА")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Решение *")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Участки требующие проведения выездной проверки")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"colspan":"2"}},[_vm._v("Наличие в реестрах ГЛПМ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Комментарии")]),_vm._v(" "),_c('th',{attrs:{"rowspan":"2","width":_vm.scroll_width}})]),_vm._v(" "),_vm._m(4)])])]),_vm._v(" "),_c('div',{staticClass:"table_body_wrap"},[_c('table',{staticClass:"conclusion_place_table conclusion_place_table__bottom"},[_c('tbody',[(_vm.getActLocations(_vm.selected_act))?_vm._l((_vm.getActLocations(_vm.selected_act)),function(line,index){return _c('tr',[_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_20),expression:"line.f_20"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_20)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_20", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_27),expression:"line.f_27"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_27)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_27", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_17),expression:"line.f_17"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_17)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_17", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_24),expression:"line.f_24"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_24)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_24", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_25),expression:"line.f_25"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_25)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_25", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_16),expression:"line.f_16"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_16)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_16", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(line.f_28),expression:"line.f_28"}],staticClass:"form-control form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(line, "f_28", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(line.f_29),expression:"line.f_29"}],staticClass:"form-control form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(line, "f_29", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(line.f_30),expression:"line.f_30"}],staticClass:"form-control form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(line, "f_30", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(line.f_31),expression:"line.f_31"}],staticClass:"form-control form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(line, "f_31", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',{staticClass:"form_td",staticStyle:{"border-right":"none"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(line.f_32),expression:"line.f_32"}],staticClass:"form-control form-control my-control table-control",attrs:{"disabled":true},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(line, "f_32", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',{staticClass:"form_td",class:{'field-error': line.f_31 == 0 && line.f_107 == 0}},[_c('npa-violation',{attrs:{"line_count":index,"id":line.f_107,"disabled":_vm.readonly}})],1),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_33},[_c('select',{staticClass:"form-control form-control my-control table-control",attrs:{"disabled":_vm.readonly,"data-line":index},domProps:{"value":line.f_33},on:{"change":function($event){_vm.decisionChange(line.f_33, $event)}}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Положительное")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Отрицательное")])])]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_91),expression:"line.f_91"}],attrs:{"type":"checkbox","data-index":index,"disabled":_vm.readonly},domProps:{"checked":Array.isArray(line.f_91)?_vm._i(line.f_91,null)>-1:(line.f_91)},on:{"change":function($event){var $$a=line.f_91,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(line.f_91=$$a.concat([$$v]))}else{$$i>-1&&(line.f_91=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(line, "f_91", $$c)}}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{attrs:{"type":"checkbox","data-index":index,"disabled":""},domProps:{"checked":line.upp == "t"}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{attrs:{"type":"checkbox","data-index":index,"disabled":""},domProps:{"checked":line.mzl == "t"}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_34),expression:"line.f_34"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":_vm.readonly},domProps:{"value":(line.f_34)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_34", $event.target.value)}}})])])}):[_vm._m(5)]],2)])])])]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col flex"},[_c('select',{staticClass:"form-control form-control my-control",class:_vm.fields_correct.f_41,attrs:{"disabled":_vm.readonly},domProps:{"value":_vm.f_41},on:{"change":function($event){_vm.mainDecisionChange(_vm.f_41, $event)}}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Положительное")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Отрицательное")])]),_vm._v(" "),_c('i',{staticClass:"fa fa-asterisk button-spread",attrs:{"title":"Распространить соответствия на все акты в группе"},on:{"click":_vm.spreadActs}})]),_vm._v(" "),_c('div',{staticClass:"col-md-5 col"},[_c('decision-reason',{attrs:{"disabled":_vm.readonly || _vm.f_41 > 0,"error":_vm.errorDecisionReason}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_43),expression:"f_43"}],staticClass:"form-control my-control",attrs:{"type":"text","disabled":_vm.readonly},domProps:{"value":(_vm.f_43)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_43=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_c('table',{staticClass:"documentsTable"},[_vm._m(7),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticStyle:{"width":"30%","border-right":"none"}},[_vm._v("Сопроводительное письмо с заключениями на Акты ЛПО")]),_vm._v(" "),_c('td',{staticStyle:{"width":"23%"}},[_c('datepicker',{staticClass:"table-control",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly},model:{value:(_vm.f_44),callback:function ($$v) {_vm.f_44=$$v},expression:"f_44"}})],1),_vm._v(" "),_c('td',{staticStyle:{"width":"23%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_45),expression:"f_45"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_45)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_45=$event.target.value}}})]),_vm._v(" "),_c('td',{staticStyle:{"width":"23%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_46),expression:"f_46"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_46)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_46=$event.target.value}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_47),expression:"f_47"}],staticClass:"form-control form-control my-control medium",attrs:{"disabled":_vm.readonly},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.f_47=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Черновик")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Чистовик")])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin":"5px"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"btnPanel"},[_c('input',{staticClass:"btn btn-secondary",attrs:{"type":"button","value":"Отмена","disabled":_vm.readonly},on:{"click":function($event){$event.preventDefault();_vm.close($event)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.submit_disabled || _vm.readonly},on:{"click":function($event){$event.preventDefault();_vm.submit($event)}}},[(_vm.submit_disabled)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v("\n\t\t\t"+_vm._s(_vm.submit_disabled ? 'Сохранение' : 'Сохранить')+"\n\t\t")])]),_vm._v(" "),_c('modal',{attrs:{"backdrop":false,"medium":""},model:{value:(_vm.display_similar_acts),callback:function ($$v) {_vm.display_similar_acts=$$v},expression:"display_similar_acts"}},[_c('div',{staticClass:"modal-header",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_c('b',[_vm._v("Редактирование состава группы")])])]),_vm._v(" "),_c('div',[_c('ul',{staticClass:"acts-list"},_vm._l((_vm.similar_acts),function(act){return _c('li',[_c('checkbox',{attrs:{"type":"info"},model:{value:(act.checked),callback:function ($$v) {_vm.$set(act, "checked", $$v)},expression:"act.checked"}},[_vm._v(" "+_vm._s(act.act_num)+" ")])],1)}))]),_vm._v(" "),_c('div',{staticClass:"modal-footer",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.display_similar_acts = false}}},[_vm._v("Отмена")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.editGroup}},[_vm._v("Сохранить")])])])],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1 col"},[_vm._v("№ акта ЛПО")]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col"},[_vm._v("Организация")]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col"},[_vm._v("Ссылка на акт")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col"},[_vm._v("Федеральный округ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_vm._v("Субъект РФ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_vm._v("Лесничество")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Официальные документы")]),_vm._v(" "),_c('th',[_vm._v("Дата *")]),_vm._v(" "),_c('th',[_vm._v("Номер *")]),_vm._v(" "),_c('th',[_vm._v("Комментарий к документу")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v("УПП")]),_vm._v(" "),_c('th',[_vm._v("МЗЛ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"form_td",attrs:{"title":"Соответствие сведений данным ГЛПМ"}},[_vm._v("свед. данным ГЛПМ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"title":"Соответствия сведений таксационным характеристикам лесного участка"}},[_vm._v("свед. ТО")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"title":"Соответствие  мероприятий данным ГЛПМ"}},[_vm._v("мероприятий данным ГЛПМ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"title":"Запрещение или ограничение законодательством РФ мероприятий"}},[_vm._v("законодательству РФ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"title":"Недостоверность сведений санитарному и лесопатологическому состоянию лесов"}},[_vm._v("недост.свед. Сан. Сост.")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("УПП")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("МЗЛ-ПРВО")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("\n\t\t\t\t\t\t\t\t\tЗагрузка...\n\t\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col"},[_c('span',{staticClass:"bold"},[_vm._v("Итоговое решение *")])]),_vm._v(" "),_c('div',{staticClass:"col-md-5 col"},[_vm._v("Главная причина отрицательного заключения")]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_vm._v("Примечание")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Официальные документы")]),_vm._v(" "),_c('th',[_vm._v("Дата")]),_vm._v(" "),_c('th',[_vm._v("Номер")]),_vm._v(" "),_c('th',[_vm._v("Комментарий к документу")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n47g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__("SQ6o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // We need to initialize the component with any
      // properties that will be used in it
      user: {
        login: '',
        password: '',
        remember: false
      },
      error: false,
      error_db: false
    };
  },

  methods: {
    submit: function submit() {
      var credentials = {
        login: this.user.login,
        password: this.user.password,
        remember: this.user.remember
        // We need to pass the component's this context
        // to properly make use of http in the auth service
      };__WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */].login(this, credentials, '/main');
    }
  },
  components: {
    alert: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["alert"]

    /*export default {
      name: 'login',
      data () {
        return {
          user: {
            login: '',
            password: '',
            remember: false
          }
        }
      },
      methods: {
        checkAuth: function () {
          var data = new FormData()
          data.append('login', this.user.login)
          data.append('password', this.user.password)
          data.append('remember', this.user.remember)
          fetch('http://localhost/garbage/vbtest/src/php/auth.php', {
            method: 'POST',
            body: data
          })
          .then(res => res.json())
          .then(res => {
            if (res !== -1) {
              router.replace('main')
            } else {
            	//router.replace('forbidden')
              console.log('failure')
            }
          })
          .catch(e => {
            console.log(e)
          })
        }
      }*/
  } });

/***/ }),

/***/ "nMCY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o7L1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o8b1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();_vm.formSubmit($event)}}},[_c('h4',[_vm._v("Предписание на группу актов")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fo_id),expression:"fo_id"}],staticClass:"form-control",attrs:{"disabled":!_vm.fo_list.length},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.fo_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.foChange]}},_vm._l((_vm.fo_list),function(fo){return _c('option',{key:fo.id,domProps:{"value":fo.id}},[_vm._v("\n                            "+_vm._s(fo.name)+"\n                        ")])}))]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.region_id),expression:"region_id"}],staticClass:"form-control",attrs:{"disabled":!_vm.regions_list.length},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.region_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.regionChange]}},_vm._l((_vm.regions_list),function(region){return _c('option',{key:region.id,domProps:{"value":region.id}},[_vm._v("\n                            "+_vm._s(region.name)+"\n                        ")])}))]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.year),expression:"year"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.yearChange]}},[_c('option',{domProps:{"value":null}}),_vm._v(" "),_c('option',{domProps:{"value":2026}},[_vm._v("2026")]),_vm._v(" "),_c('option',{domProps:{"value":2025}},[_vm._v("2025")]),_vm._v(" "),_c('option',{domProps:{"value":2024}},[_vm._v("2024")]),_vm._v(" "),_c('option',{domProps:{"value":2023}},[_vm._v("2023")]),_vm._v(" "),_c('option',{domProps:{"value":2022}},[_vm._v("2022")]),_vm._v(" "),_c('option',{domProps:{"value":2021}},[_vm._v("2021")]),_vm._v(" "),_c('option',{domProps:{"value":2020}},[_vm._v("2020")]),_vm._v(" "),_c('option',{domProps:{"value":2019}},[_vm._v("2019")]),_vm._v(" "),_c('option',{domProps:{"value":2018}},[_vm._v("2018")]),_vm._v(" "),_c('option',{domProps:{"value":2017}},[_vm._v("2017")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('table',{staticClass:"documentsTable"},[_vm._m(1),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Поступление акта ЛПО в ДЛХ по ФО*")]),_vm._v(" "),_c('td',[_c('datepicker',{staticClass:"table-control",class:(!_vm.f_51 && _vm.selected_acts_ids.length) ? "field-error-warrant" : "",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly || !_vm.selected_acts_ids.length},model:{value:(_vm.f_51),callback:function ($$v) {_vm.f_51=$$v},expression:"f_51"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_52),expression:"f_52"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly || !_vm.selected_acts_ids.length},domProps:{"value":(_vm.f_52)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_52=$event.target.value}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Приказ проведения документарной проверки")]),_vm._v(" "),_c('td',[_c('datepicker',{staticClass:"table-control",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly || !_vm.selected_acts_ids.length},model:{value:(_vm.f_54),callback:function ($$v) {_vm.f_54=$$v},expression:"f_54"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_55),expression:"f_55"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly || !_vm.selected_acts_ids.length},domProps:{"value":(_vm.f_55)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_55=$event.target.value}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Акт проведения документарной проверки**")]),_vm._v(" "),_c('td',[_c('datepicker',{staticClass:"table-control",class:(!_vm.f_57 && _vm.selected_acts_ids.length) ? "field-error-warrant-optional" : "",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly || !_vm.selected_acts_ids.length},model:{value:(_vm.f_57),callback:function ($$v) {_vm.f_57=$$v},expression:"f_57"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_58),expression:"f_58"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly || !_vm.selected_acts_ids.length},domProps:{"value":(_vm.f_58)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_58=$event.target.value}}})])]),_vm._v(" "),_c('tr',[_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_71),expression:"f_71"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly || !_vm.selected_acts_ids.length},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.f_71=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.official_docs),function(item){return _c('option',{key:item.id,domProps:{"value":item.id,"textContent":_vm._s(item.name)}})}))]),_vm._v(" "),_c('td',[_c('datepicker',{staticClass:"table-control",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly || !_vm.selected_acts_ids.length},model:{value:(_vm.f_72),callback:function ($$v) {_vm.f_72=$$v},expression:"f_72"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_73),expression:"f_73"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly || !_vm.selected_acts_ids.length},domProps:{"value":(_vm.f_73)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_73=$event.target.value}}})])])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col text-left"},[_c('button',{staticClass:"btn btn-default medium-button",attrs:{"disabled":!_vm.selected_acts_ids.length || (_vm.f_71 != 1 && _vm.f_71 != 2 && _vm.f_71 != 4)},on:{"click":_vm.printWarrant}},[_vm._v("\n                        Сформировать предписание\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default medium-button",attrs:{"disabled":!_vm.selected_acts_ids.length},on:{"click":_vm.printDocumentCheck}},[_vm._v("\n                        Сформировать акт документарной проверки\n                    ")]),_vm._v(" "),_c('dropdown',{staticClass:"medium-button",attrs:{"text":"Сохранить все акты как","disabled":_vm.submit_disabled || !_vm.selected_acts_ids.length || !_vm.f_51}},[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.submit(1)}}},[_vm._v("Черновики")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.submit(0)}}},[_vm._v("Чистовики")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default medium-button",attrs:{"disabled":!_vm.acts_nums_is_loaded},on:{"click":_vm.showActsModal}},[_vm._v("\n                        Добавить акт "),(_vm.acts_nums_is_loading)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e()])],1)]),_vm._v(" "),(_vm.actsWithPositiveDecision.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col"},[_vm._v("\n                            Акты с положительным решением\n                            "),_c('table',{staticClass:"acts_table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"rowspan":"2","width":"20"}}),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("№ акта")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Участковое лесничество")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Подлес-во")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Квартал")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Выдел")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("S выдела")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Лп. Выдел")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("S лп. выдела")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("МЗЛ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("S МЗЛ")]),_vm._v(" "),_c('th',{staticClass:"colspan_td",attrs:{"colspan":"5"}},[_vm._v("Соответствие сведений")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Решение ДЛХ по ФО")]),_vm._v(" "),_c('th',{attrs:{"rowspan":"2","width":_vm.scroll_width}})]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"table_body_wrap"},[_c('table',{staticClass:"acts_table content_table"},[_c('tbody',_vm._l((_vm.actsWithPositiveDecision),function(act){return _c('tr',{key:act.f_c},[(act.flag)?_c('td',{staticClass:"checkbox_wrapper",attrs:{"rowspan":act.count,"width":"20"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(act.checked),expression:"act.checked"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(act.checked)?_vm._i(act.checked,null)>-1:(act.checked)},on:{"input":function($event){_vm.actCheckChange($event, act.f_p)},"change":function($event){var $$a=act.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(act.checked=$$a.concat([$$v]))}else{$$i>-1&&(act.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(act, "checked", $$c)}}}})]):_vm._e(),_vm._v(" "),(act.flag)?_c('td',{attrs:{"rowspan":act.count}},[_vm._v(_vm._s(act.f_2))]):_vm._e(),_vm._v(" "),(act.flag_lf)?_c('td',{attrs:{"rowspan":act.count_lf}},[_vm._v(_vm._s(act.f_20))]):_vm._e(),_vm._v(" "),(act.flag_sf)?_c('td',{attrs:{"rowspan":act.count_sf}},[_vm._v(_vm._s(act.f_27))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_17))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_24))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_21))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_25))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_23))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_16))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_22))]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(act.f_76),expression:"act.f_76"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(act, "f_76", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(act.f_77),expression:"act.f_77"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(act, "f_77", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(act.f_78),expression:"act.f_78"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(act, "f_78", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(act.f_79),expression:"act.f_79"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(act, "f_79", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(act.f_80),expression:"act.f_80"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(act, "f_80", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(act.f_81),expression:"act.f_81"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(act, "f_81", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Положительное")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Отрицательное")])])])])}))])])])]),_vm._v(" "),(_vm.checkedPositiveActs.length)?_c('div',{staticClass:"row buttons-row"},[_c('div',{staticClass:"col-md-6 col text-left"},[_vm._v("\n                            Действия с выделенными: \n                            "),_c('button',{staticClass:"btn btn-default small-button",on:{"click":_vm.checkedToNegative}},[_vm._v("\n                                Перевести в отрицательные\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default small-button",on:{"click":_vm.deleteCheckedActsFromPositive}},[_vm._v("\n                                Удалить\n                            ")])])]):_vm._e(),_vm._v(" "),_c('hr')])]):_vm._e(),_vm._v(" "),(_vm.actsWithNegativeDecision.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col"},[_vm._v("\n                            Акты с отрицательным решением\n                            "),_c('table',{staticClass:"acts_table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"rowspan":"2","width":"20"}}),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("№ акта")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Участковое лесничество")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Подлес-во")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Квартал")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Выдел")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("S выдела")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Лп. Выдел")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("S лп. выдела")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("МЗЛ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("S МЗЛ")]),_vm._v(" "),_c('th',{staticClass:"colspan_td",attrs:{"colspan":"5"}},[_vm._v("Соответствие сведений")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Решение ДЛХ по ФО")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Главная причина отмены акта")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('th',{attrs:{"rowspan":"2","width":_vm.scroll_width}})]),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"table_body_wrap"},[_c('table',{staticClass:"acts_table content_table"},[_c('tbody',_vm._l((_vm.actsWithNegativeDecision),function(act){return _c('tr',{key:act.f_c},[(act.flag)?_c('td',{staticClass:"checkbox_wrapper",attrs:{"rowspan":act.count,"width":"20"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(act.checked),expression:"act.checked"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(act.checked)?_vm._i(act.checked,null)>-1:(act.checked)},on:{"input":function($event){_vm.actCheckChange($event, act.f_p)},"change":function($event){var $$a=act.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(act.checked=$$a.concat([$$v]))}else{$$i>-1&&(act.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(act, "checked", $$c)}}}})]):_vm._e(),_vm._v(" "),(act.flag)?_c('td',{attrs:{"rowspan":act.count}},[_vm._v(_vm._s(act.f_2))]):_vm._e(),_vm._v(" "),(act.flag_lf)?_c('td',{attrs:{"rowspan":act.count_lf}},[_vm._v(_vm._s(act.f_20))]):_vm._e(),_vm._v(" "),(act.flag_sf)?_c('td',{attrs:{"rowspan":act.count_sf}},[_vm._v(_vm._s(act.f_27))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_17))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_24))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_21))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_25))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_23))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_16))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_22))]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(act.f_76),expression:"act.f_76"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(act, "f_76", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(act.f_77),expression:"act.f_77"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(act, "f_77", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(act.f_78),expression:"act.f_78"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(act, "f_78", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(act.f_79),expression:"act.f_79"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(act, "f_79", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(act.f_80),expression:"act.f_80"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(act, "f_80", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(act.f_81),expression:"act.f_81"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(act, "f_81", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Положительное")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Отрицательное")])])]),_vm._v(" "),(act.flag)?_c('td',{attrs:{"rowspan":act.count}},[_c('select',{staticClass:"form-control my-control table-control",class:(act.errorDecisionReason || !act.f_125) ? "field-error-warrant" : "",domProps:{"value":act.f_125},on:{"change":function($event){_vm.handle125Change($event, act.f_p)}}},_vm._l((_vm.decisions),function(reason){return _c('option',{key:reason.id,domProps:{"value":reason.id}},[_vm._v("\n                                                        "+_vm._s(reason.name)+"\n                                                    ")])}))]):_vm._e(),_vm._v(" "),(act.flag)?_c('td',{staticStyle:{"position":"relative"},attrs:{"rowspan":act.count}},[_c('npa-violations',{attrs:{"npa":_vm.getNpaForAct(act.f_p),"act_num":act.f_2,"disabled":_vm.getNpaDisabledForAct(act.f_p)},on:{"change":function($event){_vm.handleNpaChange($event, act.f_p)}}})],1):_vm._e()])}))])])])]),_vm._v(" "),(_vm.checkedNegativeActs.length)?_c('div',{staticClass:"row buttons-row"},[_c('div',{staticClass:"col-md-6 col text-left"},[_vm._v("\n                            Действия с выделенными: \n                            "),_c('button',{staticClass:"btn btn-default small-button",on:{"click":_vm.checkedToPositive}},[_vm._v("\n                                Перевести в положительные\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default small-button",on:{"click":_vm.deleteCheckedActsFromNegative}},[_vm._v("\n                                Удалить\n                            ")])])]):_vm._e(),_vm._v(" "),_c('hr')])]):_vm._e(),_vm._v(" "),(_vm.actsWithoutDecision.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col"},[_vm._v("\n                            Акты без решения\n                            "),_c('table',{staticClass:"acts_table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"rowspan":"2","width":"20"}}),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("№ акта")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Участковое лесничество")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Подлес-во")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Квартал")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Выдел")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("S выдела")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Лп. Выдел")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("S лп. выдела")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("МЗЛ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("S МЗЛ")]),_vm._v(" "),_c('th',{staticClass:"colspan_td",attrs:{"colspan":"5"}},[_vm._v("Соответствие сведений")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Решение ДЛХ по ФО")]),_vm._v(" "),_c('th',{attrs:{"rowspan":"2","width":_vm.scroll_width}})]),_vm._v(" "),_vm._m(5)])]),_vm._v(" "),_c('div',{staticClass:"table_body_wrap"},[_c('table',{staticClass:"acts_table content_table"},[_c('tbody',_vm._l((_vm.actsWithoutDecision),function(act){return _c('tr',{key:act.f_c},[(act.flag)?_c('td',{staticClass:"checkbox_wrapper",attrs:{"rowspan":act.count,"width":"20"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(act.checked),expression:"act.checked"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(act.checked)?_vm._i(act.checked,null)>-1:(act.checked)},on:{"input":function($event){_vm.actCheckChange($event, act.f_p)},"change":function($event){var $$a=act.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(act.checked=$$a.concat([$$v]))}else{$$i>-1&&(act.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(act, "checked", $$c)}}}})]):_vm._e(),_vm._v(" "),(act.flag)?_c('td',{attrs:{"rowspan":act.count}},[_vm._v(_vm._s(act.f_2))]):_vm._e(),_vm._v(" "),(act.flag_lf)?_c('td',{attrs:{"rowspan":act.count_lf}},[_vm._v(_vm._s(act.f_20))]):_vm._e(),_vm._v(" "),(act.flag_sf)?_c('td',{attrs:{"rowspan":act.count_sf}},[_vm._v(_vm._s(act.f_27))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_17))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_24))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_21))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_25))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_23))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_16))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.f_22))]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(act.f_76),expression:"act.f_76"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(act, "f_76", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(act.f_77),expression:"act.f_77"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(act, "f_77", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(act.f_78),expression:"act.f_78"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(act, "f_78", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(act.f_79),expression:"act.f_79"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(act, "f_79", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(act.f_80),expression:"act.f_80"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(act, "f_80", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(act.f_81),expression:"act.f_81"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(act, "f_81", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Положительное")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Отрицательное")])])])])}))])])])]),_vm._v(" "),(_vm.checkedNeutralActs.length)?_c('div',{staticClass:"row buttons-row"},[_c('div',{staticClass:"col-md-9 col text-left"},[_vm._v("\n                            Действия с выделенными: \n                            "),_c('button',{staticClass:"btn btn-default small-button",on:{"click":function($event){_vm.checkedToPositive(true)}}},[_vm._v("\n                                Перевести в положительные\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default small-button",on:{"click":function($event){_vm.checkedToNegative(true)}}},[_vm._v("\n                                Перевести в отрицательные\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default small-button",on:{"click":_vm.deleteCheckedActsFromNeutral}},[_vm._v("\n                                Удалить\n                            ")])])]):_vm._e(),_vm._v(" "),_c('hr')])]):_vm._e(),_vm._v(" "),_c('modal',{attrs:{"backdrop":false,"width":"85%"},model:{value:(_vm.display_acts_modal),callback:function ($$v) {_vm.display_acts_modal=$$v},expression:"display_acts_modal"}},[_c('div',{staticClass:"modal-header",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_c('b',[_vm._v("Добавление актов")])])]),_vm._v(" "),_c('acts-nums-selector',{attrs:{"acts_nums":_vm.acts_nums,"acts_is_loading":_vm.acts_is_loading},on:{"change":_vm.changeSearchIds,"search":_vm.findActs}}),_vm._v(" "),_c('div',{staticClass:"row acts_table_wrap"},[_c('div',{staticClass:"col-md-12 col"},[(_vm.found_acts.length || _vm.acts_is_loading)?_c('table',{staticClass:"acts_search_table",class:{loading: _vm.acts_is_loading}},[_c('thead',[_c('tr',[_c('th',[_vm._v("\n                                        № акта\n                                    ")]),_vm._v(" "),_c('th',[_vm._v("\n                                        Дата размещения\n                                    ")]),_vm._v(" "),_c('th',[_vm._v("\n                                        ФО\n                                    ")]),_vm._v(" "),_c('th',[_vm._v("\n                                        Субъект РФ\n                                    ")]),_vm._v(" "),_c('th',[_vm._v("\n                                        Лесничество\n                                    ")]),_vm._v(" "),_c('th',[_vm._v("\n                                        Уч. лесничество\n                                    ")]),_vm._v(" "),_c('th',[_vm._v("\n                                        Подслесничество\n                                    ")]),_vm._v(" "),_c('th',[_vm._v("\n                                        Квартал\n                                    ")]),_vm._v(" "),_c('th',[_vm._v("\n                                        Выдел\n                                    ")]),_vm._v(" "),_c('th',[_vm._v("\n                                        Л.п. выдел\n                                    ")])])]),_vm._v(" "),_c('tbody',[(_vm.acts_is_loading)?_c('tr',{staticClass:"loading_row"},[_c('td',{attrs:{"colspan":"10"}},[_c('i',{staticClass:"fa fa-spinner fa-spin"})])]):_vm._l((_vm.found_acts),function(act,index){return _c('tr',{key:act.id + index,class:{"hovered": act.id == _vm.hovered_act_in_found, "selected": act.id == _vm.selected_act_in_found, "disabled": _vm.isActInBasket(act.id)},on:{"click":function($event){_vm.selectActInFound(act.id)},"mouseover":function($event){_vm.mouseOverActInFound(act.id)},"mouseleave":function($event){_vm.hovered_act_in_found = 0}}},[(act.flag)?_c('td',{attrs:{"rowspan":act.count}},[_vm._v(_vm._s(act.num))]):_vm._e(),_vm._v(" "),(act.flag)?_c('td',{attrs:{"rowspan":act.count}},[_vm._v(_vm._s(act.act_placement_date))]):_vm._e(),_vm._v(" "),(act.flag)?_c('td',{attrs:{"rowspan":act.count}},[_vm._v(_vm._s(act.fo))]):_vm._e(),_vm._v(" "),(act.flag)?_c('td',{attrs:{"rowspan":act.count}},[_vm._v(_vm._s(act.region))]):_vm._e(),_vm._v(" "),(act.flag)?_c('td',{attrs:{"rowspan":act.count}},[_vm._v(_vm._s(act.forestry))]):_vm._e(),_vm._v(" "),(act.flag_lf)?_c('td',{attrs:{"rowspan":act.count_lf}},[_vm._v(_vm._s(act.localforestry))]):_vm._e(),_vm._v(" "),(act.flag_sf)?_c('td',{attrs:{"rowspan":act.count_sf}},[_vm._v(_vm._s(act.subforestry))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.area))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.section))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(act.section_lp))])])})],2)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"modal-footer",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":_vm.hideActsModal}},[_vm._v("Отмена")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.selected_act_in_found || _vm.isActInBasket(_vm.selected_act_in_found)},on:{"click":_vm.addActToBasket}},[_vm._v("Добавить")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.found_acts.length},on:{"click":_vm.addAllActsToBasket}},[_vm._v("Добавить все")])])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col"},[_vm._v("Федеральный округ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_vm._v("Субъект")]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col"},[_vm._v("Год размещения")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Официальные документы")]),_vm._v(" "),_c('th',[_vm._v("Дата")]),_vm._v(" "),_c('th',[_vm._v("Номер")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"form_td",attrs:{"title":"Соответствие сведений данным ГЛПМ"}},[_vm._v("свед. данным ГЛПМ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"title":"соответствия сведений таксационным характеристикам лесного участка"}},[_vm._v("свед. ТО")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"title":"соответствие  мероприятий данным ГЛПМ"}},[_vm._v("мероприятий данным ГЛПМ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"title":"запрещение или ограничение законодательством РФ мероприятий"}},[_vm._v("законодательству РФ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"title":"недостоверность сведений санитарному и лесопатологическому состоянию лесов"}},[_vm._v("Недост.свед. Сан. Сост.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Нарушения"),_c('br'),_vm._v("НПА")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"form_td",attrs:{"title":"Соответствие сведений данным ГЛПМ"}},[_vm._v("свед. данным ГЛПМ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"title":"соответствия сведений таксационным характеристикам лесного участка"}},[_vm._v("свед. ТО")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"title":"соответствие  мероприятий данным ГЛПМ"}},[_vm._v("мероприятий данным ГЛПМ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"title":"запрещение или ограничение законодательством РФ мероприятий"}},[_vm._v("законодательству РФ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"title":"недостоверность сведений санитарному и лесопатологическому состоянию лесов"}},[_vm._v("Недост.свед. Сан. Сост.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"form_td",attrs:{"title":"Соответствие сведений данным ГЛПМ"}},[_vm._v("свед. данным ГЛПМ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"title":"соответствия сведений таксационным характеристикам лесного участка"}},[_vm._v("свед. ТО")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"title":"соответствие  мероприятий данным ГЛПМ"}},[_vm._v("мероприятий данным ГЛПМ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"title":"запрещение или ограничение законодательством РФ мероприятий"}},[_vm._v("законодательству РФ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"title":"недостоверность сведений санитарному и лесопатологическому состоянию лесов"}},[_vm._v("Недост.свед. Сан. Сост.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o8pT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oO+5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var ACTION_TYPE = 'get_action_type.php';
var LOCATION = 'get_warrant_location.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'actionType',
	data: function data() {
		return {
			selected: '0',
			options: []
		};
	},
	props: {
		line_count: ''
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('warrant_action_type', { index: this.line_count, value: this.selected });
		}
	},
	created: function created() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + LOCATION + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			return res[_this.line_count].f_84;
		}).then(function (id) {
			fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + ACTION_TYPE, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.options = data;

					_this.selected = id;

					__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('warrant_action_type', { index: _this.line_count, value: id });
				} else {
					_this.options = [];
					_this.selected = '0';
				}
			}).catch(function (err) {
				return console.log('7', err);
			});
		}).catch(function (err) {
			return console.log('8', err);
		});
	}
});

/***/ }),

/***/ "oYeu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var GET_STAT_REPORT = 'get_stat_report.php';
var REPORT_ID = 11;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Stat',
	data: function data() {
		return {
			rows: [],
			total_row: {}
		};
	},
	props: ['start', 'end'],
	computed: {
		endYear: function endYear() {
			return this.$props.end.split('.')[2];
		}
	},
	methods: {
		fillTable: function fillTable(start, end) {
			var _this = this;

			fetch(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DB */] + GET_STAT_REPORT + '?start=' + start + '&end=' + end).then(function (res) {
				return res.json();
			}).then(function (res) {
				//let temp_rows = [{}]
				//let flag = true
				//let total_summ = {}
				/*
        total_summ.region = 'Итого по РФ'
        total_summ.placement_all = 0
        total_summ.placement_week = 0
        total_summ.entrance_all = 0
        total_summ.entrance_week = 0
        total_summ.sending_conclusion_all = 0
        total_summ.sending_conclusion_week = 0
        total_summ.decision_false_all = 0
        total_summ.decision_false_week = 0
        total_summ.deletion_all = 0
        total_summ.deletion_week = 0
        total_summ.online_acts_all = 0
        total_summ.online_acts_week = 0
         let fo_summ = {}
        fo_summ.region = 'Итого по округу'
        fo_summ.placement_all = 0
        fo_summ.placement_week = 0
        fo_summ.entrance_all = 0
        fo_summ.entrance_week = 0
        fo_summ.sending_conclusion_all = 0
        fo_summ.sending_conclusion_week = 0
        fo_summ.decision_false_all = 0
        fo_summ.decision_false_week = 0
        fo_summ.deletion_all = 0
        fo_summ.deletion_week = 0
        fo_summ.online_acts_all = 0
        fo_summ.online_acts_week = 0
    */

				_this.total_row = {};
				_this.rows = [];
				var i = 0;
				var last_fo = null;
				for (var row_index in res) {
					if (res[row_index].fo_id == null) {
						_this.total_row = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res[row_index]));
						continue;
					}

					if (res[row_index].fo != last_fo) {
						_this.rows.push({
							new_fo: true,
							region: res[row_index].fo,
							fo: res[row_index].fo
						});
					}

					if (res[row_index].region == 'Итого по округу') {
						res[row_index].bold = true;
					}

					_this.rows.push(res[row_index]);
					last_fo = res[row_index].fo;
				}

				if (_this.total_row) {
					_this.total_row.bold = true;
					_this.rows.unshift(_this.total_row);

					_this.rows.unshift({
						new_fo: true,
						bold: true,
						region: 'Итого по РФ',
						fo: 'Итого по РФ'
					});
				}

				/*while (i < res.length - 1) {
    		if ((res[i].fo === res[i+1].fo) && flag) {
    		let obj = {}
    		obj.fo = res[i].fo
    		obj.flag = true
    		flag = false
    			if (i !== 0) {
    			let clone_fo = {} //клонируем объект для передачи по значению
    			for (let key in fo_summ) {
    				clone_fo[key] = fo_summ[key]
    			}
    				temp_rows.push(clone_fo)
    				/*fo_summ.placement_all = 0
    			fo_summ.placement_week = 0
    			fo_summ.entrance_all = 0
    			fo_summ.entrance_week = 0
    			fo_summ.sending_conclusion_all = 0
    			fo_summ.sending_conclusion_week = 0
    			fo_summ.decision_false_all = 0
    			fo_summ.decision_false_week = 0
    			fo_summ.deletion_all = 0
    			fo_summ.deletion_week = 0
    			fo_summ.online_acts_all = 0
    			fo_summ.online_acts_week = 0
    	}
    		temp_rows.push(obj)						
    }
    else {
    	/*total_summ.placement_all += +res[i].placement_all
    	total_summ.placement_week += +res[i].placement_week
    	total_summ.entrance_all += +res[i].entrance_all
    	total_summ.entrance_week += +res[i].entrance_week
    	total_summ.sending_conclusion_all += +res[i].sending_conclusion_all
    	total_summ.sending_conclusion_week += +res[i].sending_conclusion_week
    	total_summ.decision_false_all += +res[i].decision_false_all
    	total_summ.decision_false_week += +res[i].decision_false_week
    	total_summ.deletion_all += +res[i].deletion_all
    	total_summ.deletion_week += +res[i].deletion_week
    	total_summ.online_acts_all += +res[i].online_acts_all
    	total_summ.online_acts_week += +res[i].online_acts_week
    		fo_summ.placement_all += +res[i].placement_all
    	fo_summ.placement_week += +res[i].placement_week
    	fo_summ.entrance_all += +res[i].entrance_all
    	fo_summ.entrance_week += +res[i].entrance_week
    	fo_summ.sending_conclusion_all += +res[i].sending_conclusion_all
    	fo_summ.sending_conclusion_week += +res[i].sending_conclusion_week
    	fo_summ.decision_false_all += +res[i].decision_false_all
    	fo_summ.decision_false_week += +res[i].decision_false_week
    	fo_summ.deletion_all += +res[i].deletion_all
    	fo_summ.deletion_week += +res[i].deletion_week
    	fo_summ.online_acts_all += +res[i].online_acts_all
    	fo_summ.online_acts_week += +res[i].online_acts_week
    		temp_rows.push(res[i])
    	if (res[i].fo !== res[i+1].fo) {
    		flag = true
    	}
    	i++
    }*/

				/*
        let last = res.length - 1
         temp_rows.push(res[last])
         fo_summ.placement_all += +res[last].placement_all
        fo_summ.placement_week += +res[last].placement_week
        fo_summ.entrance_all += +res[last].entrance_all
        fo_summ.entrance_week += +res[last].entrance_week
        fo_summ.sending_conclusion_all += +res[last].sending_conclusion_all
        fo_summ.sending_conclusion_week += +res[last].sending_conclusion_week
        fo_summ.decision_false_all += +res[last].decision_false_all
        fo_summ.decision_false_week += +res[last].decision_false_week
        fo_summ.deletion_all += +res[last].deletion_all
        fo_summ.deletion_week += +res[last].deletion_week
        fo_summ.online_acts_all += +res[last].online_acts_all
        fo_summ.online_acts_week += +res[last].online_acts_week
         total_summ.placement_all += +res[last].placement_all
        total_summ.placement_week += +res[last].placement_week
        total_summ.entrance_all += +res[last].entrance_all
        total_summ.entrance_week += +res[last].entrance_week
        total_summ.sending_conclusion_all += +res[last].sending_conclusion_all
        total_summ.sending_conclusion_week += +res[last].sending_conclusion_week
        total_summ.decision_false_all += +res[last].decision_false_all
        total_summ.decision_false_week += +res[last].decision_false_week
        total_summ.deletion_all += +res[last].deletion_all
        total_summ.deletion_week += +res[last].deletion_week
        total_summ.online_acts_all += +res[last].online_acts_all
        total_summ.online_acts_week += +res[last].online_acts_week
         let clone_fo = {} //клонируем объект для передачи по значению
        for (let key in fo_summ) {
            clone_fo[key] = fo_summ[key]
        }
         temp_rows.push(clone_fo)
         temp_rows[0] = total_summ
         this.rows = temp_rows
    */
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		this.rows = [];
		this.fillTable(this.start, this.end);

		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$on('stat-date', function (date) {
			// console.log('mon',date)
			_this2.fillTable(date.start, date.end);
		});

		var dispay_width = document.documentElement.clientWidth;
		var dispay_height = document.documentElement.clientHeight;
		var scroll_width = 17;

		var ua = navigator.userAgent;

		// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))

		if (ua.search('OPR/') > 0) {
			scroll_width = 15;
		}

		var table_width = dispay_width - 30 - scroll_width;
		var col_width = Math.ceil(table_width / 13);

		document.querySelectorAll('.m-td').forEach(function (td) {
			td.width = col_width;
		});
		document.querySelector('.m-header-wrapper').width = table_width;
		document.querySelector('.m-body-wrapper').width = table_width;
		document.querySelector('.m-body-wrapper').style.maxHeight = dispay_height - 340 + 'px';

		// console.log(dispay_width, col_width, table_width)

		document.querySelector('.m-scroll').width = scroll_width;
	},
	created: function created() {
		if (!this.$parent.$parent.reports.some(function (e) {
			return e.id == REPORT_ID;
		})) __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].replace('/main');
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_3__lib_EventBus__["a" /* EventBus */].$off('stat-date');
	}
});

/***/ }),

/***/ "ohbW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var GET_MONITORING_REPORT = 'get_monitoring_report.php';
var REPORT_ID = 1;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Monitoring',
	data: function data() {
		return {
			rows: []
		};
	},
	props: ['start', 'end'],
	computed: {
		endYear: function endYear() {
			return this.$props.end.split('.')[2];
		}
	},
	methods: {
		fillTable: function fillTable(start, end) {
			var _this = this;

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + GET_MONITORING_REPORT + '?start=' + start + '&end=' + end).then(function (res) {
				return res.json();
			}).then(function (res) {
				var temp_rows = [{}];
				var flag = true;
				var total_summ = {};
				total_summ.region = 'Итого по РФ';
				total_summ.placement_all = 0;
				total_summ.placement_week = 0;
				total_summ.entrance_all = 0;
				total_summ.entrance_week = 0;
				total_summ.sending_conclusion_all = 0;
				total_summ.sending_conclusion_week = 0;
				total_summ.decision_false_all = 0;
				total_summ.decision_false_week = 0;
				total_summ.deletion_all = 0;
				total_summ.deletion_week = 0;
				total_summ.online_acts_all = 0;
				total_summ.online_acts_week = 0;

				var fo_summ = {};
				fo_summ.region = 'Итого по округу';
				fo_summ.placement_all = 0;
				fo_summ.placement_week = 0;
				fo_summ.entrance_all = 0;
				fo_summ.entrance_week = 0;
				fo_summ.sending_conclusion_all = 0;
				fo_summ.sending_conclusion_week = 0;
				fo_summ.decision_false_all = 0;
				fo_summ.decision_false_week = 0;
				fo_summ.deletion_all = 0;
				fo_summ.deletion_week = 0;
				fo_summ.online_acts_all = 0;
				fo_summ.online_acts_week = 0;

				var i = 0;

				while (i < res.length - 1) {

					if (res[i].fo === res[i + 1].fo && flag) {
						var obj = {};
						obj.fo = res[i].fo;
						obj.flag = true;
						flag = false;

						if (i !== 0) {
							var _clone_fo = {}; //клонируем объект для передачи по значению
							for (var key in fo_summ) {
								_clone_fo[key] = fo_summ[key];
							}

							temp_rows.push(_clone_fo);

							fo_summ.placement_all = 0;
							fo_summ.placement_week = 0;
							fo_summ.entrance_all = 0;
							fo_summ.entrance_week = 0;
							fo_summ.sending_conclusion_all = 0;
							fo_summ.sending_conclusion_week = 0;
							fo_summ.decision_false_all = 0;
							fo_summ.decision_false_week = 0;
							fo_summ.deletion_all = 0;
							fo_summ.deletion_week = 0;
							fo_summ.online_acts_all = 0;
							fo_summ.online_acts_week = 0;
						}

						temp_rows.push(obj);
					} else {
						total_summ.placement_all += +res[i].placement_all;
						total_summ.placement_week += +res[i].placement_week;
						total_summ.entrance_all += +res[i].entrance_all;
						total_summ.entrance_week += +res[i].entrance_week;
						total_summ.sending_conclusion_all += +res[i].sending_conclusion_all;
						total_summ.sending_conclusion_week += +res[i].sending_conclusion_week;
						total_summ.decision_false_all += +res[i].decision_false_all;
						total_summ.decision_false_week += +res[i].decision_false_week;
						total_summ.deletion_all += +res[i].deletion_all;
						total_summ.deletion_week += +res[i].deletion_week;
						total_summ.online_acts_all += +res[i].online_acts_all;
						total_summ.online_acts_week += +res[i].online_acts_week;

						fo_summ.placement_all += +res[i].placement_all;
						fo_summ.placement_week += +res[i].placement_week;
						fo_summ.entrance_all += +res[i].entrance_all;
						fo_summ.entrance_week += +res[i].entrance_week;
						fo_summ.sending_conclusion_all += +res[i].sending_conclusion_all;
						fo_summ.sending_conclusion_week += +res[i].sending_conclusion_week;
						fo_summ.decision_false_all += +res[i].decision_false_all;
						fo_summ.decision_false_week += +res[i].decision_false_week;
						fo_summ.deletion_all += +res[i].deletion_all;
						fo_summ.deletion_week += +res[i].deletion_week;
						fo_summ.online_acts_all += +res[i].online_acts_all;
						fo_summ.online_acts_week += +res[i].online_acts_week;

						temp_rows.push(res[i]);
						if (res[i].fo !== res[i + 1].fo) {
							flag = true;
						}
						i++;
					}
				}

				var last = res.length - 1;

				temp_rows.push(res[last]);

				fo_summ.placement_all += +res[last].placement_all;
				fo_summ.placement_week += +res[last].placement_week;
				fo_summ.entrance_all += +res[last].entrance_all;
				fo_summ.entrance_week += +res[last].entrance_week;
				fo_summ.sending_conclusion_all += +res[last].sending_conclusion_all;
				fo_summ.sending_conclusion_week += +res[last].sending_conclusion_week;
				fo_summ.decision_false_all += +res[last].decision_false_all;
				fo_summ.decision_false_week += +res[last].decision_false_week;
				fo_summ.deletion_all += +res[last].deletion_all;
				fo_summ.deletion_week += +res[last].deletion_week;
				fo_summ.online_acts_all += +res[last].online_acts_all;
				fo_summ.online_acts_week += +res[last].online_acts_week;

				total_summ.placement_all += +res[last].placement_all;
				total_summ.placement_week += +res[last].placement_week;
				total_summ.entrance_all += +res[last].entrance_all;
				total_summ.entrance_week += +res[last].entrance_week;
				total_summ.sending_conclusion_all += +res[last].sending_conclusion_all;
				total_summ.sending_conclusion_week += +res[last].sending_conclusion_week;
				total_summ.decision_false_all += +res[last].decision_false_all;
				total_summ.decision_false_week += +res[last].decision_false_week;
				total_summ.deletion_all += +res[last].deletion_all;
				total_summ.deletion_week += +res[last].deletion_week;
				total_summ.online_acts_all += +res[last].online_acts_all;
				total_summ.online_acts_week += +res[last].online_acts_week;

				var clone_fo = {}; //клонируем объект для передачи по значению
				for (var _key in fo_summ) {
					clone_fo[_key] = fo_summ[_key];
				}

				temp_rows.push(clone_fo);

				temp_rows[0] = total_summ;

				_this.rows = temp_rows;
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		this.rows = [];
		this.fillTable(this.start, this.end);

		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on('monitoring-date', function (date) {
			// console.log('mon',date)
			_this2.fillTable(date.start, date.end);
		});

		var dispay_width = document.documentElement.clientWidth;
		var dispay_height = document.documentElement.clientHeight;
		var scroll_width = 17;

		var ua = navigator.userAgent;

		// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))

		if (ua.search('OPR/') > 0) {
			scroll_width = 15;
		}

		var table_width = dispay_width - 30 - scroll_width;
		var col_width = Math.ceil(table_width / 13);

		document.querySelectorAll('.m-td').forEach(function (td) {
			td.width = col_width;
		});
		document.querySelector('.m-header-wrapper').width = table_width;
		document.querySelector('.m-body-wrapper').width = table_width;
		document.querySelector('.m-body-wrapper').style.maxHeight = dispay_height - 340 + 'px';

		// console.log(dispay_width, col_width, table_width)

		document.querySelector('.m-scroll').width = scroll_width;
	},
	created: function created() {
		/*if(!this.$parent.$parent.reports.some((e) => {
  	return e.id == REPORT_ID
  }))
  	router.replace('/main')*/
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('monitoring-date');
	}
});

/***/ }),

/***/ "oyOU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mzl_vue__ = __webpack_require__("tuV/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ac1966c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Mzl_vue__ = __webpack_require__("V7ym");
function injectStyle (ssrContext) {
  __webpack_require__("Au1H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8ac1966c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mzl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ac1966c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Mzl_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p6OC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var FORESTRY = 'forestrie_list.php';
var HEADER = 'get_header.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'forestry',
	data: function data() {
		return {
			selected: '0',
			options: [],
			id: this.type + '_forestry'
		};
	},
	props: {
		type: '',
		reg_id: '',
		f_id: ''
	},
	methods: {
		fill: function fill(id) {
			var _this = this;

			//console.log(id)
			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + FORESTRY + '?id=' + id).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					// this.selected = select ? select : '0'
					_this.options = [{ id: '0', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
					_this.selected = _this.f_id ? _this.f_id : '0';
				} else {
					_this.selected = '0';
					_this.options = [];
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	watch: {
		reg_id: function reg_id(r) {
			if (r) {
				this.fill(r);
			}
		}
	}
});

/***/ }),

/***/ "pEw+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subforestry_vue__ = __webpack_require__("vW3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1862856f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_subforestry_vue__ = __webpack_require__("hoGZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subforestry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1862856f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_subforestry_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pY7n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forestPurpose_vue__ = __webpack_require__("tAxI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39561ba4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_forestPurpose_vue__ = __webpack_require__("aUj4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forestPurpose_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39561ba4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_forestPurpose_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pt6s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control table-control my-control",attrs:{"id":_vm.id,"data-num":"f_20","data-table":"1","disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qI5z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("8x0Q");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__constants__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__constants__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__constants__["b"]; });


/***/ }),

/***/ "qm+7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_npaViolations_vue__ = __webpack_require__("aWQz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_400d5694_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_npaViolations_vue__ = __webpack_require__("jW3/");
function injectStyle (ssrContext) {
  __webpack_require__("4y5K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_npaViolations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_400d5694_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_npaViolations_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rQ3I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rQ6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var GET_FO = 'get_fo.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'FoList',
	data: function data() {
		return {
			selected_fo: '',
			options_fo: []
		};
	},
	props: {
		all: false
	},
	watch: {
		selected_fo: function selected_fo(val) {
			if (val == -1) {
				//select all FO
				__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('change_fo', { id: -1, name: 'Все федеральные округа' });
			} else {
				__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('change_fo', this.options_fo.find(function (e) {
					return e.id == val;
				}));
			}
		}
	},
	methods: {
		fill_fo: function fill_fo() {
			var _this = this;

			fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + GET_FO, {
				credentials: 'include'
			}).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.options_fo = data;
					_this.selected_fo = _this.options_fo[0].id;
					__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('change_fo', _this.options_fo[0]);
				} else {
					_this.options_fo = [];
					_this.selected_fo = null;
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	created: function created() {
		this.fill_fo();
	},
	beforeDestroy: function beforeDestroy() {}
});

/***/ }),

/***/ "raIG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_actionType_vue__ = __webpack_require__("igSH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69b65156_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_actionType_vue__ = __webpack_require__("+HUB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_actionType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69b65156_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_actionType_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "raWs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var FILTER = 'get_filter.php';
var LIST_OFFSET = 20;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Filter',
	data: function data() {
		return {
			all_items: [],
			items: [],
			offset: 0,
			sel: true,
			val: false,
			filtered: false,
			saved_items: [],
			loading: false,
			text: '',
			scrollDebounce: false,
			FILTER: null,
			flag: false
		};
	},

	props: ['name', 'field', 'filter', 'suffix', 'wideWindow', 'rightAlign', 'year'],
	components: {
		dropdown: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["dropdown"],
		checkbox: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["checkbox"]
	},
	watch: {
		sel: function sel(e) {
			this.all_items.map(function (t) {
				t.checked = e;
			});
		},
		text: function text(s) {
			if (s && s.length) {
				this.items = [];
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.all_items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var line = _step.value;

						var needle = s.toLowerCase();
						if (line.value.toLowerCase().indexOf(needle) !== -1) {
							var temp_line = line;
							var regexp = new RegExp('(' + needle + ')', "i");
							temp_line.show_value = temp_line.value.replace(regexp, '<span class="needle">$1</span>');
							this.items.push(temp_line);
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				this.setCheckedToItems();
			} else {
				this.items = this.all_items.slice(0, this.offset);
			}
			this.$forceUpdate();
		}
	},
	methods: {
		checkboxInput: function checkboxInput(value, rank) {
			//console.warn(value, rank)
			//const
			//for(let i in this.all_items)
			//	if(this.all_items[i].dense_rank == rank)

			//console.warn(value, rank)

			this.all_items[+rank].checked = value;

			var result = [];
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.all_items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var item = _step2.value;

					if (item.checked) result.push(item.value);
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			this.filtered = result.length !== this.all_items.length && result.length !== 0;
			//EventBus.$emit('filter' + (this.suffix ? this.suffix : ''), {field: this.field, value: this.filtered ? result : [], filtered: this.filtered})

			//console.warn(this.all_items[81])
		},
		setCheckedToItems: function setCheckedToItems() {
			for (var i = 0; i < this.items.length; i++) {
				//if (typeof this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')] !== 'undefined') {
				/*this.sel = false
    this.items[i].checked = false
    let flag = false
    for (let j = 0; j < this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')].value.length; j++) {
    	if (this.items[i].value === this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')].value[j]) {
    		this.items[i].checked = true
    		flag = true
    	}
    	else if (!flag) {
    		this.items[i].checked = false
    		flag = false
    	}
    }*/
				// else {
				//	const rank = this.items[i].rank
				//	this.items[i].checked = this.sel ? true : this.all_items[+rank].checked
				//}
			}
		},
		listScrollHandler: function listScrollHandler(e) {
			var _this = this;

			if (this.text) return false;

			if (this.scrollDebounce) {
				setTimeout(function () {
					_this.scrollDebounce = false;
					_this.listScrollHandler(e);
				}, 500);
				return false;
			}

			if (e.target.scrollTop + e.target.clientHeight + 100 >= e.target.scrollHeight && this.offset < this.all_items.length) {
				this.scrollDebounce = true;
				setTimeout(function () {
					return _this.scrollDebounce = false;
				}, 500);

				this.offset += LIST_OFFSET;
				this.items = this.all_items.slice(0, this.offset);
				this.setCheckedToItems();
			}
		},
		ok: function ok() {
			this.val = false;
			this.text = '';
			var result = [];

			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.all_items), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var item = _step3.value;

					if (item.checked) result.push(item.value);
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			this.filtered = result.length !== this.all_items.length && result.length !== 0;

			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('filter' + (this.suffix ? this.suffix : ''), { field: this.field, value: this.filtered ? result : [], filtered: this.filtered });
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('filter' + (this.suffix ? this.suffix : '') + '_list', { field: this.field, value: this.filtered ? result : [], filtered: this.filtered });
		},
		cancel: function cancel() {
			this.val = false;
		},
		open: function open(show) {
			var _this2 = this;

			if (show) {
				this.loading = true;
				var where = '(';
				for (var f in this.filter) {
					var _field_name = f;
					_field_name = _field_name.replace(this.suffix, '');

					if (_field_name == 'conclusion_date' || _field_name == 'act_placement_date') {
						if (this.filter[f].length == 2) {
							var from = this.filter[f][0];
							var to = this.filter[f][1];
							where += _field_name + ' BETWEEN \'' + from + '\' AND \'' + to + '\'  or ';
						}
					} else {
						for (var i = 0; i < this.filter[f].length; i++) {
							if (_field_name !== this.field) where += _field_name + ' = \'' + this.filter[f][i] + '\' or ';
						}
					}
					if (_field_name !== this.field) {
						where = this.filter[f].length !== 0 ? where.slice(0, -4) : where;
						where += this.filter[f].length !== 0 ? ') and (' : '';
					}
				}
				where = where.slice(0, -6);
				if (where && where.length) {
					if (this.year) {
						where += ' and ';
						where += '(act_placement_date BETWEEN \'' + this.year + '-01-01\' AND \'' + this.year + '-12-31\')';
					}
				}

				var field_name = this.field;
				if (this.suffix) field_name = field_name.replace(this.suffix, '');

				if (typeof this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')] == 'undefined') this.sel = true;else this.sel = false;

				fetch(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + this.FILTER + '?field=' + field_name + '&filter=' + where).then(function (res) {
					return res.json();
				}).then(function (res) {
					if (res) {
						var arr = res.map(function (r, i) {
							return {
								value: r[field_name] ? field_name !== 'act_placement_date' && field_name !== 'conclusion_date' ? r[field_name] : __WEBPACK_IMPORTED_MODULE_4_moment___default()(r[field_name], 'YYYY-MM-DD').format('DD.MM.YYYY') : '',
								checked: _this2.sel,
								rank: r.dense_rank,
								show_value: ''
							};
						});

						//console.warn(this.$parent.$parent.selected_filters)

						_this2.all_items = arr;
						//debugger;
						if (typeof _this2.$parent.$parent.selected_filters[_this2.field + (_this2.suffix ? _this2.suffix : '')] !== 'undefined') {
							//this.sel = false

							var saved_filter = _this2.$parent.$parent.selected_filters[_this2.field + (_this2.suffix ? _this2.suffix : '')].value;

							for (var _i = 0; _i < _this2.all_items.length; _i++) {
								if (saved_filter.includes(_this2.all_items[_i].value)) _this2.all_items[_i].checked = true;else _this2.all_items[_i].checked = false;
							}
						}
						//console.warn(this.all_items)

						/*for (let i = 0; i < arr.length; i++) {
      	for (let j = 0; j < this.all_items.length; j++) {
      		if (arr[i].value === this.all_items[j].value) {
      			arr[i].checked = this.all_items[j].checked
      		}
      	}
      }*/
					} else {
						_this2.all_items = [];
					}
					_this2.text = '';
					_this2.offset = LIST_OFFSET;
					_this2.items = _this2.all_items.slice(0, _this2.offset);
					_this2.setCheckedToItems();
					_this2.loading = false;
				}).catch(function (err) {
					return console.log(err);
				});
			}
		},
		fill: function fill() {
			var _this3 = this;

			fetch(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + this.FILTER + '?field=' + this.field + '&filter=').then(function (res) {
				return res.json();
			}).then(function (res) {
				if (res) {
					var arr = res.map(function (r) {
						return {
							value: r[_this3.field] ? _this3.field !== 'act_placement_date' ? r[_this3.field] : __WEBPACK_IMPORTED_MODULE_4_moment___default()(r[_this3.field], 'YYYY-MM-DD').format('DD.MM.YYYY') : '',
							checked: true
						};
					});
					_this3.all_items = arr;
				} else {
					_this3.all_items = [];
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	created: function created() {
		var _this4 = this;

		if (typeof this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')] !== 'undefined') {
			this.filtered = this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')].filtered;
		} else {
			this.saved_items = [];
		}

		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on('clearFilters' + (this.suffix ? this.suffix : ''), function (f) {
			_this4.filtered = false;
			_this4.sel = true;
			_this4.all_items = [];
			_this4.fill();
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('filter' + (_this4.suffix ? _this4.suffix : ''), { field: _this4.field, value: [], filtered: false, cf: true });
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('filter' + (_this4.suffix ? _this4.suffix : '') + '_list', { field: _this4.field, value: [], filtered: false, cf: true });
		});
	},
	mounted: function mounted() {
		this.FILTER = 'get_filter' + (this.suffix ? this.suffix : '') + '.php';
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('clearFilters' + (this.suffix ? this.suffix : ''));
	}
});

/***/ }),

/***/ "riCz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.disabled},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s6+2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__("Uhku");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c9c938e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__("eTRH");
function injectStyle (ssrContext) {
  __webpack_require__("cgn1")
  __webpack_require__("yUMX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c9c938e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c9c938e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sAI+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var PROTECTIVE_CAT = 'get_protective_cat.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'protectiveCat',
	data: function data() {
		return {
			selected: '',
			options: []
		};
	},
	props: {
		line_count: 0,
		type: '',
		id: null
	},
	watch: {
		id: function id(val) {
			if (val) {
				this.selected = val;
			}
		}
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit(this.type + '_protective_cat', { index: this.line_count, value: this.selected });
			//EventBus.$emit(`${this.type}_protective_cat_${this.line_count}`, this.selected)
		}
	},
	created: function created() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + PROTECTIVE_CAT, {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (data) {
			if (data) {
				_this.options = data;
				_this.selected = _this.id ? _this.id : data[0].id;
				_this.change();
			} else {
				_this.options = [];
			}
		}).catch(function (err) {
			return console.log(err);
		});
	}
});

/***/ }),

/***/ "sFFk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("qI5z");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var NPA_VIOLATION = 'get_npa_violation_new.php';
var ACT_INFO = 'get_act_info.php';
var WARRANT_INFO = 'get_warrant_info.php';

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'npaViolation',
	data: function data() {
		return {
			items: [],
			names: '',
			names_obj: {},
			val: false,
			sel: false,
			formattedDate: ""
		};
	},

	props: {
		npa_disabled: false,
		ids: ''
	},
	components: {
		dropdown: __WEBPACK_IMPORTED_MODULE_0_vue_strap__["dropdown"],
		checkbox: __WEBPACK_IMPORTED_MODULE_0_vue_strap__["checkbox"]
	},
	watch: {
		sel: function sel(e) {
			this.items.map(function (t) {
				t.checked = e;
			});
		}
	},
	methods: {
		check: function check(id, name, value) {
			if (value) this.names_obj[id] = name;else this.names_obj[id] = null;

			var text = '';
			var ids = [];
			for (var key in this.names_obj) {
				if (typeof this.names_obj[key] != 'undefined' && this.names_obj[key] != null) {
					text += this.names_obj[key] + ', ';
					ids.push(key);
				}
			}

			text = text.slice(0, -2);

			if (text.length > 105) this.names = text.slice(0, 105) + '...';else this.names = text;

			//console.warn(ids)
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('warrant_npa_violation_ids', ids);
		},
		open: function open(show) {
			if (show) {
				var _ids = '';
				for (var i = 0; i < this.ids.length; i++) {
					_ids += this.ids[i];
				}

				_ids = _ids.slice(1, -1).split(',');
				for (var _i = 0; _i < _ids.length; _i++) {
					for (var j = 0; j < this.items.length; j++) {
						if (_ids[_i] == this.items[j].id) {
							this.items[j].checked = true;
						}
					}
				}
			}
		},
		fill: function fill(ids) {
			var _this = this;

			fetch(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + NPA_VIOLATION + "?date=" + this.formattedDate).then(function (res) {
				return res.json();
			}).then(function (res) {
				if (res) {
					var arr = res.map(function (r) {
						return {
							id: r.id,
							name: r.name,
							violation: r.violation,
							checked: false
						};
					});

					if (typeof ids != 'undefined') {
						var text = '';
						for (var i = 0; i < ids.length; i++) {
							for (var j = 0; j < arr.length; j++) {
								if (ids[i] == arr[j].id) {
									text += arr[j].name + ', ';
								}
							}
						}

						text = text.slice(0, -2);

						if (text.length > 105) _this.names = text.slice(0, 105) + '...';else _this.names = text;
					}

					_this.items = arr;
				} else {
					_this.items = [];
				}
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	created: function created() {
		var _this2 = this;

		fetch(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + ACT_INFO + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (res) {
			var act_date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(res[0].f_3, "YYYY-MM-DD");
			if (act_date.isValid()) {
				_this2.formattedDate = act_date.format("DD.MM.YYYY");
			} else {
				_this2.formattedDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format("DD.MM.YYYY");
			}

			fetch(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DB */] + WARRANT_INFO + '?id=' + _this2.$route.params.id, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				return res[0].f_92;
			}).then(function (ids) {
				if (ids) {
					ids = ids.slice(1, -1).split(',');
					_this2.fill(ids);
				} else {
					_this2.fill();
				}
			});
		});
	}
});

/***/ }),

/***/ "sJgg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"my-control form-control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "shda":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var NPA_VIOLATION_NEW = 'get_npa_violation_new.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'npaViolation',
	data: function data() {
		return {
			selected: '',
			options: [],
			internal_id: null
		};
	},
	props: {
		id: null,
		line_count: null,
		disabled: false
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('npa_violation', { index: this.$props.line_count, value: this.selected });
		}
	},
	created: function created() {
		var _this = this;

		/*fetch(DB + NPA_VIOLATION_NEW, {
  	credentials: 'include'
  })
  .then(data => data.json())
  .then(data => {
  	if (data) {
  		this.options = data
  		this.selected = this.internal_id ? this.internal_id : data[0].id
  		this.internal_id = null
  	}
  	else {
  		this.options = []
  	}
  })
  .catch(err => console.log(err))*/

		this.internal_id = this.$props.id;
		if (this.$parent.npa_violations.length) {
			this.options = this.$parent.npa_violations;
			this.selected = this.internal_id ? this.internal_id : this.options[0].id;
			this.internal_id = null;
		} else {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$on('fetch_npa_violations_complete', function () {
				_this.options = _this.$parent.npa_violations;
				_this.selected = _this.internal_id ? _this.internal_id : _this.options[0].id;
				_this.internal_id = null;
			});
		}
	}
});

/***/ }),

/***/ "suaB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control table-control my-control",attrs:{"id":_vm.id,"data-num":"f_20","data-table":"1","disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t+BB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t9MA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_select2__ = __webpack_require__("hv7s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_select2_dist_css_select2_css__ = __webpack_require__("+3jA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_select2_dist_css_select2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_select2_dist_css_select2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var SPECIES = 'get_species.php';
var ACT_LOCATION = 'get_act_location.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'species',
	data: function data() {
		return {
			selected: '0',
			options: []
		};
	},
	props: {
		line_count: '',
		sp_id: ''
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_5__lib_EventBus__["a" /* EventBus */].$emit('species', { index: this.line_count, value: this.selected });
		}
	},
	mounted: function mounted() {
		var _this = this;

		var region_id = this.$parent.f_12;

		fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + SPECIES + ('?region_id=' + region_id), {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (data) {
			if (data) {
				//console.warn(this.sp_id)
				_this.options = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
				_this.selected = _this.sp_id ? _this.sp_id : '';
			} else {
				_this.options = [];
			}

			return { id: _this.selected, text: _this.options[1].children.find(function (e) {
					return e.id == _this.selected;
				}) };
		}).then(function (data) {
			if (data.id) {
				data.text = data.text.name;
				if (__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#species_' + _this.$props.line_count).find("option[value='" + data.id + "']").length) {
					__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#species_' + _this.$props.line_count).val(data.id).trigger('change');
				} else {
					var newOption = new Option(data.text, data.id, true, true);
					__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#species_' + _this.$props.line_count).append(newOption).trigger('change');
				}
			}
		}).catch(function (err) {
			return console.log(err);
		});

		__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).ready(function () {
			__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#species_' + _this.$props.line_count).select2({});
			__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#species_' + _this.$props.line_count).on('change', function (e) {
				_this.$emit('input', e.target.value);
			});
		});

		this.$on('input', function (id) {
			__WEBPACK_IMPORTED_MODULE_5__lib_EventBus__["a" /* EventBus */].$emit('species', { index: _this.$props.line_count, value: id });
		});
	}
});

/***/ }),

/***/ "tAxI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var FOREST_PURPOSE = 'get_forest_purpose.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'forestPurpose',
	data: function data() {
		return {
			selected: '',
			options: []
		};
	},
	props: {
		line_count: 0,
		type: '',
		id: ''
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit(this.type + '_forest_purpose', { index: this.line_count, value: this.selected });
		}
	},
	created: function created() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + FOREST_PURPOSE, {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (data) {
			if (data) {
				_this.options = data;
				_this.selected = _this.id ? _this.id : data[0].id;
				_this.change();
			} else {
				_this.options = [];
			}
		}).catch(function (err) {
			return console.log(err);
		});
	}
});

/***/ }),

/***/ "tDd1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var ACTION_TYPE = 'get_action_type.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'actionType',
	data: function data() {
		return {
			selected: '0',
			options: []
		};
	},
	props: {
		line_count: '',
		id: null
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('action_type', { index: this.line_count, value: this.selected });
		}
	},
	created: function created() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + ACTION_TYPE, {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (data) {
			if (data) {
				_this.options = data;
				if (_this.id) {
					_this.selected = _this.id;
					_this.change();
				}
			} else {
				_this.options = [];
			}
		}).catch(function (err) {
			return console.log(err);
		});
	}
});

/***/ }),

/***/ "tcnj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("0pd7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_855b781a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("iEyu");
function injectStyle (ssrContext) {
  __webpack_require__("rQ3I")
  __webpack_require__("ZjKP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-855b781a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_855b781a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tpcH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('div',{staticClass:"tooltip_warn"},[_c('div',{staticClass:"tooltip_warn_close",on:{"click":_vm.close}},[_vm._v("x")]),_vm._v("\n\tДля данного вида мероприятий возможен ввод только целочисленных значений\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tuV/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var GET_MZL_REPORT = 'get_mzl_report.php';
var REPORT_ID = 3;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Mzl',
	data: function data() {
		return {
			rows: []
		};
	},
	props: ['start', 'end'],
	methods: {
		fillTable: function fillTable(start, end) {
			var _this = this;

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + GET_MZL_REPORT + '?start=' + start + '&end=' + end).then(function (res) {
				return res.json();
			}).then(function (res) {
				var temp_rows = [{}];
				var flag = true;
				var total_summ = {};
				total_summ.region = 'Итого по РФ';
				total_summ.lpo_volume = 0;
				total_summ.mzl_volume_published = 0;
				total_summ.mzl_volume_obtained = 0;
				total_summ.mzl_volume_obtained_som = 0;
				total_summ.mzl_volume_obtained_prof = 0;
				total_summ.mzl_volume_obtained_agit = 0;
				total_summ.mzl_volume_obtained_ssr = 0;
				total_summ.mzl_volume_obtained_vsr = 0;
				total_summ.mzl_volume_obtained_und = 0;
				total_summ.mzl_volume_obtained_rad = 0;
				total_summ.mzl_volume_obtained_others = 0;
				total_summ.mzl_volume_obtained_negative_ssr = 0;
				total_summ.mzl_volume_obtained_negative_vsr = 0;
				total_summ.mzl_volume_obtained_negative_und = 0;
				total_summ.mzl_volume_obtained_negative_rad = 0;
				total_summ.mzl_volume_obtained_negative_others = 0;

				var fo_summ = {};
				fo_summ.region = 'Итого по округу';
				fo_summ.lpo_volume = 0;
				fo_summ.mzl_volume_published = 0;
				fo_summ.mzl_volume_obtained = 0;
				fo_summ.mzl_volume_obtained_som = 0;
				fo_summ.mzl_volume_obtained_prof = 0;
				fo_summ.mzl_volume_obtained_agit = 0;
				fo_summ.mzl_volume_obtained_ssr = 0;
				fo_summ.mzl_volume_obtained_vsr = 0;
				fo_summ.mzl_volume_obtained_und = 0;
				fo_summ.mzl_volume_obtained_rad = 0;
				fo_summ.mzl_volume_obtained_others = 0;
				fo_summ.mzl_volume_obtained_negative_ssr = 0;
				fo_summ.mzl_volume_obtained_negative_vsr = 0;
				fo_summ.mzl_volume_obtained_negative_und = 0;
				fo_summ.mzl_volume_obtained_negative_rad = 0;
				fo_summ.mzl_volume_obtained_negative_others = 0;

				var i = 0;

				while (i < res.length - 1) {

					if (res[i].fo === res[i + 1].fo && flag) {
						var obj = {};
						obj.fo = res[i].fo;
						obj.flag = true;
						flag = false;

						if (i !== 0) {
							var _clone_fo = {}; //клонируем объект для передачи по значению
							for (var key in fo_summ) {
								_clone_fo[key] = fo_summ[key];
							}

							temp_rows.push(_clone_fo);

							fo_summ.lpo_volume = 0;
							fo_summ.mzl_volume_published = 0;
							fo_summ.mzl_volume_obtained = 0;
							fo_summ.mzl_volume_obtained_som = 0;
							fo_summ.mzl_volume_obtained_prof = 0;
							fo_summ.mzl_volume_obtained_agit = 0;
							fo_summ.mzl_volume_obtained_ssr = 0;
							fo_summ.mzl_volume_obtained_vsr = 0;
							fo_summ.mzl_volume_obtained_und = 0;
							fo_summ.mzl_volume_obtained_rad = 0;
							fo_summ.mzl_volume_obtained_others = 0;
							fo_summ.mzl_volume_obtained_negative_ssr = 0;
							fo_summ.mzl_volume_obtained_negative_vsr = 0;
							fo_summ.mzl_volume_obtained_negative_und = 0;
							fo_summ.mzl_volume_obtained_negative_rad = 0;
							fo_summ.mzl_volume_obtained_negative_others = 0;
						}

						temp_rows.push(obj);
					} else {
						total_summ.lpo_volume += +res[i].lpo_volume;
						total_summ.mzl_volume_published += +res[i].mzl_volume_published;
						total_summ.mzl_volume_obtained += +res[i].mzl_volume_obtained;
						total_summ.mzl_volume_obtained_som += +res[i].mzl_volume_obtained_som;
						total_summ.mzl_volume_obtained_prof += +res[i].mzl_volume_obtained_prof;
						total_summ.mzl_volume_obtained_agit += +res[i].mzl_volume_obtained_agit;
						total_summ.mzl_volume_obtained_ssr += +res[i].mzl_volume_obtained_ssr;
						total_summ.mzl_volume_obtained_vsr += +res[i].mzl_volume_obtained_vsr;
						total_summ.mzl_volume_obtained_und += +res[i].mzl_volume_obtained_und;
						total_summ.mzl_volume_obtained_rad += +res[i].mzl_volume_obtained_rad;
						total_summ.mzl_volume_obtained_others += +res[i].mzl_volume_obtained_others;
						total_summ.mzl_volume_obtained_negative_ssr += +res[i].mzl_volume_obtained_negative_ssr;
						total_summ.mzl_volume_obtained_negative_vsr += +res[i].mzl_volume_obtained_negative_vsr;
						total_summ.mzl_volume_obtained_negative_und += +res[i].mzl_volume_obtained_negative_und;
						total_summ.mzl_volume_obtained_negative_rad += +res[i].mzl_volume_obtained_negative_rad;
						total_summ.mzl_volume_obtained_negative_others += +res[i].mzl_volume_obtained_negative_others;

						fo_summ.lpo_volume += +res[i].lpo_volume;
						fo_summ.mzl_volume_published += +res[i].mzl_volume_published;
						fo_summ.mzl_volume_obtained += +res[i].mzl_volume_obtained;
						fo_summ.mzl_volume_obtained_som += +res[i].mzl_volume_obtained_som;
						fo_summ.mzl_volume_obtained_prof += +res[i].mzl_volume_obtained_prof;
						fo_summ.mzl_volume_obtained_agit += +res[i].mzl_volume_obtained_agit;
						fo_summ.mzl_volume_obtained_ssr += +res[i].mzl_volume_obtained_ssr;
						fo_summ.mzl_volume_obtained_vsr += +res[i].mzl_volume_obtained_vsr;
						fo_summ.mzl_volume_obtained_und += +res[i].mzl_volume_obtained_und;
						fo_summ.mzl_volume_obtained_rad += +res[i].mzl_volume_obtained_rad;
						fo_summ.mzl_volume_obtained_others += +res[i].mzl_volume_obtained_others;
						fo_summ.mzl_volume_obtained_negative_ssr += +res[i].mzl_volume_obtained_negative_ssr;
						fo_summ.mzl_volume_obtained_negative_vsr += +res[i].mzl_volume_obtained_negative_vsr;
						fo_summ.mzl_volume_obtained_negative_und += +res[i].mzl_volume_obtained_negative_und;
						fo_summ.mzl_volume_obtained_negative_rad += +res[i].mzl_volume_obtained_negative_rad;
						fo_summ.mzl_volume_obtained_negative_others += +res[i].mzl_volume_obtained_negative_others;

						for (var _key in fo_summ) {
							if (_key !== 'region') fo_summ[_key] = +fo_summ[_key].toFixed(2);
						}

						temp_rows.push(res[i]);
						if (res[i].fo !== res[i + 1].fo) {
							flag = true;
						}
						i++;
					}
				}

				var last = res.length - 1;

				temp_rows.push(res[last]);

				total_summ.lpo_volume += +res[last].lpo_volume;
				total_summ.mzl_volume_published += +res[last].mzl_volume_published;
				total_summ.mzl_volume_obtained += +res[last].mzl_volume_obtained;
				total_summ.mzl_volume_obtained_som += +res[last].mzl_volume_obtained_som;
				total_summ.mzl_volume_obtained_prof += +res[last].mzl_volume_obtained_prof;
				total_summ.mzl_volume_obtained_agit += +res[last].mzl_volume_obtained_agit;
				total_summ.mzl_volume_obtained_ssr += +res[last].mzl_volume_obtained_ssr;
				total_summ.mzl_volume_obtained_vsr += +res[last].mzl_volume_obtained_vsr;
				total_summ.mzl_volume_obtained_und += +res[last].mzl_volume_obtained_und;
				total_summ.mzl_volume_obtained_rad += +res[last].mzl_volume_obtained_rad;
				total_summ.mzl_volume_obtained_others += +res[last].mzl_volume_obtained_others;
				total_summ.mzl_volume_obtained_negative_ssr += +res[last].mzl_volume_obtained_negative_ssr;
				total_summ.mzl_volume_obtained_negative_vsr += +res[last].mzl_volume_obtained_negative_vsr;
				total_summ.mzl_volume_obtained_negative_und += +res[last].mzl_volume_obtained_negative_und;
				total_summ.mzl_volume_obtained_negative_rad += +res[last].mzl_volume_obtained_negative_rad;
				total_summ.mzl_volume_obtained_negative_others += +res[last].mzl_volume_obtained_negative_others;

				fo_summ.lpo_volume += +res[last].lpo_volume;
				fo_summ.mzl_volume_published += +res[last].mzl_volume_published;
				fo_summ.mzl_volume_obtained += +res[last].mzl_volume_obtained;
				fo_summ.mzl_volume_obtained_som += +res[last].mzl_volume_obtained_som;
				fo_summ.mzl_volume_obtained_prof += +res[last].mzl_volume_obtained_prof;
				fo_summ.mzl_volume_obtained_agit += +res[last].mzl_volume_obtained_agit;
				fo_summ.mzl_volume_obtained_ssr += +res[last].mzl_volume_obtained_ssr;
				fo_summ.mzl_volume_obtained_vsr += +res[last].mzl_volume_obtained_vsr;
				fo_summ.mzl_volume_obtained_und += +res[last].mzl_volume_obtained_und;
				fo_summ.mzl_volume_obtained_rad += +res[last].mzl_volume_obtained_rad;
				fo_summ.mzl_volume_obtained_others += +res[last].mzl_volume_obtained_others;
				fo_summ.mzl_volume_obtained_negative_ssr += +res[last].mzl_volume_obtained_negative_ssr;
				fo_summ.mzl_volume_obtained_negative_vsr += +res[last].mzl_volume_obtained_negative_vsr;
				fo_summ.mzl_volume_obtained_negative_und += +res[last].mzl_volume_obtained_negative_und;
				fo_summ.mzl_volume_obtained_negative_rad += +res[last].mzl_volume_obtained_negative_rad;
				fo_summ.mzl_volume_obtained_negative_others += +res[last].mzl_volume_obtained_negative_others;

				for (var _key2 in fo_summ) {
					if (_key2 !== 'region') fo_summ[_key2] = +fo_summ[_key2].toFixed(2);
				}

				var clone_fo = {}; //клонируем объект для передачи по значению
				for (var _key3 in fo_summ) {
					clone_fo[_key3] = fo_summ[_key3];
				}

				for (var _key4 in total_summ) {
					if (_key4 !== 'region') total_summ[_key4] = +total_summ[_key4].toFixed(2);
					// total_summ[key] = total_summ[key]
				}

				temp_rows.push(clone_fo);

				temp_rows[0] = total_summ;

				_this.rows = temp_rows;
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		this.fillTable(this.start, this.end);

		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on('mzl-date', function (date) {
			_this2.fillTable(date.start, date.end);
		});

		var dispay_width = document.documentElement.clientWidth;
		var dispay_height = document.documentElement.clientHeight;
		var scroll_width = 17;

		var ua = navigator.userAgent;
		if (ua.search('OPR/') > 0) {
			scroll_width = 15;
		}

		var table_width = dispay_width - 30 - scroll_width;
		var col_width = Math.ceil(table_width / 23);
		var double_col_width = 2 * col_width;

		document.querySelectorAll('.s-td-small').forEach(function (td) {
			td.width = col_width;
		});

		document.querySelectorAll('.s-td').forEach(function (td) {
			td.width = double_col_width;
		});

		document.querySelector('.s-header-wrapper').width = table_width;
		document.querySelector('.s-body-wrapper').width = table_width;
		document.querySelector('.s-body-wrapper').style.maxHeight = dispay_height - 340 + 'px';

		// console.log(dispay_width, col_width, table_width)


		// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))
		document.querySelector('.s-scroll').width = scroll_width;
	},
	updated: function updated() {
		var dispay_width = document.documentElement.clientWidth;
		var dispay_height = document.documentElement.clientHeight;
		var scroll_width = 17;

		var ua = navigator.userAgent;
		if (ua.search('OPR/') > 0) {
			scroll_width = 15;
		}

		var table_width = dispay_width - 30 - scroll_width;
		var col_width = Math.ceil(table_width / 23);
		var double_col_width = 2 * col_width;

		document.querySelectorAll('.s-td-small').forEach(function (td) {
			td.width = col_width;
		});
	},
	created: function created() {
		/*if(!this.$parent.$parent.reports.some((e) => {
  	return e.id == REPORT_ID
  }))
  	router.replace('/main')*/
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('mzl-date');
	}
});

/***/ }),

/***/ "u9oH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var LOCALFORESTRY = 'localforestrie_list.php';
var HEADER = 'get_header.php';
var LOCATION = 'get_conclusion_location.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'localforestry',
	data: function data() {
		return {
			selected: '0',
			options: [],
			id: this.type + '_localforestry_' + this.line_count
		};
	},
	props: {
		line_count: 0,
		type: ''
	},
	created: function created() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + HEADER + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			return res[2].val;
		}).then(function (id) {
			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + LOCALFORESTRY + '?id=' + id).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.options = [{ id: '0', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
				} else {
					_this.selected = '0';
					_this.options = [];
				}
			}).then(function () {
				fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + LOCATION + '?id=' + _this.$route.params.id, {
					credentials: 'include'
				}).then(function (res) {
					return res.json();
				}).then(function (res) {
					var lf = res.filter(function (item) {
						return item.field == 'f_20';
					});

					_this.selected = lf[_this.line_count] ? lf[_this.line_count].val : '0';
				}).catch(function (err) {
					return console.log('1', err);
				});
			}).catch(function (err) {
				return console.log('2', err);
			});
		}).catch(function (err) {
			return console.log('3', err);
		});
	}

});

/***/ }),

/***/ "uJ1M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_organization_vue__ = __webpack_require__("LEMR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4b3eafa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_organization_vue__ = __webpack_require__("mtrZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_organization_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4b3eafa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_organization_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uKak":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListDecisions_vue__ = __webpack_require__("4h8u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76d49014_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ListDecisions_vue__ = __webpack_require__("OxvV");
function injectStyle (ssrContext) {
  __webpack_require__("NgKa")
  __webpack_require__("n47g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76d49014"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListDecisions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76d49014_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ListDecisions_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uMkM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control",attrs:{"id":_vm.id,"data-num":"f_9","data-table":"1"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uc+W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('div',{staticClass:"tooltip_warn"},[_c('div',{staticClass:"tooltip_warn_close",on:{"click":_vm.close}},[_vm._v("x")]),_vm._v("\n\tДля данного вида мероприятий возможен ввод только целочисленных значений\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "usgw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v0ZA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();_vm.submit($event)}}},[_c('h4',[_vm._v("Мониторинг актов ЛПО (редактирование)")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-1 col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_2),expression:"f_2"}],staticClass:"form-control my-control",class:_vm.fields_correct.f_2,attrs:{"type":"text","disabled":_vm.readonly},domProps:{"value":(_vm.f_2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_2=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 col"},[_c('organization',{attrs:{"org_id":_vm.f_11,"disabled":_vm.readonly,"field_class":_vm.fields_correct.f_11}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_4),expression:"f_4"}],staticClass:"form-control my-control",attrs:{"type":"text","disabled":_vm.readonly},domProps:{"value":(_vm.f_4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_4=$event.target.value}}})])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 col"},[_c('fo',{attrs:{"type":"add","reg_id":_vm.f_12}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-3 col"},[_c('region',{attrs:{"type":"edit","reg_id":_vm.f_12,"disabled":_vm.readonly,"field_class":_vm.fields_correct.f_12}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-3 col"},[_c('forestry',{attrs:{"type":"edit","reg_id":_vm.f_12,"f_id":_vm.f_9,"disabled":_vm.readonly,"field_class":_vm.fields_correct.f_9}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-7",staticStyle:{"margin-bottom":"5px"}},[_c('input',{class:_vm.lines_correct,attrs:{"id":"btnAddLine","value":"Добавить","type":"button","disabled":_vm.readonly},on:{"click":_vm.addLine}}),_vm._v(" "),_c('input',{attrs:{"id":"btnCopyLine","value":"Дублировать отмеченное","type":"button","disabled":"true"},on:{"click":_vm.copyLine}}),_vm._v(" "),_c('input',{attrs:{"id":"btnDeleteLine","value":"Удалить отмеченное","type":"button","disabled":_vm.readonly},on:{"click":_vm.deleteLine}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"table_head_wrap"},[_c('table',{staticClass:"place_table place_table__top"},[_c('thead',[_c('tr',[_c('th',{staticClass:"form_td_chkbox"},[_c('input',{attrs:{"id":"chkBoxSelAll","type":"checkbox","disabled":_vm.readonly},on:{"click":_vm.selectAll}})]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Участковое лесничество *")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Подлес-во")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Квартал *")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Выдел *")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("S выдела *")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Лп. выдел")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("S лп. выдела")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Состав")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Возраст")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Полнота")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Запас")]),_vm._v(" "),_c('location-table-field',{attrs:{"field_name":"f_131","title":"СКС насаждения"},on:{"set":_vm.setSKSAllLocations}},[_vm._v("\n\t\t\t\t\t\t\t\tСКС насаждения\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("МЗЛ *")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("S МЗЛ (для РАД шт.)")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Целевое назначение лесов")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Категория защитных лесов")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("ОЗУ")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Порода")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Причина ослабления")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Комментарии")]),_vm._v(" "),_c('th',{attrs:{"width":_vm.scroll_width}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"table_body_wrap"},[_c('table',{staticClass:"place_table place_table__bottom"},[_c('tbody',_vm._l((_vm.lines),function(line,index){return _c('tr',[_c('td',{staticClass:"form_td_chkbox"},[_c('input',{staticClass:"checkbox control-access-first",attrs:{"type":"checkbox","data-index":index,"disabled":_vm.readonly}})]),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_20},[_c('localforestry',{attrs:{"line_count":index,"type":"edit","disabled":_vm.readonly,"f_id":line.f_9,"lf_id":line.f_20}})],1),_vm._v(" "),_c('td',{staticClass:"form_td",staticStyle:{"border-right":"none"}},[_c('subforestry',{attrs:{"line_count":index,"type":"edit","disabled":_vm.readonly,"lf_id":line.f_20,"sf_id":line.f_27}})],1),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_17},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_17),expression:"line.f_17"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":_vm.readonly,"data-field":"f_17","line_count":index},domProps:{"value":(line.f_17)},on:{"keyup":_vm.tdChange,"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_17", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_24},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_24),expression:"line.f_24"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":_vm.readonly,"data-field":"f_24","line_count":index},domProps:{"value":(line.f_24)},on:{"keyup":_vm.tdChange,"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_24", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_21},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_21),expression:"line.f_21"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":_vm.readonly,"data-field":"f_21","line_count":index},domProps:{"value":(line.f_21)},on:{"keyup":function (e) {_vm.tdChange(e)},"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_21", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_25),expression:"line.f_25"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":_vm.readonly},domProps:{"value":(line.f_25)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_25", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_23,staticStyle:{"border-right":"none"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_23),expression:"line.f_23"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","data-field":"f_23","data-line":index,"disabled":_vm.readonly},domProps:{"value":(line.f_23)},on:{"keyup":_vm.calcSLP,"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_23", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_111,staticStyle:{"border-right":"none"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_111),expression:"line.f_111"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","data-field":"f_111","data-line":index,"disabled":_vm.readonly},domProps:{"value":(line.f_111)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_111", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_112,staticStyle:{"border-right":"none"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_112),expression:"line.f_112"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","data-field":"f_112","data-line":index,"disabled":_vm.readonly},domProps:{"value":(line.f_112)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_112", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_113,staticStyle:{"border-right":"none"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_113),expression:"line.f_113"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","data-field":"f_113","data-line":index,"disabled":_vm.readonly},domProps:{"value":(line.f_113)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_113", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_114,staticStyle:{"border-right":"none"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_114),expression:"line.f_114"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","data-field":"f_114","data-line":index,"disabled":_vm.readonly},domProps:{"value":(line.f_114)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_114", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.f_131 ? "" : "field-error",staticStyle:{"border-right":"none"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_131),expression:"line.f_131"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","data-field":"f_131","data-line":index,"disabled":_vm.readonly},domProps:{"value":(line.f_131)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_131", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('action-type',{attrs:{"line_count":index,"disabled":_vm.readonly,"at_id":line.f_16}})],1),_vm._v(" "),_c('td',{staticClass:"form_td",staticStyle:{"position":"relative"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_22),expression:"line.f_22"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","data-field":"f_22","data-line":index,"disabled":_vm.readonly},domProps:{"value":(line.f_22)},on:{"keyup":_vm.calcSAT,"blur":function (e) {_vm.tryBlurMzl(e, line.f_22, line.f_16 == _vm.mzlRAD.id)},"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_22", $event.target.value)}}}),_vm._v(" "),_c('tooltip-warn',{key:index,attrs:{"value":line.f_22,"type-is-rad":line.f_16 == _vm.mzlRAD.id,"id":index}})],1),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_116),expression:"line.f_116"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","data-field":"f_116","data-line":index,"disabled":_vm.readonly},domProps:{"value":(line.f_116)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_116", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('forest-purpose',{attrs:{"line_count":index,"type":"edit","id":line.f_104,"disabled":_vm.readonly}})],1),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('protective-cat',{attrs:{"line_count":index,"type":"edit","id":line.f_105,"disabled":_vm.readonly}})],1),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('protective-cat-ext',{attrs:{"line_count":index,"type":"edit","id":line.f_106,"disabled":_vm.readonly}})],1),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('species',{attrs:{"line_count":index,"disabled":_vm.readonly,"sp_id":line.f_26}})],1),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('damage-reason',{attrs:{"line_count":index,"disabled":_vm.readonly,"dmg_id":line.f_19}})],1),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_18),expression:"line.f_18"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":_vm.readonly},domProps:{"value":(line.f_18)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_18", $event.target.value)}}})])])}))])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"20px","margin-bottom":"10px"}},[_c('div',{staticClass:"col-md-1",staticStyle:{"padding-right":"0"}},[_c('div',{staticClass:"left_input_wrapper"},[_c('span',{staticClass:"bold"},[_vm._v("S ЛПО *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_13),expression:"f_13"}],staticClass:"short_plus form-control my-control",class:_vm.fields_correct.f_13,staticStyle:{"float":"right"},attrs:{"type":"text","disabled":_vm.readonly},domProps:{"value":(_vm.f_13)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_13=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-11"},[_c('table',{staticClass:"table-mzl"},[_c('thead',[_c('tr',[_c('th',[_vm._v("\n\t\t\t\t\t\t\tS лп. выдела\n\t\t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.mzlRAD.name)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._l((_vm.mzlNoRAD),function(item){return _c('th',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t\t\t\t")])})],2)]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{attrs:{"rowspan":"2"}},[_vm._v(_vm._s(_vm.summ_s_lp))]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v(_vm._s(_vm.mzlRAD.value))]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v(_vm._s(_vm.value_summ))]),_vm._v(" "),_vm._l((_vm.mzlNoRAD),function(item){return _c('td',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(item.value)+"\n\t\t\t\t\t\t")])})],2),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":_vm.mzl.length}},[_vm._v(_vm._s(_vm.floatConvert(_vm.summ_s_action_type - _vm.mzlRAD.value)))])])])])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('table',{staticClass:"dateTable"},[_vm._m(5),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{class:_vm.fields_correct.f_1},[_c('datepicker',{staticClass:"table-control",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly},model:{value:(_vm.f_1),callback:function ($$v) {_vm.f_1=$$v},expression:"f_1"}})],1),_vm._v(" "),_c('td',{class:_vm.fields_correct.f_5},[_c('datepicker',{staticClass:"table-control",attrs:{"id":"edit_datepicker_f_5","format":"dd.MM.yyyy","disabled":_vm.readonly},on:{"input":_vm.adoptionChange},model:{value:(_vm.f_5),callback:function ($$v) {_vm.f_5=$$v},expression:"f_5"}})],1),_vm._v(" "),_c('td',{class:_vm.fields_correct.f_3},[_c('datepicker',{staticClass:"table-control",attrs:{"id":"edit_datepicker_f_3","format":"dd.MM.yyyy","disabled":_vm.readonly},on:{"input":_vm.placeChange},model:{value:(_vm.f_3),callback:function ($$v) {_vm.f_3=$$v},expression:"f_3"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.controlTwenty),expression:"controlTwenty"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.controlTwenty)},on:{"input":function($event){if($event.target.composing){ return; }_vm.controlTwenty=$event.target.value}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.daysLeft),expression:"daysLeft"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.daysLeft)},on:{"input":function($event){if($event.target.composing){ return; }_vm.daysLeft=$event.target.value}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"rent-title"},[_vm._v("Аренда")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_126),expression:"f_126"}],staticClass:"form-control my-control medium",class:_vm.fields_correct.f_126,on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.f_126=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}}),_vm._v(" "),_c('option',{domProps:{"value":true}},[_vm._v("Да")]),_vm._v(" "),_c('option',{domProps:{"value":false}},[_vm._v("Нет")])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin":"5px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('table',{staticClass:"dateTable"},[_vm._m(6),_vm._v(" "),_c('tbody',[_c('td',[_c('lpo-reason',{attrs:{"disabled":_vm.readonly}})],1),_vm._v(" "),_c('td',[_c('lpo-method',{attrs:{"disabled":_vm.readonly}})],1),_vm._v(" "),_c('td',[_c('lpo-mode',{attrs:{"disabled":_vm.readonly,"method":_vm.f_89}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin":"5px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('table',{staticClass:"dateTable"},[_vm._m(7),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('datepicker',{staticClass:"table-control",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly},model:{value:(_vm.f_7),callback:function ($$v) {_vm.f_7=$$v},expression:"f_7"}})],1),_vm._v(" "),_c('td',[_c('deletion-reason',{attrs:{"disabled":_vm.readonly}})],1),_vm._v(" "),_c('td',[_c('conclusion-user',{attrs:{"disabled":_vm.readonly || _vm.conclusion_user_disabled}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_10),expression:"f_10"}],staticClass:"form-control form-control my-control medium",attrs:{"disabled":_vm.readonly},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.f_10=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Черновик")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Чистовик")])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin":"5px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_vm._m(8),_vm._v(" "),_c('table',{staticClass:"dateTable"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"no-right-border",staticStyle:{"width":"15%"}},[_vm._v("ФИО")]),_vm._v(" "),_c('td',{class:_vm.fields_correct.f_127},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_127),expression:"f_127"}],staticClass:"table-control my-control form-control",attrs:{"type":"text"},domProps:{"value":(_vm.f_127)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_127=$event.target.value}}})]),_vm._v(" "),_c('td',{staticClass:"no-right-border",staticStyle:{"width":"20%"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_129),expression:"f_129"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.f_129=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change_f_129]}},_vm._l((_vm.organization_types),function(type){return _c('option',{key:type.id,domProps:{"value":type.id}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(type.name)+"\n\t\t\t\t\t\t\t\t")])}))]),_vm._v(" "),_c('td',{class:_vm.f_129 == 2 ? _vm.fields_correct.f_128 : _vm.fields_correct.f_130},[(_vm.f_129 == 1)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_130),expression:"f_130"}],staticClass:"form-control my-control table-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.f_130=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.lpo_filials),function(item){return _c('option',{key:item.id,domProps:{"value":item.id}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t\t\t\t\t\t")])})):_vm._e(),_vm._v(" "),(_vm.f_129 == 2)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_128),expression:"f_128"}],staticClass:"table-control my-control form-control",attrs:{"type":"text"},domProps:{"value":(_vm.f_128)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_128=$event.target.value}}}):_vm._e()])])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"btnPanel"},[_c('input',{staticClass:"btn btn-secondary",attrs:{"type":"button","value":"Отмена","disabled":_vm.readonly},on:{"click":function($event){$event.preventDefault();_vm.close($event)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.submit_disabled || _vm.readonly},on:{"click":function($event){$event.preventDefault();_vm.submit($event)}}},[(_vm.submit_disabled)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v("\n\t\t\t"+_vm._s(_vm.submit_disabled ? 'Сохранение' : 'Сохранить')+"\n\t\t")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-1 col"},[_c('span',{staticClass:"bold"},[_vm._v("№ акта ЛПО *")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 col"},[_c('span',{staticClass:"bold"},[_vm._v("Организация *")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col"},[_vm._v("Ссылка на акт")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 col"},[_vm._v("Федеральный округ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 col"},[_c('span',{staticClass:"bold"},[_vm._v("Субъект РФ *")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 col"},[_c('span',{staticClass:"bold"},[_vm._v("Лесничество *")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"form_td"},[_vm._v("V(м"),_c('sup',[_vm._v("3")]),_vm._v(")")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_vm._v("\n\t\t\t\t\t\t\tV(м"),_c('sup',[_vm._v("3")]),_vm._v(")\n\t\t\t\t\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1 col-md-offset-2"},[_c('label',[_vm._v("Контроль 3 дня")])]),_vm._v(" "),_c('div',{staticClass:"col-md-1",staticStyle:{"margin-left":"6.33%"}},[_c('label',[_vm._v("Даты")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("проведения ЛПО *")]),_vm._v(" "),_c('th',[_vm._v("утверждения *")]),_vm._v(" "),_c('th',[_vm._v("размещения на сайте *")]),_vm._v(" "),_c('th',[_vm._v("контроль 20 дней")]),_vm._v(" "),_c('th',[_vm._v("осталось дней")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Основание проведения ЛПО")]),_vm._v(" "),_c('th',[_vm._v("Метод проведения ЛПО")]),_vm._v(" "),_c('th',[_vm._v("Способ проведения ЛПО")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Дата снятия с сайта")]),_vm._v(" "),_c('th',[_vm._v("Причина снятия с сайта Акта ЛПО")]),_vm._v(" "),_c('th',[_vm._v("Ответственный за заключение на акты ЛПО")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"dateTable no-bottom-border"},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"4"}},[_vm._v("Исполнитель работ по ЛПО")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vBF1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editTerritoryCatalog_vue__ = __webpack_require__("Pi43");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40d58e98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_editTerritoryCatalog_vue__ = __webpack_require__("YXqo");
function injectStyle (ssrContext) {
  __webpack_require__("Gp+w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40d58e98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editTerritoryCatalog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40d58e98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_editTerritoryCatalog_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vDdQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subforestry_vue__ = __webpack_require__("JXV7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c1e556f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_subforestry_vue__ = __webpack_require__("hyCX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subforestry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c1e556f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_subforestry_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vKkZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vQlM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var DAMAGES = 'get_damages.php';
var ACT_LOCATION = 'get_act_location.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'damageReason',
	data: function data() {
		return {
			selected: '',
			options: []
		};
	},
	props: {
		line_count: '',
		dmg_id: ''
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('edit_damages', { index: this.line_count, value: this.selected });
		}
	},
	created: function created() {
		var _this = this;

		if (this.$parent.data_location.damage_reason == null) {
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on('fetch_damage_reason_complete', function (data) {
				if (data) {
					_this.options = [{ id: '', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
					_this.selected = _this.dmg_id ? _this.dmg_id : '';
				} else {
					_this.options = [];
					_this.selected = '';
				}
				__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('fetch_damage_reason_complete');
			});
		} else {
			var data = this.$parent.data_location.damage_reason;
			if (data) {
				this.options = [{ id: '', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
				this.selected = this.dmg_id ? this.dmg_id : '';
			} else {
				this.options = [];
				this.selected = '';
			}
		}
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('fetch_damage_reason_complete');
	}
});

/***/ }),

/***/ "vRcf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListSupervisory_vue__ = __webpack_require__("WAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74a5abce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ListSupervisory_vue__ = __webpack_require__("E+Qb");
function injectStyle (ssrContext) {
  __webpack_require__("vKkZ")
  __webpack_require__("C752")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74a5abce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListSupervisory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74a5abce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ListSupervisory_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vW3K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var SUBFORESTRY = 'subforestrie_list.php';
//const HEADER = 'get_header.php'
var LOCATION = 'get_act_location.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'subforestry',
	data: function data() {
		return {
			id: this.type + '_localforestry_' + this.line_count,
			selected: '0',
			options: []
		};
	},
	props: {
		line_count: 0,
		type: ''
	},
	created: function created() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + LOCATION + '?id=' + this.$route.params.id, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			var lf = res.filter(function (item) {
				return item.field == 'f_20';
			});
			var sf = res.filter(function (item) {
				return item.field == 'f_27';
			});
			if (lf[_this.line_count]) {
				if (sf[_this.line_count]) return { localforestry_id: lf[_this.line_count].val, subforestry_id: sf[_this.line_count].val };else return { localforestry_id: lf[_this.line_count].val, subforestry_id: '0' };
			} else return { localforestry_id: '0', subforestry_id: '0' };
		}).then(function (location) {
			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + SUBFORESTRY + '?id=' + location.localforestry_id).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					_this.options = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
					_this.selected = !location.subforestry_id ? '0' : location.subforestry_id;
				} else {
					_this.selected = '0';
					_this.options = [];
				}
			}).catch(function (err) {
				return console.log('4', err);
			});
		}).catch(function (err) {
			return console.log('5', err);
		});
	}
});

/***/ }),

/***/ "vYQi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();_vm.submit($event)}}},[_c('h4',[_vm._v("Заключение на Акт ЛПО")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1 col"},[_c('input',{staticClass:"form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.f_2}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col"},[_c('organization',{attrs:{"org_id":_vm.f_11,"disabled":""}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col act_link"},[_c('a',{attrs:{"href":_vm.f_4}},[_vm._v(_vm._s(_vm.f_4))])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col"},[_c('fo',{attrs:{"reg_id":_vm.f_12,"disabled":""}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_c('region',{attrs:{"type":"conclusion","reg_id":_vm.f_12,"disabled":""}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_c('forestry',{attrs:{"type":"conclusion","reg_id":_vm.f_12,"f_id":_vm.f_9,"disabled":""}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('table',{staticClass:"documentsTable"},[_vm._m(2),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border-right":"none"}},[_vm._v("Реквизиты исходящего из ДЛХ")]),_vm._v(" "),_c('td',{class:_vm.fields_correct.f_35},[_c('datepicker',{staticClass:"table-control",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly},model:{value:(_vm.f_35),callback:function ($$v) {_vm.f_35=$$v},expression:"f_35"}})],1),_vm._v(" "),_c('td',{class:_vm.fields_correct.f_36},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_36),expression:"f_36"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_36)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_36=$event.target.value}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_37),expression:"f_37"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_37)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_37=$event.target.value}}})])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"border-right":"none"}},[_vm._v("Реквизиты входящего в Рослесозащиту")]),_vm._v(" "),_c('td',[_c('datepicker',{staticClass:"table-control",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly},model:{value:(_vm.f_38),callback:function ($$v) {_vm.f_38=$$v},expression:"f_38"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_39),expression:"f_39"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_39)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_39=$event.target.value}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_40),expression:"f_40"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_40)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_40=$event.target.value}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('table',{staticClass:"documentsTable",staticStyle:{"margin-top":"28px"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"border-right":"none"}},[_vm._v("Заключение на Акт ЛПО")]),_vm._v(" "),_c('td',{class:_vm.fields_correct.f_48},[_c('datepicker',{staticClass:"table-control",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly},model:{value:(_vm.f_48),callback:function ($$v) {_vm.f_48=$$v},expression:"f_48"}})],1),_vm._v(" "),_c('td',{class:_vm.fields_correct.f_49},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_49),expression:"f_49"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_49)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_49=$event.target.value}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_50),expression:"f_50"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_50)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_50=$event.target.value}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2",staticStyle:{"margin-top":"20px"}},[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();_vm.setRegistryAccordance($event)}}},[_vm._v("Установить соответствие")])]),_vm._v(" "),_c('div',{staticClass:"col-md-1",staticStyle:{"margin-top":"20px"}},[_c('span',{staticClass:"registry_stat_wrap"},[_c('span',{staticClass:"registry_stat_title"},[_vm._v("Статистика")]),_vm._v(" "),_c('div',{staticClass:"registry_stat_popup"},[_c('table',[_vm._m(3),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Количество участков")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.upp_count))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.mzl_count))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Дата обновления")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.upp_lastdate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.mzl_lastdate))])])])])])])]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"20px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"table_head_wrap"},[_c('table',{staticClass:"conclusion_place_table conclusion_place_table__top"},[_c('thead',[_c('tr',[_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Участковое лесничество")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Подлес-во")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Квартал")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Выдел")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Лп. выдел")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("МЗЛ")]),_vm._v(" "),_c('th',{staticClass:"colspan_td",attrs:{"colspan":"5"}},[_vm._v("Соответствие")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Нарушение НПА")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Решение *")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Участки требующие проведения выездной проверки")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"colspan":"2"}},[_vm._v("Наличие в реестрах ГЛПМ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Комментарии")]),_vm._v(" "),_c('th',{attrs:{"rowspan":"2","width":_vm.scroll_width}})]),_vm._v(" "),_vm._m(4)])])]),_vm._v(" "),_c('div',{staticClass:"table_body_wrap"},[_c('table',{staticClass:"conclusion_place_table conclusion_place_table__bottom"},[_c('tbody',_vm._l((_vm.lines),function(line,index){return _c('tr',{key:line.f_c},[_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_20),expression:"line.f_20"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_20)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_20", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_27),expression:"line.f_27"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_27)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_27", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_17),expression:"line.f_17"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_17)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_17", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_24),expression:"line.f_24"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_24)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_24", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_25),expression:"line.f_25"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_25)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_25", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_16),expression:"line.f_16"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_16)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_16", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(line.f_28),expression:"line.f_28"}],staticClass:"form-control form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(line, "f_28", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(line.f_29),expression:"line.f_29"}],staticClass:"form-control form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(line, "f_29", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(line.f_30),expression:"line.f_30"}],staticClass:"form-control form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(line, "f_30", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(line.f_31),expression:"line.f_31"}],staticClass:"form-control form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(line, "f_31", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',{staticClass:"form_td",staticStyle:{"border-right":"none"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(line.f_32),expression:"line.f_32"}],staticClass:"form-control form-control my-control table-control",attrs:{"disabled":true},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(line, "f_32", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',{staticClass:"form_td",class:{'field-error': line.f_31 == 0 && line.f_107 == 0}},[_c('npa-violation',{attrs:{"line_count":index,"id":line.f_107,"disabled":_vm.readonly}})],1),_vm._v(" "),_c('td',{staticClass:"form_td",class:line.correct_f_33},[_c('select',{staticClass:"form-control form-control my-control table-control",attrs:{"disabled":_vm.readonly,"data-line":index},domProps:{"value":line.f_33},on:{"change":function($event){_vm.decisionChange(line.f_33, $event)}}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Положительное")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Отрицательное")])])]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_91),expression:"line.f_91"}],attrs:{"type":"checkbox","data-index":index,"disabled":_vm.readonly},domProps:{"checked":Array.isArray(line.f_91)?_vm._i(line.f_91,null)>-1:(line.f_91)},on:{"change":function($event){var $$a=line.f_91,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(line.f_91=$$a.concat([$$v]))}else{$$i>-1&&(line.f_91=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(line, "f_91", $$c)}}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{attrs:{"type":"checkbox","data-index":index,"disabled":""},domProps:{"checked":line.upp == "t"}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{attrs:{"type":"checkbox","data-index":index,"disabled":""},domProps:{"checked":line.mzl == "t"}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_34),expression:"line.f_34"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":_vm.readonly},domProps:{"value":(line.f_34)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_34", $event.target.value)}}})])])}))])])])]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col"},[_c('select',{staticClass:"form-control form-control my-control",class:_vm.fields_correct.f_41,attrs:{"disabled":_vm.readonly},domProps:{"value":_vm.f_41},on:{"change":function($event){_vm.mainDecisionChange(_vm.f_41, $event)}}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Положительное")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Отрицательное")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5 col"},[_c('decision-reason',{attrs:{"disabled":_vm.readonly || _vm.f_41 > 0,"error":_vm.errorDecisionReason}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_43),expression:"f_43"}],staticClass:"form-control my-control",attrs:{"type":"text","disabled":_vm.readonly},domProps:{"value":(_vm.f_43)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_43=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_c('table',{staticClass:"documentsTable"},[_vm._m(6),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticStyle:{"width":"30%","border-right":"none"}},[_vm._v("Сопроводительное письмо с заключениями на Акты ЛПО")]),_vm._v(" "),_c('td',{staticStyle:{"width":"23%"}},[_c('datepicker',{staticClass:"table-control",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly},model:{value:(_vm.f_44),callback:function ($$v) {_vm.f_44=$$v},expression:"f_44"}})],1),_vm._v(" "),_c('td',{staticStyle:{"width":"23%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_45),expression:"f_45"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_45)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_45=$event.target.value}}})]),_vm._v(" "),_c('td',{staticStyle:{"width":"23%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_46),expression:"f_46"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_46)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_46=$event.target.value}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_47),expression:"f_47"}],staticClass:"form-control form-control my-control medium",attrs:{"disabled":_vm.readonly},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.f_47=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Черновик")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Чистовик")])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin":"5px"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"btnPanel"},[_c('input',{staticClass:"btn btn-secondary",attrs:{"type":"button","value":"Отмена","disabled":_vm.readonly},on:{"click":function($event){$event.preventDefault();_vm.close($event)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.submit_disabled || _vm.readonly},on:{"click":function($event){$event.preventDefault();_vm.submit($event)}}},[(_vm.submit_disabled)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v("\n\t\t\t\t"+_vm._s(_vm.submit_disabled ? 'Сохранение' : 'Сохранить')+"\n\t\t\t")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1 col"},[_vm._v("№ акта ЛПО")]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col"},[_vm._v("Организация")]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col"},[_vm._v("Ссылка на акт")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col"},[_vm._v("Федеральный округ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_vm._v("Субъект РФ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_vm._v("Лесничество")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Официальные документы")]),_vm._v(" "),_c('th',[_vm._v("Дата *")]),_vm._v(" "),_c('th',[_vm._v("Номер *")]),_vm._v(" "),_c('th',[_vm._v("Комментарий к документу")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v("УПП")]),_vm._v(" "),_c('th',[_vm._v("МЗЛ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"form_td",attrs:{"title":"Соответствие сведений данным ГЛПМ"}},[_vm._v("свед. данным ГЛПМ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"title":"Соответствия сведений таксационным характеристикам лесного участка"}},[_vm._v("свед. ТО")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"title":"Соответствие  мероприятий данным ГЛПМ"}},[_vm._v("мероприятий данным ГЛПМ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"title":"Запрещение или ограничение законодательством РФ мероприятий"}},[_vm._v("законодательству РФ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"title":"Недостоверность сведений санитарному и лесопатологическому состоянию лесов"}},[_vm._v("недост.свед. Сан. Сост.")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("УПП")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("МЗЛ-ПРВО")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col"},[_c('span',{staticClass:"bold"},[_vm._v("Итоговое решение *")])]),_vm._v(" "),_c('div',{staticClass:"col-md-5 col"},[_vm._v("Главная причина отрицательного заключения")]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_vm._v("Примечание")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Официальные документы")]),_vm._v(" "),_c('th',[_vm._v("Дата")]),_vm._v(" "),_c('th',[_vm._v("Номер")]),_vm._v(" "),_c('th',[_vm._v("Комментарий к документу")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vmUS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonitoringRlh_vue__ = __webpack_require__("Le89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289aed31_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringRlh_vue__ = __webpack_require__("d6dh");
function injectStyle (ssrContext) {
  __webpack_require__("lKmh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-289aed31"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonitoringRlh_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289aed31_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringRlh_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vq+Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_decisionReason_vue__ = __webpack_require__("UqYO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19a00385_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_decisionReason_vue__ = __webpack_require__("i49r");
function injectStyle (ssrContext) {
  __webpack_require__("Iu82")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19a00385"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_decisionReason_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19a00385_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_decisionReason_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w8zh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth__ = __webpack_require__("SQ6o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__("qI5z");






var _name$data$components;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var GET_FO = 'get_fo.php';
var GET_REGIONS = 'region_list.php';
var GET_FORESTRIES = 'forestrie_list.php';
var GET_ACTS_BY_FORESTRY = 'get_acts_by_forestry.php';
var GET_SUPERVISORY_ACTS = 'get_supervisory_acts.php';
var GET_SUPERVISON_INFO = 'get_supervisory_info.php';
var GROUP_JSON = 'group_json.php';

var TIMEOUT = 120000; //2 минуты
var MAX_BUTTON_TEXT_LENGTH = 40;

/* harmony default export */ __webpack_exports__["a"] = (_name$data$components = {
	name: 'supervisionForm',
	data: function data() {
		return {
			scroll_width: 17,
			readonly: false,

			submit_disabled: false,
			firstInitDone: false,

			fo_id: 0,
			region_id: 0,
			forestry_id: 0,
			f_118: '',
			f_119: '',
			f_120: '',
			f_121: '',
			f_122: '',

			fo_options: [],
			region_options: [],
			forestry_options: [],

			showActsModal: false,
			acts_short: [],
			acts_full: [],
			selected_acts: [],

			saved_acts_short: [],
			counter: 0,
			supervisory_id: null,

			fields_correct: {
				f_118: '',
				f_119: '',
				f_120: '',
				f_121: ''
			},

			fields: ['f_118', 'f_119', 'f_120', 'f_121', 'f_122'],
			fields_to_check: ['f_118', 'f_119', 'f_120', 'f_121']
		};
	},
	components: {
		datepicker: __WEBPACK_IMPORTED_MODULE_8_vue_strap__["datepicker"], modal: __WEBPACK_IMPORTED_MODULE_8_vue_strap__["modal"], checkbox: __WEBPACK_IMPORTED_MODULE_8_vue_strap__["checkbox"]
	},
	computed: {
		selectedActsIdsShort: function selectedActsIdsShort() {
			var selected_nums = this.selected_acts.map(function (e) {
				return e.act_num;
			});
			var str = selected_nums.join(', ');
			if (str.length > MAX_BUTTON_TEXT_LENGTH) return str.substr(0, MAX_BUTTON_TEXT_LENGTH) + '...';else return str;
		},
		selectedActsIds: function selectedActsIds() {
			var selected_nums = this.selected_acts.map(function (e) {
				return e.act_num;
			});
			var str = selected_nums.join(', ');
			return str;
		},
		form_disabled: function form_disabled() {
			return !Boolean(this.acts_full.length > 0);
		}
	},
	watch: {},
	methods: {
		checkInput: function checkInput(name) {
			if ((!this[name] || !this[name].length) && !this.form_disabled) this.fields_correct[name] = 'field-error';else this.fields_correct[name] = '';
		},
		floatConvert: function floatConvert(number) {
			return +parseFloat(number).toPrecision(12);
		},
		filterInput: function filterInput(e) {
			e.target.value = e.target.value.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "");
		},
		checkFields: function checkFields() {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.fields_to_check), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var field = _step.value;

					this.checkInput(field);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.fields_to_check), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var _field = _step2.value;

					if (!this[_field] || !this[_field].length) return false;
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			return true;
		},
		onChangeFO: function onChangeFO() {
			var _this = this;

			this.region_id = 0;
			this.forestry_id = 0;
			this.acts_short = [];
			this.acts_full = [];
			this.selected_acts = [];
			this.clearFields();

			fetch(__WEBPACK_IMPORTED_MODULE_10__constants__["a" /* DB */] + GET_REGIONS + '?id=' + this.fo_id, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				if (res) {
					_this.region_options = [{ id: 0, name: '' }].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(res));
				}
			}).catch(function (err) {
				return console.log(err);
			});
		},
		onChangeRegion: function onChangeRegion() {
			var _this2 = this;

			this.forestry_id = 0;
			this.acts_short = [];
			this.acts_full = [];
			this.selected_acts = [];
			this.clearFields();

			fetch(__WEBPACK_IMPORTED_MODULE_10__constants__["a" /* DB */] + GET_FORESTRIES + '?id=' + this.region_id, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				if (res) {
					_this2.forestry_options = [{ id: 0, name: '' }].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(res));
				}
			}).catch(function (err) {
				return console.log(err);
			});
		},
		onChangeForestry: function onChangeForestry() {
			this.acts_short = [];
			this.acts_full = [];
			this.selected_acts = [];
			this.clearFields();

			if (this.forestry_id) {
				this.loadActsShort();
			}
		},
		changeActCheckbox: function changeActCheckbox(e, index) {
			if (this.counter > 0) {
				this.counter--;
				return false;
			}

			this.counter = 0;
			if (this.acts_short[index].supervisory_id) {
				for (var act_id in this.acts_short) {
					if (this.acts_short[act_id].supervisory_id == this.acts_short[index].supervisory_id) {
						if (this.acts_short[act_id].checked != e) {
							this.acts_short[act_id].checked = e;
							this.counter++;
						}
					} else {
						if (this.acts_short[act_id].checked != false && this.acts_short[act_id].checked != undefined) {
							this.acts_short[act_id].checked = false;
							this.counter++;
						}
					}
				}
			} else {
				for (var act in this.acts_short) {
					if (this.acts_short[act].supervisory_id) {
						if (this.acts_short[act].checked != false && this.acts_short[act].checked != undefined) {
							this.acts_short[act].checked = false;
							this.counter++;
						}
					}
				}
			}

			this.$forceUpdate();
		},
		checkIsActInGroup: function checkIsActInGroup(i) {
			if (this.acts_short[i].supervisory_id && !this.acts_short[i - 1]) {
				return 'first_act_in_group ' + this.acts_short[i].class;
			}

			if (this.acts_short[i].supervisory_id && this.acts_short[i - 1] && this.acts_short[i - 1].supervisory_id && this.acts_short[i - 1].supervisory_id != this.acts_short[i].supervisory_id) {
				return 'first_act_in_group ' + this.acts_short[i].class;
			}

			if (this.acts_short[i].supervisory_id) return 'act_in_group ' + this.acts_short[i].class;
		},
		loadActsShort: function loadActsShort() {
			var _this3 = this;

			var saveSelectedActs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			var selected_ids = [];
			if (saveSelectedActs) {
				selected_ids = this.selected_acts.map(function (e) {
					return e.main_id;
				});
			} else {
				this.selected_acts = [];
			}

			fetch(__WEBPACK_IMPORTED_MODULE_10__constants__["a" /* DB */] + GET_ACTS_BY_FORESTRY + '?id=' + this.forestry_id, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				_this3.acts_short = res || [];
				var current_class = 'odd';
				for (var act in _this3.acts_short) {
					if (selected_ids.includes(_this3.acts_short[act].main_id)) _this3.acts_short[act].checked = true;

					if (_this3.acts_short[act].supervisory_id) {
						if (_this3.acts_short[act].supervisory_id && !_this3.acts_short[act - 1]) {
							_this3.acts_short[act].class = current_class;
						}
						if (_this3.acts_short[act].supervisory_id && _this3.acts_short[act - 1] && _this3.acts_short[act - 1].supervisory_id && _this3.acts_short[act - 1].supervisory_id != _this3.acts_short[act].supervisory_id) {
							if (current_class == 'odd') current_class = 'even';else current_class = 'odd';

							_this3.acts_short[act].class = current_class;
						}

						if (_this3.acts_short[act].supervisory_id) _this3.acts_short[act].class = current_class;
					}
				}
				if (_this3.$route.params.id && !_this3.firstInitDone) {
					// let acts = this.$parent.supervisory_obj.act_nums;
					// acts = acts.split(',');
					// console.log(acts);

					// let act_num = acts[0];

					var supervisory_id = _this3.$route.params.id;

					var current_act = null;

					_this3.acts_short.forEach(function (act, i) {
						if (act.supervisory_id === supervisory_id) {
							current_act = i;
						}
					});
					_this3.openActsModal();
					_this3.changeActCheckbox(true, current_act);

					_this3.okActsModal();

					_this3.firstInitDone = true;

					_this3.counter = 0;
				}
			}).catch(function (err) {
				return console.log(err);
			});
		},
		loadSupervisionInfo: function loadSupervisionInfo(id) {
			var _this4 = this;

			fetch(__WEBPACK_IMPORTED_MODULE_10__constants__["a" /* DB */] + GET_SUPERVISON_INFO + '?id=' + id, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				for (var field in res[0]) {
					if (field !== 'f_117') {
						_this4[field] = res[0][field];
					}
				}
			});
		},
		clearFields: function clearFields() {
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.fields), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var field = _step3.value;

					this[field] = '';
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}
		},
		openActsModal: function openActsModal() {
			this.saved_acts_short = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.acts_short));
			this.showActsModal = true;
		},
		cancelActsModal: function cancelActsModal() {
			var _this5 = this;

			this.showActsModal = false;

			//wait for end of animation
			setTimeout(function () {
				_this5.acts_short = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this5.saved_acts_short));
			}, 500);
		},
		okActsModal: function okActsModal() {
			var _this6 = this;

			this.showActsModal = false;
			this.selected_acts = [];
			var selected_ids = [];
			var supervisory_id = null;
			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;

			try {
				for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.acts_short), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var act = _step4.value;

					if (act.checked) {
						selected_ids.push(act.main_id);
						this.selected_acts.push({ main_id: act.main_id, act_num: act.act_num });
						if (act.supervisory_id) supervisory_id = act.supervisory_id;
					}
				}
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}

			this.supervisory_id = supervisory_id;

			if (this.supervisory_id == null) this.clearFields();

			if (this.selected_acts.length) {
				this.loadSupervisionInfo(supervisory_id);
				fetch(__WEBPACK_IMPORTED_MODULE_10__constants__["a" /* DB */] + GET_SUPERVISORY_ACTS + '?ids={' + selected_ids.join(',') + '}', { credentials: 'include' }).then(function (res) {
					return res.json();
				}).then(function (res) {
					var temp_lines = [];
					var prev_id = -1;
					var prev_localforestry_id = -1;
					var prev_subforestry_id = -1;

					for (var i = 0; i < res.length; i++) {
						var _act = {};

						var start_fo = i;
						while (i > 0 && res[start_fo - 1].act_id === res[i].act_id && start_fo > 1) {
							start_fo--;
						}

						var curr = start_fo;
						while (curr < res.length && res[curr].act_id === res[start_fo].act_id) {
							curr++;
						}
						_act.count = curr - start_fo;

						if (res[i].act_id === prev_id) {
							_act.flag = false;
						} else {
							_act.flag = true;
						}
						//////////////////

						var start_lf = i;
						while (i > 0 && res[start_lf - 1].localforestry_id === res[i].localforestry_id && start_lf > 1 && res[start_lf - 1].act_id === res[i].act_id) {
							start_lf--;
						}

						var curr_lf = start_lf;
						while (curr_lf < res.length && res[curr_lf].act_id === res[start_lf].act_id && res[curr_lf].localforestry_id === res[i].localforestry_id) {
							curr_lf++;
						}
						_act.count_lf = curr_lf - start_lf;

						if (res[i].act_id === prev_id && prev_localforestry_id === res[i].localforestry_id) {
							_act.flag_lf = false;
						} else {
							_act.flag_lf = true;
						}

						////////////////////////
						var start_sf = i;
						while (i > 0 && res[start_sf - 1].localforestry_id === res[i].localforestry_id && start_sf > 1 && res[start_sf - 1].act_id === res[i].act_id) {
							start_sf--;
						}

						var curr_sf = start_sf;
						while (curr_sf < res.length && res[curr_sf].act_id === res[start_sf].act_id && res[curr_sf].localforestry_id === res[i].localforestry_id) {
							curr_sf++;
						}
						_act.count_sf = curr_sf - start_sf;

						if (res[i].act_id === prev_id && prev_localforestry_id === res[i].localforestry_id) {
							_act.flag_sf = false;
						} else {
							_act.flag_sf = true;
						}
						////////////////////////


						prev_id = res[i].act_id;
						prev_localforestry_id = res[i].localforestry_id;
						prev_subforestry_id = res[i].subforestry_id;

						__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(_act, res[i]);

						temp_lines.push(_act);
					}
					_this6.acts_full = temp_lines;
				});
			} else {
				this.acts_full = [];
			}
		},
		submit: function submit() {
			var _this7 = this;

			this.submit_disabled = true;

			var obj = [{}];
			if (this.supervisory_id) {
				//update
				obj[0].u = [];
				obj[0].u.push({});
				obj[0].u[0].tab_id = 4;
				obj[0].u[0].f_v = {};
				obj[0].u[0].f_v.f_c = this.supervisory_id;

				var _iteratorNormalCompletion5 = true;
				var _didIteratorError5 = false;
				var _iteratorError5 = undefined;

				try {
					for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.fields), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
						var field = _step5.value;

						obj[0].u[obj[0].u.length - 1].f_v[field] = this[field];
					}
					//const selected_nums = this.selected_acts.map(e => {return e.main_id})
					//const str = selected_nums.join(', ')
				} catch (err) {
					_didIteratorError5 = true;
					_iteratorError5 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion5 && _iterator5.return) {
							_iterator5.return();
						}
					} finally {
						if (_didIteratorError5) {
							throw _iteratorError5;
						}
					}
				}
			} else {
				//insert
				obj[0].i = {};
				obj[0].i.tab = [];
				obj[0].i.tab.push({});
				obj[0].i.tab[0].tab_id = 4;
				obj[0].i.tab[0].f_v = {};

				var _iteratorNormalCompletion6 = true;
				var _didIteratorError6 = false;
				var _iteratorError6 = undefined;

				try {
					for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.fields), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
						var _field2 = _step6.value;

						obj[0].i.tab[0].f_v[_field2] = this[_field2];
					}
				} catch (err) {
					_didIteratorError6 = true;
					_iteratorError6 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion6 && _iterator6.return) {
							_iterator6.return();
						}
					} finally {
						if (_didIteratorError6) {
							throw _iteratorError6;
						}
					}
				}

				var selected_ids = this.selected_acts.map(function (e) {
					return e.main_id;
				});
				var str = '{' + selected_ids.join(', ') + '}';
				obj[0].i.tab[0].f_v.f_117 = str;
			}

			var submit_act_info = function submit_act_info() {
				var form = new FormData();
				form.append('json', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(obj));

				var first_check_result = null;
				var second_check_result = null;

				var first_check = setTimeout(function () {
					if (first_check_result === null) {
						first_check_result = false;
						alert('Во время сохранения акта произошла ошибка. Повторите попытку позже.');
						_this7.submit_disabled = false;
					}
				}, TIMEOUT);

				fetch(__WEBPACK_IMPORTED_MODULE_10__constants__["a" /* DB */] + GROUP_JSON, {
					credentials: 'include',
					method: 'post',
					body: form
				}).then(function (result) {
					return result.json();
				}).then(function (result) {
					if (first_check_result === null) {
						first_check_result = true;
						clearTimeout(first_check);

						if (result[0].code === '0') {
							alert('Акт сохранен');
							_this7.loadActsShort(true);
							//router.replace('/main')
						} else {
							alert('Во время сохранения акта произошла ошибка. На Ваш компьютер будет сохранён файл с отладочной информацией. Перешлите данный файл вместе со скриншотом экрана разработчикам для выявления и устранения ошибки.');
							_this7.download(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(obj) + '_' + result[0].name, 'edit_' + Date() + '.json', 'text/json');
						}
						_this7.submit_disabled = false;
					}
				}).catch(function (err) {
					console.log(err);
					_this7.submit_disabled = false;
				});
			};
			if (this.checkFields()) {
				if (document.querySelector('.field-error') !== null) {
					var b = confirm('Часть полей может содержать некорректные данные. Вы уверены, что хотите продолжить?');
					if (b) {
						submit_act_info();
					} else {
						this.submit_disabled = false;
					}
				} else {
					submit_act_info();
				}
			} else {
				alert('Поля, отмеченные звёздочкой, обязательны к заполнению.');
				this.submit_disabled = false;
			}

			//console.log(this.prepareToDelete)
		},
		download: function download(content, fileName, contentType) {
			var a = document.createElement("a");
			var file = new Blob([content], { type: contentType });
			a.href = URL.createObjectURL(file);
			a.download = fileName;
			var event = document.createEvent("MouseEvents");
			event.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
			a.dispatchEvent(event);
		},
		close: function close() {
			if (history.length > 1) history.go(-1);else __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].replace('/main');
		}
	},
	created: function created() {
		var _this8 = this;

		fetch(__WEBPACK_IMPORTED_MODULE_10__constants__["a" /* DB */] + GET_FO, {
			credentials: 'include'
		}).then(function (res) {
			return res.json();
		}).then(function (res) {
			if (res) {
				_this8.fo_options = res;
			}
		}).catch(function (err) {
			return console.log(err);
		});

		if (this.$route.params.id && this.$parent.supervisory_obj) {

			var act = this.$parent.supervisory_obj;

			this.fo_id = act.fo_id;
			this.onChangeFO();

			this.region_id = act.region_id;
			this.onChangeRegion();

			this.forestry_id = act.forestry_id;
			this.onChangeForestry();
		}
	},
	beforeDestroy: function beforeDestroy() {}
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$data$components, 'watch', {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$data$components, 'updated', function updated() {}), _name$data$components);

function commaToPeriod(str) {
	return str.replace(/,/g, ".");
}

/***/ }),

/***/ "wHl5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wQSF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control",class:_vm.field_class,attrs:{"id":_vm.id,"data-num":"f_9","data-table":"1","disabled":_vm.disabled},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wj3t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var DAMAGES = 'get_damages.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'damages',
	data: function data() {
		return {
			selected: '',
			options: []
		};
	},
	props: {
		line_count: '',
		id: null
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('damages', { index: this.line_count, value: this.selected });
		}
	},
	mounted: function mounted() {
		var _this = this;

		fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + DAMAGES, {
			credentials: 'include'
		}).then(function (data) {
			return data.json();
		}).then(function (data) {
			if (data) {
				_this.options = [{ id: '', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
				if (_this.id) {
					_this.selected = _this.id;
				}
			} else {
				_this.options = [];
				_this.selected = '0';
			}
		}).catch(function (err) {
			return console.log(err);
		});
	}
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bdb4538_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("LDEc");
function injectStyle (ssrContext) {
  __webpack_require__("RFht")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bdb4538"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bdb4538_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xPiU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xdC7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_protectiveCatExt_vue__ = __webpack_require__("7Von");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b6d5224_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_protectiveCatExt_vue__ = __webpack_require__("Raak");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_protectiveCatExt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b6d5224_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_protectiveCatExt_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xhmk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0f5b46e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CheckIcon_vue__ = __webpack_require__("dWXX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0f5b46e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CheckIcon_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xpPz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var LOCALFORESTRY = 'localforestrie_list.php';
var HEADER = 'get_header.php';
var ACT_LOCATION = 'get_act_location.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'localforestry',
	data: function data() {
		return {
			selected: '0',
			options: [],
			id: this.type + '_localforestry_' + this.line_count
		};
	},
	props: {
		line_count: 0,
		type: '',
		f_id: '',
		lf_id: ''
	},
	methods: {
		change: function change() {
			//console.warn(this.selected)
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit(this.type + '_localforestry_' + this.line_count, this.selected);
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit(this.type + '_localforestry', { index: this.line_count, value: this.selected });
		},
		fill: function fill(f_id, lf_id) {
			var _this = this;

			if (this.$parent.data_location.localforestry == null) {
				__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on('fetch_localforestry_complete', function (data) {
					if (data) {
						_this.options = [{ id: '0', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
						_this.selected = lf_id ? lf_id : '0';
					} else {
						_this.options = [];
						_this.selected = '0';
					}
					__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('fetch_localforestry_complete');
				});
			} else {
				var data = this.$parent.data_location.localforestry;
				if (data) {
					this.options = [{ id: '0', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
					this.selected = lf_id ? lf_id : '0';
				} else {
					this.options = [];
					this.selected = '0';
				}
			}
		}
	},
	created: function created() {
		var _this2 = this;

		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on(this.type + '_forestry', function (id) {
			_this2.fill(id);
		});

		/*var _this = this
  this.$nextTick(()=>{
  		//this.fill(_this.$options._parentVnode.data.attrs.f_id, _this.$options._parentVnode.data.attrs.lf_id)
  	console.log(_this.$options._parentVnode.data.attrs)
  })*/

		var f_id = this.$options.propsData.f_id;
		var lf_id = this.$options.propsData.lf_id;
		if (f_id) this.fill(f_id, lf_id);else this.fill(document.getElementById('edit_forestry').value);
		//console.log(this.$options.propsData)
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off(this.type + '_forestry');
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('fetch_localforestry_complete');
	}
});

/***/ }),

/***/ "y1d8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_localforestry_vue__ = __webpack_require__("u9oH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56eda54c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_localforestry_vue__ = __webpack_require__("suaB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_localforestry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56eda54c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_localforestry_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yDFC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var REGION = 'region_list.php';
var HEADER = 'get_header.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'region',
	data: function data() {
		return {
			selected: '0',
			options: [],
			id: this.type + '_region'
		};
	},
	props: {
		type: '',
		reg_id: false,
		field_class: ''
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit(this.type + '_region', this.selected);
		}
	},
	watch: {
		reg_id: function reg_id(id) {
			var _this = this;

			if (typeof id !== 'undefined') {
				fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + REGION, {
					credentials: 'include'
				}).then(function (data) {
					return data.json();
				}).then(function (data) {
					if (data) {
						_this.options = [{ id: '0', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
						_this.selected = id ? id : '0';
						__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('init_region_correct', _this.selected);
					} else {
						_this.options = [];
					}
				}).catch(function (err) {
					return console.log(err);
				});
			}
		}
	}
});

/***/ }),

/***/ "yNX4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();_vm.submit($event)}}},[_c('h4',[_vm._v("Документарная проверка")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1 col"},[_c('input',{staticClass:"form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.f_2}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col"},[_c('organization',{attrs:{"org_id":_vm.f_11,"disabled":""}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col act_link"},[_c('a',{attrs:{"href":_vm.f_4}},[_vm._v(_vm._s(_vm.f_4))])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col"},[_c('fo',{attrs:{"reg_id":_vm.f_12}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_c('region',{attrs:{"type":"warrant","reg_id":_vm.f_12,"disabled":""}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_c('forestry',{attrs:{"type":"warrant","reg_id":_vm.f_12,"f_id":_vm.f_9,"disabled":""}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('table',{staticClass:"documentsTable"},[_vm._m(3),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Поступление акта ЛПО в ДЛХ по ФО*")]),_vm._v(" "),_c('td',[_c('datepicker',{staticClass:"table-control",class:(_vm.f_71 != 3 && !_vm.f_51) ? "field-error-warrant" : "",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly},model:{value:(_vm.f_51),callback:function ($$v) {_vm.f_51=$$v},expression:"f_51"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_52),expression:"f_52"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_52)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_52=$event.target.value}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_53),expression:"f_53"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_53)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_53=$event.target.value}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Приказ проведения документарной проверки")]),_vm._v(" "),_c('td',[_c('datepicker',{staticClass:"table-control",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly},model:{value:(_vm.f_54),callback:function ($$v) {_vm.f_54=$$v},expression:"f_54"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_55),expression:"f_55"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_55)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_55=$event.target.value}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_56),expression:"f_56"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_56)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_56=$event.target.value}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Акт проведения документарной проверки**")]),_vm._v(" "),_c('td',[_c('datepicker',{staticClass:"table-control",class:(_vm.f_71 != 3 && !_vm.f_57) ? "field-error-warrant-optional" : "",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly},model:{value:(_vm.f_57),callback:function ($$v) {_vm.f_57=$$v},expression:"f_57"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_58),expression:"f_58"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_58)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_58=$event.target.value}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_59),expression:"f_59"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_59)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_59=$event.target.value}}})])])])])])]),_vm._v(" "),(_vm.f_42)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-md-10 fbu_main_decision"},[_c('b',[_vm._v("Главная причина отрицального заключения ФБУ «Рослесозащита»:")]),_vm._v(" "+_vm._s(_vm.f_42_text)+"\n\t\t\t")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"10px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"table_head_wrap"},[_c('table',{staticClass:"warrant_place_table warrant_place_table__top",staticStyle:{"margin-bottom":"0px"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Участковое лесничество")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Подлес-во")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Квартал")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Выдел")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("S выдела")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Лп. Выдел")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("S лп. выдела")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("МЗЛ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("S МЗЛ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2","title":"Решение по заключению ФБУ \"Рослесозащита\""}},[_vm._v("Реш-е ФБУ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Участки требующие проведения выездной проверки")]),_vm._v(" "),_c('th',{staticClass:"colspan_td",attrs:{"colspan":"5"}},[_vm._v("Соответствие сведений")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Решение ДЛХ по ФО*")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Участки требующие проведения выездной проверки")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Комментарии")]),_vm._v(" "),_c('th',{attrs:{"rowspan":"2","width":_vm.scroll_width}})]),_vm._v(" "),_c('tr',[_c('warrant-table-field',{attrs:{"field_name":"f_76","title":"Соответствие сведений данным ГЛПМ"},on:{"set":_vm.setAccordanceToLocations}},[_vm._v("\n\t\t\t\t\t\t\t\t\tсвед. данным ГЛПМ\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('warrant-table-field',{attrs:{"field_name":"f_77","title":"Соответствие сведений таксационным характеристикам лесного участка"},on:{"set":_vm.setAccordanceToLocations}},[_vm._v("\n\t\t\t\t\t\t\t\t\tсвед. ТО\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('warrant-table-field',{attrs:{"field_name":"f_78","title":"Соответствие  мероприятий данным ГЛПМ"},on:{"set":_vm.setAccordanceToLocations}},[_vm._v("\n\t\t\t\t\t\t\t\t\tмероприятий данным ГЛПМ\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('warrant-table-field',{attrs:{"field_name":"f_79","title":"Запрещение или ограничение законодательством РФ мероприятий"},on:{"set":_vm.setAccordanceToLocations}},[_vm._v("\n\t\t\t\t\t\t\t\t\tзаконодательству РФ\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('warrant-table-field',{attrs:{"field_name":"f_80","title":"Недостоверность сведений санитарному и лесопатологическому состоянию лесов"},on:{"set":_vm.setAccordanceToLocations}},[_vm._v("\n\t\t\t\t\t\t\t\t\tНедост.свед. Сан. Сост.\n\t\t\t\t\t\t\t\t")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"table_body_wrap"},[_c('table',{staticClass:"warrant_place_table warrant_place_table__bottom",attrs:{"id":"warrant_table"}},[_c('tbody',_vm._l((_vm.lines),function(line,index){return _c('tr',[_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_20),expression:"line.f_20"}],staticClass:"table-control form-control my-control",attrs:{"disabled":""},domProps:{"value":(line.f_20)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_20", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_27),expression:"line.f_27"}],staticClass:"table-control form-control my-control",attrs:{"disabled":""},domProps:{"value":(line.f_27)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_27", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_17),expression:"line.f_17"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_17)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_17", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_24),expression:"line.f_24"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_24)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_24", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_21),expression:"line.f_21"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_21)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_21", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_25),expression:"line.f_25"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_25)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_25", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_23),expression:"line.f_23"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_23)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_23", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_16),expression:"line.f_16"}],staticClass:"table-control form-control my-control",attrs:{"disabled":""},domProps:{"value":(line.f_16)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_16", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_22),expression:"line.f_22"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_22)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_22", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(line.f_33),expression:"line.f_33"}],staticClass:"form-control my-control table-control",attrs:{"disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(line, "f_33", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Положительное")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Отрицательное")])])]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_91),expression:"line.f_91"}],attrs:{"type":"checkbox","disabled":""},domProps:{"checked":Array.isArray(line.f_91)?_vm._i(line.f_91,null)>-1:(line.f_91)},on:{"change":function($event){var $$a=line.f_91,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(line.f_91=$$a.concat([$$v]))}else{$$i>-1&&(line.f_91=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(line, "f_91", $$c)}}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(line.f_76),expression:"line.f_76"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(line, "f_76", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(line.f_77),expression:"line.f_77"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(line, "f_77", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(line.f_78),expression:"line.f_78"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(line, "f_78", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(line.f_79),expression:"line.f_79"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(line, "f_79", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(line.f_80),expression:"line.f_80"}],staticClass:"form-control my-control table-control",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(line, "f_80", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateViolations]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Соответствует")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не соответствует")])])]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(line.f_81),expression:"line.f_81"}],staticClass:"form-control my-control table-control",class:(_vm.f_71 != 3 && line.f_81 == 2) ? "field-error-warrant" : "",attrs:{"disabled":_vm.readonly},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(line, "f_81", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Положительное")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Отрицательное")])])]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_83),expression:"line.f_83"}],attrs:{"type":"checkbox","data-index":index,"disabled":_vm.readonly},domProps:{"checked":Array.isArray(line.f_83)?_vm._i(line.f_83,null)>-1:(line.f_83)},on:{"click":_vm.pushLine,"change":function($event){var $$a=line.f_83,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(line.f_83=$$a.concat([$$v]))}else{$$i>-1&&(line.f_83=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(line, "f_83", $$c)}}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_82),expression:"line.f_82"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":_vm.readonly},domProps:{"value":(line.f_82)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_82", $event.target.value)}}})])])}))])])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('table',{staticClass:"documentsTable"},[_vm._m(5),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Основание для проведения выездной проверки*")]),_vm._v(" "),_c('td',[_c('datepicker',{staticClass:"table-control",class:(_vm.f_71 != 3 && _vm.lines_copy.length && !_vm.f_60) ? "field-error-warrant" : "",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly},model:{value:(_vm.f_60),callback:function ($$v) {_vm.f_60=$$v},expression:"f_60"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_61),expression:"f_61"}],staticClass:"table-control form-control my-control",class:(_vm.f_71 != 3 && _vm.lines_copy.length && !_vm.f_61) ? "field-error-warrant" : "",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_61)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_61=$event.target.value}}})]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_62),expression:"f_62"}],staticClass:"form-control my-control table-control",class:(_vm.f_71 != 3 && _vm.lines_copy.length && !_vm.f_62) ? "field-error-warrant" : "",attrs:{"disabled":_vm.readonly},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.f_62=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"Невозможность проверки обоснованности мероприятий"}},[_vm._v("Невозможность проверки обоснованности мероприятий")]),_vm._v(" "),_c('option',{attrs:{"value":"Обращения граждан и юридических лиц"}},[_vm._v("Обращения граждан и юридических лиц")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Приказ о проведении выездной проверки*")]),_vm._v(" "),_c('td',[_c('datepicker',{staticClass:"table-control",class:(_vm.f_71 != 3 && _vm.lines_copy.length && !_vm.f_63) ? "field-error-warrant" : "",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly},model:{value:(_vm.f_63),callback:function ($$v) {_vm.f_63=$$v},expression:"f_63"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_64),expression:"f_64"}],staticClass:"table-control form-control my-control",class:(_vm.f_71 != 3 && _vm.lines_copy.length && !_vm.f_64) ? "field-error-warrant" : "",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_64)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_64=$event.target.value}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_65),expression:"f_65"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_65)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_65=$event.target.value}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Акт проведения выездной проверки*")]),_vm._v(" "),_c('td',[_c('datepicker',{staticClass:"table-control",class:(_vm.f_71 != 3 && _vm.lines_copy.length && !_vm.f_66) ? "field-error-warrant" : "",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly},model:{value:(_vm.f_66),callback:function ($$v) {_vm.f_66=$$v},expression:"f_66"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_67),expression:"f_67"}],staticClass:"table-control form-control my-control",class:(_vm.f_71 != 3 && _vm.lines_copy.length && !_vm.f_67) ? "field-error-warrant" : "",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_67)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_67=$event.target.value}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_68),expression:"f_68"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_68)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_68=$event.target.value}}})])])])])])]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"20px"}}),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('table',{staticClass:"result_table"},[_vm._m(7),_vm._v(" "),_c('tbody',_vm._l((_vm.lines_copy),function(line,index){return _c('tr',{key:line.index},[_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_20),expression:"line.f_20"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_20)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_20", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_27),expression:"line.f_27"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_27)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_27", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_17),expression:"line.f_17"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_17)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_17", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_24),expression:"line.f_24"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_24)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_24", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_25),expression:"line.f_25"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_25)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_25", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_16),expression:"line.f_16"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_16)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_16", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(line.f_22),expression:"line.f_22"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":""},domProps:{"value":(line.f_22)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(line, "f_22", $event.target.value)}}})]),_vm._v(" "),_vm._m(8,true),_vm._v(" "),_vm._m(9,true),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('action-type',{attrs:{"line_count":line.index,"data-index":line.index,"disabled":_vm.readonly}})],1),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lines[line.index].f_85),expression:"lines[line.index].f_85"}],staticClass:"table-control form-control my-control",class:(_vm.f_71 != 3 && !_vm.lines[line.index].f_85) ? "field-error-warrant" : "",attrs:{"type":"text","disabled":_vm.readonly},domProps:{"value":(_vm.lines[line.index].f_85)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.lines[line.index], "f_85", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('discovered-violations',{attrs:{"index":line.index,"ids":_vm.lines[line.index].f_110}})],1),_vm._v(" "),_c('td',{staticClass:"form_td"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lines[line.index].f_86),expression:"lines[line.index].f_86"}],staticClass:"table-control form-control my-control",attrs:{"type":"text","disabled":_vm.readonly},domProps:{"value":(_vm.lines[line.index].f_86)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.lines[line.index], "f_86", $event.target.value)}}})])])}))])])]),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_69),expression:"f_69"}],staticClass:"form-control my-control",class:(_vm.f_71 != 3 && _vm.f_69 == 2) ? "field-error-warrant" : "",attrs:{"disabled":_vm.readonly},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.f_69=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.mainDecisionChange($event)}]}},[_c('option',{attrs:{"value":"2"}},[_vm._v("Нет данных")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Положительное")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Отрицательное")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.npa_violation_text),expression:"npa_violation_text"}],staticClass:"form-control height-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.npa_violation_text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.npa_violation_text=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('npa-violation',{attrs:{"npa_disabled":_vm.npa_disabled_comp,"ids":_vm.f_92}})],1)]),_vm._v(" "),(_vm.f_69 == 0)?[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_125),expression:"f_125"}],staticClass:"form-control my-control",class:_vm.errorDecisionReason ? "field-error-warrant" : "",attrs:{"disabled":_vm.readonly || _vm.f_69 != 0},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.f_125=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.errorDecisionReasonHandler]}},_vm._l((_vm.decisions),function(reason){return _c('option',{key:reason.id,domProps:{"value":reason.id}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(reason.name)+"\n\t\t\t\t\t\t")])}))])])]:_vm._e(),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_70),expression:"f_70"}],staticClass:"form-control my-control",attrs:{"type":"text","disabled":_vm.readonly},domProps:{"value":(_vm.f_70)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_70=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('table',{staticClass:"documentsTable"},[_vm._m(13),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('official-docs',{attrs:{"disabled":_vm.readonly}})],1),_vm._v(" "),_c('td',[_c('datepicker',{staticClass:"table-control",attrs:{"format":"dd.MM.yyyy","disabled":_vm.readonly},model:{value:(_vm.f_72),callback:function ($$v) {_vm.f_72=$$v},expression:"f_72"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_73),expression:"f_73"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_73)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_73=$event.target.value}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_74),expression:"f_74"}],staticClass:"table-control form-control my-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.f_74)},on:{"input":function($event){if($event.target.composing){ return; }_vm.f_74=$event.target.value}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.f_75),expression:"f_75"}],staticClass:"form-control form-control my-control medium",attrs:{"disabled":_vm.readonly},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.f_75=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Черновик")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Чистовик")])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin":"5px"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"btnPanel"},[_c('input',{staticClass:"btn btn-secondary",attrs:{"type":"button","value":"Отмена","disabled":_vm.readonly},on:{"click":function($event){$event.preventDefault();_vm.close($event)}}}),_vm._v(" "),_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Сохранить","disabled":_vm.readonly},on:{"click":_vm.submit}})])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1 col"},[_vm._v("№ акта ЛПО")]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col"},[_vm._v("Организация")]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col"},[_vm._v("Ссылка на акт")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col"},[_vm._v("Федеральный округ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_vm._v("Субъект РФ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col"},[_vm._v("Лесничество")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col"},[_c('b',[_vm._v("Документарная проверка")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Официальные документы")]),_vm._v(" "),_c('th',[_vm._v("Дата")]),_vm._v(" "),_c('th',[_vm._v("Номер")]),_vm._v(" "),_c('th',[_vm._v("Комментарий к документу")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col"},[_c('b',[_vm._v("Выездная проверка")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Официальные документы")]),_vm._v(" "),_c('th',[_vm._v("Дата")]),_vm._v(" "),_c('th',[_vm._v("Номер")]),_vm._v(" "),_c('th',[_vm._v("Комментарий к документу")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_vm._v("\n\t\t\t\tРезультат выездной проверки\n\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Участковое "),_c('br'),_vm._v(" лесничество")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Подлес-во")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Квартал")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Выдел")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Лп. выдел")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("МЗЛ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("S МЗЛ")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("критерии")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("проверка")]),_vm._v(" "),_c('th',{staticClass:"colspan_td",attrs:{"colspan":"3"}},[_vm._v("решение по результатам выездной проверки*")]),_vm._v(" "),_c('th',{staticClass:"form_td",attrs:{"rowspan":"2"}},[_vm._v("Комментарии")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"form_td"},[_vm._v("МЗЛ")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("S МЗЛ")]),_vm._v(" "),_c('th',{staticClass:"form_td"},[_vm._v("Выявленные нарушение")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('input',{staticClass:"form-control form-control my-control table-control",attrs:{"disabled":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('input',{staticClass:"form-control form-control my-control table-control",attrs:{"disabled":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"margin-top":"5px"}},[_c('div',{staticClass:"col-md-2 col"},[_vm._v("Итоговое решение")]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col"},[_vm._v("Нарушение пунктов постан. Прав-ва.1158")]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col"},[_vm._v("Нарушения НПА")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col text-center",staticStyle:{"height":"24px","line-height":"24px"}},[_vm._v("Главная причина отмены акта")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col"},[_vm._v("Примечание")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Официальные документы")]),_vm._v(" "),_c('th',[_vm._v("Дата")]),_vm._v(" "),_c('th',[_vm._v("Номер")]),_vm._v(" "),_c('th',[_vm._v("Комментарий к документу")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yUMX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yZxP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");

//
//
//
//
//
//
//
//


var FORESTRY = 'forestrie_list.php';
var HEADER = 'get_header.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'forestry',
	data: function data() {
		return {
			selected: '0',
			options: [],
			id: this.type + '_forestry'
		};
	},
	props: {
		type: '',
		reg_id: '',
		f_id: '',
		field_class: '',
		disabled: ''
	},
	methods: {
		fill: function fill(id) {
			var _this = this;

			//console.log(id)
			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + FORESTRY + '?id=' + id).then(function (data) {
				return data.json();
			}).then(function (data) {
				if (data) {
					// this.selected = select ? select : '0'
					_this.options = [{ id: '0', name: '' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
					_this.selected = _this.f_id ? _this.f_id : '0';
					__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit('init_forestry_correct', _this.selected);
				} else {
					_this.selected = '0';
					_this.options = [];
				}
			}).then(function () {
				if (_this.disabled) {
					document.getElementById('btnAddLine').disabled = true;
					document.getElementById('btnCopyLine').disabled = true;
					document.getElementById('btnDeleteLine').disabled = true;
				} else {
					document.getElementById('btnAddLine').disabled = _this.selected === '0';
					document.getElementById('btnCopyLine').disabled = _this.selected === '0';
					document.getElementById('btnDeleteLine').disabled = _this.selected === '0';
				}
			}).catch(function (err) {
				return console.log(err);
			});
		},
		change: function change() {
			document.getElementById('btnAddLine').disabled = this.selected === '0';
			document.getElementById('btnCopyLine').disabled = this.selected === '0';
			document.getElementById('btnDeleteLine').disabled = this.selected === '0';

			this.$parent.data_location.localforestry = null;
			__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$emit(this.type + '_forestry', this.selected);
		}
	},
	created: function created() {
		var _this2 = this;

		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on(this.type + '_region', function (id) {
			_this2.fill(id);
		});
	},

	watch: {
		reg_id: function reg_id(id) {
			if (typeof id !== 'undefined' && id !== null) {
				this.fill(id);
			}
		}
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off(this.type + '_region');
	}
});

/***/ }),

/***/ "yc1Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z/Fz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control my-control table-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n\t\t"+_vm._s(option.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z4V9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_EventBus__ = __webpack_require__("O67w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TerritoryFilter__ = __webpack_require__("4+jQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editTerritoryCatalog__ = __webpack_require__("vBF1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap__ = __webpack_require__("YesG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_css_fontawesome_all_min_css__ = __webpack_require__("ThaU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_css_fontawesome_all_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__lib_css_fontawesome_all_min_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var GET_TERRITORY_JOURNAL = 'get_territory_journal.php';

var PADDING = 3;
var ROWS_ON_PAGE = 50;
var COLUMNS_COUNT = 4;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'TerritoryCatalog',
	data: function data() {
		return {
			territory_journal: [],
			pages: [],
			page_num: 1,

			filter: {
				region_name: [],
				forestry_name: [],
				localforestry_name: [],
				subforestry_name: []
			},

			showScrollWrap: false,
			need_recalc_table: false,
			DBlink: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */],

			displayEditTerritory: false,

			load_journal_status: false
		};
	},

	components: {
		TerritoryFilter: __WEBPACK_IMPORTED_MODULE_3__TerritoryFilter__["a" /* default */], editTerritoryCatalog: __WEBPACK_IMPORTED_MODULE_4__editTerritoryCatalog__["a" /* default */], modal: __WEBPACK_IMPORTED_MODULE_5_vue_strap__["modal"]
	},
	methods: {
		showEditTerritoryModal: function showEditTerritoryModal() {
			this.displayEditTerritory = true;
		},
		hideEditTerritoryModal: function hideEditTerritoryModal() {
			this.displayEditTerritory = false;
		},
		isNumeric: function isNumeric(x) {
			return !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(+x);
		},
		compose_filter: function compose_filter() {
			var where = '(';
			for (var f in this.filter) {
				for (var i = 0; i < this.filter[f].length; i++) {
					if (f !== this.field) where += this.filter[f][i] !== '' ? f + '=\'' + this.filter[f][i] + '\' or ' : f + ' is null or ';
				}
				if (f !== this.field) {
					where = this.filter[f].length !== 0 ? where.slice(0, -4) : where;
					where += this.filter[f].length !== 0 ? ') and (' : '';
				}
			}

			var where_range = [];
			for (var _f in this.filterRange) {
				var filter_name = _f;
				if (filter_name == 'forest_age') filter_name = 'forest_age::int';
				if (this.filterRange[_f].min) where_range.push(filter_name + ' >= ' + this.filterRange[_f].min);
				if (this.filterRange[_f].max) where_range.push(filter_name + ' <= ' + this.filterRange[_f].max);
			}

			var joined = where_range.join(' and ');
			where = where.slice(0, -6);
			if (where) {
				if (joined) where = where + ' and ' + joined;
			} else {
				if (joined) where = joined;
			}
			return where;
		},
		filter_journal: function filter_journal() {
			var _this = this;

			var drop_page_num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			if (drop_page_num) this.page_num = 1;

			//console.warn(where)

			this.load_journal_status = true;

			var data = new FormData();
			data.append('start_num', (this.page_num - 1) * ROWS_ON_PAGE + 1);
			data.append('show_count', ROWS_ON_PAGE);

			data.append('where', this.compose_filter());

			fetch(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DB */] + GET_TERRITORY_JOURNAL, {
				method: 'POST',
				body: data,
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				_this.locations_count = res[res.length - 1].count;
				_this.pages_count = Math.ceil(res[res.length - 1].count / ROWS_ON_PAGE);
				res.length--;

				_this.fill_pages();

				_this.territory_journal = res;
				_this.load_journal_status = false;
				_this.need_recalc_table = true;
			});
		},
		fill_pages: function fill_pages() {
			var _this2 = this;

			//debugger
			var temp_pages = [];

			if (this.page_num - 2 > PADDING) {
				temp_pages.push({ active: false, num: 1 });
				temp_pages.push({ active: false, num: '...' });
			}
			if (this.page_num - 2 == PADDING) {
				temp_pages.push({ active: false, num: 1 });
			}

			for (var i = this.page_num - PADDING - 1; i < this.page_num + PADDING; i++) {
				if (i >= 0 && i < this.pages_count) temp_pages.push({ active: false, num: i + 1 });
			}if (this.page_num < this.pages_count - PADDING - 1) {
				temp_pages.push({ active: false, num: '...' });
				temp_pages.push({ active: false, num: this.pages_count });
			}
			if (this.page_num == this.pages_count - PADDING - 1) {
				temp_pages.push({ active: false, num: this.pages_count });
			}

			this.pages = temp_pages;

			this.pages.forEach(function (p) {
				p.active = p.num == _this2.page_num;
			});
		},
		select_page: function select_page(e) {
			var value = e;
			if (!this.isNumeric(value)) value = +e.target.getAttribute('data-value');

			this.page_num = value;
			this.filter_journal(false);
			this.fill_pages();
		}
	},
	updated: function updated() {
		var _this3 = this;

		this.$nextTick(function () {
			if (_this3.need_recalc_table) {
				var scrollBlock = document.querySelector('.scroller-bottom');
				var newShowScrollWrap = Boolean(scrollBlock.scrollHeight > scrollBlock.clientHeight);
				if (newShowScrollWrap != _this3.showScrollWrap) {
					_this3.showScrollWrap = newShowScrollWrap;
					return;
				}
				//this.showScrollWrap = 

				for (var i = 1; i <= COLUMNS_COUNT; i++) {
					if (document.querySelector('.main-table td:nth-child(' + i + ')')) document.querySelector('.main-table td:nth-child(' + i + ')').style.width = document.querySelector('.top-table th:nth-child(' + i + ')').offsetWidth + 'px';
				}

				_this3.need_recalc_table = false;
			}
		});
	},
	mounted: function mounted() {
		var _this4 = this;

		this.filter_journal();

		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$on('territory_filter', function (f) {
			_this4.filter[f.field] = f.value !== '' ? f.value : null;
			_this4.filter_journal();
		});
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__lib_EventBus__["a" /* EventBus */].$off('territory_filter');
	}
});

/***/ }),

/***/ "zHFB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("qI5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_EventBus__ = __webpack_require__("O67w");
//
//
//
//
//
//
//
//


var ACT_INFO = 'get_act_info.php';
var LPO_MODE = 'get_lpo_mode.php';



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'lpoMode',
	data: function data() {
		return {
			selected: '',
			options: [],
			remote_sensing: false
		};
	},
	props: {
		method: null
	},
	methods: {
		change: function change() {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$emit('edit_lpo_mode', this.selected);
		},
		getOptions: function getOptions(method_id) {
			var _this = this;

			fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + ACT_INFO + '?id=' + this.$route.params.id, {
				credentials: 'include'
			}).then(function (res) {
				return res.json();
			}).then(function (res) {
				return res[0].f_90;
			}).then(function (id) {
				fetch(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DB */] + LPO_MODE + '?id=' + method_id, {
					credentials: 'include'
				}).then(function (data) {
					return data.json();
				}).then(function (data) {
					if (data) {
						_this.options = data;
						_this.selected = id ? id : data[0].id;
					} else {
						_this.options = [];
					}
				}).catch(function (err) {
					return console.log(err);
				});
			}).catch(function (err) {
				return console.log(err);
			});
		}
	},
	created: function created() {
		var _this2 = this;

		if (this.method) {
			this.getOptions(this.method);
		} else {
			__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$on('edit_lpo_method', function (id) {
				_this2.getOptions(id);
			});
		}

		/*EventBus.$on('edit_lpo_method', id => {
  	if(id == 1)
  	{
  		if(this.selected == 2)
  		{
  			this.selected = 1
  			this.change()
  		}
  		this.remote_sensing = true
  	}
  	else
  		this.remote_sensing = false
  })*/
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_1__lib_EventBus__["a" /* EventBus */].$off('edit_lpo_method');
	}
});

/***/ }),

/***/ "zLbM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatLpo_vue__ = __webpack_require__("CBfh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_519e7362_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_StatLpo_vue__ = __webpack_require__("hfaA");
function injectStyle (ssrContext) {
  __webpack_require__("T7Xe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-519e7362"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatLpo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_519e7362_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_StatLpo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zXUn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fo_vue__ = __webpack_require__("K3yO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41499f14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_fo_vue__ = __webpack_require__("GX2f");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41499f14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_fo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zmlw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_damages_vue__ = __webpack_require__("wj3t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_723889f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_damages_vue__ = __webpack_require__("WJ8b");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_damages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_723889f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_damages_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.572e02fe6e172d4936a0.js